
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    var mod = $parcel$modules[id];
    if (mod !== undefined) {
      return mod.exports;
    }
    var init = $parcel$inits[id];
    if (init !== undefined) {
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("5SzHz", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $4ZxLt = parcelRequire("4ZxLt");

const $01831239f93415a0$var$getEmptyResult = ()=>Promise.resolve({
        data: null,
        loading: false,
        error: null
    });
const $01831239f93415a0$export$ec3af86ec6a1dfc6 = async (spaceKey = '')=>{
    if (spaceKey) return (0, $dYU3e.query)({
        query: (0, $4ZxLt.default),
        variables: {
            spaceKey: spaceKey
        }
    });
    return $01831239f93415a0$var$getEmptyResult();
};
const $01831239f93415a0$export$2403e25f29f92c16 = async (spaceKey = '')=>{
    return $01831239f93415a0$export$ec3af86ec6a1dfc6(spaceKey);
};
module.exports["fetchSpaceDetail"] = $01831239f93415a0$export$ec3af86ec6a1dfc6;
module.exports["preloadSpaceDetail"] = $01831239f93415a0$export$2403e25f29f92c16;

});

parcelRegister("fbPMY", function(module, exports) {
/* EditorForgeConfigHelperRenderer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");

const $ec323015f520f003$var$hideIframe = null;
const $ec323015f520f003$var$bodiedExtensionHelper = {
    setRenderer: ()=>{}
}; /**
    * A component that allows us to render Forge UI Extensions directly in the editor
    * Normally, they are rendered as part of the extension manifest's render function,
    * but that function is not called for bodied extensions, so we need to render them separately.
    */ 
const $ec323015f520f003$export$d78837c9c32f5ea5 = ()=>{
    const [renderer, setRenderer] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState(null);
    $ec323015f520f003$var$bodiedExtensionHelper.setRenderer = (renderer)=>setRenderer(// We wrap the renderer function here, otherwise setState thinks we're passing a state mutation function
        ()=>renderer);
    return renderer ? renderer() : null;
};
const $ec323015f520f003$export$893920e86f275cd9 = async ({ extension: extension, forgeExtensionNode: forgeExtensionNode, hasCustomConfig: hasCustomConfig, isInitialInsertion: isInitialInsertion, createRenderFunction: createRenderFunction, onSubmit: onSubmit, onValidate: onValidate })=>{
    let gqlExtension = extension;
    let customEditContext;
    if (hasCustomConfig) {
        gqlExtension = {
            ...extension,
            properties: {
                ...extension.properties,
                resource: extension.properties?.config?.resource,
                render: extension.properties?.config?.render,
                title: extension.properties?.config?.title,
                viewportSize: extension.properties?.config?.viewportSize
            }
        };
        const onModalClose = ()=>$ec323015f520f003$var$bodiedExtensionHelper.setRenderer(null);
        customEditContext = {
            isInserting: isInitialInsertion,
            bridge: {
                close: onModalClose,
                submit: ({ data: data })=>{
                    // This can throw and propagate exceptions back down to the app
                    const payload = onValidate(data); // This can throw and propagate exceptions back down to the app
                    onSubmit(payload);
                    if (!payload.keepEditing) onModalClose();
                    return true;
                }
            },
            modalExtension: {
                type: 'macroConfig',
                title: extension.properties?.config?.title,
                closeModalExtension: onModalClose,
                modalWidth: extension.properties?.config?.viewportSize,
                shouldCloseOnOverlayClick: (0, $dh538.fg)('forge-ui-modal-close-a11y') ? true : false,
                shouldCloseOnEscapePress: (0, $dh538.fg)('forge-ui-modal-close-a11y') ? true : false
            }
        };
    }
    const renderFunction = await createRenderFunction(gqlExtension, customEditContext); // The Forge Doc config iframe should be hidden and resolve the config in the background
    // The loading component for custom config is unaffected as it is rendered in a Portal
    $ec323015f520f003$var$bodiedExtensionHelper.setRenderer(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            className: (0, $gMc0m.default)([
                "_1e0cglyw"
            ])
        }, renderFunction({
            node: forgeExtensionNode
        })));
};
const $ec323015f520f003$export$7d20cbfd94f605c9 = async ({ extension: extension, forgeExtensionNode: forgeExtensionNode, createRenderFunction: createRenderFunction })=>{
    const renderFunction = await createRenderFunction(extension);
    $ec323015f520f003$var$bodiedExtensionHelper.setRenderer(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            className: (0, $gMc0m.default)([
                "_1e0cglyw"
            ])
        }, renderFunction({
            node: forgeExtensionNode
        })));
};
module.exports["EditorForgeExtensionConfigHelperRenderer"] = $ec323015f520f003$export$d78837c9c32f5ea5;
module.exports["renderConfigHelper"] = $ec323015f520f003$export$893920e86f275cd9;
module.exports["renderBodiedExtensionIframe"] = $ec323015f520f003$export$7d20cbfd94f605c9;

});

parcelRegister("fPsyy", function(module, exports) {

var $7fDQr = parcelRequire("7fDQr");


const $9e907e6c94f6a3f7$export$fc997db2c0ab195 = async ({ intl: intl, editorActions: editorActions, extensionHandlers: extensionHandlers, createAnalyticsEvent: createAnalyticsEvent, externalToolbarItems: externalToolbarItems })=>{
    const { buildManifest: buildManifest } = await (parcelRequire("hVZns"));
    return buildManifest({
        intl: intl,
        editorActions: editorActions,
        parseNumber: $7fDQr.parseNumber,
        extensionHandlerWithReference: extensionHandlers,
        createAnalyticsEvent: createAnalyticsEvent,
        externalToolbarItems: externalToolbarItems || []
    });
};
module.exports["createChartsExtension"] = $9e907e6c94f6a3f7$export$fc997db2c0ab195;

});

parcelRegister("7fDQr", function(module, exports) {
const $0ce40a2f1d4c3720$export$6bf0e8cf8e1d780d = (numStr)=>{
    numStr = numStr.replace(/[,$%]/g, '');
    const num = Number(numStr);
    if (!Number.isNaN(num)) return num;
    return null;
};
module.exports["parseNumber"] = $0ce40a2f1d4c3720$export$6bf0e8cf8e1d780d;

});

parcelRegister("hVZns", function(module, exports) {

let $d0e75ece5c2dd7f9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $d0e75ece5c2dd7f9$var$load("6wr18"),
    $d0e75ece5c2dd7f9$var$load("8vVzT"),
    $d0e75ece5c2dd7f9$var$load("8UKe0"),
    $d0e75ece5c2dd7f9$var$load("ffEVr"),
    $d0e75ece5c2dd7f9$var$load("bXHUH")
]).then(()=>parcelRequire('4dpqU'));

});

parcelRegister("4mJKd", function(module, exports) {
"use strict";


let $32dcb3648bfd454e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("8tirZ")).shardUrl((parcelRequire("02nRr")).resolve(id), maxShards));
    };
module.exports = $32dcb3648bfd454e$var$load;

});

parcelRegister("8tirZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $62af5803f3d08114$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $62af5803f3d08114$var$getDomainShardIndex;
module.exports.shardUrl = $62af5803f3d08114$var$shardUrl;
module.exports.shardUrlUnchecked = $62af5803f3d08114$var$shardUrlUnchecked;
const $62af5803f3d08114$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $62af5803f3d08114$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $62af5803f3d08114$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $62af5803f3d08114$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $62af5803f3d08114$var$removeTrailingShard(subdomain) {
    if (!$62af5803f3d08114$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $62af5803f3d08114$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$62af5803f3d08114$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $62af5803f3d08114$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $62af5803f3d08114$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $62af5803f3d08114$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $62af5803f3d08114$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $62af5803f3d08114$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$62af5803f3d08114$var$globalKeyName]) return url;
    return $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards);
}
const $62af5803f3d08114$var$domainShardingKey = module.exports.domainShardingKey = $62af5803f3d08114$var$globalKeyName;

});

parcelRegister("02nRr", function(module, exports) {
$parcel$export(module.exports, "register", () => $0072b2502976b004$export$6503ec6e8aabbaf, (v) => $0072b2502976b004$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0072b2502976b004$export$f7ad0328861e2f03, (v) => $0072b2502976b004$export$f7ad0328861e2f03 = v);
var $0072b2502976b004$export$6503ec6e8aabbaf;
var $0072b2502976b004$export$f7ad0328861e2f03;
"use strict";
var $0072b2502976b004$var$mapping = new Map();
function $0072b2502976b004$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0072b2502976b004$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0072b2502976b004$var$resolve(id) {
    var resolved = $0072b2502976b004$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0072b2502976b004$export$6503ec6e8aabbaf = $0072b2502976b004$var$register;
$0072b2502976b004$export$f7ad0328861e2f03 = $0072b2502976b004$var$resolve;

});

parcelRegister("gH8jv", function(module, exports) {

var $4cOi8 = parcelRequire("4cOi8");


var $rsHkn = parcelRequire("rsHkn");


var $5zHV6 = parcelRequire("5zHV6");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");


var $cbvYp = parcelRequire("cbvYp");


const $d29a7626179a8a1f$var$cardsExtensionProviderLoader = async (props)=>{
    const module = await (parcelRequire("bHNGV"));
    return module.cardsExtensionProvider(props);
};

const $d29a7626179a8a1f$var$carouselExtensionProviderLoader = async (props)=>{
    const module = await (parcelRequire("jGS4n"));
    return module.carouselExtensionProvider(props);
};

const $d29a7626179a8a1f$var$platformSearchExtensionProviderLoader = async (props)=>{
    const module = await (parcelRequire("8ciZM"));
    return module.searchExtensionProvider(props);
};

const $d29a7626179a8a1f$var$platformSpotlightExtensionProviderLoader = async (props)=>{
    const module = await (parcelRequire("1JbHt"));
    return module.spotlightExtensionProvider(props);
};

const $d29a7626179a8a1f$var$platformLinksMenuExtensionProviderLoader = async (props)=>{
    const module = await (parcelRequire("fjkEz"));
    return module.linksMenuExtensionProvider(props);
};

const $d29a7626179a8a1f$var$platformSectionExtensionProviderLoader = async (props)=>{
    const module = await (parcelRequire("jvj3J"));
    return module.sectionExtensionProvider(props);
};
const $d29a7626179a8a1f$export$5cf5e33faff4fd37 = async (props)=>{
    const extensionProviders = $d29a7626179a8a1f$var$listPremiumExtensionProviders(props.contentId, props.allowCompanyHubExclusiveExtensions);
    const premiumExtensions = [];
    for (const provider of extensionProviders)try {
        const instance = await provider(props);
        const manifests = await instance.getExtensions();
        premiumExtensions.push(...manifests);
    } catch (error) {
        (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $3IBnw.Attribution).PERFORMANCE_INSIGHTS
        });
    }
    return premiumExtensions;
};
function $d29a7626179a8a1f$var$listPremiumExtensionProviders(contentId, allowCompanyHubExclusiveExtensions) {
    const extensionProviders = [];
    extensionProviders.push(async (providerProps)=>(await $d29a7626179a8a1f$var$platformSpotlightExtensionProviderLoader({
            contentId: contentId,
            mode: (0, $4cOi8.ExtensionMode).EDITOR,
            propsProvider: (0, $cbvYp.ConfluenceDependenciesProvider)
        }))(providerProps));
    extensionProviders.push(async (providerProps)=>(await $d29a7626179a8a1f$var$carouselExtensionProviderLoader({
            contentId: contentId,
            propsProvider: (0, $cbvYp.ConfluenceDependenciesProvider)
        }))(providerProps));
    extensionProviders.push(async (providerProps)=>(await $d29a7626179a8a1f$var$cardsExtensionProviderLoader({
            contentId: contentId,
            mode: (0, $4cOi8.ExtensionMode).EDITOR,
            propsProvider: (0, $cbvYp.ConfluenceDependenciesProvider)
        }))(providerProps));
    if (allowCompanyHubExclusiveExtensions) {
        extensionProviders.push(async (providerProps)=>(await $d29a7626179a8a1f$var$platformLinksMenuExtensionProviderLoader({
                contentId: contentId,
                mode: (0, $4cOi8.ExtensionMode).EDITOR,
                propsProvider: (0, $cbvYp.ConfluenceDependenciesProvider)
            }))(providerProps));
        extensionProviders.push(async (providerProps)=>(await $d29a7626179a8a1f$var$platformSectionExtensionProviderLoader({
                contentId: contentId,
                mode: (0, $4cOi8.ExtensionMode).EDITOR,
                propsProvider: (0, $cbvYp.ConfluenceDependenciesProvider),
                getSectionExtensionContents: $5zHV6.getSectionExtensionContents
            }))(providerProps));
        extensionProviders.push((0, $rsHkn.hubElementPlaceholderExtensionProvider));
        extensionProviders.push(async (providerProps)=>(await $d29a7626179a8a1f$var$platformSearchExtensionProviderLoader({
                contentId: contentId,
                mode: (0, $4cOi8.ExtensionMode).EDITOR,
                propsProvider: (0, $cbvYp.ConfluenceDependenciesProvider)
            }))(providerProps));
    }
    return extensionProviders;
}
module.exports["createPremiumExtensionManifests"] = $d29a7626179a8a1f$export$5cf5e33faff4fd37;

});

parcelRegister("rsHkn", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $4wH3g = parcelRequire("4wH3g");


var $bre0g = parcelRequire("bre0g");


var $bl1ay = parcelRequire("bl1ay");


var $cgtv4 = parcelRequire("cgtv4");

const $00496677170bf47e$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    title: {
        id: "company-hub.hub-element-placeholder.manifest.extension-title",
        defaultMessage: "Hub element placeholder"
    }
});



const $7f0c9adb44f07373$var$HubElementPlaceholderExtension = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "xUz9t",
    name: "HubElementPlaceholderExtension",
    loader: async ()=>(await (parcelRequire("232NP"))).HubElementPlaceholderExtension,
    loading: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {})
});

const $7f0c9adb44f07373$export$48207f1a9fb5511d = async ({ contentId: contentId, editorActions: editorActions, openConfigPanel: openConfigPanel, intl: intl })=>{
    const type = (0, $bl1ay.HUB_ELEMENT_PLACEHOLDER_EXTENSION_TYPE);
    const title = intl.formatMessage((0, $00496677170bf47e$export$a7357cdd1f0b0168).title);
    const icons = {
        '48': ()=>(parcelRequire("lkdwc")).then(({ default: PremiumIcon })=>()=>/*#__PURE__*/ (0, $l998X.jsx)(PremiumIcon, {
                        color: "var(--ds-icon-subtle, #505258)",
                        label: "",
                        spacing: "spacious"
                    }))
    };
    const update = async ()=>{
        const selectedNode = editorActions?.getSelectedNode()?.toJSON();
        const selectedLocalId = selectedNode?.attrs?.localId;
        if (!!selectedLocalId && openConfigPanel) openConfigPanel(selectedLocalId);
    };
    const render = async ()=>({ node: node })=>{
            // Only render the extension if we are in the editor
            return editorActions ? /*#__PURE__*/ (0, $l998X.jsx)($7f0c9adb44f07373$var$HubElementPlaceholderExtension, {
                openConfigPanel: openConfigPanel,
                editorActions: editorActions,
                extensionNode: node,
                contentId: contentId
            }) : null;
        };
    return new (0, $bre0g.default)([
        {
            key: (0, $bl1ay.HUB_ELEMENT_PLACEHOLDER_EXTENSION_KEY),
            icons: icons,
            title: title,
            type: type,
            description: '',
            modules: {
                nodes: {
                    default: {
                        type: 'extension',
                        render: render,
                        update: update
                    }
                }
            }
        }
    ]);
};
module.exports["hubElementPlaceholderExtensionProvider"] = $7f0c9adb44f07373$export$48207f1a9fb5511d;

});

parcelRegister("232NP", function(module, exports) {

let $17de0926a61f38d7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $17de0926a61f38d7$var$load("iJogx"),
    $17de0926a61f38d7$var$load("hwLGf"),
    $17de0926a61f38d7$var$load("e6ams"),
    $17de0926a61f38d7$var$load("iVgrO"),
    $17de0926a61f38d7$var$load("8gQdh"),
    $17de0926a61f38d7$var$load("8x9cy"),
    $17de0926a61f38d7$var$load("l5llo"),
    $17de0926a61f38d7$var$load("9Oy8P"),
    $17de0926a61f38d7$var$load("dChec"),
    $17de0926a61f38d7$var$load("2YffH"),
    $17de0926a61f38d7$var$load("f35QR"),
    $17de0926a61f38d7$var$load("eVYW1"),
    $17de0926a61f38d7$var$load("ls0Um"),
    $17de0926a61f38d7$var$load("020xd"),
    $17de0926a61f38d7$var$load("eTBsW"),
    $17de0926a61f38d7$var$load("bYxCZ"),
    $17de0926a61f38d7$var$load("6HBYC"),
    $17de0926a61f38d7$var$load("eDqo1"),
    $17de0926a61f38d7$var$load("lxiFd"),
    $17de0926a61f38d7$var$load("1oiJ6"),
    $17de0926a61f38d7$var$load("huUvS"),
    $17de0926a61f38d7$var$load("3RdRc"),
    $17de0926a61f38d7$var$load("98UJI"),
    $17de0926a61f38d7$var$load("b0cmi"),
    $17de0926a61f38d7$var$load("51haJ"),
    $17de0926a61f38d7$var$load("eBRUf"),
    $17de0926a61f38d7$var$load("jg5LT"),
    $17de0926a61f38d7$var$load("7f9Fz"),
    $17de0926a61f38d7$var$load("9S9Mz"),
    $17de0926a61f38d7$var$load("7EorR"),
    $17de0926a61f38d7$var$load("8j9XC"),
    $17de0926a61f38d7$var$load("2euij"),
    $17de0926a61f38d7$var$load("kZMnh"),
    $17de0926a61f38d7$var$load("855o0"),
    $17de0926a61f38d7$var$load("8MfZE"),
    $17de0926a61f38d7$var$load("Wowvf"),
    $17de0926a61f38d7$var$load("6vhrJ"),
    $17de0926a61f38d7$var$load("fxC6e"),
    $17de0926a61f38d7$var$load("dYtBN"),
    $17de0926a61f38d7$var$load("6wr18"),
    $17de0926a61f38d7$var$load("kjZZD"),
    $17de0926a61f38d7$var$load("ffEVr"),
    $17de0926a61f38d7$var$load("dTsOE"),
    $17de0926a61f38d7$var$load("hhss7"),
    $17de0926a61f38d7$var$load("bTmOC"),
    $17de0926a61f38d7$var$load("lFZaH"),
    $17de0926a61f38d7$var$load("6nDfv"),
    $17de0926a61f38d7$var$load("5zcov")
]).then(()=>parcelRequire('iyWZb'));

});

parcelRegister("lkdwc", function(module, exports) {

let $f865f3b2f1da87a2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f865f3b2f1da87a2$var$load("jle6Z").then(()=>parcelRequire('iNP4c'));

});

parcelRegister("5zHV6", function(module, exports) {

var $bl1ay = parcelRequire("bl1ay");

const $77d225805ec2338a$export$993dca3597b448e8 = ({ header: header, subHeader: subHeader, placeholderTitle: placeholderTitle })=>[
        {
            type: 'extensionFrame',
            content: [
                {
                    type: 'heading',
                    attrs: {
                        level: 1,
                        localId: null
                    },
                    content: [
                        {
                            type: 'text',
                            text: `${header}`
                        }
                    ]
                },
                {
                    type: 'paragraph',
                    attrs: {
                        localId: null
                    },
                    content: [
                        {
                            type: 'text',
                            text: `${subHeader}`
                        }
                    ]
                },
                {
                    type: 'paragraph',
                    attrs: {
                        localId: null
                    }
                },
                {
                    type: 'extension',
                    attrs: {
                        extensionKey: (0, $bl1ay.HUB_ELEMENT_PLACEHOLDER_EXTENSION_KEY),
                        extensionType: (0, $bl1ay.HUB_ELEMENT_PLACEHOLDER_EXTENSION_TYPE),
                        parameters: {
                            extensionTitle: placeholderTitle
                        },
                        text: null,
                        layout: 'default',
                        localId: null
                    }
                }
            ]
        }
    ];
module.exports["getSectionExtensionContents"] = $77d225805ec2338a$export$993dca3597b448e8;

});

parcelRegister("bHNGV", function(module, exports) {

let $885a418a35091ac7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $885a418a35091ac7$var$load("70l64"),
    $885a418a35091ac7$var$load("7czq2"),
    $885a418a35091ac7$var$load("8gQdh"),
    $885a418a35091ac7$var$load("8x9cy"),
    $885a418a35091ac7$var$load("l5llo"),
    $885a418a35091ac7$var$load("9Oy8P"),
    $885a418a35091ac7$var$load("2YffH"),
    $885a418a35091ac7$var$load("f35QR"),
    $885a418a35091ac7$var$load("eVYW1"),
    $885a418a35091ac7$var$load("ls0Um"),
    $885a418a35091ac7$var$load("020xd"),
    $885a418a35091ac7$var$load("eTBsW"),
    $885a418a35091ac7$var$load("bYxCZ"),
    $885a418a35091ac7$var$load("6HBYC"),
    $885a418a35091ac7$var$load("eDqo1"),
    $885a418a35091ac7$var$load("lxiFd"),
    $885a418a35091ac7$var$load("1oiJ6"),
    $885a418a35091ac7$var$load("huUvS"),
    $885a418a35091ac7$var$load("1wZEW"),
    $885a418a35091ac7$var$load("98UJI"),
    $885a418a35091ac7$var$load("hwLGf"),
    $885a418a35091ac7$var$load("2B6wT"),
    $885a418a35091ac7$var$load("gKYwM"),
    $885a418a35091ac7$var$load("iJogx"),
    $885a418a35091ac7$var$load("b0cmi"),
    $885a418a35091ac7$var$load("51haJ"),
    $885a418a35091ac7$var$load("lPQcc"),
    $885a418a35091ac7$var$load("8VT23"),
    $885a418a35091ac7$var$load("eBRUf"),
    $885a418a35091ac7$var$load("jg5LT"),
    $885a418a35091ac7$var$load("7f9Fz"),
    $885a418a35091ac7$var$load("9S9Mz"),
    $885a418a35091ac7$var$load("8j9XC"),
    $885a418a35091ac7$var$load("9ijrN"),
    $885a418a35091ac7$var$load("3w411"),
    $885a418a35091ac7$var$load("e1qbZ"),
    $885a418a35091ac7$var$load("fSobj"),
    $885a418a35091ac7$var$load("74u2y"),
    $885a418a35091ac7$var$load("7EorR"),
    $885a418a35091ac7$var$load("Wowvf"),
    $885a418a35091ac7$var$load("6vhrJ"),
    $885a418a35091ac7$var$load("fxC6e"),
    $885a418a35091ac7$var$load("6nDfv"),
    $885a418a35091ac7$var$load("e6ams"),
    $885a418a35091ac7$var$load("iVgrO"),
    $885a418a35091ac7$var$load("nFBKt"),
    $885a418a35091ac7$var$load("bTmOC"),
    $885a418a35091ac7$var$load("2euij"),
    $885a418a35091ac7$var$load("kZMnh"),
    $885a418a35091ac7$var$load("855o0"),
    $885a418a35091ac7$var$load("8MfZE"),
    $885a418a35091ac7$var$load("6wr18"),
    $885a418a35091ac7$var$load("kjZZD"),
    $885a418a35091ac7$var$load("ffEVr"),
    $885a418a35091ac7$var$load("dTsOE"),
    $885a418a35091ac7$var$load("3gJkK"),
    $885a418a35091ac7$var$load("hhss7"),
    $885a418a35091ac7$var$load("fMsyQ")
]).then(()=>parcelRequire('kWs4M'));

});

parcelRegister("jGS4n", function(module, exports) {

let $e55be1a718911887$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $e55be1a718911887$var$load("70l64"),
    $e55be1a718911887$var$load("7czq2"),
    $e55be1a718911887$var$load("e6ams"),
    $e55be1a718911887$var$load("iVgrO"),
    $e55be1a718911887$var$load("8gQdh"),
    $e55be1a718911887$var$load("8x9cy"),
    $e55be1a718911887$var$load("l5llo"),
    $e55be1a718911887$var$load("9Oy8P"),
    $e55be1a718911887$var$load("2YffH"),
    $e55be1a718911887$var$load("f35QR"),
    $e55be1a718911887$var$load("eVYW1"),
    $e55be1a718911887$var$load("ls0Um"),
    $e55be1a718911887$var$load("020xd"),
    $e55be1a718911887$var$load("eTBsW"),
    $e55be1a718911887$var$load("bYxCZ"),
    $e55be1a718911887$var$load("6HBYC"),
    $e55be1a718911887$var$load("eDqo1"),
    $e55be1a718911887$var$load("lxiFd"),
    $e55be1a718911887$var$load("1oiJ6"),
    $e55be1a718911887$var$load("huUvS"),
    $e55be1a718911887$var$load("d9TJ0"),
    $e55be1a718911887$var$load("8nWJU"),
    $e55be1a718911887$var$load("g2A8O"),
    $e55be1a718911887$var$load("98UJI"),
    $e55be1a718911887$var$load("hwLGf"),
    $e55be1a718911887$var$load("bTmOC"),
    $e55be1a718911887$var$load("iJogx"),
    $e55be1a718911887$var$load("b0cmi"),
    $e55be1a718911887$var$load("51haJ"),
    $e55be1a718911887$var$load("eBRUf"),
    $e55be1a718911887$var$load("jg5LT"),
    $e55be1a718911887$var$load("7f9Fz"),
    $e55be1a718911887$var$load("5uN9h"),
    $e55be1a718911887$var$load("9S9Mz"),
    $e55be1a718911887$var$load("7EorR"),
    $e55be1a718911887$var$load("6aY84"),
    $e55be1a718911887$var$load("5CaYW"),
    $e55be1a718911887$var$load("8j9XC"),
    $e55be1a718911887$var$load("e1qbZ"),
    $e55be1a718911887$var$load("2euij"),
    $e55be1a718911887$var$load("kZMnh"),
    $e55be1a718911887$var$load("855o0"),
    $e55be1a718911887$var$load("8MfZE"),
    $e55be1a718911887$var$load("Wowvf"),
    $e55be1a718911887$var$load("dek7I"),
    $e55be1a718911887$var$load("1MWOL"),
    $e55be1a718911887$var$load("6vhrJ"),
    $e55be1a718911887$var$load("fxC6e"),
    $e55be1a718911887$var$load("dYtBN"),
    $e55be1a718911887$var$load("kNV5Y"),
    $e55be1a718911887$var$load("6wr18"),
    $e55be1a718911887$var$load("kjZZD"),
    $e55be1a718911887$var$load("6nDfv"),
    $e55be1a718911887$var$load("ffEVr"),
    $e55be1a718911887$var$load("dTsOE"),
    $e55be1a718911887$var$load("hhss7"),
    $e55be1a718911887$var$load("dJOHz")
]).then(()=>parcelRequire('8Hi5s'));

});

parcelRegister("8ciZM", function(module, exports) {

let $5f7e2dd414fd0c00$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $5f7e2dd414fd0c00$var$load("8gQdh"),
    $5f7e2dd414fd0c00$var$load("8x9cy"),
    $5f7e2dd414fd0c00$var$load("l5llo"),
    $5f7e2dd414fd0c00$var$load("9Oy8P"),
    $5f7e2dd414fd0c00$var$load("1wZEW"),
    $5f7e2dd414fd0c00$var$load("nFBKt"),
    $5f7e2dd414fd0c00$var$load("b0cmi"),
    $5f7e2dd414fd0c00$var$load("51haJ"),
    $5f7e2dd414fd0c00$var$load("lPQcc"),
    $5f7e2dd414fd0c00$var$load("kjZZD"),
    $5f7e2dd414fd0c00$var$load("7f9Fz"),
    $5f7e2dd414fd0c00$var$load("9fGNu"),
    $5f7e2dd414fd0c00$var$load("9S9Mz"),
    $5f7e2dd414fd0c00$var$load("3Bbwl"),
    $5f7e2dd414fd0c00$var$load("3w411"),
    $5f7e2dd414fd0c00$var$load("fSobj"),
    $5f7e2dd414fd0c00$var$load("74u2y"),
    $5f7e2dd414fd0c00$var$load("7EorR"),
    $5f7e2dd414fd0c00$var$load("Wowvf"),
    $5f7e2dd414fd0c00$var$load("6wr18"),
    $5f7e2dd414fd0c00$var$load("cMlHc"),
    $5f7e2dd414fd0c00$var$load("3SmkN"),
    $5f7e2dd414fd0c00$var$load("4L1zw"),
    $5f7e2dd414fd0c00$var$load("6nDfv"),
    $5f7e2dd414fd0c00$var$load("ffEVr"),
    $5f7e2dd414fd0c00$var$load("hhss7"),
    $5f7e2dd414fd0c00$var$load("kUykF")
]).then(()=>parcelRequire('27HWy'));

});

parcelRegister("1JbHt", function(module, exports) {

let $142311cf10409559$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $142311cf10409559$var$load("hwLGf"),
    $142311cf10409559$var$load("e6ams"),
    $142311cf10409559$var$load("iVgrO"),
    $142311cf10409559$var$load("8gQdh"),
    $142311cf10409559$var$load("8x9cy"),
    $142311cf10409559$var$load("l5llo"),
    $142311cf10409559$var$load("9Oy8P"),
    $142311cf10409559$var$load("dChec"),
    $142311cf10409559$var$load("2YffH"),
    $142311cf10409559$var$load("f35QR"),
    $142311cf10409559$var$load("eVYW1"),
    $142311cf10409559$var$load("ls0Um"),
    $142311cf10409559$var$load("020xd"),
    $142311cf10409559$var$load("eTBsW"),
    $142311cf10409559$var$load("bYxCZ"),
    $142311cf10409559$var$load("6HBYC"),
    $142311cf10409559$var$load("eDqo1"),
    $142311cf10409559$var$load("lxiFd"),
    $142311cf10409559$var$load("1oiJ6"),
    $142311cf10409559$var$load("huUvS"),
    $142311cf10409559$var$load("3RdRc"),
    $142311cf10409559$var$load("98UJI"),
    $142311cf10409559$var$load("b0cmi"),
    $142311cf10409559$var$load("51haJ"),
    $142311cf10409559$var$load("eBRUf"),
    $142311cf10409559$var$load("jg5LT"),
    $142311cf10409559$var$load("7f9Fz"),
    $142311cf10409559$var$load("9S9Mz"),
    $142311cf10409559$var$load("7EorR"),
    $142311cf10409559$var$load("8j9XC"),
    $142311cf10409559$var$load("2euij"),
    $142311cf10409559$var$load("kZMnh"),
    $142311cf10409559$var$load("855o0"),
    $142311cf10409559$var$load("8MfZE"),
    $142311cf10409559$var$load("Wowvf"),
    $142311cf10409559$var$load("6vhrJ"),
    $142311cf10409559$var$load("fxC6e"),
    $142311cf10409559$var$load("dYtBN"),
    $142311cf10409559$var$load("6wr18"),
    $142311cf10409559$var$load("kjZZD"),
    $142311cf10409559$var$load("6nDfv"),
    $142311cf10409559$var$load("ffEVr"),
    $142311cf10409559$var$load("dTsOE"),
    $142311cf10409559$var$load("hhss7"),
    $142311cf10409559$var$load("bTmOC"),
    $142311cf10409559$var$load("lFZaH")
]).then(()=>parcelRequire('cBfKJ'));

});

parcelRegister("fjkEz", function(module, exports) {

let $b258a6b3fe72be97$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b258a6b3fe72be97$var$load("e1qbZ"),
    $b258a6b3fe72be97$var$load("8gQdh"),
    $b258a6b3fe72be97$var$load("8x9cy"),
    $b258a6b3fe72be97$var$load("l5llo"),
    $b258a6b3fe72be97$var$load("9Oy8P"),
    $b258a6b3fe72be97$var$load("2YffH"),
    $b258a6b3fe72be97$var$load("cgmWe"),
    $b258a6b3fe72be97$var$load("b0cmi"),
    $b258a6b3fe72be97$var$load("51haJ"),
    $b258a6b3fe72be97$var$load("2Gceu"),
    $b258a6b3fe72be97$var$load("eBRUf"),
    $b258a6b3fe72be97$var$load("bGpE6"),
    $b258a6b3fe72be97$var$load("4RbVd"),
    $b258a6b3fe72be97$var$load("jg5LT"),
    $b258a6b3fe72be97$var$load("7f9Fz"),
    $b258a6b3fe72be97$var$load("igTEs"),
    $b258a6b3fe72be97$var$load("9S9Mz"),
    $b258a6b3fe72be97$var$load("7EorR"),
    $b258a6b3fe72be97$var$load("iFEfD"),
    $b258a6b3fe72be97$var$load("Wowvf"),
    $b258a6b3fe72be97$var$load("dek7I"),
    $b258a6b3fe72be97$var$load("jiFtb"),
    $b258a6b3fe72be97$var$load("6wr18"),
    $b258a6b3fe72be97$var$load("ffEVr"),
    $b258a6b3fe72be97$var$load("kjZZD"),
    $b258a6b3fe72be97$var$load("6nDfv"),
    $b258a6b3fe72be97$var$load("hhss7"),
    $b258a6b3fe72be97$var$load("aUuEW")
]).then(()=>parcelRequire('aALia'));

});

parcelRegister("jvj3J", function(module, exports) {

let $e32fb25867eddb23$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $e32fb25867eddb23$var$load("6wr18"),
    $e32fb25867eddb23$var$load("b0cmi"),
    $e32fb25867eddb23$var$load("51haJ"),
    $e32fb25867eddb23$var$load("grbhN"),
    $e32fb25867eddb23$var$load("ffEVr"),
    $e32fb25867eddb23$var$load("6nDfv"),
    $e32fb25867eddb23$var$load("frwBA")
]).then(()=>parcelRequire('j1jge'));

});

parcelRegister("bfil7", function(module, exports) {
/* eslint-disable prefer-const */ 
var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");


var $bre0g = parcelRequire("bre0g");


var $2Nwuj = parcelRequire("2Nwuj");


var $iXCQx = parcelRequire("iXCQx");


var $5spQU = parcelRequire("5spQU");





var $dh538 = parcelRequire("dh538");


var $lzcvT = parcelRequire("lzcvT");





var $7ShCl = parcelRequire("7ShCl");


var $3Mg7y = parcelRequire("3Mg7y");

/* AIPanelRenderer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");





var $8C5kA = parcelRequire("8C5kA");


var $iyDxB = parcelRequire("iyDxB");


var $h9yJL = parcelRequire("h9yJL");


var $5SAOw = parcelRequire("5SAOw");





var $67O0h = parcelRequire("67O0h");


var $lspPP = parcelRequire("lspPP");


var $b7FrM = parcelRequire("b7FrM");


var $aoVih = parcelRequire("aoVih");


var $cOrQJ = parcelRequire("cOrQJ");





var $ls2Fy = parcelRequire("ls2Fy");







const $cf5fb4ef446900a2$export$82f46aa4e6535a45 = (content)=>{
    switch(content){
        case 'INPUT_EXCEEDS_TOKEN_LIMIT':
            return (0, $ls2Fy.aiFailedStateMessages).tokenLimitExceeded;
        case 'INPUT_TOO_SHORT_TO_SUMMARIZE':
            return (0, $ls2Fy.aiFailedStateMessages).inputTooShortError;
        case 'INPUT_TOO_SHORT_TO_PROCESS':
            return (0, $ls2Fy.aiFailedStateMessages).inputTooShortError;
        case 'RATE_LIMIT':
            return (0, $ls2Fy.aiFailedStateMessages).rateLimitEnforced;
        case 'OPENAI_RATE_LIMIT_USER_ABUSE':
            return (0, $ls2Fy.aiFailedStateMessages).rateLimitEnforced;
        case 'NO_AGENT':
            return (0, $ls2Fy.aiFailedStateMessages).internalServerError;
        case 'FEATURE_DISABLED_ON_SITE':
            return (0, $ls2Fy.aiFailedStateMessages).internalServerError;
        case 'FEATURE_DISABLED':
            return (0, $ls2Fy.aiFailedStateMessages).internalServerError;
        case 'INTERNAL_SERVER_ERROR':
            return (0, $ls2Fy.aiFailedStateMessages).internalServerError;
        case 'PLUGIN_ERRORED':
            return (0, $ls2Fy.aiFailedStateMessages).internalServerError;
        case 'HIPAA_CONTENT_DETECTED':
            return (0, $ls2Fy.aiFailedStateMessages).hipaaContentError;
        case 'EXCEEDING_CONTEXT_LENGTH_ERROR':
            return (0, $ls2Fy.aiFailedStateMessages).tokenLimitExceeded;
        default:
            return (0, $ls2Fy.aiFailedStateMessages).apiError;
    }
};
const $cf5fb4ef446900a2$export$b3199784470a824d = (formatMessage)=>{
    return formatMessage((0, $ls2Fy.aiFailedStateMessages).aupViolationMessage, {
        auplink: (chunks)=>(0, $dh538.fg)('dst-a11y__replace-anchor-with-link__editor-ai') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
                href: "https://www.atlassian.com/legal/acceptable-use-policy",
                target: "_blank"
            }, chunks) : // eslint-disable-next-line react/jsx-no-target-blank, @atlaskit/design-system/no-html-anchor
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("a", {
                href: "https://www.atlassian.com/legal/acceptable-use-policy",
                target: "_blank"
            }, chunks)
    });
};
const $cf5fb4ef446900a2$export$3c9530b6fa51254f = (formatMessage)=>{
    return formatMessage((0, $ls2Fy.aiFailedStateMessages).internalServerError, {
        link: (chunks)=>(0, $dh538.fg)('dst-a11y__replace-anchor-with-link__editor-ai') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
                href: "https://status.atlassian.com/",
                target: "_blank"
            }, chunks) : // eslint-disable-next-line react/jsx-no-target-blank, @atlaskit/design-system/no-html-anchor
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("a", {
                href: "https://status.atlassian.com/",
                target: "_blank"
            }, chunks)
    });
};
const $cf5fb4ef446900a2$export$93f9f2a0033ee0e6 = (formatMessage)=>{
    return formatMessage((0, $ls2Fy.aiFailedStateMessages).rateLimitEnforced, {
        link: (chunks)=>(0, $dh538.fg)('dst-a11y__replace-anchor-with-link__editor-ai') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
                href: "https://support.atlassian.com/organization-administration/docs/excessive-use-in-atlassian-intelligence/",
                target: "_blank"
            }, chunks) : // eslint-disable-next-line react/jsx-no-target-blank, @atlaskit/design-system/no-html-anchor
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("a", {
                href: "https://support.atlassian.com/organization-administration/docs/excessive-use-in-atlassian-intelligence/",
                target: "_blank"
            }, chunks)
    });
};






var $3pfAb = parcelRequire("3pfAb");


var $inPa6 = parcelRequire("inPa6");


var $d925B = parcelRequire("d925B");

const $62a01701e320b4eb$export$25b5539498f7439e = ({ node: node })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    (0, $42omo.useEffect)(()=>{
        const getNodeMarkCount = (content)=>{
            return content.reduce((accum, currentNode)=>{
                const { type: type, marks: marks } = currentNode;
                accum.nodes[type] = (accum.nodes[type] || 0) + 1;
                if (Array.isArray(marks)) marks.forEach(({ type: type })=>{
                    accum.marks[type] = (accum.marks[type] || 0) + 1;
                });
                return accum;
            }, {
                nodes: {},
                marks: {}
            });
        };
        const prepareAndSendAnalytics = ()=>{
            const nodeMarkCount = Array.isArray(node.content) ? getNodeMarkCount(node.content) : {};
            const event = {
                action: (0, $d925B.ACTION).RENDERED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).BODIED_EXTENSION,
                actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).AI_PANELS_BODIED_EXTENSION,
                eventType: (0, $d925B.EVENT_TYPE).UI,
                attributes: {
                    platform: 'web',
                    extensionKey: node.extensionKey,
                    extensionType: node.extensionType,
                    localId: node.localId,
                    panelStatus: node.parameters?.macroMetadata?.status,
                    nodeMarkCount: nodeMarkCount
                }
            };
            if (createAnalyticsEvent) createAnalyticsEvent(event)?.fire((0, $3pfAb.FabricChannel).editor);
        };
        if ('requestIdleCallback' in window) // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        window.requestIdleCallback(prepareAndSendAnalytics);
        else // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        window.requestAnimationFrame(prepareAndSendAnalytics);
    }, [
        createAnalyticsEvent,
        node.content,
        node.extensionKey,
        node.extensionType,
        node.localId,
        node.parameters?.macroMetadata?.status
    ]);
};


const $109830dcc0614428$var$jsonTransformer = new (0, $h9yJL.JSONTransformer)();
const $109830dcc0614428$var$prismBackground = null;
const $109830dcc0614428$var$prismBackgroundLight = null;
const $109830dcc0614428$var$prismBackgroundDark = null;
const $109830dcc0614428$var$aiPanel = null;
const $109830dcc0614428$var$aiPanelContainer = null;
const $109830dcc0614428$var$createNodesFromContent = (content, schema)=>{
    const nodes = [];
    for (const node of content){
        if (node?.type === 'text') {
            const textNode = schema.text(node.text ?? '');
            nodes.push(textNode);
        } else if (schema.nodes[node.type] && node.content) {
            const contentNodes = $109830dcc0614428$var$createNodesFromContent(node.content, schema);
            const newNode = schema.nodes[node.type].create(node.attrs, contentNodes);
            nodes.push(newNode);
        }
    }
    return nodes;
};
const $109830dcc0614428$export$e197b6fcca07a8f5 = ({ node: node, providerFactory: providerFactory })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { colorMode: colorMode } = (0, $cOrQJ.default)();
    const [errorMessage, setErrorMessage] = (0, $42omo.useState)(undefined);
    const [theme, setTheme] = (0, $42omo.useState)(undefined);
    (0, $42omo.useEffect)(()=>{
        const status = node.parameters?.macroMetadata?.status;
        if (status === 'failed' || status === 'aup-violation') switch(node.parameters?.content){
            case 'ACCEPTABLE_USE_VIOLATIONS':
                const aupViolationMessage = (0, $cf5fb4ef446900a2$export$b3199784470a824d)(formatMessage);
                setErrorMessage(aupViolationMessage);
                break;
            case 'NO_AGENT':
            case 'FEATURE_DISABLED_ON_SITE':
            case 'FEATURE_DISABLED':
            case 'INTERNAL_SERVER_ERROR':
            case 'PLUGIN_ERRORED':
                const internalServerError = (0, $cf5fb4ef446900a2$export$3c9530b6fa51254f)(formatMessage);
                setErrorMessage(internalServerError);
                break;
            case 'RATE_LIMIT':
            case 'OPENAI_RATE_LIMIT_USER_ABUSE':
                const rateLimitErrorMessage = (0, $cf5fb4ef446900a2$export$93f9f2a0033ee0e6)(formatMessage);
                setErrorMessage(rateLimitErrorMessage);
                break;
            default:
                const errorMessageDescriptor = (0, $cf5fb4ef446900a2$export$82f46aa4e6535a45)(node.parameters?.content ?? 'API_FAILED');
                const errorMessage = formatMessage(errorMessageDescriptor);
                setErrorMessage(errorMessage);
                break;
        }
        setTheme(colorMode);
    }, [
        node.parameters?.macroMetadata?.status,
        node.parameters?.content,
        formatMessage,
        colorMode
    ]);
    (0, $62a01701e320b4eb$export$25b5539498f7439e)({
        node: node
    });
    const doc = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useMemo(()=>{
        if (!node?.content || errorMessage) return null;
        const adfEncoder = new (0, $b7FrM.ADFEncoder)(()=>$109830dcc0614428$var$jsonTransformer);
        return adfEncoder.encode($109830dcc0614428$var$jsonTransformer.encode((0, $iyDxB.defaultSchema).nodes.doc.create({}, (0, $5SAOw.Fragment).from($109830dcc0614428$var$createNodesFromContent(node.content, (0, $iyDxB.defaultSchema))))));
    }, [
        node.content,
        errorMessage
    ]);
    if (errorMessage) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_2rko6tcb _ca0qe4h9 _u5f3e4h9 _n3tde4h9 _19bve4h9",
            theme === 'light' ? "_11q77bg2" : "_11q71i7g"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_2rko12b0 _bfhk1bhr"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aoVih.default), {
        appearance: "error",
        title: ''
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        as: "p"
    }, errorMessage)))));
    if (!doc) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_2rko6tcb _ca0qe4h9 _u5f3e4h9 _n3tde4h9 _19bve4h9",
            theme === 'light' ? "_11q77bg2" : "_11q71i7g"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_2rko12b0 _bfhk1bhr"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lspPP.RendererActionsContext), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $67O0h.default), {
        document: doc,
        appearance: "full-width",
        dataProviders: providerFactory
    })))));
};


const $4f5348a75e0b92cf$var$buildActionItemsPanelManifest = ({ intl: intl, providerFactory: providerFactory })=>{
    return {
        title: intl.formatMessage((0, $7ShCl.aiMessages).actionItemsPageTitle),
        type: 'com.atlassian.ai-blocks',
        key: 'ai-action-items-block',
        description: intl.formatMessage((0, $7ShCl.aiMessages).actionItemsPageDescription),
        icons: {
            // Ignored via go/ees005
            // eslint-disable-next-line require-await
            '48': async ()=>()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3Mg7y))), {
                        label: intl.formatMessage((0, $7ShCl.aiMessages).actionItemsPageTitle)
                    })
        },
        modules: {
            nodes: {
                aiActionItemsBodiedExtension: {
                    type: 'bodiedExtension',
                    // Ignored via go/ees005
                    // eslint-disable-next-line require-await
                    render: async ()=>({ node: node })=>{
                            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $109830dcc0614428$export$e197b6fcca07a8f5), {
                                node: node,
                                providerFactory: providerFactory
                            });
                        }
                }
            }
        }
    };
};
var $4f5348a75e0b92cf$export$2e2bcd8739ae039 = $4f5348a75e0b92cf$var$buildActionItemsPanelManifest;












const $aa877869a368108d$var$buildSummarisePagePanelManifest = ({ intl: intl, providerFactory: providerFactory })=>{
    return {
        title: intl.formatMessage((0, $7ShCl.aiMessages).summarizePageTitle),
        type: 'com.atlassian.ai-blocks',
        key: 'ai-summary-block',
        description: intl.formatMessage((0, $7ShCl.aiMessages).summarisePageDescription),
        icons: {
            // Ignored via go/ees005
            // eslint-disable-next-line require-await
            '48': async ()=>()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3Mg7y))), {
                        label: intl.formatMessage((0, $7ShCl.aiMessages).summarizePageTitle)
                    })
        },
        modules: {
            nodes: {
                aiSummaryBodiedExtension: {
                    type: 'bodiedExtension',
                    // Ignored via go/ees005
                    // eslint-disable-next-line require-await
                    render: async ()=>({ node: node })=>{
                            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $109830dcc0614428$export$e197b6fcca07a8f5), {
                                node: node,
                                providerFactory: providerFactory
                            });
                        }
                }
            }
        }
    };
};
var $aa877869a368108d$export$2e2bcd8739ae039 = $aa877869a368108d$var$buildSummarisePagePanelManifest;


const $c98f3a85236f8fc0$export$34ea67e5ccaac92 = ({ intl: intl, providerFactory: providerFactory })=>{
    const summarisePage = (0, $aa877869a368108d$export$2e2bcd8739ae039)({
        intl: intl,
        providerFactory: providerFactory
    });
    const findActionItems = (0, $4f5348a75e0b92cf$export$2e2bcd8739ae039)({
        intl: intl,
        providerFactory: providerFactory
    });
    const extensions = [];
    /**
	 * WARNING: Do not remove the isFedRamp check.
	 * This is to ensure that AI functionality is not enabled in FedRamp environments.
	 */ const isEnabled = (0, $dh538.fg)('use_frontend_feature_encoding_sdk_platform') ? (0, $5spQU.isFeatureEnabled)('rovo', 'rovo-editor-ai-panels') : !(0, $lzcvT.isFedRamp)();
    if (isEnabled) {
        extensions.push(summarisePage);
        extensions.push(findActionItems);
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return new (0, $bre0g.default)(extensions);
};



var $fPsyy = parcelRequire("fPsyy");


var $ccP7J = parcelRequire("ccP7J");


var $gH8jv = parcelRequire("gH8jv");


var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");


var $9Cbhx = parcelRequire("9Cbhx");





var $8EF7j = parcelRequire("8EF7j");







var $b1ab9d378fb1009f$exports = {};
$b1ab9d378fb1009f$exports = new URL("whiteboard-icon.f6879358.svg", import.meta.url).toString();






var $jhwJP = parcelRequire("jhwJP");

const $fedaa3ee3f94e7ae$var$messagesBase = (0, $cgtv4.defineMessages)({
    whiteboardManifestDescription: {
        id: "whiteboard-extension.description",
        defaultMessage: "Create an empty whiteboard"
    },
    whiteboardManifestTitle: {
        id: "whiteboard-extension.title",
        defaultMessage: "Whiteboard extension"
    },
    createWhiteboardTitle: {
        id: "whiteboard-extension.create-whiteboard.title",
        defaultMessage: "Create whiteboard"
    },
    createWhiteboardTitleElement: {
        id: "whiteboard-extension.create-whiteboard.title-element",
        defaultMessage: "Whiteboard"
    },
    createWhiteboardRetrospectiveTitle: {
        id: "whiteboard-extension.create-retrospective.title",
        defaultMessage: "Create retrospective"
    },
    createWhiteboardRetrospectiveTitleElement: {
        id: "whiteboard-extension.create-retrospective.title-element",
        defaultMessage: "Retrospective"
    },
    createWhiteboardDiagramTitle: {
        id: "whiteboard-extension.create-diagram.title",
        defaultMessage: "Create diagram"
    },
    createWhiteboardDiagramTitleElement: {
        id: "whiteboard-extension.create-diagram.title-element",
        defaultMessage: "Diagram"
    },
    createWhiteboardFlowchartTitle: {
        id: "whiteboard-extension.create-flowchart.title",
        defaultMessage: "Create flowchart"
    },
    createWhiteboardFlowchartTitleElement: {
        id: "whiteboard-extension.create-flowchart.title-element",
        defaultMessage: "Flowchart"
    },
    createWhiteboardBrainstormingTitle: {
        id: "whiteboard-extension.create-brainstorming.title",
        defaultMessage: "Create brainstorm session"
    },
    createWhiteboardBrainstormingTitleElement: {
        id: "whiteboard-extension.create-brainstorming.title-element",
        defaultMessage: "Brainstorm session"
    },
    createWhiteboardRoadmapTitle: {
        id: "whiteboard-extension.create-roadmap.title",
        defaultMessage: "Create roadmap"
    },
    createWhiteboardRoadmapTitleElement: {
        id: "whiteboard-extension.create-roadmap.title-element",
        defaultMessage: "Roadmap"
    },
    createWhiteboardDescription: {
        id: "whiteboard-extension.create-whiteboard.description",
        defaultMessage: "Create a blank whiteboard"
    },
    createWhiteboardRetrospectiveDescription: {
        id: "whiteboard-extension.create-retrospective.description",
        defaultMessage: "Create a whiteboard using the simple retrospective template"
    },
    createWhiteboardDiagramDescription: {
        id: "whiteboard-extension.create-diagram.description",
        defaultMessage: "Create a whiteboard using the flowchart template"
    },
    createWhiteboardFlowchartDescription: {
        id: "whiteboard-extension.create-flowchart.description",
        defaultMessage: "Create a whiteboard using the flowchart template"
    },
    createWhiteboardBrainstormingDescription: {
        id: "whiteboard-extension.create-brainstorming.description",
        defaultMessage: "Create a whiteboard using the brainwriting template"
    },
    createWhiteboardRoadmapDescription: {
        id: "whiteboard-extension.create-roadmap.description",
        defaultMessage: "Create a whiteboard using the product roadmap template"
    },
    createWhiteboardIconAltText: {
        id: "whiteboard-extension.create-whiteboard.icon-alt-text",
        defaultMessage: "Create whiteboard icon"
    },
    successFlagTitle: {
        id: "whiteboard-extension.success-flag.title",
        defaultMessage: "Whiteboard added to content tree"
    },
    successFlagAction: {
        id: "whiteboard-extension.success-flag.action",
        defaultMessage: "Go to whiteboard"
    },
    successFlagDescription: {
        id: "whiteboard-extension.success-flag.description",
        defaultMessage: "The source whiteboard has been created in the tree. Go to the whiteboard to move its location or change its permissions."
    },
    whiteboardDefaultErrorFlagTitle: {
        id: "whiteboard-extension.error-flag.title",
        defaultMessage: "We\u2019re unable to create right now"
    },
    whiteboardDefaultErrorFlagDescription: {
        id: "whiteboard-extension.error-flag.description",
        defaultMessage: "Refresh or wait a few minutes and try again. If this keeps happening, contact support."
    },
    whiteboardParentPageMovedErrorTitle: {
        id: "whiteboard-extension.error.parent-page-moved-error-title",
        defaultMessage: "The parent has moved"
    },
    whiteboardParentPageMovedErrorDescription: {
        id: "whiteboard-extension.error.parent-page-moved-error-description",
        defaultMessage: "Refresh to create in the new location."
    },
    whiteboardPermissionRemovedErrorTitle: {
        id: "whiteboard-extension.error.permission-removed-error-title",
        defaultMessage: "We\u2019re unable to create this content"
    },
    whiteboardPermissionRemovedErrorDescription: {
        id: "whiteboard-extension.error.permission-removed-error-description",
        defaultMessage: "You don\u2019t have permission to create here or the space has been recently deleted."
    },
    whiteboardInvalidParentErrorTitle: {
        id: "whiteboard-extension.error.invalid-parent-error-title",
        defaultMessage: "We can\u2019t create a whiteboard"
    },
    whiteboardInvalidParentErrorDescription: {
        id: "whiteboard-extension.error.invalid-parent-error-description",
        defaultMessage: "This page was deleted or archived. You can create a whiteboard on a different page."
    },
    whiteboardFeaturedItemDescription: {
        id: "whiteboard-extension.featured.description",
        defaultMessage: "Use a whiteboard to add visuals to your page"
    }
});
const $fedaa3ee3f94e7ae$var$messagesLiveDocs = (0, $cgtv4.defineMessages)({
    whiteboardInvalidParentErrorDescription: {
        id: "whiteboard-extension.error.invalid-parent-error-description.livedocs",
        defaultMessage: "This item was deleted or archived. You can create a whiteboard on a different page."
    }
});
const $fedaa3ee3f94e7ae$export$defe85febe8b728c = (0, $jhwJP.mergeLiveDocI18n)($fedaa3ee3f94e7ae$var$messagesBase, $fedaa3ee3f94e7ae$var$messagesLiveDocs);









var $irVI7 = parcelRequire("irVI7");


var $aJPUt = parcelRequire("aJPUt");


var $7Sm4c = parcelRequire("7Sm4c");


var $jn9ek = parcelRequire("jn9ek");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");


var $hQnHK = parcelRequire("hQnHK");


var $1NBp8 = parcelRequire("1NBp8");



var $1uFM6 = parcelRequire("1uFM6");


const $e46ddd38893da75d$var$isParentPageMovedError = (error)=>{
    if (error && 'graphQLErrors' in error) return error.graphQLErrors?.some((graphQLError)=>graphQLError.extensions.data.errors.some((nestedError)=>nestedError.message.key.includes('The parent space does not match the desired space')));
    return false;
};
const $e46ddd38893da75d$export$99d61d22bbf0a4ec = (error)=>{
    if (error && 'graphQLErrors' in error) return error.graphQLErrors?.some((graphQLError)=>graphQLError.extensions.data.errors.some((nestedError)=>nestedError.message.key.includes('Invalid potential parent passed')));
    return false;
};
const $e46ddd38893da75d$export$56cb25c20f68202b = (error)=>{
    if ($e46ddd38893da75d$var$isParentPageMovedError(error)) return {
        title: (0, $fedaa3ee3f94e7ae$export$defe85febe8b728c).whiteboardParentPageMovedErrorTitle,
        description: (0, $fedaa3ee3f94e7ae$export$defe85febe8b728c).whiteboardParentPageMovedErrorDescription
    };
    else if ($e46ddd38893da75d$export$99d61d22bbf0a4ec(error)) return {
        title: (0, $fedaa3ee3f94e7ae$export$defe85febe8b728c).whiteboardInvalidParentErrorTitle,
        description: (0, $fedaa3ee3f94e7ae$export$defe85febe8b728c).whiteboardInvalidParentErrorDescription
    };
    else if ((0, $1uFM6.isUnauthorizedError)(error)) return {
        title: (0, $fedaa3ee3f94e7ae$export$defe85febe8b728c).whiteboardPermissionRemovedErrorTitle,
        description: (0, $fedaa3ee3f94e7ae$export$defe85febe8b728c).whiteboardPermissionRemovedErrorDescription
    };
    return null;
};



var $eSUdr = parcelRequire("eSUdr");


var $hp2SH = parcelRequire("hp2SH");


var $fhofE = parcelRequire("fhofE");

async function $d23d3820cfa9f1e7$export$233ac44b3eda1727(pageId, spaceId, spaceKey, templateKey, createAnalyticsEvent) {
    // eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- Read http://go/cfe-no-direct-apollo-query-and-mutation-operations
    const mutationResult = await (0, $hp2SH.getApolloClient)().mutate({
        // eslint-disable-next-line graphql-relay-compat/consistent-graphql-operation-naming -- The naming is actually fine, but the eslint rule mis-fires due to dash in the filename
        mutation: (0, $eSUdr.default)`mutation CreateWhiteboardMutation($createdInContentId:ID!$spaceKey:String){createContentInline(input:{createdInContentId:$createdInContentId spaceKey:$spaceKey type:"whiteboard"}){id}}`,
        variables: {
            createdInContentId: pageId,
            spaceKey: spaceKey
        }
    });
    const contentId = mutationResult.data?.createContentInline.id;
    if (!contentId) throw Error('no content id present');
    // track event - whiteboard created inline
    const event = createAnalyticsEvent?.({
        type: 'sendTrackEvent',
        data: {
            action: 'createdByFlow',
            actionSubject: 'content',
            objectType: 'whiteboard',
            objectId: contentId,
            containerType: 'space',
            containerId: spaceId,
            source: 'createContentHandler',
            attributes: {
                flow: 'inlineWhiteboardCreation',
                contentType: 'whiteboard',
                collabService: 'canvas-relay',
                templateKey: templateKey
            }
        }
    });
    event?.fire();
    // return full URL so user can navigate
    return {
        contentId: contentId,
        fullUrl: (0, $fhofE.getFullWhiteboardUrl)(contentId, spaceKey)
    };
}


const $b90b80e740b78cf8$export$f15f03ee0d5fba0d = (pageId, spaceId, spaceKey, experienceTracker, createAnalyticsEvent, flags, templateKey, pageTreeStateUpdater)=>{
    return async ()=>{
        try {
            const instrumentedTemplateKey = templateKey ?? 'blank';
            experienceTracker?.start({
                name: (0, $irVI7.CREATE_WHITEBOARD_EXPERIENCE),
                timeout: (0, $aJPUt.ExperienceTimeout).CREATE_CONTENT,
                attributes: {
                    flow: 'inlinePageCreation',
                    template: instrumentedTemplateKey
                }
            });
            // call API to create whiteboard
            const { fullUrl: fullUrl, contentId: contentId } = await (0, $d23d3820cfa9f1e7$export$233ac44b3eda1727)(pageId, spaceId, spaceKey, instrumentedTemplateKey, createAnalyticsEvent);
            // allow user to navigate directly to whiteboard
            await flags?.showFlag({
                type: 'success-circle',
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $fedaa3ee3f94e7ae$export$defe85febe8b728c).successFlagTitle),
                actions: [
                    {
                        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $fedaa3ee3f94e7ae$export$defe85febe8b728c).successFlagAction),
                        href: fullUrl
                    }
                ],
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $fedaa3ee3f94e7ae$export$defe85febe8b728c).successFlagDescription)
            });
            if (pageTreeStateUpdater && contentId) pageTreeStateUpdater.setForceFetchPageId(pageId);
            experienceTracker?.succeed({
                name: (0, $irVI7.CREATE_WHITEBOARD_EXPERIENCE)
            });
            const url = new URL(fullUrl);
            const originatingUrl = (0, $1NBp8.EDIT_PAGE_V2).toUrl({
                contentType: 'pages',
                spaceKey: spaceKey,
                contentId: pageId
            });
            if (templateKey) // for applying a specific template once opened
            url.searchParams.set((0, $hQnHK.INSERT_TEMPLATE_WITH_KEY_QUERY_PARAM), templateKey);
            // for reconstructing the URL on the other side
            url.searchParams.set((0, $hQnHK.CREATED_FROM_SLUG), originatingUrl);
            window.open(url, '_blank', 'noreferrer, noopener');
            return {
                type: 'embedCard',
                attrs: {
                    url: fullUrl
                }
            };
        } catch (error) {
            const expectedErrorMessage = (0, $e46ddd38893da75d$export$56cb25c20f68202b)(error);
            if (expectedErrorMessage) {
                await flags?.showErrorFlag({
                    title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), expectedErrorMessage.title),
                    description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), expectedErrorMessage.description)
                });
                experienceTracker?.succeed({
                    name: (0, $irVI7.CREATE_WHITEBOARD_EXPERIENCE),
                    attributes: {
                        abortReason: 'expectedErrorMessage'
                    }
                });
            } else {
                const monitoringClient = (0, $5ZqQS.getMonitoringClient)();
                monitoringClient.submitError(error, {
                    attribution: (0, $3IBnw.Attribution).WHITEBOARDS
                });
                await flags?.showErrorFlag({
                    title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $fedaa3ee3f94e7ae$export$defe85febe8b728c).whiteboardDefaultErrorFlagTitle),
                    description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $fedaa3ee3f94e7ae$export$defe85febe8b728c).whiteboardDefaultErrorFlagDescription)
                });
                experienceTracker?.stopOnError({
                    name: (0, $irVI7.CREATE_WHITEBOARD_EXPERIENCE),
                    error: error,
                    attributes: {
                        cteTraceId: (0, $jn9ek.getTraceIdFromApolloError)(error)
                    }
                });
            }
            (0, $7Sm4c.markErrorAsHandled)(error);
        }
    };
};



const $1ecba3309686f865$export$6a8eaf1da3a38496 = [
    {
        key: 'whiteboard',
        title: (0, $fedaa3ee3f94e7ae$export$defe85febe8b728c).createWhiteboardTitle,
        description: (0, $fedaa3ee3f94e7ae$export$defe85febe8b728c).createWhiteboardDescription
    },
    {
        key: 'retrospective',
        title: (0, $fedaa3ee3f94e7ae$export$defe85febe8b728c).createWhiteboardRetrospectiveTitle,
        description: (0, $fedaa3ee3f94e7ae$export$defe85febe8b728c).createWhiteboardRetrospectiveDescription,
        templateKey: 'simple-retrospective'
    },
    {
        key: 'diagram',
        title: (0, $fedaa3ee3f94e7ae$export$defe85febe8b728c).createWhiteboardDiagramTitle,
        description: (0, $fedaa3ee3f94e7ae$export$defe85febe8b728c).createWhiteboardDiagramDescription,
        templateKey: 'flow-chart',
        priority: -200
    },
    {
        key: 'flowchart',
        title: (0, $fedaa3ee3f94e7ae$export$defe85febe8b728c).createWhiteboardFlowchartTitle,
        description: (0, $fedaa3ee3f94e7ae$export$defe85febe8b728c).createWhiteboardFlowchartDescription,
        templateKey: 'flow-chart'
    },
    {
        key: 'brainstorming',
        title: (0, $fedaa3ee3f94e7ae$export$defe85febe8b728c).createWhiteboardBrainstormingTitle,
        description: (0, $fedaa3ee3f94e7ae$export$defe85febe8b728c).createWhiteboardBrainstormingDescription,
        templateKey: 'brainwriting'
    },
    {
        key: 'roadmap',
        title: (0, $fedaa3ee3f94e7ae$export$defe85febe8b728c).createWhiteboardRoadmapTitle,
        description: (0, $fedaa3ee3f94e7ae$export$defe85febe8b728c).createWhiteboardRoadmapDescription,
        templateKey: 'product-roadmap'
    }
];



const $e34976de7a15a4c3$export$f5b268b2504551e9 = ({ pageId: pageId, spaceId: spaceId, spaceKey: spaceKey, intl: intl, flags: flags, experienceTracker: experienceTracker, createAnalyticsEvent: createAnalyticsEvent, contentType: contentType, allowWhiteboardQuickInsert: allowWhiteboardQuickInsert, pageTreeStateUpdater: pageTreeStateUpdater })=>{
    // empty extension if not on page
    if (contentType !== 'page') return {
        title: intl.formatMessage((0, $fedaa3ee3f94e7ae$export$defe85febe8b728c).whiteboardManifestTitle),
        description: intl.formatMessage((0, $fedaa3ee3f94e7ae$export$defe85febe8b728c).whiteboardManifestDescription),
        type: 'com.atlassian.confluence.macro.core',
        key: 'whiteboard-extension',
        icons: {
            // eslint-disable-next-line import/dynamic-import-chunkname
            '48': ()=>(parcelRequire("fSxYU"))
        },
        modules: {
            quickInsert: []
        }
    };
    const icon = async ()=>()=>{
            if ((0, $9wGTI.fg)('cc_fd_wb_update_diagram_icon')) // Return new ADS icon when feature gate is enabled
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8EF7j))), {
                label: ""
            });
            else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("img", {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($b1ab9d378fb1009f$exports))),
                alt: ""
            });
        };
    const shouldApplyPriority = [
        'wb_first',
        'db_first'
    ].includes((0, $6mKj3.expVal)('cc_fd_wb_create_priority_in_slash_menu_experiment', 'cohort', 'control'));
    const quickInsertCommands = (0, $1ecba3309686f865$export$6a8eaf1da3a38496).map((command)=>({
            key: `create-${command.key}`,
            title: intl.formatMessage(command.title),
            description: intl.formatMessage(command.description),
            priority: shouldApplyPriority ? command.priority : undefined,
            icon: icon,
            action: (0, $b90b80e740b78cf8$export$f15f03ee0d5fba0d)(pageId, spaceId, spaceKey, experienceTracker, createAnalyticsEvent, flags, command.templateKey, pageTreeStateUpdater),
            ...command.key === 'diagram' && {
                featured: true
            }
        }));
    return {
        title: intl.formatMessage((0, $fedaa3ee3f94e7ae$export$defe85febe8b728c).whiteboardManifestTitle),
        description: intl.formatMessage((0, $fedaa3ee3f94e7ae$export$defe85febe8b728c).whiteboardManifestDescription),
        type: 'com.atlassian.confluence.macro.core',
        key: 'whiteboard-extension',
        icons: {
            '48': icon
        },
        modules: {
            quickInsert: allowWhiteboardQuickInsert ? quickInsertCommands : []
        }
    };
};



var $cOau5 = parcelRequire("cOau5");


var $Qcu7n = parcelRequire("Qcu7n");


var $3IXUB = parcelRequire("3IXUB");


var $6OgRG = parcelRequire("6OgRG");


var $6mEZ3 = parcelRequire("6mEZ3");


var $8pcS0 = parcelRequire("8pcS0");


var $cV0On = parcelRequire("cV0On");


var $aMlgD = parcelRequire("aMlgD");


var $fgbpl = parcelRequire("fgbpl");





function $7a29776dd6927980$export$eb802fdec29ee1cc(extensionHandlers) {
    return {
        title: 'Redacted Macro Placeholder',
        key: (0, $8pcS0.EXTENSION_KEY).REDACTED_MACRO_PLACEHOLDER,
        type: (0, $8pcS0.EXTENSION_TYPE).MACRO_CORE,
        icons: {
            '48': async ()=>Promise.resolve((parcelRequire("9Q2dU")))
        },
        modules: {
            nodes: {
                default: {
                    type: 'extension',
                    render: async ()=>({ node: node })=>{
                            // We are already loading `RedactedPlaceholderExtensionHandler` for `extensionHandlers`
                            // and it also uses `@confluence/loadable` so loading it here asynchronously isn't useful
                            const handler = extensionHandlers[(0, $8pcS0.EXTENSION_TYPE).MACRO_CORE];
                            if (typeof handler === 'function') return handler(node, null);
                            return null;
                        }
                }
            }
        }
    };
}



var $9tVje = parcelRequire("9tVje");


const $fd320ef48aed12ed$export$8e57f4d7d2152080 = {
    type: 'com.atlassian.confluence.migration',
    key: 'nested-table',
    title: 'Nested tables',
    description: 'Allows you to nest tables within tables',
    icons: {
        '48': ()=>Promise.resolve((parcelRequire("dk0le")))
    },
    modules: {}
};


var $8eaad4326dd1f025$export$c2e660b99d13fe1a = /*#__PURE__*/ function(MappedFieldTypes) {
    MappedFieldTypes["int"] = "number";
    MappedFieldTypes["percentage"] = "string";
    MappedFieldTypes["url"] = "string";
    MappedFieldTypes["cql"] = "dynamic-fieldset";
    MappedFieldTypes["relativedate"] = "string";
    MappedFieldTypes["group"] = "string";
    MappedFieldTypes["color"] = "string";
    return MappedFieldTypes;
}({});


const $2f69ce15c0bd4ea6$export$f977989607a3df34 = {
    label: {
        type: 'custom',
        label: 'Label',
        isMultiple: true,
        allowDuplicates: true,
        isRequired: true,
        options: {
            resolver: {
                type: 'label'
            }
        }
    },
    text: {
        type: 'string',
        op: '~',
        label: 'Including text'
    },
    contributor: {
        key: 'contributor',
        type: 'custom',
        label: 'Contributor',
        isMultiple: true,
        options: {
            resolver: {
                type: 'username'
            }
        }
    },
    creator: {
        key: 'creator',
        type: 'custom',
        label: 'Creator',
        isMultiple: true,
        options: {
            resolver: {
                type: 'username'
            }
        }
    },
    mention: {
        key: 'mention',
        type: 'custom',
        label: 'Mentioning',
        isMultiple: true,
        options: {
            resolver: {
                type: 'username'
            }
        }
    },
    parent: {
        type: 'custom',
        label: 'With parent',
        options: {
            resolver: {
                type: 'confluence-content-by-id'
            }
        }
    },
    ancestor: {
        type: 'custom',
        label: 'With ancestor',
        isMultiple: true,
        options: {
            resolver: {
                type: 'confluence-content-by-id'
            }
        }
    },
    space: {
        type: 'custom',
        label: 'In space',
        isMultiple: true,
        options: {
            resolver: {
                type: 'spacekey'
            }
        }
    },
    // TODO: https://product-fabric.atlassian.net/browse/ED-10532
    created: {
        type: 'string',
        op: '>=',
        label: 'Created after',
        description: 'Enter dates as YYYY-MM-DD, or use CQL functions like `now(-1d)` for yesterday.'
    },
    lastmodified: {
        type: 'string',
        op: '<=',
        label: 'Last modified',
        description: 'Enter dates as YYYY-MM-DD, or use CQL functions like `now(-1d)` for yesterday.'
    },
    title: {
        type: 'string',
        op: '~',
        label: 'With title'
    },
    type: {
        type: 'enum',
        label: 'Of type',
        isMultiple: false,
        style: 'select',
        items: [
            {
                value: 'page',
                label: 'Page'
            },
            {
                value: 'blogpost',
                label: 'Blog'
            },
            {
                value: 'comment',
                label: 'Comment'
            },
            {
                value: 'attachment',
                label: 'Attachment'
            }
        ]
    }
};
const $2f69ce15c0bd4ea6$export$9545db27234e21a8 = ()=>Object.keys($2f69ce15c0bd4ea6$export$f977989607a3df34).map((name)=>({
            name: name,
            ...$2f69ce15c0bd4ea6$export$f977989607a3df34[name]
        }));


/**
 * Confluence returns a namespace inside description and label when the field is empty.
 * To map it to the new extension api, we need to remove it or replace it depending on the case.
 *
 * The original code can be found at https://stash.atlassian.com/projects/CONFCLOUD/repos/confluence/browse/confluence-plugins/confluence-editor-plugins/confluence-macro-browser/src/main/resources/js/macro-browser-editor.js#441
 * @param value
 * @param fallback
 * @param params
 * @param macroData
 * @param fieldType
 */ const $38eecb7cd02ce24e$var$safeGetBodyValue = (value, fallback, params, macroData, fieldType)=>{
    const { pluginKey: pluginKey, macroName: macroName } = macroData;
    if (value === [
        pluginKey,
        macroName,
        'param',
        params.name,
        fieldType
    ].join('.')) return fallback;
    return value;
};
const $38eecb7cd02ce24e$var$getBaseAttributes = (params, macroData)=>{
    const { displayName: displayName, name: name, description: description } = params;
    return {
        label: $38eecb7cd02ce24e$var$safeGetBodyValue(displayName, name, params, macroData, 'label'),
        name: params.name || 'defaultParameterValue',
        defaultValue: params.defaultValue,
        description: $38eecb7cd02ce24e$var$safeGetBodyValue(description ?? '', '', params, macroData, 'desc'),
        isMultiple: !!params.multiple,
        isRequired: !!params.required,
        isHidden: !!params.hidden
    };
};
const $38eecb7cd02ce24e$var$isNativeFieldType = (fieldType)=>{
    return /^(enum|string|number|boolean|date)$/.test(fieldType);
};
const $38eecb7cd02ce24e$export$f5f12fd2c8b33ce0 = (params, macroData)=>{
    const fieldType = $38eecb7cd02ce24e$var$transformFieldType(params.type.name);
    const baseAttributes = $38eecb7cd02ce24e$var$getBaseAttributes(params, macroData);
    if (fieldType === 'custom') {
        const customField = {
            ...baseAttributes,
            type: 'custom',
            options: {
                resolver: {
                    type: params.type.name
                }
            }
        };
        return customField;
    }
    if (params.type.name === 'cql') {
        let label = $38eecb7cd02ce24e$var$safeGetBodyValue(params.displayName, params.name, params, macroData, 'label');
        if (label === 'cql') label = 'CQL';
        const cqlField = {
            label: label,
            name: params.name || 'defaultParameterValue',
            fields: (0, $2f69ce15c0bd4ea6$export$9545db27234e21a8)(),
            type: 'fieldset',
            options: {
                isDynamic: true,
                transformer: {
                    type: params.type.name
                }
            }
        };
        return cqlField;
    }
    if (fieldType === 'enum') {
        const enumField = {
            ...baseAttributes,
            type: 'enum',
            style: 'select',
            defaultValue: baseAttributes.defaultValue ?? undefined,
            items: (params.enumValues || []).map((item)=>({
                    label: item,
                    value: item
                }))
        };
        return enumField;
    }
    // Transform default value of number from `null` -> `0`
    if (fieldType === 'number') {
        const numberField = {
            ...baseAttributes,
            type: 'number',
            defaultValue: baseAttributes.defaultValue ?? undefined
        };
        return numberField;
    }
    // Transform default value of number from `"false"` -> `false`
    if (fieldType === 'boolean') {
        const booleanField = {
            ...baseAttributes,
            type: 'boolean',
            isRequired: false,
            defaultValue: typeof baseAttributes.defaultValue === 'string' ? baseAttributes.defaultValue !== 'false' : !!baseAttributes.defaultValue
        };
        return booleanField;
    }
    const field = {
        ...baseAttributes,
        type: fieldType
    };
    return field;
};
const $38eecb7cd02ce24e$var$isMappedField = (fieldType)=>fieldType in (0, $8eaad4326dd1f025$export$c2e660b99d13fe1a);
const $38eecb7cd02ce24e$var$transformFieldType = (fieldType)=>{
    if ($38eecb7cd02ce24e$var$isMappedField(fieldType)) return (0, $8eaad4326dd1f025$export$c2e660b99d13fe1a)[fieldType];
    if ($38eecb7cd02ce24e$var$isNativeFieldType(fieldType)) return fieldType;
    return 'custom';
};



var $e7owm = parcelRequire("e7owm");


var $eQyFc = parcelRequire("eQyFc");


var $2E7zk = parcelRequire("2E7zk");


var $f7B1p = parcelRequire("f7B1p");

const $f5981546cd91a250$var$search = async (options)=>{
    const params = Object.entries(options).map(([key, value])=>Array.isArray(value) ? value.map((item)=>`${key}=${item}`) : `${key}=${value}`).flat().join('&');
    // /json/attachmentsearch.action?pageId=910426922&fileTypes=pdf&fileTypes=xls
    const res = await (0, $f7B1p.cfetch)(`/wiki/json/attachmentsearch.action?${params}`);
    const { attachments: attachments } = await res.json();
    if (attachments) return attachments.map(({ title: title })=>({
            label: title,
            value: title
        }));
    return [];
};
const $f5981546cd91a250$var$getAttachmentResolver = (options)=>async (searchTerm, selectedValue)=>{
        const searchers = [];
        searchers.push($f5981546cd91a250$var$search({
            ...options,
            title: searchTerm
        }));
        if (selectedValue) searchers.push(Promise.resolve((Array.isArray(selectedValue) ? selectedValue : [
            selectedValue
        ]).map((value)=>({
                label: value,
                value: value
            }))));
        return (await Promise.all(searchers)).flat();
    };
const $f5981546cd91a250$export$98306171982e2202 = (macro, pageContext)=>{
    const pageId = pageContext.contentId;
    // fileTypes were taken from
    // https://stash.atlassian.com/projects/CONFCLOUD/repos/confluence/browse/confluence-plugins/confluence-bundled-plugins/officeconnector/Zen/src/main/resources/javascript/office-connector-macro-fields.js#125-128
    switch(macro.macroName){
        case 'viewpdf':
            return $f5981546cd91a250$var$getAttachmentResolver({
                pageId: pageId,
                fileTypes: [
                    'pdf'
                ]
            });
        case 'viewdoc':
            return $f5981546cd91a250$var$getAttachmentResolver({
                pageId: pageId,
                fileTypes: [
                    'doc',
                    'docx'
                ]
            });
        case 'viewxls':
            return $f5981546cd91a250$var$getAttachmentResolver({
                pageId: pageId,
                fileTypes: [
                    'xls',
                    'xlsx'
                ]
            });
        case 'viewppt':
            return $f5981546cd91a250$var$getAttachmentResolver({
                pageId: pageId,
                fileTypes: [
                    'ppt',
                    'pptx'
                ]
            });
        default:
            return $f5981546cd91a250$var$getAttachmentResolver({
                pageId: pageId
            });
    }
};





const $99dfcbe48c719a87$var$search = async (searchTerm)=>{
    const res = await (0, $f7B1p.cfetch)(`/wiki/rest/calendar-services/1.0/calendar/search/subcalendars.json?term=${searchTerm}&limit=25&showSubCalendarsInView=true`);
    const resp = await res.json();
    if (!resp.success) return [];
    return resp.payload.map(({ subCalendar: { name: name, spaceName: spaceName, id: id } })=>({
            label: name,
            description: spaceName,
            value: id
        }));
};
const $99dfcbe48c719a87$var$fromIds = async (uuids)=>{
    const res = await (0, $f7B1p.cfetch)(`/wiki/rest/calendar-services/1.0/calendar/util/format/subcalendar/ids.json?subCalendarIds=${uuids.join('%2C')}`);
    const resp = await res.json();
    return resp.map(({ name: name, id: id })=>({
            label: name,
            value: id
        }));
};
const $99dfcbe48c719a87$export$79a154fc3ca3f9ae = async (searchTerm, selectedValue)=>{
    const searchers = [];
    if (searchTerm) searchers.push($99dfcbe48c719a87$var$search(searchTerm));
    if (selectedValue) {
        if (Array.isArray(selectedValue)) searchers.push($99dfcbe48c719a87$var$fromIds(selectedValue));
        else searchers.push($99dfcbe48c719a87$var$fromIds([
            selectedValue
        ]));
    }
    return (await Promise.all(searchers)).flat();
};





const $6b5a09c45142de10$export$45b10814cc054894 = (maybeArray = [])=>[].concat(maybeArray);


const $24ca4725cd610b37$var$search = async (cql)=>{
    return (0, $f7B1p.cfetch)(`/wiki/rest/api/search?limit=10&expand=content.container.icon&cql=${cql}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        }
    }).then((result)=>result.json()).then((response)=>response.results.map((result)=>({
                label: result.content.title,
                value: result.content.id,
                icon: `/wiki${result.content.container.icon.path}`,
                description: result.content.container.name
            })));
};
const $24ca4725cd610b37$export$a5caa672469ad596 = (contentIds)=>`id IN (${contentIds.join(',')})`;
const $24ca4725cd610b37$export$41173a2c419f6dfc = async (searchTerm, selectedValue, options)=>{
    const searchers = [];
    const type = options && options.type || 'page, blogpost';
    const selectedValues = (0, $6b5a09c45142de10$export$45b10814cc054894)(selectedValue);
    const conditionalCql = selectedValues.length ? `OR ${$24ca4725cd610b37$export$a5caa672469ad596(selectedValues)}` : '';
    if (searchTerm) searchers.push($24ca4725cd610b37$var$search(`type IN (${type}) AND title ~ "${searchTerm}*" ${conditionalCql}`));
    else searchers.push($24ca4725cd610b37$var$search(`type IN (${type}) AND id in recentlyViewedContent(5) ${conditionalCql}`));
    return (await Promise.all(searchers)).flat();
};


const $2fdd0370d00b842a$var$defaultPrefixSetting = {
    prefix: '',
    labelFunc: (val)=>val
};
const $2fdd0370d00b842a$export$4172796c9e33488c = ({ resolver: resolver, prefixSettings: prefixSettings })=>{
    // Returns a prefix if `val` starts with a prefix, or `undefined` otherwise.
    const getPrefixSetting = (val)=>{
        for (const setting of prefixSettings){
            if (val?.startsWith(setting.prefix)) return setting;
        }
        return undefined;
    };
    // Removes a prefix from `val` if it starts with one.
    const removePrefix = (val)=>{
        const prefix = getPrefixSetting(val)?.prefix;
        if (prefix) // Remove the `prefix` from `val`.
        return val.slice(prefix.length);
        return val;
    };
    // Known issue: If a value has a prefix when the page is loaded, it is stuck in the `selectedValue` array forever.
    // This makes it impossible to switch a value from one prefix to another, or to remove the prefix,
    // without removing the value, reloading the page, and adding it again.
    return async (searchTerm, selectedValue)=>{
        // Create a `preprocessedSelectedValue` array without prefixes so the resolver gives accurate reccommendations.
        let preprocessedSelectedValue = selectedValue;
        // A map from prefix-less labels to the PrefixSetting object that matches with the prefix they started with.
        const labelToPrefixSetting = {};
        // Depending on the resolver, `selectedValue` can be an array of strings, or just a string.  This handles both cases.
        if (Array.isArray(selectedValue)) {
            for (const selVal of selectedValue){
                const selValWithoutPrefix = removePrefix(selVal);
                labelToPrefixSetting[selValWithoutPrefix] = getPrefixSetting(selVal);
            }
            preprocessedSelectedValue = selectedValue.map(removePrefix);
        } else if (selectedValue) {
            const selValWithoutPrefix = removePrefix(selectedValue);
            labelToPrefixSetting[selValWithoutPrefix] = getPrefixSetting(selectedValue);
            preprocessedSelectedValue = selValWithoutPrefix;
        }
        // Remove the prefix from the searchTerm, and save the PrefixSetting corresponding with its prefix.
        const searchTermPrefixSetting = getPrefixSetting(searchTerm) ?? $2fdd0370d00b842a$var$defaultPrefixSetting;
        if (searchTerm) searchTerm = removePrefix(searchTerm);
        // Call the resolver with normal, prefix-less arguments.
        const results = await resolver(searchTerm, preprocessedSelectedValue);
        // Add prefixes back on to the results of the resolver.
        return results.map((result)=>{
            // Default to using no prefix.
            let prefixSetting = $2fdd0370d00b842a$var$defaultPrefixSetting;
            if (searchTerm) // If a search is happening, use the searchTerm's prefix.
            prefixSetting = searchTermPrefixSetting;
            else if (result.value in labelToPrefixSetting) // When no search is happening, use the prefixes from the selectedValue array.
            // This allows results to render correctly on initial load.
            prefixSetting = labelToPrefixSetting[result.value] ?? $2fdd0370d00b842a$var$defaultPrefixSetting;
            return {
                ...result,
                // Use the labelFunc to modify the result's label.
                // This displays prefixes in a more user-friendly way
                label: prefixSetting.labelFunc(removePrefix(result.label)),
                // Add the prefix back on to the result's value.
                value: `${prefixSetting.prefix}${result.value}`
            };
        });
    };
};


const $ca514041a0cedbe0$export$1766a89a46ff2e41 = ({ resolver: resolver, values: values })=>{
    const notSpecial = (val)=>values.indexOf(val) === -1;
    return async (searchTerm, selectedValue)=>{
        if (Array.isArray(selectedValue)) selectedValue = selectedValue.filter(notSpecial);
        else if (!notSpecial(selectedValue)) selectedValue = '';
        const results = await resolver(searchTerm, selectedValue);
        results.push(...values.map((value)=>({
                label: value,
                value: value
            })));
        return results;
    };
};



var $9fLxI = parcelRequire("9fLxI");







const $132842a839e22041$var$labelSearchQuery = // eslint-disable-next-line graphql-relay-compat/consistent-graphql-operation-naming -- Read https://go/connie-relay-migration-fyi
(0, $eSUdr.default)`query LabelSearch($searchTerm:String!){labelSearch(searchText:$searchTerm limit:25){otherLabels{label}suggestedLabels{label}}}`;
const $132842a839e22041$var$extractResults = (labelResults)=>labelResults.map((res)=>({
            label: res.label,
            value: res.label
        }));
const $132842a839e22041$var$search = async (searchTerm)=>{
    const client = (0, $hp2SH.getApolloClient)();
    // eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- Read http://go/cfe-no-direct-apollo-query-and-mutation-operations
    const { data: { labelSearch: labelSearch } } = await client.query({
        query: $132842a839e22041$var$labelSearchQuery,
        variables: {
            searchTerm: searchTerm
        }
    });
    return [
        ...$132842a839e22041$var$extractResults(labelSearch.suggestedLabels),
        ...$132842a839e22041$var$extractResults(labelSearch.otherLabels)
    ];
};
const $132842a839e22041$export$a821dfb2c4620119 = async (searchTerm, selectedValue)=>{
    const searchers = [];
    if (searchTerm) searchers.push($132842a839e22041$var$search(searchTerm));
    if (selectedValue) {
        if (Array.isArray(selectedValue)) searchers.push(Promise.resolve(selectedValue.map((label)=>({
                label: label,
                value: label
            }))));
        else searchers.push(Promise.resolve([
            {
                label: selectedValue,
                value: selectedValue
            }
        ]));
    }
    return (await Promise.all(searchers)).flat();
};





/**
 * @graphql cc
 */ 






const $0a9a42b243ec1ac9$var$spaceSearchQuery = // eslint-disable-next-line graphql-relay-compat/consistent-graphql-operation-naming -- Read https://go/connie-relay-migration-fyi
(0, $eSUdr.default)`query SpaceSearchQuery($cql:String!){search:confluence_search(cql:$cql first:25){edges{node{entityType title space{key icon{path}}}}}}`;
const $0a9a42b243ec1ac9$var$search = async (cql)=>{
    const client = (0, $hp2SH.getApolloClient)();
    // eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- Read http://go/cfe-no-direct-apollo-query-and-mutation-operations
    const res = await client.query({
        query: $0a9a42b243ec1ac9$var$spaceSearchQuery,
        variables: {
            cql: cql
        }
    });
    return res.data.search.edges.map((edge)=>({
            label: edge.node.title,
            value: edge.node.space.key,
            icon: `/wiki${edge.node.space.icon.path}`
        }));
};
const $0a9a42b243ec1ac9$var$quoteString = (str)=>`"${str}"`;
const $0a9a42b243ec1ac9$export$e92c2756cc1b853b = (spaces)=>`space.key IN (${spaces.map($0a9a42b243ec1ac9$var$quoteString).join(',')})`;
const $0a9a42b243ec1ac9$var$searchByTitleOrSpaceKey = (searchTerm, selectedValues = [])=>$0a9a42b243ec1ac9$var$search(`type = space AND (space.title ~ "${searchTerm}*" OR ${$0a9a42b243ec1ac9$export$e92c2756cc1b853b(selectedValues.concat(searchTerm))})`);
const $0a9a42b243ec1ac9$export$534da981b85f5d27 = (supportsCurrentSpace)=>async (searchTerm, selectedValue)=>{
        const selectedValues = (0, $6b5a09c45142de10$export$45b10814cc054894)(selectedValue);
        const searchers = [];
        if (searchTerm) searchers.push($0a9a42b243ec1ac9$var$searchByTitleOrSpaceKey(searchTerm, selectedValues));
        else {
            if (supportsCurrentSpace) searchers.push(Promise.resolve([
                {
                    label: 'Current space',
                    value: 'currentSpace()'
                }
            ]));
            const conditionalCql = selectedValues.length ? ` OR ${$0a9a42b243ec1ac9$export$e92c2756cc1b853b(selectedValues)}` : '';
            searchers.push($0a9a42b243ec1ac9$var$search(`type = space AND (space in recentlyViewedSpaces(4) ${conditionalCql})`));
        }
        return (await Promise.all(searchers)).flat();
    };
const $0a9a42b243ec1ac9$export$bab0f33d6337c008 = (macro)=>{
    // create-from-template doesn't support CQL-style
    // `currentSpace()` values, so don't show that menu option
    //
    // likewise for pagetree
    if ([
        'create-from-template',
        'pagetree'
    ].indexOf(macro.macroName) > -1) return $0a9a42b243ec1ac9$export$534da981b85f5d27(false);
    else return $0a9a42b243ec1ac9$export$534da981b85f5d27(true);
};



const $7474bd4805c6fe29$export$4d47f6bf8ec8af17 = (resolver)=>async (searchTerm, selectedValue)=>{
        const options = await resolver(searchTerm, selectedValue);
        const memory = new Map();
        return options.filter(({ value: value })=>{
            const isKnownValue = memory.has(value);
            memory.set(value, true);
            return !isKnownValue;
        });
    };


const $10e93d065b18a316$var$spacekeyWithCurrentSpace = (0, $0a9a42b243ec1ac9$export$534da981b85f5d27)(true);
const $10e93d065b18a316$export$ed8020fd2c03836f = (0, $7474bd4805c6fe29$export$4d47f6bf8ec8af17)(async (searchTerm, selectedValue)=>{
    if (typeof selectedValue === 'string') selectedValue = selectedValue.split(',');
    let selectedSpaces;
    let selectedPages;
    if (selectedValue && selectedValue.length > 0) {
        selectedSpaces = selectedValue.filter((value)=>!(0, $2E7zk.isPageId)(value));
        selectedSpaces = selectedSpaces.length ? selectedSpaces : undefined;
        selectedPages = selectedValue.filter((0, $2E7zk.isPageId));
        selectedPages = selectedPages.length ? selectedPages : undefined;
    }
    const spaceResults = await $10e93d065b18a316$var$spacekeyWithCurrentSpace(searchTerm, selectedSpaces);
    // we don't want to find blogposts; this resolver is used for spaceAndPage field for task report macro which
    // does not support blog posts
    const contentResults = await (0, $24ca4725cd610b37$export$41173a2c419f6dfc)(searchTerm, selectedPages, {
        type: 'page, folder'
    });
    return [
        spaceResults,
        contentResults
    ].flat();
});






const $3b8b016da39bc505$var$search = async (query)=>{
    const type = 'page,blogpost';
    return (0, $f7B1p.cfetch)(`/wiki/rest/prototype/1/search/name.json?max-results=10&pageSize=10&type=${type}&query=${encodeURIComponent(query)}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        }
    }).then((result)=>result.json()).then((response)=>{
        // two groups, one for pages and another for blogposts
        const res = [];
        response.group.forEach((groupResults)=>res.push(...groupResults.result.map((result)=>({
                    label: result.title,
                    value: `${result.space.key}:${result.title}`,
                    description: result.space.title
                }))));
        return res;
    });
};
const $3b8b016da39bc505$export$ddc3fcea26200983 = ()=>(0, $7474bd4805c6fe29$export$4d47f6bf8ec8af17)(async (searchTerm, selectedValue)=>{
        const searchers = [];
        if (searchTerm) searchers.push($3b8b016da39bc505$var$search(searchTerm));
        if (selectedValue) {
            if (typeof selectedValue === 'string' || Array.isArray(selectedValue)) {
                if (typeof selectedValue === 'string') selectedValue = selectedValue.split(',');
                selectedValue.forEach((selectedValue)=>{
                    const splitId = selectedValue.split(':');
                    const pageTitle = splitId[splitId.length - 1];
                    searchers.push($3b8b016da39bc505$var$search(pageTitle));
                });
            }
        }
        return (await Promise.all(searchers)).flat();
    });




var $gw2T1 = parcelRequire("gw2T1");

const $8540ddfe85cd4073$export$3f7da36354f8b724 = (resolver)=>async (searchTerm, selectedValue)=>{
        const options = await resolver(searchTerm, selectedValue);
        if (selectedValue) {
            const selectedValues = [].concat(selectedValue);
            return selectedValues.filter((v)=>!options.find(({ value: value })=>value === v)).map((v)=>({
                    label: v,
                    value: v
                })).concat(options);
        }
        return options;
    };


/**
 * @graphql cc
 */ 





var $1d06acb41b6c7038$exports = {};
/*
 * Generated by PEG.js 0.10.0.
 *
 * http://pegjs.org/
 */ "use strict";
function $1d06acb41b6c7038$var$peg$subclass(child, parent) {
    function ctor() {
        this.constructor = child;
    }
    ctor.prototype = parent.prototype;
    child.prototype = new ctor();
}
function $1d06acb41b6c7038$var$peg$SyntaxError(message, expected, found, location) {
    this.message = message;
    this.expected = expected;
    this.found = found;
    this.location = location;
    this.name = "SyntaxError";
    if (typeof Error.captureStackTrace === "function") Error.captureStackTrace(this, $1d06acb41b6c7038$var$peg$SyntaxError);
}
$1d06acb41b6c7038$var$peg$subclass($1d06acb41b6c7038$var$peg$SyntaxError, Error);
$1d06acb41b6c7038$var$peg$SyntaxError.buildMessage = function(expected, found) {
    var DESCRIBE_EXPECTATION_FNS = {
        literal: function(expectation) {
            return "\"" + literalEscape(expectation.text) + "\"";
        },
        "class": function(expectation) {
            var escapedParts = "", i;
            for(i = 0; i < expectation.parts.length; i++)escapedParts += expectation.parts[i] instanceof Array ? classEscape(expectation.parts[i][0]) + "-" + classEscape(expectation.parts[i][1]) : classEscape(expectation.parts[i]);
            return "[" + (expectation.inverted ? "^" : "") + escapedParts + "]";
        },
        any: function(expectation) {
            return "any character";
        },
        end: function(expectation) {
            return "end of input";
        },
        other: function(expectation) {
            return expectation.description;
        }
    };
    function hex(ch) {
        return ch.charCodeAt(0).toString(16).toUpperCase();
    }
    function literalEscape(s) {
        return s.replace(/\\/g, '\\\\').replace(/"/g, '\\"').replace(/\0/g, '\\0').replace(/\t/g, '\\t').replace(/\n/g, '\\n').replace(/\r/g, '\\r').replace(/[\x00-\x0F]/g, function(ch) {
            return '\\x0' + hex(ch);
        }).replace(/[\x10-\x1F\x7F-\x9F]/g, function(ch) {
            return '\\x' + hex(ch);
        });
    }
    function classEscape(s) {
        return s.replace(/\\/g, '\\\\').replace(/\]/g, '\\]').replace(/\^/g, '\\^').replace(/-/g, '\\-').replace(/\0/g, '\\0').replace(/\t/g, '\\t').replace(/\n/g, '\\n').replace(/\r/g, '\\r').replace(/[\x00-\x0F]/g, function(ch) {
            return '\\x0' + hex(ch);
        }).replace(/[\x10-\x1F\x7F-\x9F]/g, function(ch) {
            return '\\x' + hex(ch);
        });
    }
    function describeExpectation(expectation) {
        return DESCRIBE_EXPECTATION_FNS[expectation.type](expectation);
    }
    function describeExpected(expected) {
        var descriptions = new Array(expected.length), i, j;
        for(i = 0; i < expected.length; i++)descriptions[i] = describeExpectation(expected[i]);
        descriptions.sort();
        if (descriptions.length > 0) {
            for(i = 1, j = 1; i < descriptions.length; i++)if (descriptions[i - 1] !== descriptions[i]) {
                descriptions[j] = descriptions[i];
                j++;
            }
            descriptions.length = j;
        }
        switch(descriptions.length){
            case 1:
                return descriptions[0];
            case 2:
                return descriptions[0] + " or " + descriptions[1];
            default:
                return descriptions.slice(0, -1).join(", ") + ", or " + descriptions[descriptions.length - 1];
        }
    }
    function describeFound(found) {
        return found ? "\"" + literalEscape(found) + "\"" : "end of input";
    }
    return "Expected " + describeExpected(expected) + " but " + describeFound(found) + " found.";
};
function $1d06acb41b6c7038$var$peg$parse(input, options) {
    options = options !== void 0 ? options : {};
    var peg$FAILED = {}, peg$startRuleIndices = {
        aqlStatement: 0
    }, peg$startRuleIndex = 0, peg$consts = [
        function(clause, orderby) {
            return {
                clause: clause,
                orderby: orderby
            };
        },
        function(orderby) {
            return orderby;
        },
        "order by",
        peg$literalExpectation("ORDER BY", true),
        function(primary, secondary) {
            return [
                primary,
                ...secondary
            ];
        },
        ",",
        peg$literalExpectation(",", false),
        function(clause) {
            return clause;
        },
        function(field, direction) {
            return {
                field: field,
                direction: direction
            };
        },
        "asc",
        peg$literalExpectation("ASC", true),
        "desc",
        peg$literalExpectation("DESC", true),
        function(clause, joined) {
            return {
                nodeType: 'clause',
                clauses: [
                    clause,
                    ...joined
                ],
                type: 'or'
            };
        },
        "or",
        peg$literalExpectation("OR", true),
        function(clause, joined) {
            return {
                nodeType: 'clause',
                clauses: [
                    clause,
                    ...joined
                ],
                type: 'and'
            };
        },
        "and",
        peg$literalExpectation("AND", true),
        function(haveNot, clause) {
            return {
                nodeType: 'clause',
                clause: clause,
                invert: !!haveNot
            };
        },
        function(expr) {
            return {
                nodeType: 'expr',
                ...expr
            };
        },
        "not ",
        peg$literalExpectation("NOT ", true),
        "!",
        peg$literalExpectation("!", false),
        function(field, op, value) {
            return {
                field: field,
                op: op,
                value: value
            };
        },
        function(field, op, value) {
            return {
                field: field,
                op: op,
                value: value
            };
        },
        "<",
        peg$literalExpectation("<", false),
        ">",
        peg$literalExpectation(">", false),
        "~",
        peg$literalExpectation("~", false),
        "!~",
        peg$literalExpectation("!~", false),
        "in",
        peg$literalExpectation("IN", true),
        function(haveNot) {
            return haveNot ? 'NOT IN' : 'IN';
        },
        "=",
        peg$literalExpectation("=", false),
        "!=",
        peg$literalExpectation("!=", false),
        function(v1, vremain) {
            return [
                v1,
                ...vremain
            ];
        },
        function(val) {
            return val;
        },
        ">=",
        peg$literalExpectation(">=", false),
        "<=",
        peg$literalExpectation("<=", false),
        function(n) {
            return Number.parseFloat(n);
        },
        "(",
        peg$literalExpectation("(", false),
        ")",
        peg$literalExpectation(")", false),
        function(funcName, params) {
            return `${funcName}(${(params || []).join(',')})`;
        },
        function(value, remaining) {
            return [
                value,
                ...remaining
            ];
        },
        function(value) {
            return value;
        },
        "'",
        peg$literalExpectation("'", false),
        "\\",
        peg$literalExpectation("\\", false),
        "\"",
        peg$literalExpectation("\"", false),
        ".",
        peg$literalExpectation(".", false),
        /^[^']/,
        peg$classExpectation([
            "'"
        ], true, false),
        function(val) {
            return val.join('');
        },
        /^[^"]/,
        peg$classExpectation([
            "\""
        ], true, false),
        function(val) {
            return val.join('.');
        },
        /^[0-9]/,
        peg$classExpectation([
            [
                "0",
                "9"
            ]
        ], false, false),
        /^[\\\-]/,
        peg$classExpectation([
            "\\",
            "-"
        ], false, false),
        function(rootIdentifier, indexedIdentifier) {
            return [
                rootIdentifier,
                ...indexedIdentifier
            ];
        },
        function(item) {
            return item;
        },
        /^[a-zA-Z_]/,
        peg$classExpectation([
            [
                "a",
                "z"
            ],
            [
                "A",
                "Z"
            ],
            "_"
        ], false, false),
        /^[a-zA-Z_0-9]/,
        peg$classExpectation([
            [
                "a",
                "z"
            ],
            [
                "A",
                "Z"
            ],
            "_",
            [
                "0",
                "9"
            ]
        ], false, false),
        function(firstLetter, remaining) {
            return firstLetter + remaining;
        },
        /^[eE]/,
        peg$classExpectation([
            "e",
            "E"
        ], false, false),
        /^[\-+]/,
        peg$classExpectation([
            "-",
            "+"
        ], false, false),
        /^[\t ]/,
        peg$classExpectation([
            "\t",
            " "
        ], false, false)
    ], peg$bytecode = [
        peg$decode("%;&/7#;!.\" &\"/)$8\": \"\"! )(\"'#&'#"),
        peg$decode("%;V/1#;\"/($8\":!\"! )(\"'#&'#"),
        peg$decode("%3\"\"\"5(7#/K#;V/B$;$/9$$;#0#*;#&/)$8$:$$\"! )($'#(#'#(\"'#&'#"),
        peg$decode("%2%\"\"6%7&/:#;W/1$;$/($8#:'#! )(#'#(\"'#&'#"),
        peg$decode("%;M/;#;V/2$;%/)$8#:(#\"\" )(#'#(\"'#&'#"),
        peg$decode("3)\"\"5#7*.) &3+\"\"5$7,"),
        peg$decode("%;(/9#$;'0#*;'&/)$8\":-\"\"! )(\"'#&'#"),
        peg$decode("%;V/I#3.\"\"5\"7//:$;V/1$;(/($8$:'$! )($'#(#'#(\"'#&'#"),
        peg$decode("%;+/9#$;)0#*;)&/)$8\":0\"\"! )(\"'#&'#"),
        peg$decode("%;V/I#31\"\"5#72/:$;V/1$;*/($8$:'$! )($'#(#'#(\"'#&'#"),
        peg$decode("%;,.\" &\"/2#;+/)$8\":3\"\"! )(\"'#&'#"),
        peg$decode("%;J/L#;W/C$;&/:$;W/1$;K/($8%:'%!\")(%'#($'#(#'#(\"'#&'#./ &%;-/' 8!:4!! )"),
        peg$decode("35\"\"5$76.) &27\"\"6778"),
        peg$decode(";..5 &;/./ &;1.) &;0.# &;2"),
        peg$decode("%;M/N#;W/E$;6/<$;W/3$;5/*$8%:9%#$\" )(%'#($'#(#'#(\"'#&'#"),
        peg$decode("%;M/N#;W/E$;7/<$;W/3$;9/*$8%:9%#$\" )(%'#($'#(#'#(\"'#&'#.X &%;M/N#;W/E$;8/<$;W/3$;=/*$8%:9%#$\" )(%'#($'#(#'#(\"'#&'#"),
        peg$decode("%;M/N#;W/E$;>/<$;W/3$;3/*$8%::%#$\" )(%'#($'#(#'#(\"'#&'#"),
        peg$decode("%;M/N#;W/E$;>/<$;W/3$;4/*$8%::%#$\" )(%'#($'#(#'#(\"'#&'#"),
        peg$decode("%;M/\\#2;\"\"6;7</M$;M/D$2=\"\"6=7>/5$;A/,$;@/#$+&)(&'#(%'#($'#(#'#(\"'#&'#"),
        peg$decode(";?.* &%;C/\"!&,)"),
        peg$decode("%;C/\"!&,).# &;B"),
        peg$decode(";M.# &;C"),
        peg$decode("2?\"\"6?7@.) &2A\"\"6A7B"),
        peg$decode("%;,.\" &\"/7#3C\"\"5\"7D/($8\":E\"!!)(\"'#&'#"),
        peg$decode("2F\"\"6F7G.) &2H\"\"6H7I"),
        peg$decode(";C.# &;:"),
        peg$decode("%;J/f#;W/]$;</T$;W/K$$;;0#*;;&/;$;W/2$;K/)$8':J'\"$\")(''#(&'#(%'#($'#(#'#(\"'#&'#"),
        peg$decode("%2%\"\"6%7&/J#$;V0#*;V&/:$;</1$;W/($8$:K$!!)($'#(#'#(\"'#&'#"),
        peg$decode(";C.# &;="),
        peg$decode(";C./ &;M.) &;P.# &;?"),
        peg$decode("2L\"\"6L7M.Y &2N\"\"6N7O.M &2=\"\"6=7>.A &2;\"\"6;7<.5 &2F\"\"6F7G.) &2H\"\"6H7I"),
        peg$decode("%;U/' 8!:P!! )"),
        peg$decode("%;7/:#;V.\" &\"/,$;9/#$+#)(#'#(\"'#&'#.\xB9 &%;8/:#;V.\" &\"/,$;=/#$+#)(#'#(\"'#&'#.\x92 &%;6/:#;V.\" &\"/,$;5/#$+#)(#'#(\"'#&'#.k &%;>/:#;V.\" &\"/,$;4/#$+#)(#'#(\"'#&'#.D &%;>/:#;V.\" &\"/,$;3/#$+#)(#'#(\"'#&'#"),
        peg$decode("%;I/,#;M/#$+\")(\"'#&'#"),
        peg$decode(";P.# &;M"),
        peg$decode("%;M/p#;W/g$2Q\"\"6Q7R/X$;W/O$;D.\" &\"/A$;W/8$2S\"\"6S7T/)$8':U'\"&\")(''#(&'#(%'#($'#(#'#(\"'#&'#"),
        peg$decode("%;=/9#$;E0#*;E&/)$8\":V\"\"! )(\"'#&'#"),
        peg$decode("%2%\"\"6%7&/:#;W/1$;=/($8#:W#! )(#'#(\"'#&'#"),
        peg$decode("2X\"\"6X7Y"),
        peg$decode("2Z\"\"6Z7["),
        peg$decode("2\\\"\"6\\7]"),
        peg$decode("2^\"\"6^7_"),
        peg$decode("2Q\"\"6Q7R"),
        peg$decode("2S\"\"6S7T"),
        peg$decode("%;G/,#;F/#$+\")(\"'#&'#.O &%;G/,#;G/#$+\")(\"'#&'#.6 &%;G/,#;H/#$+\")(\"'#&'#"),
        peg$decode("%;F/g#$%;L/\"!&,).) &4`\"\"5!7a06*%;L/\"!&,).) &4`\"\"5!7a&/1$;F/($8#:b#!!)(#'#(\"'#&'#.\x83 &%;H/g#$%;L/\"!&,).) &4c\"\"5!7d06*%;L/\"!&,).) &4c\"\"5!7d&/1$;H/($8#:b#!!)(#'#(\"'#&'#./ &%;Q/' 8!:e!! )"),
        peg$decode("4f\"\"5!7g"),
        peg$decode("%4h\"\"5!7i/\"!&,)"),
        peg$decode("%%;N/t#;N/k$;N/b$;N/Y$;O/P$;N/G$;N/>$;O/5$;N/,$;N/#$+*)(*'#()'#(('#(''#(&'#(%'#($'#(#'#(\"'#&'#/\"!&,)"),
        peg$decode("%;S/9#$;R0#*;R&/)$8\":j\"\"! )(\"'#&'#"),
        peg$decode("%;I/1#;S/($8\":k\"! )(\"'#&'#"),
        peg$decode("%4l\"\"5!7m/L#%$4n\"\"5!7o0)*4n\"\"5!7o&/\"!&,)/)$8\":p\"\"! )(\"'#&'#"),
        peg$decode("$4f\"\"5!7g/,#0)*4f\"\"5!7g&&&#"),
        peg$decode("%;T/\x98#%2^\"\"6^7_/?#$4f\"\"5!7g0)*4f\"\"5!7g&/#$+\")(\"'#&'#.\" &\"/^$%4q\"\"5!7r/@#4s\"\"5!7t.\" &\"/,$;T/#$+#)(#'#(\"'#&'#.\" &\"/#$+#)(#'#(\"'#&'#.} &%2^\"\"6^7_/g#;T/^$%4q\"\"5!7r/@#4s\"\"5!7t.\" &\"/,$;T/#$+#)(#'#(\"'#&'#.\" &\"/#$+#)(#'#(\"'#&'#.# &;T"),
        peg$decode("$4u\"\"5!7v/,#0)*4u\"\"5!7v&&&#"),
        peg$decode("$4u\"\"5!7v0)*4u\"\"5!7v&")
    ], peg$currPos = 0, peg$savedPos = 0, peg$posDetailsCache = [
        {
            line: 1,
            column: 1
        }
    ], peg$maxFailPos = 0, peg$maxFailExpected = [], peg$silentFails = 0, peg$result;
    if ("startRule" in options) {
        if (!(options.startRule in peg$startRuleIndices)) throw new Error("Can't start parsing from rule \"" + options.startRule + "\".");
        peg$startRuleIndex = peg$startRuleIndices[options.startRule];
    }
    function text() {
        return input.substring(peg$savedPos, peg$currPos);
    }
    function location() {
        return peg$computeLocation(peg$savedPos, peg$currPos);
    }
    function expected(description, location) {
        location = location !== void 0 ? location : peg$computeLocation(peg$savedPos, peg$currPos);
        throw peg$buildStructuredError([
            peg$otherExpectation(description)
        ], input.substring(peg$savedPos, peg$currPos), location);
    }
    function error(message, location) {
        location = location !== void 0 ? location : peg$computeLocation(peg$savedPos, peg$currPos);
        throw peg$buildSimpleError(message, location);
    }
    function peg$literalExpectation(text, ignoreCase) {
        return {
            type: "literal",
            text: text,
            ignoreCase: ignoreCase
        };
    }
    function peg$classExpectation(parts, inverted, ignoreCase) {
        return {
            type: "class",
            parts: parts,
            inverted: inverted,
            ignoreCase: ignoreCase
        };
    }
    function peg$anyExpectation() {
        return {
            type: "any"
        };
    }
    function peg$endExpectation() {
        return {
            type: "end"
        };
    }
    function peg$otherExpectation(description) {
        return {
            type: "other",
            description: description
        };
    }
    function peg$computePosDetails(pos) {
        var details = peg$posDetailsCache[pos], p;
        if (details) return details;
        else {
            p = pos - 1;
            while(!peg$posDetailsCache[p])p--;
            details = peg$posDetailsCache[p];
            details = {
                line: details.line,
                column: details.column
            };
            while(p < pos){
                if (input.charCodeAt(p) === 10) {
                    details.line++;
                    details.column = 1;
                } else details.column++;
                p++;
            }
            peg$posDetailsCache[pos] = details;
            return details;
        }
    }
    function peg$computeLocation(startPos, endPos) {
        var startPosDetails = peg$computePosDetails(startPos), endPosDetails = peg$computePosDetails(endPos);
        return {
            start: {
                offset: startPos,
                line: startPosDetails.line,
                column: startPosDetails.column
            },
            end: {
                offset: endPos,
                line: endPosDetails.line,
                column: endPosDetails.column
            }
        };
    }
    function peg$fail(expected) {
        if (peg$currPos < peg$maxFailPos) return;
        if (peg$currPos > peg$maxFailPos) {
            peg$maxFailPos = peg$currPos;
            peg$maxFailExpected = [];
        }
        peg$maxFailExpected.push(expected);
    }
    function peg$buildSimpleError(message, location) {
        return new $1d06acb41b6c7038$var$peg$SyntaxError(message, null, null, location);
    }
    function peg$buildStructuredError(expected, found, location) {
        return new $1d06acb41b6c7038$var$peg$SyntaxError($1d06acb41b6c7038$var$peg$SyntaxError.buildMessage(expected, found), expected, found, location);
    }
    function peg$decode(s) {
        var bc = new Array(s.length), i;
        for(i = 0; i < s.length; i++)bc[i] = s.charCodeAt(i) - 32;
        return bc;
    }
    function peg$parseRule(index) {
        var bc = peg$bytecode[index], ip = 0, ips = [], end = bc.length, ends = [], stack = [], params, i;
        while(true){
            while(ip < end)switch(bc[ip]){
                case 0:
                    stack.push(peg$consts[bc[ip + 1]]);
                    ip += 2;
                    break;
                case 1:
                    stack.push(void 0);
                    ip++;
                    break;
                case 2:
                    stack.push(null);
                    ip++;
                    break;
                case 3:
                    stack.push(peg$FAILED);
                    ip++;
                    break;
                case 4:
                    stack.push([]);
                    ip++;
                    break;
                case 5:
                    stack.push(peg$currPos);
                    ip++;
                    break;
                case 6:
                    stack.pop();
                    ip++;
                    break;
                case 7:
                    peg$currPos = stack.pop();
                    ip++;
                    break;
                case 8:
                    stack.length -= bc[ip + 1];
                    ip += 2;
                    break;
                case 9:
                    stack.splice(-2, 1);
                    ip++;
                    break;
                case 10:
                    stack[stack.length - 2].push(stack.pop());
                    ip++;
                    break;
                case 11:
                    stack.push(stack.splice(stack.length - bc[ip + 1], bc[ip + 1]));
                    ip += 2;
                    break;
                case 12:
                    stack.push(input.substring(stack.pop(), peg$currPos));
                    ip++;
                    break;
                case 13:
                    ends.push(end);
                    ips.push(ip + 3 + bc[ip + 1] + bc[ip + 2]);
                    if (stack[stack.length - 1]) {
                        end = ip + 3 + bc[ip + 1];
                        ip += 3;
                    } else {
                        end = ip + 3 + bc[ip + 1] + bc[ip + 2];
                        ip += 3 + bc[ip + 1];
                    }
                    break;
                case 14:
                    ends.push(end);
                    ips.push(ip + 3 + bc[ip + 1] + bc[ip + 2]);
                    if (stack[stack.length - 1] === peg$FAILED) {
                        end = ip + 3 + bc[ip + 1];
                        ip += 3;
                    } else {
                        end = ip + 3 + bc[ip + 1] + bc[ip + 2];
                        ip += 3 + bc[ip + 1];
                    }
                    break;
                case 15:
                    ends.push(end);
                    ips.push(ip + 3 + bc[ip + 1] + bc[ip + 2]);
                    if (stack[stack.length - 1] !== peg$FAILED) {
                        end = ip + 3 + bc[ip + 1];
                        ip += 3;
                    } else {
                        end = ip + 3 + bc[ip + 1] + bc[ip + 2];
                        ip += 3 + bc[ip + 1];
                    }
                    break;
                case 16:
                    if (stack[stack.length - 1] !== peg$FAILED) {
                        ends.push(end);
                        ips.push(ip);
                        end = ip + 2 + bc[ip + 1];
                        ip += 2;
                    } else ip += 2 + bc[ip + 1];
                    break;
                case 17:
                    ends.push(end);
                    ips.push(ip + 3 + bc[ip + 1] + bc[ip + 2]);
                    if (input.length > peg$currPos) {
                        end = ip + 3 + bc[ip + 1];
                        ip += 3;
                    } else {
                        end = ip + 3 + bc[ip + 1] + bc[ip + 2];
                        ip += 3 + bc[ip + 1];
                    }
                    break;
                case 18:
                    ends.push(end);
                    ips.push(ip + 4 + bc[ip + 2] + bc[ip + 3]);
                    if (input.substr(peg$currPos, peg$consts[bc[ip + 1]].length) === peg$consts[bc[ip + 1]]) {
                        end = ip + 4 + bc[ip + 2];
                        ip += 4;
                    } else {
                        end = ip + 4 + bc[ip + 2] + bc[ip + 3];
                        ip += 4 + bc[ip + 2];
                    }
                    break;
                case 19:
                    ends.push(end);
                    ips.push(ip + 4 + bc[ip + 2] + bc[ip + 3]);
                    if (input.substr(peg$currPos, peg$consts[bc[ip + 1]].length).toLowerCase() === peg$consts[bc[ip + 1]]) {
                        end = ip + 4 + bc[ip + 2];
                        ip += 4;
                    } else {
                        end = ip + 4 + bc[ip + 2] + bc[ip + 3];
                        ip += 4 + bc[ip + 2];
                    }
                    break;
                case 20:
                    ends.push(end);
                    ips.push(ip + 4 + bc[ip + 2] + bc[ip + 3]);
                    if (peg$consts[bc[ip + 1]].test(input.charAt(peg$currPos))) {
                        end = ip + 4 + bc[ip + 2];
                        ip += 4;
                    } else {
                        end = ip + 4 + bc[ip + 2] + bc[ip + 3];
                        ip += 4 + bc[ip + 2];
                    }
                    break;
                case 21:
                    stack.push(input.substr(peg$currPos, bc[ip + 1]));
                    peg$currPos += bc[ip + 1];
                    ip += 2;
                    break;
                case 22:
                    stack.push(peg$consts[bc[ip + 1]]);
                    peg$currPos += peg$consts[bc[ip + 1]].length;
                    ip += 2;
                    break;
                case 23:
                    stack.push(peg$FAILED);
                    if (peg$silentFails === 0) peg$fail(peg$consts[bc[ip + 1]]);
                    ip += 2;
                    break;
                case 24:
                    peg$savedPos = stack[stack.length - 1 - bc[ip + 1]];
                    ip += 2;
                    break;
                case 25:
                    peg$savedPos = peg$currPos;
                    ip++;
                    break;
                case 26:
                    params = bc.slice(ip + 4, ip + 4 + bc[ip + 3]);
                    for(i = 0; i < bc[ip + 3]; i++)params[i] = stack[stack.length - 1 - params[i]];
                    stack.splice(stack.length - bc[ip + 2], bc[ip + 2], peg$consts[bc[ip + 1]].apply(null, params));
                    ip += 4 + bc[ip + 3];
                    break;
                case 27:
                    stack.push(peg$parseRule(bc[ip + 1]));
                    ip += 2;
                    break;
                case 28:
                    peg$silentFails++;
                    ip++;
                    break;
                case 29:
                    peg$silentFails--;
                    ip++;
                    break;
                default:
                    throw new Error("Invalid opcode: " + bc[ip] + ".");
            }
            if (ends.length > 0) {
                end = ends.pop();
                ip = ips.pop();
            } else break;
        }
        return stack[0];
    }
    peg$result = peg$parseRule(peg$startRuleIndex);
    if (peg$result !== peg$FAILED && peg$currPos === input.length) return peg$result;
    else {
        if (peg$result !== peg$FAILED && peg$currPos < input.length) peg$fail(peg$endExpectation());
        throw peg$buildStructuredError(peg$maxFailExpected, peg$maxFailPos < input.length ? input.charAt(peg$maxFailPos) : null, peg$maxFailPos < input.length ? peg$computeLocation(peg$maxFailPos, peg$maxFailPos + 1) : peg$computeLocation(peg$maxFailPos, peg$maxFailPos));
    }
}
$1d06acb41b6c7038$exports = {
    SyntaxError: $1d06acb41b6c7038$var$peg$SyntaxError,
    parse: $1d06acb41b6c7038$var$peg$parse
};



const $be58797972986c91$export$96e6fc3a139b2555 = (text)=>text.replace(/\\/g, '\\\\').replace(/"/g, '\\"');
const $be58797972986c91$export$2c4c4d2119dc396f = (value)=>value === 'currentSpace()' ? value : `"${$be58797972986c91$export$96e6fc3a139b2555(value.toString())}"`;
const $be58797972986c91$export$ac8a9eb5c5a129c4 = (content)=>{
    const exprs = [];
    // content is an object with key/value pairs
    // we first convert it array and filter out undefined/null
    // if content is array, we convert each object in array to tuple array of [key, value]
    const arr = Object.entries(content).filter((entry)=>entry[1]);
    exprs.push(...arr.map((entry)=>{
        // eslint-disable-next-line prefer-const
        let [key, value] = entry;
        const definition = (0, $2f69ce15c0bd4ea6$export$f977989607a3df34)[key];
        const cqlKey = definition.key || key;
        let cqlValue;
        let cqlOp = '=';
        // use a different operator for this field?
        // e.g. a text field might want to use ~
        if (definition && definition.op) cqlOp = definition.op;
        // flatten singular arrays to scalar
        if (Array.isArray(value) && value.length === 1) value = value[0];
        // construct the value expression
        if (Array.isArray(value)) {
            cqlValue = `(${value.map($be58797972986c91$export$2c4c4d2119dc396f).join(', ')})`;
            cqlOp = 'IN';
        } else if (typeof value === 'number') // we don't have any number cql fields as of yet, but just in case
        cqlValue = value.toString();
        else cqlValue = $be58797972986c91$export$2c4c4d2119dc396f(value.toString());
        return `${cqlKey} ${cqlOp} ${cqlValue}`;
    }));
    return exprs.join(' AND ');
};
// walks the parse tree and finds expressions
// it also ensures we only have AND queries
function* $be58797972986c91$var$collectExpr(node) {
    if (node.clause) yield* $be58797972986c91$var$collectExpr(node.clause);
    if (node.clauses) {
        if (node.type.toUpperCase() === 'OR' && node.clauses.length !== 1) throw new SyntaxError('cannot handle multiple OR clauses');
        for (const subclause of node.clauses)yield* $be58797972986c91$var$collectExpr(subclause);
    }
    if (node.nodeType === 'expr') yield node;
}
const $be58797972986c91$export$7b88d2983fb8d650 = (value)=>{
    if (value === null || typeof value === 'undefined') return {};
    // try to parse CQL and pull only expressions out of the AST
    const parsed = (0, $1d06acb41b6c7038$exports.parse)(value);
    const exprs = Array.from($be58797972986c91$var$collectExpr(parsed));
    // create an object from the set of expressions
    const deserializedCQL = {};
    exprs.forEach((expr)=>{
        deserializedCQL[expr.field] = expr.value;
    });
    return deserializedCQL;
};


const $c1e526d8b8327452$var$userSearchQuery = // eslint-disable-next-line graphql-relay-compat/consistent-graphql-operation-naming -- Read https://go/connie-relay-migration-fyi
(0, $eSUdr.default)`query UserSearchQuery($cql:String!){searchUser:confluence_searchUser(cql:$cql first:25 sitePermissionTypeFilter:"all"){edges{node{user:confluencePerson{displayName accountId profilePicture{path}}}}}}`;
const $c1e526d8b8327452$var$getQueryTerm = (term)=>{
    // query term looks like this: "type = user AND (user.fullname ~ \"bob*\" OR user = \"bob\")"
    return `type = user AND (user.fullname ~ "${term}*" OR user = "${term}")`;
};
const $c1e526d8b8327452$var$search = async (cql)=>{
    const client = (0, $hp2SH.getApolloClient)();
    // eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- Read http://go/cfe-no-direct-apollo-query-and-mutation-operations
    const res = await client.query({
        query: $c1e526d8b8327452$var$userSearchQuery,
        variables: {
            cql: cql
        }
    });
    return res.data.searchUser.edges.map((edge)=>({
            label: edge.node.user.displayName,
            value: edge.node.user.accountId,
            icon: edge.node.user.profilePicture.path
        }));
};
const $c1e526d8b8327452$export$63f9bb9a5820f1bc = async (searchTerm, selectedValue)=>{
    const searchers = [];
    if (searchTerm) searchers.push($c1e526d8b8327452$var$search($c1e526d8b8327452$var$getQueryTerm(searchTerm)));
    if (selectedValue) {
        if (Array.isArray(selectedValue)) // if values are in array, concat the items into one search phrase
        // e.g if array is ["sponge", "bob"], query term is: "user IN ( \"sponge\", \"bob\")"
        searchers.push($c1e526d8b8327452$var$search(`user IN (${selectedValue.map((val)=>`"${(0, $be58797972986c91$export$96e6fc3a139b2555)(val)}"`).join(', ')})`));
        else // if not an array just pass in the term as selected val
        searchers.push($c1e526d8b8327452$var$search($c1e526d8b8327452$var$getQueryTerm(selectedValue)));
    }
    return (await Promise.all(searchers)).flat();
};



var $kTVK2 = parcelRequire("kTVK2");

const $6ec8fb0cb8d57c0c$export$1bb3f7145befbf14 = (intl)=>async (searchTerm, selectedValue)=>{
        const items = [
            {
                label: intl.formatMessage((0, $kTVK2.i18nWidth).fullLabel),
                value: '100%'
            },
            {
                label: intl.formatMessage((0, $kTVK2.i18nWidth).threeQuartersLabel),
                value: '75%'
            },
            {
                label: intl.formatMessage((0, $kTVK2.i18nWidth).halfLabel),
                value: '50%'
            },
            {
                label: intl.formatMessage((0, $kTVK2.i18nWidth).quarterLabel),
                value: '25%'
            }
        ];
        // Add the current input value if it is not one of the predefined options
        // This is necessary to allow values beyond the predefined ones. (i.e. "90%")
        if (selectedValue && typeof selectedValue === 'string' && !Object.values(items).map((item)=>item.value).includes(selectedValue)) items.push({
            label: selectedValue,
            value: selectedValue
        });
        if (searchTerm) return Promise.resolve(items.filter((item)=>item.value.indexOf(searchTerm) !== -1));
        return Promise.resolve(items);
    };



const $0772041b1b3e00cb$var$i18n = (0, $cgtv4.defineMessages)({
    deprecatedMacroDescription: {
        id: "fabric-extension-lib.deprecation.description",
        defaultMessage: "This macro has been deprecated. <alink>Find out more about this change</alink>"
    },
    configValuePrefixRequired: {
        id: "fabric-extension-lib.config-value-prefix.required",
        defaultMessage: "{fieldValue} (required)"
    },
    configValuePrefixExcluded: {
        id: "fabric-extension-lib.config-value-prefix.excluded",
        defaultMessage: "{fieldValue} (excluded)"
    }
});
const $0772041b1b3e00cb$var$PLUS_MINUS_PREFIX_SETTINGS = (intl)=>[
        {
            prefix: '+',
            labelFunc: (labelExcludingPrefix)=>intl.formatMessage($0772041b1b3e00cb$var$i18n.configValuePrefixRequired, {
                    fieldValue: labelExcludingPrefix
                })
        },
        {
            prefix: '-',
            labelFunc: (labelExcludingPrefix)=>intl.formatMessage($0772041b1b3e00cb$var$i18n.configValuePrefixExcluded, {
                    fieldValue: labelExcludingPrefix
                })
        }
    ];
// We downloaded the extension manifest
// earlier within query-preloaders
// the resulting manifest is cached
const $0772041b1b3e00cb$var$getMacroLegacyManifest = (0, $9fLxI.getExtensionManifest);
const $0772041b1b3e00cb$export$a3cca4b25908b904 = (macro)=>{
    // TODO: remove this code when cleaning up deprecating_low_usage_macros FG after macro removal on Sep 25 2025
    if ((0, $cV0On.DEPRECATED_MACROS).includes(macro.macroName)) return {
        isDeprecated: true,
        message: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            weight: "medium"
        }, "\u26A0\uFE0F\xa0", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
            ...$0772041b1b3e00cb$var$i18n.deprecatedMacroDescription,
            values: {
                alink: (...chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
                        href: (0, $cV0On.MACRO_DEPRECATION_INFO_URL),
                        target: "_blank"
                    }, chunks)
            }
        }))
    };
    return undefined;
};
const $0772041b1b3e00cb$var$mapLegacyManifestsToModernManifest = async (legacyMacros, pageContext, extensionHandlers, getMigrationExtensionManifest, openMacroBrowserToEditExistingMacro, openMacroBrowserForInitialConfiguration, editorAPI, intl, macroBrowserConfig, editorActions, createAnalyticsEvent, onCompleteCallback, isLivePage, flags, allowLegacyMacros = false, isLivePagesFeatureEnabled)=>{
    const isAllowed = (0, $6OgRG.isAllowedWithFeatureFlags)();
    return legacyMacros.map((macro)=>{
        const manifest = $0772041b1b3e00cb$export$42915e364448bf43((0, $8pcS0.EXTENSION_TYPE).MACRO_CORE, macro, pageContext, extensionHandlers, !isAllowed(macro), openMacroBrowserToEditExistingMacro, openMacroBrowserForInitialConfiguration, editorAPI, intl, macroBrowserConfig, editorActions, createAnalyticsEvent, onCompleteCallback, isLivePage, allowLegacyMacros, isLivePagesFeatureEnabled);
        return manifest;
    }).concat(getMigrationExtensionManifest(pageContext.contentId, !!editorActions, intl, flags, createAnalyticsEvent));
};
const $0772041b1b3e00cb$export$42915e364448bf43 = (extensionType, macro, pageContext, extensionHandlers, readonly, openMacroBrowserToEditExistingMacro, openMacroBrowserForInitialConfiguration, editorAPI, intl, macroBrowserConfig, editorActions, createAnalyticsEvent, onCompleteCallback, isLivePage, allowLegacyMacros = false, isLivePagesFeatureEnabled)=>{
    const extensionKey = macro.macroName;
    let renderCache = null;
    const isEditor = !!editorActions;
    const { enabled: isConfigPanelEnabled, optedOut: excludedMacros } = pageContext.features.configPanel || {};
    const adfNodeType = (0, $eQyFc.getExtensionBodyType)(macro);
    // Override title & description in manifest for certain macros in Fabric editor only
    const macroOverrides = {
        title: (0, $aMlgD.getMacroTitleOverride)(extensionKey, intl, isLivePagesFeatureEnabled) ?? macro.title,
        description: (0, $aMlgD.getMacroDescriptionOverride)(extensionKey, intl, isLivePagesFeatureEnabled) ?? macro.description
    };
    macro = {
        ...macro,
        ...macroOverrides
    };
    const defaultNode = {
        type: adfNodeType,
        render: ()=>{
            const extensionHandler = extensionHandlers[extensionType];
            return Promise.resolve((extension)=>{
                // per backend restrictions, spaceKey and templateName are required in the extension's macroParams object in order for create-from-template macro to work for autogenerated blueprint index pages.
                if (extension.node.extensionKey === 'create-from-template') {
                    const macroParams = extension.node.parameters?.['macroParams'];
                    if (!macroParams?.spaceKey) macroParams.spaceKey = {
                        value: pageContext.spaceKey
                    };
                    if (!macroParams?.templateName) macroParams.templateName = macroParams.contentBlueprintId;
                }
                // if an override is provided for title, update the title for extension label lozenge component
                // This is necessary to update existing macros on a page after a title change rolls out
                if (isEditor && extension.node.parameters.macroMetadata && macroOverrides?.title) extension.node.parameters.macroMetadata.title = macroOverrides.title;
                const showPlaceholder = (0, $eQyFc.shouldShowPlaceholder)(macro, excludedMacros, extension.node, isEditor);
                if ((isConfigPanelEnabled || !isEditor) && showPlaceholder) return (0, $9tVje.getMissingConfigPlaceholderComponent)(macro, extension.node, isEditor);
                if (isConfigPanelEnabled && isEditor && !(0, $eQyFc.canRenderInTheEditor)(macro)) return (0, $9tVje.getNonRenderablePlaceholderComponent)(macro, (0, $eQyFc.getExtensionBodyType)(macro), isLivePage);
                if (typeof extensionHandler === 'function') return extensionHandler(extension.node, {
                    references: extension.references,
                    actions: extension.actions
                });
                return extensionHandler.render(extension.node, {
                    references: extension.references,
                    actions: extension.actions
                });
            });
        },
        renderSync () {
            return renderCache;
        },
        async preloadRender () {
            // Extension provider's preload function will loop through all nodes and call this function
            // See platform/packages/editor/editor-common/src/extensions/default-extension-provider.ts
            renderCache = await this.render();
        }
    };
    const allowEdit = allowLegacyMacros || !readonly;
    if (allowEdit && ((0, $eQyFc.getVisibleParameters)(macro).length > 0 || (0, $eQyFc.shouldUseMacroBrowser)(macro, excludedMacros))) {
        const editInMacroBrowser = async (data, actions)=>{
            let selectedNode;
            /**
       * In API v1, we used to pass the whole `node` as `parameters`.
       * We fixed it in API v2 and now only passing `parameters`.
       * But Bodied Extensions inside Macro Browser still need the body for preview.
       * @see DEVHELP-6152
       */ if ((0, $fgbpl.isBodiedExtension)(adfNodeType)) // Currently, there's no other way to get selected node without using private API.
            selectedNode = (0, $2E7zk.getSelectedBodiedExtensionNode)(editorActions);
            const currentNode = await (0, $eQyFc.prepareMacro)({
                name: macro.macroName,
                params: (0, $6mEZ3.unwrapMacroParams)(data.macroParams)
            }, pageContext.contentId, selectedNode, intl, isLivePagesFeatureEnabled);
            const defaultParameterValue = (0, $6mEZ3.getDefaultParamValue)(data.macroParams || {});
            if (defaultParameterValue) {
                const macroParams = currentNode.attrs?.parameters?.macroParams;
                if (macroParams) macroParams[''] = defaultParameterValue;
            }
            const macroFilter = undefined;
            const extensionAnalyticsInfo = {
                createAnalyticsEvent: createAnalyticsEvent,
                contentId: pageContext.contentId
            };
            const updateMacro = (newNode)=>{
                selectedNode = (0, $2E7zk.getSelectedBodiedExtensionNode)(editorActions);
                actions.doc.update(selectedNode?.attrs?.localId, ()=>({
                        attrs: newNode.attrs,
                        marks: newNode.marks,
                        content: newNode.content
                    }));
            };
            const newNode = await openMacroBrowserToEditExistingMacro(currentNode, macroBrowserConfig, macroFilter, extensionAnalyticsInfo, updateMacro, intl, isLivePagesFeatureEnabled);
            // For bodiedExtension we should update the content
            if ((0, $fgbpl.isBodiedExtension)(adfNodeType) && actions?.doc?.update) {
                actions.doc.update(selectedNode?.attrs?.localId, ()=>({
                        attrs: newNode.attrs,
                        marks: newNode.marks,
                        content: newNode.content
                    }));
                return;
            }
            return newNode.attrs.parameters || {};
        };
        let params;
        if (!(0, $cV0On.isMacroDeprecated)(extensionKey)) defaultNode.update = async (data, actions)=>{
            // The adf parameters for macros look like:
            // {
            //    macroParams: {
            //        q: {value: 1},
            //        search: {value: 'my keyword'}
            //    },
            //    macroMetadata: {}
            // }
            // The only editable bit is what is inside the `macroParams`. This method unwraps the params and pass it to
            // the context panel for editing, and then wraps it back after saving.
            const transformBefore = (parameters)=>{
                params = (0, $6mEZ3.unwrapMacroParams)(parameters.macroParams);
                return (0, $e7owm.transformParams)('transformBefore', macro, params, pageContext, createAnalyticsEvent);
            };
            const transformAfter = async (initialParameters)=>{
                const parameters = (0, $e7owm.transformParams)('transformAfter', macro, initialParameters, pageContext, createAnalyticsEvent);
                // macros might have metadata changed based on macroParams so we need to fetch again. The rule changes on
                // each of them so we can't do it client side.
                const macroDefinition = {
                    name: macro.macroName,
                    params: parameters
                };
                const defaultParameterValue = (0, $6mEZ3.getDefaultParamValue)(parameters);
                if (defaultParameterValue) macroDefinition.defaultParameterValue = defaultParameterValue;
                const node = await (0, $eQyFc.prepareMacro)(macroDefinition, pageContext.contentId, null, intl, isLivePagesFeatureEnabled);
                // add a new macroId if we don't already have one
                if (node.attrs.parameters) {
                    if (!node.attrs.parameters.macroMetadata) node.attrs.parameters.macroMetadata = {};
                    if (!node.attrs.parameters.macroMetadata['macroId']) node.attrs.parameters.macroMetadata['macroId'] = {
                        value: (0, $9Cbhx.getMacroId)(node.attrs.parameters)
                    };
                }
                return node.attrs.parameters || {};
            };
            if (!isConfigPanelEnabled || (0, $eQyFc.shouldUseMacroBrowser)(macro, excludedMacros)) return editInMacroBrowser(data, actions);
            return actions.editInContextPanel(transformBefore, transformAfter);
        };
        if ((0, $eQyFc.getVisibleParameters)(macro).length > 0) defaultNode.getFieldsDefinition = ()=>{
            const fields = macro.formDetails.parameters.map((params)=>(0, $38eecb7cd02ce24e$export$f5f12fd2c8b33ce0)(params, {
                    pluginKey: macro.pluginKey,
                    macroName: (0, $eQyFc.safeGetMacroName)(macro)
                }));
            return (0, $e7owm.remapCustomFields)(macro, fields, pageContext, intl, params, createAnalyticsEvent, isLivePage, isLivePagesFeatureEnabled);
        };
    }
    return {
        type: extensionType,
        key: extensionKey,
        title: macro.title,
        description: macro.description,
        deprecation: $0772041b1b3e00cb$export$a3cca4b25908b904(macro),
        icons: (0, $eQyFc.buildIconObject)(macro),
        documentationUrl: macro.formDetails.documentationUrl || undefined,
        modules: {
            quickInsert: !readonly && !(0, $cV0On.isMacroDeprecated)(extensionKey) && editorActions && (0, $Qcu7n.shouldIncludeMacroInQuickInsert)(extensionKey) ? (0, $2E7zk.createQuickInsertModule)(macro, pageContext, openMacroBrowserForInitialConfiguration, editorAPI, intl, macroBrowserConfig, editorActions, createAnalyticsEvent, onCompleteCallback, isLivePage, isLivePagesFeatureEnabled) : [],
            nodes: {
                default: defaultNode
            },
            fields: {
                custom: {
                    attachment: {
                        resolver: (0, $f5981546cd91a250$export$98306171982e2202)(macro, pageContext)
                    },
                    spacekey: {
                        resolver: (0, $0a9a42b243ec1ac9$export$bab0f33d6337c008)(macro)
                    },
                    username: {
                        resolver: (0, $c1e526d8b8327452$export$63f9bb9a5820f1bc)
                    },
                    label: {
                        resolver: (0, $132842a839e22041$export$a821dfb2c4620119)
                    },
                    labelWithPlusMinusPrefixes: {
                        resolver: (0, $2fdd0370d00b842a$export$4172796c9e33488c)({
                            resolver: (0, $132842a839e22041$export$a821dfb2c4620119),
                            prefixSettings: $0772041b1b3e00cb$var$PLUS_MINUS_PREFIX_SETTINGS(intl)
                        })
                    },
                    'confluence-content-by-id': {
                        resolver: (0, $24ca4725cd610b37$export$41173a2c419f6dfc)
                    },
                    'confluence-content': {
                        resolver: (0, $8540ddfe85cd4073$export$3f7da36354f8b724)((0, $3b8b016da39bc505$export$ddc3fcea26200983)())
                    },
                    spaceAndPage: {
                        resolver: (0, $10e93d065b18a316$export$ed8020fd2c03836f)
                    },
                    spaceKeyAndPageTitleContent: {
                        resolver: (0, $3b8b016da39bc505$export$ddc3fcea26200983)()
                    },
                    rootPage: {
                        resolver: (0, $ca514041a0cedbe0$export$1766a89a46ff2e41)({
                            resolver: (0, $3b8b016da39bc505$export$ddc3fcea26200983)(),
                            values: [
                                '@self',
                                '@home',
                                '@parent',
                                '@none'
                            ]
                        })
                    },
                    calendar: {
                        resolver: (0, $99dfcbe48c719a87$export$79a154fc3ca3f9ae)
                    },
                    template: {
                        resolver: (0, $gw2T1.getTemplateResolver)(pageContext)
                    },
                    blogRecentlyUpdatedSpace: {
                        resolver: (0, $ca514041a0cedbe0$export$1766a89a46ff2e41)({
                            /* recently updated macro doesn't support currentSpace() */ resolver: (0, $0a9a42b243ec1ac9$export$534da981b85f5d27)(false),
                            values: [
                                '@self',
                                '@personal',
                                '@global',
                                '@favorite',
                                '@favourite',
                                '@all',
                                '*'
                            ]
                        })
                    },
                    blogRecentlyUpdatedSpaceWithPlusMinusPrefixes: {
                        resolver: (0, $ca514041a0cedbe0$export$1766a89a46ff2e41)({
                            /* blog posts macro doesn't support currentSpace() */ resolver: (0, $2fdd0370d00b842a$export$4172796c9e33488c)({
                                /* blog posts macro needs support for requiring or excluding spaces with "+" or "-" prefixes.*/ resolver: (0, $0a9a42b243ec1ac9$export$534da981b85f5d27)(false),
                                prefixSettings: $0772041b1b3e00cb$var$PLUS_MINUS_PREFIX_SETTINGS(intl)
                            }),
                            values: [
                                '@self',
                                '@personal',
                                '@global',
                                '@favorite',
                                '@favourite',
                                '@all',
                                '*'
                            ]
                        })
                    },
                    contributorsSpaceParamResolver: {
                        resolver: (0, $ca514041a0cedbe0$export$1766a89a46ff2e41)({
                            resolver: (0, $0a9a42b243ec1ac9$export$534da981b85f5d27)(false),
                            values: [
                                '@personal',
                                '@global',
                                '@all'
                            ]
                        })
                    },
                    recentlyUpdatedDashboardSpaceKeyResolver: {
                        resolver: (0, $ca514041a0cedbe0$export$1766a89a46ff2e41)({
                            resolver: (0, $0a9a42b243ec1ac9$export$534da981b85f5d27)(false),
                            values: [
                                '*'
                            ]
                        })
                    },
                    widthPercentage: {
                        resolver: (0, $6ec8fb0cb8d57c0c$export$1bb3f7145befbf14)(intl)
                    }
                },
                fieldset: {
                    cql: {
                        serializer: (0, $be58797972986c91$export$ac8a9eb5c5a129c4),
                        deserializer: (0, $be58797972986c91$export$7b88d2983fb8d650)
                    }
                }
            }
        }
    };
};


const $0772041b1b3e00cb$export$1afad384655af93f = async (pageContext, extensionHandlers, editorAPI, editorActions, macroBrowserConfig, getMigrationExtensionManifest, openMacroBrowserToEditExistingMacro, openMacroBrowserForInitialConfiguration, intl, createAnalyticsEvent, onCompleteCallback, isLivePage, flags, experienceTracker, contentType, allowCreateDatabaseExtension = false, allowDatabaseQuickInsert = false, allowCreateWhiteboardExtension = false, allowLegacyMacros = false, isLivePagesFeatureEnabled, isCompanyHub, pageTreeStateUpdater)=>{
    const [legacyManifests, macroAutoConverters] = await Promise.all([
        $0772041b1b3e00cb$var$getMacroLegacyManifest(pageContext),
        (0, $3IXUB.getAutoConverter)(macroBrowserConfig)
    ]);
    // Block unsupported 1p macro insertion if we're in the Company Hub,
    // the company-hub-migration-prevent-1p-macro experiment is enabled,
    // and the company-hub-prevent-1p-macro-via-tap-trait gate returns false.
    // company-hub-prevent-1p-macro-via-tap-trait is controlled by a tap trait that checks if a tenant's company hub
    // has been published with unsupported 1p macros in the last 4 months,
    // in which case we will allow them to insert unsupported 1p macros.
    const hideMacrosOptions = {
        isLivePage: isLivePage,
        isCompanyHub: isCompanyHub && (0, $6mKj3.expVal)('company-hub-migration-prevent-1p-macro', 'isEnabled', false) && !(0, $9wGTI.fg)('company-hub-prevent-1p-macro-via-tap-trait')
    };
    const legacyManifestMacros = (0, $2E7zk.filterOutHiddenMacros)(legacyManifests.macros, hideMacrosOptions);
    let modernManifests = await $0772041b1b3e00cb$var$mapLegacyManifestsToModernManifest(legacyManifestMacros, pageContext, extensionHandlers, getMigrationExtensionManifest, openMacroBrowserToEditExistingMacro, openMacroBrowserForInitialConfiguration, editorAPI, intl, macroBrowserConfig, editorActions, createAnalyticsEvent, onCompleteCallback, isLivePage, flags, allowLegacyMacros, isLivePagesFeatureEnabled);
    if ((0, $9wGTI.fg)('cq_native_macro')) {
        const nativeManifest = modernManifests.find((m)=>m.key === 'questionslist-macro-native');
        const connectManifest = modernManifests.find((m)=>m.key === 'questionslist-macro');
        if (nativeManifest) {
            if (connectManifest) modernManifests = modernManifests.filter((m)=>m.key !== 'questionslist-macro');
            // Keep the native manifest (for new macros)
            // Add hijacked manifest (for existing Connect macros)
            // This creates TWO manifests:
            // 1. 'questionslist-macro-native' -> for new macros created via /questions
            // 2. 'questionslist-macro' -> for existing Connect macros in documents
            const hijackedManifest = {
                ...nativeManifest,
                key: 'questionslist-macro' // Use Connect key for existing macro lookups
            };
            modernManifests.push(hijackedManifest);
        }
    } else {
        const nativeManifest = modernManifests.find((m)=>m.key === 'questionslist-macro-native');
        if (nativeManifest) modernManifests = modernManifests.filter((m)=>m.key !== 'questionslist-macro-native');
    }
    modernManifests = modernManifests.filter((manifest)=>manifest.key !== 'toc');
    const macro = legacyManifestMacros.find((m)=>m.macroName === 'toc');
    const { tableOfContentsExtension: tableOfContentsExtension } = await (parcelRequire("apZnX"));
    const createTableOfContentsExtension = tableOfContentsExtension({
        macro: macro,
        pageContext: pageContext,
        extensionHandlers: extensionHandlers,
        editorAPI: editorAPI,
        openMacroBrowserForInitialConfiguration: openMacroBrowserForInitialConfiguration,
        macroBrowserConfig: macroBrowserConfig,
        editorActions: editorActions,
        createAnalyticsEvent: createAnalyticsEvent,
        intl: intl,
        onCompleteCallback: onCompleteCallback,
        isLivePage: isLivePage
    });
    modernManifests.push(createTableOfContentsExtension);
    const { redactionExtension: redactionExtension } = await (parcelRequire("eKQ2A"));
    if ((0, $9wGTI.fg)('confluence_dlp_content_redaction')) {
        if ((0, $9wGTI.fg)('dlp_cc-redactions-tour')) modernManifests.push((0, $cOau5.createTourableRedactionExtension)({
            contentId: pageContext?.contentId
        }));
        else modernManifests.push(redactionExtension());
    }
    modernManifests.push((0, $fd320ef48aed12ed$export$8e57f4d7d2152080));
    if (allowCreateDatabaseExtension) modernManifests.push((0, $ccP7J.createDatabaseExtension)({
        pageId: pageContext.contentId,
        spaceKey: pageContext.spaceKey,
        spaceId: pageContext.spaceId,
        intl: intl,
        flags: flags,
        createAnalyticsEvent: createAnalyticsEvent,
        experienceTracker: experienceTracker,
        contentType: contentType,
        allowDatabaseQuickInsert: allowDatabaseQuickInsert && !(0, $9wGTI.fg)('confluence_frontend_databases_opt-out'),
        isEdit: true,
        pageTreeStateUpdater: pageTreeStateUpdater
    }));
    if (allowCreateWhiteboardExtension && pageContext.spaceId && pageContext.spaceKey && (0, $6mKj3.expVal)('create_whiteboard_via_slash_command', 'enabled', false)) modernManifests.push((0, $e34976de7a15a4c3$export$f5b268b2504551e9)({
        pageId: pageContext.contentId,
        spaceKey: pageContext.spaceKey,
        spaceId: pageContext.spaceId,
        intl: intl,
        flags: flags,
        experienceTracker: experienceTracker,
        createAnalyticsEvent: createAnalyticsEvent,
        contentType: contentType,
        allowWhiteboardQuickInsert: allowCreateWhiteboardExtension,
        pageTreeStateUpdater: pageTreeStateUpdater
    }));
    return new (0, $bre0g.default)(modernManifests, [
        (link)=>{
            const result = macroAutoConverters(link);
            if (result) return result;
        }
    ]);
};

const $0772041b1b3e00cb$export$eeaf69e6b00b13ad = async (pageContext, extensionHandlers, getMigrationExtensionManifest, openMacroBrowserToEditExistingMacro, openMacroBrowserForInitialConfiguration, intl, createAnalyticsEvent, providerFactory, isLivePagesFeatureEnabled)=>{
    const chartsExtensionPromise = (0, $fPsyy.createChartsExtension)({
        // TODO: use intl5 instead
        intl: intl,
        extensionHandlers: extensionHandlers[(0, $8pcS0.EXTENSION_TYPE).MACRO_WITH_REFERENCES],
        createAnalyticsEvent: createAnalyticsEvent
    });
    const legacyManifests = await $0772041b1b3e00cb$var$getMacroLegacyManifest(pageContext);
    let modernManifests = await $0772041b1b3e00cb$var$mapLegacyManifestsToModernManifest(legacyManifests.macros, pageContext, extensionHandlers, getMigrationExtensionManifest, openMacroBrowserToEditExistingMacro, openMacroBrowserForInitialConfiguration, // We don't have the `editorAPI` for the renderer
    undefined, intl, undefined, undefined, undefined, undefined, undefined, undefined, undefined, isLivePagesFeatureEnabled // Need this for macro naming overrides for placeholders in renderer
    );
    modernManifests.push((0, $7a29776dd6927980$export$eb802fdec29ee1cc)(extensionHandlers));
    if (chartsExtensionPromise) modernManifests.push(await chartsExtensionPromise);
    // We don't want to check for the aiOptInStatus as we want to show the rendered block
    // regardless of AI status so we don't lose content if people downgrade etc
    const aiBlockProvider = await (0, $c98f3a85236f8fc0$export$34ea67e5ccaac92)({
        intl: intl,
        providerFactory: providerFactory
    });
    modernManifests.push(...await aiBlockProvider.getExtensions());
    const { contentId: contentId } = pageContext;
    modernManifests.push(...await (0, $gH8jv.createPremiumExtensionManifests)({
        contentId: contentId,
        intl: intl,
        allowCompanyHubExclusiveExtensions: true
    }));
    modernManifests.push((0, $ccP7J.createDatabaseExtension)({
        pageId: contentId,
        spaceKey: pageContext.spaceKey,
        spaceId: pageContext.spaceId,
        intl: intl,
        createAnalyticsEvent: createAnalyticsEvent,
        isEdit: false
    }));
    const { redactionExtension: redactionExtension } = await (parcelRequire("eKQ2A"));
    if ((0, $9wGTI.fg)('confluence_dlp_content_redaction')) {
        if ((0, $9wGTI.fg)('dlp_cc-redactions-tour')) modernManifests.push((0, $cOau5.createTourableRedactionExtension)({
            contentId: contentId
        }));
        else modernManifests.push(redactionExtension());
    }
    modernManifests.push((0, $fd320ef48aed12ed$export$8e57f4d7d2152080));
    return new (0, $bre0g.default)(modernManifests);
};
module.exports["getConfluenceMacrosExtensionProviderForEditor"] = $0772041b1b3e00cb$export$1afad384655af93f;
module.exports["getConfluenceMacrosExtensionProviderForRenderer"] = $0772041b1b3e00cb$export$eeaf69e6b00b13ad;

});

parcelRegister("fSxYU", function(module, exports) {

let $b8f6422d7c09d941$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b8f6422d7c09d941$var$load("3XbzG").then(()=>parcelRequire('4s2T0'));

});

parcelRegister("Qcu7n", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");

const $faff5e0943db906b$export$141553e7ddf20c24 = (extensionKey)=>{
    if (extensionKey === 'questionslist-macro' && (0, $9wGTI.fg)('cq_native_macro')) return 'questionslist-macro-native';
    return extensionKey;
};
const $faff5e0943db906b$export$23818186db3523fd = (macroKey)=>{
    // When cq_native_macro is enabled, hide the Connect macro from Quick Insert
    // (existing macros with this key will still render via handler hijacking)
    if (macroKey === 'questionslist-macro' && (0, $9wGTI.fg)('cq_native_macro')) return false;
    // When cq_native_macro is disabled, hide the native macro from Quick Insert
    if (macroKey === 'questionslist-macro-native' && !(0, $9wGTI.fg)('cq_native_macro')) return false;
    return true;
};
module.exports["resolveQuestionsMacroExtensionKey"] = $faff5e0943db906b$export$141553e7ddf20c24;
module.exports["shouldIncludeMacroInQuickInsert"] = $faff5e0943db906b$export$23818186db3523fd;

});

parcelRegister("cV0On", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");

const $94a28c7ac9ed7f37$export$cccbb2118061f032 = [
    'chart',
    'contributors-summary',
    'gallery',
    'google-drive-docs',
    'google-drive-sheets',
    'google-drive-slides',
    'index',
    'viewppt',
    'viewdoc',
    'recently-updated-dashboard',
    'related-labels',
    'spaces',
    'span'
];
const $94a28c7ac9ed7f37$export$adfeadb35be8d156 = 'https://support.atlassian.com/confluence-cloud/docs/learn-which-macros-are-being-removed/';
const $94a28c7ac9ed7f37$export$9d00c2217e733ab2 = (extensionKey)=>{
    if ($94a28c7ac9ed7f37$export$cccbb2118061f032.includes(extensionKey) && (0, $9wGTI.fg)('deprecating_low_usage_macros')) switch(extensionKey){
        case 'chart':
            return (0, $9wGTI.fg)('confluence_deprecate_chart_macro');
        case 'contributors-summary':
            return (0, $9wGTI.fg)('confluence_deprecate_contributors_summary');
        case 'gallery':
            return (0, $9wGTI.fg)('confluence_deprecate_gallery_macro');
        case 'google-drive-docs':
            return (0, $9wGTI.fg)('confluence_deprecate_google_drive_macro');
        case 'google-drive-sheets':
            return (0, $9wGTI.fg)('confluence_deprecate_google_drive_macro');
        case 'google-drive-slides':
            return (0, $9wGTI.fg)('confluence_deprecate_google_drive_macro');
        case 'index':
            return (0, $9wGTI.fg)('confluence_deprecate_page_index_macro');
        case 'viewppt':
            return (0, $9wGTI.fg)('confluence_deprecate_powerpoint_macro');
        case 'viewdoc':
            return (0, $9wGTI.fg)('confluence_deprecate_word_macro');
        case 'recently-updated-dashboard':
            return (0, $9wGTI.fg)('confluence_deprecate_recently_updated_dashboard');
        case 'related-labels':
            return (0, $9wGTI.fg)('confluence_deprecate_related_labels_macro');
        case 'spaces':
            return (0, $9wGTI.fg)('confluence_deprecate_spaces_list_macro');
        case 'span':
            return (0, $9wGTI.fg)('confluence_deprecate_span_macro');
        default:
            return false;
    }
    return false;
};
module.exports["DEPRECATED_MACROS"] = $94a28c7ac9ed7f37$export$cccbb2118061f032;
module.exports["MACRO_DEPRECATION_INFO_URL"] = $94a28c7ac9ed7f37$export$adfeadb35be8d156;
module.exports["isMacroDeprecated"] = $94a28c7ac9ed7f37$export$9d00c2217e733ab2;

});

parcelRegister("apZnX", function(module, exports) {

let $795bdb0a30eab8fd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $795bdb0a30eab8fd$var$load("9V45O"),
    $795bdb0a30eab8fd$var$load("l5llo"),
    $795bdb0a30eab8fd$var$load("9Oy8P"),
    $795bdb0a30eab8fd$var$load("7aOpi"),
    $795bdb0a30eab8fd$var$load("kjaQZ"),
    $795bdb0a30eab8fd$var$load("4amFq"),
    $795bdb0a30eab8fd$var$load("jXx9i"),
    $795bdb0a30eab8fd$var$load("9ftJe"),
    $795bdb0a30eab8fd$var$load("hhss7"),
    $795bdb0a30eab8fd$var$load("jjWia")
]).then(()=>parcelRequire('liyuV'));

});

parcelRegister("eKQ2A", function(module, exports) {

let $abddbac6a62d1de8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $abddbac6a62d1de8$var$load("dYKkq").then(()=>parcelRequire('huQ3W'));

});

parcelRegister("e1Stz", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $36f7db2a9cac59c0$export$7cf7439e5d7797c5 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "ymRP0",
    name: "PagePropertiesReportRenderer",
    loader: async ()=>(await (parcelRequire("elllk"))).PagePropertiesReportRenderer
});
module.exports["PagePropertiesReportRenderer"] = $36f7db2a9cac59c0$export$7cf7439e5d7797c5;

});

parcelRegister("elllk", function(module, exports) {

let $a71395226ac00a62$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a71395226ac00a62$var$load("dnwTC").then(()=>parcelRequire('3Jp28'));

});

parcelRegister("9JyIJ", function(module, exports) {
/* GlobalQuestionsListMacroHandler.tsx generated by @compiled/babel-plugin v0.36.1 */ /**
 * @graphql cc
 */ 
var $42omo = parcelRequire("42omo");


var $gdv5Z = parcelRequire("gdv5Z");

var $iXCQx = parcelRequire("iXCQx");


var $jMyy4 = parcelRequire("jMyy4");


var $bQm3c = parcelRequire("bQm3c");





var $inPa6 = parcelRequire("inPa6");





var $c0cL3 = parcelRequire("c0cL3");


var $5UmiT = parcelRequire("5UmiT");


var $3qLHF = parcelRequire("3qLHF");


var $6Uz6K = parcelRequire("6Uz6K");


var $1NBp8 = parcelRequire("1NBp8");


var $aJkCZ = parcelRequire("aJkCZ");





























var $jIiwF = parcelRequire("jIiwF");

/* BaseQuestionsListMacro.tsx generated by @compiled/babel-plugin v0.36.1 */ 



var $gtD4K = parcelRequire("gtD4K");




var $eyWa4 = parcelRequire("eyWa4");




var $9hlns = parcelRequire("9hlns");


var $bqQGV = parcelRequire("bqQGV");


var $cgtv4 = parcelRequire("cgtv4");

const $badebc9b52fd1a79$export$78684885d30390f3 = (0, $cgtv4.defineMessages)({
    noQuestionsFound: {
        id: "questions.list.noQuestionsFound",
        defaultMessage: "No questions found"
    }
});


const $e9c9490bc5719eda$var$styles = {
    scrollable: "_c71l1c3h _1tke1ns9 _4t3i1wug _18m91wug",
    centerContainer: "_y3gn1h6o _1tkeuuw1"
};
const $e9c9490bc5719eda$export$8652e5edc3425435 = ({ questions: questions, loading: loading, error: error, limit: limit, routerName: routerName, defaultLimit: defaultLimit = 10 })=>{
    if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $e9c9490bc5719eda$var$styles.centerContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
        size: "medium",
        label: "Loading"
    }));
    if (error || !questions?.length) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $e9c9490bc5719eda$var$styles.centerContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $badebc9b52fd1a79$export$78684885d30390f3).noQuestionsFound)));
     // Ensure we always have a valid limit for scroll calculation
    const effectiveLimit = limit || defaultLimit; // Only enable scrolling if both the limit is high enough AND we have enough questions
    const shouldScroll = effectiveLimit > 9 && questions.length > 9;
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        space: "space.250",
        role: "list"
    }, questions.map((question)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bqQGV.QuestionItem), {
            key: question.content.id,
            createdBy: question.content.history.createdBy.displayName,
            numberOfAnswers: question.content.answersTotalCount,
            numberOfVotes: question.content.numberOfVotes,
            createdDate: new Date(question.content.history.createdDate),
            questionTitle: question.content.title,
            spaceKey: question.content.space.key,
            spaceName: question.content.space?.name,
            routerName: routerName,
            questionId: question.content.id,
            topics: question.content.labels,
            hasAcceptedAnswer: question.content.hasAcceptedAnswer
        })));
    if (shouldScroll) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $e9c9490bc5719eda$var$styles.scrollable,
        paddingInlineEnd: "space.100",
        testId: "scrollable-questions-container"
    }, content);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        testId: "questions-container"
    }, content);
};


const $dded665385f37a2b$export$c4704c6f9e4fd1c = ({ spaceKey: spaceKey, limit: limit, filter: filter, topics: topics, includeTopics: includeTopics })=>{
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [cql, setCql] = (0, $42omo.useState)('');
    const filterType = filter === 'popular' ? (0, $6Uz6K.FilterType).POPULAR : filter === 'unanswered' ? (0, $6Uz6K.FilterType).UNANSWERED : (0, $6Uz6K.FilterType).RECENT;
    const questionsLimit = limit || (0, $jIiwF.QUESTIONS_PER_PAGE);
    const queryVariables = (0, $42omo.useMemo)(()=>({
            cql: cql,
            limit: questionsLimit,
            cloudId: cloudId,
            answerContentType: (0, $3qLHF.ANSWER_CONTENT_TYPE)
        }), [
        cloudId,
        cql,
        questionsLimit
    ]);
    const { data: data, loading: loading, error: error } = (0, $c0cL3.useQueryWithError)((0, $5UmiT.QuestionListQuery), {
        variables: queryVariables,
        skip: !cql
    });
    const questions = (0, $42omo.useMemo)(()=>data?.search?.nodes && data?.search?.nodes.length > 0 ? data?.search?.nodes.map((question)=>(0, $aJkCZ.mapQuestionDefaultValues)(question?.content, '', spaceKey)) : [], [
        data?.search?.nodes,
        spaceKey
    ]);
    (0, $42omo.useEffect)(()=>{
        const generatedCql = (0, $6Uz6K.getCQLForFilter)(filterType, topics, includeTopics, spaceKey);
        setCql(generatedCql);
    }, [
        filterType,
        topics,
        includeTopics,
        spaceKey
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!loading && !error && data?.search) createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'SpaceQuestionsListMacro'
            }
        }).fire();
    }, [
        cql,
        loading,
        error,
        data?.search,
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e9c9490bc5719eda$export$8652e5edc3425435), {
        questions: questions,
        loading: loading || !cql,
        error: error,
        limit: limit || (0, $jIiwF.QUESTIONS_PER_PAGE),
        routerName: (0, $1NBp8.SPACE_QUESTION_NATIVE).name,
        defaultLimit: (0, $jIiwF.QUESTIONS_PER_PAGE)
    });
};



const $3dd3f91b5121a412$export$9feb9bf45fe6d2b2 = ({ limit: limit, filter: filter, space: space, includeTopics: includeTopics = 'all', topics: topics = [] })=>{
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [cql, setCql] = (0, $42omo.useState)('');
    const filterType = filter === 'popular' ? (0, $6Uz6K.FilterType).POPULAR : filter === 'unanswered' ? (0, $6Uz6K.FilterType).UNANSWERED : (0, $6Uz6K.FilterType).RECENT;
    const questionsLimit = limit || 10;
    const queryVariables = (0, $42omo.useMemo)(()=>({
            cql: cql,
            limit: questionsLimit,
            cloudId: cloudId,
            answerContentType: (0, $3qLHF.ANSWER_CONTENT_TYPE)
        }), [
        cloudId,
        cql,
        questionsLimit
    ]);
    const { data: data, loading: loading, error: error } = (0, $c0cL3.useQueryWithError)((0, $5UmiT.QuestionListQuery), {
        variables: queryVariables,
        skip: !cql
    });
    const questions = (0, $42omo.useMemo)(()=>data?.search?.nodes && data?.search?.nodes.length > 0 ? data?.search?.nodes.map((question)=>(0, $aJkCZ.mapQuestionDefaultValues)(question?.content)) : [], [
        data?.search?.nodes
    ]);
    (0, $42omo.useEffect)(()=>{
        const generatedCql = (0, $6Uz6K.getCQLForFilter)(filterType, topics, includeTopics);
        setCql(generatedCql);
    }, [
        filterType,
        topics,
        includeTopics
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!loading && !error && data?.search) createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'GlobalQuestionsListMacro'
            }
        }).fire();
    }, [
        cql,
        loading,
        error,
        data?.search,
        createAnalyticsEvent
    ]);
    if (space) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dded665385f37a2b$export$c4704c6f9e4fd1c), {
        limit: limit,
        filter: filter,
        spaceKey: space,
        topics: topics,
        includeTopics: includeTopics
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e9c9490bc5719eda$export$8652e5edc3425435), {
        questions: questions,
        loading: loading || !cql,
        error: error,
        limit: questionsLimit,
        routerName: (0, $1NBp8.QUESTION_NATIVE).name,
        defaultLimit: 10
    });
};



var $5MgbR = parcelRequire("5MgbR");


var $6ZQ5i = parcelRequire("6ZQ5i");

const $c685300bb714fa21$var$styles = {
    centerContainer: "_y3gn1h6o _1tkeuuw1"
};
const $c685300bb714fa21$export$aa662dd09c22e89d = ({ macroParams: macroParams })=>{
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { data: data } = (0, $jMyy4.useQueryInterop)((0, $6ZQ5i.default), {
        variables: {
            cloudId: cloudId
        },
        skip: !cloudId,
        fetchPolicy: 'cache-first'
    });
    const limit = macroParams?.limit?.value ? parseInt(macroParams.limit.value, 10) : 10;
    const filter = macroParams?.filter?.value?.toLowerCase() || 'popular';
    const space = macroParams?.space?.value;
    const includeTopics = macroParams?.['include-topics']?.value || 'all';
    const topicsString = macroParams?.topic?.value || '';
    const topics = topicsString ? topicsString.split(',').map((topic)=>topic.trim()).filter(Boolean) : [];
    // Check access permission
    if (!data?.confluence_questionsConfiguration?.hasConfluenceQuestionsAccess) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $c685300bb714fa21$var$styles.centerContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), null, "You do not have the correct permissions to view Questions. Please request access from your Atlassian Cloud administrator."));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5MgbR.FlagsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3dd3f91b5121a412$export$9feb9bf45fe6d2b2), {
        limit: limit,
        filter: filter,
        space: space,
        includeTopics: includeTopics,
        topics: topics
    }));
};
module.exports["GlobalQuestionsListMacroHandler"] = $c685300bb714fa21$export$aa662dd09c22e89d;

});

parcelRegister("c0cL3", function(module, exports) {

var $1KmJq = parcelRequire("1KmJq");

var $xQxzY = parcelRequire("xQxzY");


var $422HI = parcelRequire("422HI");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $8H5XZ = parcelRequire("8H5XZ");


var $7Sm4c = parcelRequire("7Sm4c");





var $5MgbR = parcelRequire("5MgbR");

const $912bdcda1ef5251f$var$i18n = (0, $cgtv4.defineMessages)({
    errorTitle: {
        id: "questions.generic-error.title",
        defaultMessage: "Something went wrong"
    },
    errorDescription: {
        id: "questions.generic-error.description",
        defaultMessage: "The request returned an error."
    }
});
const $912bdcda1ef5251f$var$extractErrors = (data, path)=>{
    const errors = path.split('.').reduce((acc, part)=>acc && acc[part], data);
    return errors && errors.length > 0 ? new (0, $422HI.ApolloErrorInterop)({
        graphQLErrors: errors
    }) : null;
};
const $912bdcda1ef5251f$var$useErrorHandling = (errorOptions)=>{
    const { errorTitle: errorTitle, errorDescription: errorDescription } = errorOptions ?? {};
    const { showErrorFlag: showErrorFlag } = (0, $5MgbR.useFlags)();
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    //TODO apollo errors seems are not handled here
    return (error)=>{
        if ((0, $8H5XZ.isGraphQLError)(error) && !(0, $7Sm4c.isErrorMarkedAsHandled)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
        showErrorFlag({
            id: 'questions-error-flag',
            title: errorTitle || formatMessage($912bdcda1ef5251f$var$i18n.errorTitle),
            description: errorDescription || formatMessage($912bdcda1ef5251f$var$i18n.errorDescription),
            isAutoDismiss: true
        });
    };
};
const $912bdcda1ef5251f$var$handleCompletion = (data, errorOptions, options, handleError)=>{
    if (errorOptions?.responseErrorPath) {
        const error = $912bdcda1ef5251f$var$extractErrors(data, errorOptions.responseErrorPath);
        if (error) {
            handleError(error);
            options?.onError && options.onError(error);
            return;
        }
    }
    options?.onCompleted && options.onCompleted(data);
};
const $912bdcda1ef5251f$export$881c4f898e5b8b6f = (mutation, options, errorOptions)=>{
    const handleError = $912bdcda1ef5251f$var$useErrorHandling(errorOptions);
    const onCompleted = (data)=>$912bdcda1ef5251f$var$handleCompletion(data, errorOptions, options, handleError);
    const onError = (error)=>{
        handleError(error);
        options?.onError && options.onError(error);
    };
    const [mutateFunction, result] = (0, $1KmJq.useMutation)(mutation, {
        ...options,
        onCompleted: onCompleted,
        onError: onError
    });
    return [
        mutateFunction,
        result
    ];
};
const $912bdcda1ef5251f$export$8737ce7175d79bf5 = (query, options, errorOptions)=>{
    const handleError = $912bdcda1ef5251f$var$useErrorHandling(errorOptions);
    const onCompleted = (data)=>$912bdcda1ef5251f$var$handleCompletion(data, errorOptions, options, handleError);
    const onError = (error)=>{
        handleError(error);
        options?.onError && options.onError(error);
    };
    return (0, $xQxzY.useQuery)(query, {
        ...options,
        onCompleted: onCompleted,
        onError: onError
    });
};
module.exports["useMutationWithError"] = $912bdcda1ef5251f$export$881c4f898e5b8b6f;
module.exports["useQueryWithError"] = $912bdcda1ef5251f$export$8737ce7175d79bf5;

});

parcelRegister("5MgbR", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $7aRa9 = parcelRequire("7aRa9");

const $654bfaadbe08eb5c$var$FlagsContext = /*#__PURE__*/ (0, $42omo.createContext)(undefined);
const $654bfaadbe08eb5c$export$a4270ab432ac8a58 = (0, $7aRa9.withFlags)(({ children: children, flags: flags })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($654bfaadbe08eb5c$var$FlagsContext.Provider, {
        value: flags
    }, children));
const $654bfaadbe08eb5c$export$2879604e6aec4ab = ()=>{
    const context = (0, $42omo.useContext)($654bfaadbe08eb5c$var$FlagsContext);
    if (!context) throw new Error('useFlags must be used within a FlagsProvider');
    return context;
};
module.exports["FlagsProvider"] = $654bfaadbe08eb5c$export$a4270ab432ac8a58;
module.exports["useFlags"] = $654bfaadbe08eb5c$export$2879604e6aec4ab;

});

parcelRegister("5UmiT", function(module, exports) {
/** @graphql cc **/ 
var $eSUdr = parcelRequire("eSUdr");

const $9b04d5234c9ea8f2$export$96dbd51488e4fef1 = (0, $eSUdr.default)`query QuestionListQuery($cloudId:ID!$cql:String!$limit:Int$after:String$answerContentType:String){search:confluence_search(cloudId:$cloudId cql:$cql first:$limit after:$after){nodes{content{id title labels{nodes{name}}space{name alias key}properties{nodes{key value}}history{createdDate createdBy{displayName}}children(type:$answerContentType){nodes{id}}}}pageInfo{hasNextPage endCursor}}}`;
module.exports["QuestionListQuery"] = $9b04d5234c9ea8f2$export$96dbd51488e4fef1;

});

parcelRegister("3qLHF", function(module, exports) {
const $f5e2cba7906d01d5$export$20fdc5b94f807d17 = 'ac:com.atlassian.confluence.plugins.confluence-questions:question';
const $f5e2cba7906d01d5$export$a304b64b6d72c766 = 'ac:com.atlassian.confluence.plugins.confluence-questions:answer';
const $f5e2cba7906d01d5$export$21545b38a2d03e2f = 'atl_cq_votes';
const $f5e2cba7906d01d5$export$3196903b0ef53c21 = 'atl_cq_accepted_answer';
module.exports["QUESTION_CONTENT_TYPE"] = $f5e2cba7906d01d5$export$20fdc5b94f807d17;
module.exports["ANSWER_CONTENT_TYPE"] = $f5e2cba7906d01d5$export$a304b64b6d72c766;
module.exports["VOTES_PROPERTY_KEY"] = $f5e2cba7906d01d5$export$21545b38a2d03e2f;
module.exports["ACCEPTED_ANSWER_PROPERTY_KEY"] = $f5e2cba7906d01d5$export$3196903b0ef53c21;

});

parcelRegister("6Uz6K", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $gdv5Z = parcelRequire("gdv5Z");


var $hArLp = parcelRequire("hArLp");


var $ccHMk = parcelRequire("ccHMk");


var $3qLHF = parcelRequire("3qLHF");

const $69086db34fc14ea2$var$i18n = (0, $cgtv4.defineMessages)({
    recentFilterButton: {
        id: "questions.questions-list.recent-filter-button",
        defaultMessage: "Recent"
    },
    popularFilterButton: {
        id: "questions.questions-list.popular-filter-button",
        defaultMessage: "Popular"
    },
    unansweredFilterButton: {
        id: "questions.questions-list.unasnwered-filter-button",
        defaultMessage: "Unanswered"
    }
});
var $69086db34fc14ea2$export$c67e46de1ec7dfa6 = /*#__PURE__*/ function(FilterType) {
    FilterType["RECENT"] = "recent";
    FilterType["POPULAR"] = "popular";
    FilterType["UNANSWERED"] = "unanswered";
    return FilterType;
}({});
const $69086db34fc14ea2$export$110ec509983fa451 = (filter, topics, includeTopicsMode, spaceKey)=>{
    const baseType = `type="${(0, $3qLHF.QUESTION_CONTENT_TYPE)}"`;
    const spaceQuery = spaceKey ? ` AND space="${spaceKey}"` : '';
    let labelQuery = '';
    if (topics && topics.length > 0) {
        if (includeTopicsMode === 'any') {
            const labelConditions = topics.map((topic)=>`label="${topic}"`).join(' OR ');
            labelQuery = ` AND (${labelConditions})`;
        } else labelQuery = topics.map((topic)=>` AND label="${topic}"`).join('');
    }
    switch(filter){
        case "popular":
            return `${baseType}${spaceQuery}${labelQuery} AND atl_cq_votes_total > 0 order by atl_cq_votes_total desc, lastmodified desc`;
        case "unanswered":
            return `${baseType}${spaceQuery}${labelQuery} AND content.property[atl_cq_has_answers].any_answer=false order by created desc, title`;
        case "recent":
        default:
            return `${baseType}${spaceQuery}${labelQuery} order by created desc, title`;
    }
};
const $69086db34fc14ea2$export$8c9e2333b82fdfd2 = ({ onFilterChange: onFilterChange, labelFilter: labelFilter, disableFilter: disableFilter = false, spaceKey: spaceKey, currentFilter: currentFilter })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    (0, $42omo.useEffect)(()=>{
        const topics = labelFilter ? [
            labelFilter
        ] : undefined;
        onFilterChange($69086db34fc14ea2$export$110ec509983fa451(currentFilter, topics, 'all', spaceKey), currentFilter);
    // Run on mount to initialize the query
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleClick = (filter)=>{
        const topics = labelFilter ? [
            labelFilter
        ] : undefined;
        onFilterChange($69086db34fc14ea2$export$110ec509983fa451(filter, topics, 'all', spaceKey), filter);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hArLp.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        onClick: ()=>handleClick("recent"),
        isSelected: currentFilter === "recent"
    }, formatMessage($69086db34fc14ea2$var$i18n.recentFilterButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        isDisabled: disableFilter,
        onClick: ()=>handleClick("popular"),
        isSelected: currentFilter === "popular"
    }, formatMessage($69086db34fc14ea2$var$i18n.popularFilterButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        isDisabled: disableFilter,
        onClick: ()=>handleClick("unanswered"),
        isSelected: currentFilter === "unanswered"
    }, formatMessage($69086db34fc14ea2$var$i18n.unansweredFilterButton))));
};
module.exports["FilterType"] = $69086db34fc14ea2$export$c67e46de1ec7dfa6;
module.exports["getCQLForFilter"] = $69086db34fc14ea2$export$110ec509983fa451;
module.exports["QuestionsFilters"] = $69086db34fc14ea2$export$8c9e2333b82fdfd2;

});

parcelRegister("aJkCZ", function(module, exports) {

var $3qLHF = parcelRequire("3qLHF");

// //delete the cache to load questions from server after deleting/creating questions
// //remove it when nextFetchPolicy from apollo 3 is available or alternatives
// //more info https://medium.com/@martinseanhunt/how-to-invalidate-cached-data-in-apollo-and-handle-updating-paginated-queries-379e4b9e4698
const $1da6e843482c7c1d$var$deleteSpaceQuestionsCache = (cache)=>{
    Object.keys(cache.data?.data || []).forEach((key)=>key.includes('confluence.questionsForSpace') && cache.data.delete(key));
};
const $1da6e843482c7c1d$var$deleteGlobalQuestionsCache = (cache)=>{
    Object.keys(cache.data?.data || []).forEach((key)=>key.includes('search') && cache.data.delete(key));
};
const $1da6e843482c7c1d$var$deleteExpertsCache = (cache)=>{
    Object.keys(cache.data?.data || []).forEach((key)=>(key.includes('confluence_expertsOfAllTime') || key.includes('confluence_expertsByTopic') || key.includes('confluence_expertsOfWeek') || key.includes('confluence_expert')) && cache.data.delete(key));
};
const $1da6e843482c7c1d$export$8c2ddd9504996f1d = (cache)=>{
    $1da6e843482c7c1d$var$deleteSpaceQuestionsCache(cache);
    $1da6e843482c7c1d$var$deleteGlobalQuestionsCache(cache);
};
const $1da6e843482c7c1d$export$7174f92a87efe7b9 = (cache)=>{
    $1da6e843482c7c1d$var$deleteExpertsCache(cache);
};
function $1da6e843482c7c1d$export$ffd321fc8ab460c0(properties) {
    if (!properties?.nodes) return 0;
    const votesProperty = properties.nodes.find((prop)=>prop?.key === (0, $3qLHF.VOTES_PROPERTY_KEY));
    if (!votesProperty?.value) return 0;
    try {
        const votesData = JSON.parse(votesProperty.value);
        return votesData.total || 0;
    } catch  {
        return 0;
    }
}
function $1da6e843482c7c1d$export$9b0e520b479dc189(children) {
    if (!children?.nodes) return 0;
    const count = children.nodes.length;
    return count;
}
function $1da6e843482c7c1d$export$b69a59226c9db1bd(properties) {
    if (!properties?.nodes) return false;
    const acceptedAnswerProperty = properties.nodes.find((prop)=>prop.key === (0, $3qLHF.ACCEPTED_ANSWER_PROPERTY_KEY));
    if (!acceptedAnswerProperty?.value) return false;
    try {
        const acceptedAnswerData = JSON.parse(acceptedAnswerProperty.value);
        return acceptedAnswerData.answer_id != null;
    } catch  {
        return false;
    }
}
function $1da6e843482c7c1d$export$5f4ea733e74e307f(labels) {
    if (!labels) return [];
    if ('nodes' in labels) // Handle QuestionListQuery format
    return labels.nodes.map((node)=>({
            name: node.name
        }));
    // Handle QuestionsForSpaceQuery format
    return labels.map((label)=>({
            name: label.label
        }));
}
function $1da6e843482c7c1d$export$f9575b58d19e9d38(node, displayName, spaceKey) {
    if (!node) return {
        content: {
            id: '',
            title: '',
            space: {
                key: '',
                name: '',
                alias: ''
            },
            history: {
                createdDate: '',
                createdBy: {
                    displayName: ''
                }
            },
            answersTotalCount: 0,
            labels: [],
            numberOfVotes: 0,
            hasAcceptedAnswer: false
        }
    };
    return {
        content: {
            id: node.id ?? '',
            title: node.title ?? '',
            labels: $1da6e843482c7c1d$export$5f4ea733e74e307f(node.labels),
            space: {
                key: node.space?.key ?? spaceKey ?? '',
                name: node.space?.name ?? '',
                alias: node.space?.alias ?? ''
            },
            history: {
                createdDate: node.latestVersion?.createdAt ?? node.history?.createdDate ?? '',
                createdBy: {
                    displayName: node.history?.createdBy?.displayName ?? displayName ?? ''
                }
            },
            answersTotalCount: node.answersTotalCount ?? $1da6e843482c7c1d$export$9b0e520b479dc189(node.children) ?? 0,
            numberOfVotes: node.voteProperties?.total ?? $1da6e843482c7c1d$export$ffd321fc8ab460c0(node.properties),
            hasAcceptedAnswer: node.hasAcceptedAnswer ?? $1da6e843482c7c1d$export$b69a59226c9db1bd(node.properties)
        }
    };
}
module.exports["deleteQuestionListCache"] = $1da6e843482c7c1d$export$8c2ddd9504996f1d;
module.exports["deleteExpertsListCache"] = $1da6e843482c7c1d$export$7174f92a87efe7b9;
module.exports["mapQuestionDefaultValues"] = $1da6e843482c7c1d$export$f9575b58d19e9d38;

});

parcelRegister("jIiwF", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $6f0Oj = parcelRequire("6f0Oj");

var $1GzhS = parcelRequire("1GzhS");

var $5dK2X = parcelRequire("5dK2X");

var $ecnYn = parcelRequire("ecnYn");


var $9hlns = parcelRequire("9hlns");


var $6Uz6K = parcelRequire("6Uz6K");


var $bqQGV = parcelRequire("bqQGV");


var $iUThO = parcelRequire("iUThO");


var $bU366 = parcelRequire("bU366");

const $7c28cab3ee180cb0$export$c069ea996b4c712d = 15;
const $7c28cab3ee180cb0$var$i18n = (0, $cgtv4.defineMessages)({
    noQuestionsFound: {
        id: "questions.questions-list.no-questions-found",
        defaultMessage: "No questions found"
    }
});
const $7c28cab3ee180cb0$var$ContainerStyles = (0, $ecnYn.xcss)({
    textAlign: 'center',
    minHeight: '200px'
});
const $7c28cab3ee180cb0$export$c9b03d89919b1b57 = ({ questions: questions, loading: loading, asideComponent: asideComponent, mainContentHeader: mainContentHeader, routerName: routerName, showSpaceName: showSpaceName, pageInfo: pageInfo, fetchMore: fetchMore, queryVariables: queryVariables, connectionPath: connectionPath, onFilterChange: onFilterChange, labelFilter: labelFilter, disableFilter: disableFilter, spaceKey: spaceKey, currentFilter: currentFilter })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const renderMainContent = ()=>{
        if (loading) //TODO make spinner and placeholder reusable
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $7c28cab3ee180cb0$var$ContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
            size: "medium",
            label: "Loading"
        }));
        if (!questions?.length) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $7c28cab3ee180cb0$var$ContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), null, formatMessage($7c28cab3ee180cb0$var$i18n.noQuestionsFound)));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
            space: "space.250",
            role: "list"
        }, questions.map((question)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bqQGV.QuestionItem), {
                key: question.content.id,
                createdBy: question.content.history.createdBy.displayName,
                numberOfAnswers: question.content.answersTotalCount,
                //TODO show votes count
                //https://product-fabric.atlassian.net/browse/CCECO-4083
                numberOfVotes: question.content.numberOfVotes,
                createdDate: new Date(question.content.history.createdDate),
                questionTitle: question.content.title,
                spaceKey: question.content.space.key,
                spaceName: showSpaceName ? question.content.space?.name : '',
                routerName: routerName,
                questionId: question.content.id,
                topics: question.content.labels,
                hasAcceptedAnswer: question.content.hasAcceptedAnswer
            }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bU366.Pagination), {
            pageInfo: pageInfo,
            fetchMore: fetchMore,
            queryVariables: queryVariables,
            connectionPath: connectionPath
        }));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iUThO.Layout), {
        rightColumnWidth: "large",
        mainContentHeader: mainContentHeader,
        mainContent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
            space: "space.250",
            alignBlock: "start",
            spread: "space-between",
            grow: "fill"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6Uz6K.QuestionsFilters), {
            onFilterChange: onFilterChange,
            labelFilter: labelFilter,
            disableFilter: disableFilter,
            spaceKey: spaceKey,
            currentFilter: currentFilter
        }), renderMainContent()),
        asideContent: asideComponent
    });
};
module.exports["QUESTIONS_PER_PAGE"] = $7c28cab3ee180cb0$export$c069ea996b4c712d;
module.exports["BaseQuestionsList"] = $7c28cab3ee180cb0$export$c9b03d89919b1b57;

});

parcelRegister("kTuMi", function(module, exports) {
/* SpaceLink.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $8lYIw = parcelRequire("8lYIw");


var $1NBp8 = parcelRequire("1NBp8");

const $46ec6250d7571871$var$spaceLinkStyles = null;
const $46ec6250d7571871$export$8a708d0cf2dc6e64 = ({ spaceKey: spaceKey, spaceName: spaceName })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8lYIw.Link), {
        name: (0, $1NBp8.SPACE_QUESTIONS_NATIVE).name,
        params: {
            spaceKey: spaceKey
        },
        "aria-label": spaceName,
        className: (0, $gMc0m.default)([
            "_11c8wadc _syazd34b"
        ])
    }, spaceName);
};
module.exports["SpaceLink"] = $46ec6250d7571871$export$8a708d0cf2dc6e64;

});

parcelRegister("izEQ8", function(module, exports) {
/* QuestionTopics.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-selectors */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $ho4zm = parcelRequire("ho4zm");


var $bRPo1 = parcelRequire("bRPo1");


var $inPa6 = parcelRequire("inPa6");


var $fpGTa = parcelRequire("fpGTa");


var $1NBp8 = parcelRequire("1NBp8");

const $879ad131bf99fc11$var$tagLinkStyles = null;
const $879ad131bf99fc11$export$2b92f0949119dd70 = ({ topics: topics })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    if (!topics || topics.length === 0) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bRPo1.default), null, topics.map(({ name: name })=>{
        try {
            const href = (0, $1NBp8.QUESTIONS_TOPIC_NATIVE).toUrl({
                topicName: name.toLowerCase()
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ho4zm.default), {
                text: name,
                href: href,
                key: name,
                linkComponent: ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fpGTa.default), {
                        ...props,
                        className: (0, $gMc0m.default)([
                            "_syaz1kw7 _10531kw7 _f8pj1kw7 _30l31kw7 _9h8h1kw7"
                        ])
                    }, children)
            });
        } catch (error) {
            createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: {
                    action: 'failed',
                    actionSubject: 'topicUrlGeneration',
                    source: 'QuestionTopics',
                    attributes: {
                        topicName: name,
                        errorMessage: error instanceof Error ? error.message : 'Unknown error',
                        errorName: error instanceof Error ? error.name : 'Error'
                    }
                }
            }).fire();
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ho4zm.default), {
                text: name,
                key: name,
                href: undefined
            });
        }
    }));
};
module.exports["QuestionTopics"] = $879ad131bf99fc11$export$2b92f0949119dd70;

});

parcelRegister("iUThO", function(module, exports) {
/* Layout.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gdv5Z = parcelRequire("gdv5Z");

var $d8SNb = parcelRequire("d8SNb");

const $ae798e585bbeb555$var$gridStylesSmall = {
    root: "_zulppxbi _1bsb1osq _yv0e9kwb"
};
const $ae798e585bbeb555$var$gridStylesLarge = {
    root: "_zulppxbi _1bsb1osq _yv0ee9gk"
};
const $ae798e585bbeb555$var$SmallGrid = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d8SNb.default), {
        ...props,
        xcss: $ae798e585bbeb555$var$gridStylesSmall.root
    });
const $ae798e585bbeb555$var$LargeGrid = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d8SNb.default), {
        ...props,
        xcss: $ae798e585bbeb555$var$gridStylesLarge.root
    });
const $ae798e585bbeb555$export$c84671f46d6a1ca = ({ mainContent: mainContent, mainContentHeader: mainContentHeader, asideContent: asideContent, rightColumnWidth: rightColumnWidth = 'small' })=>{
    const GridComponent = rightColumnWidth === 'large' ? $ae798e585bbeb555$var$LargeGrid : $ae798e585bbeb555$var$SmallGrid;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(GridComponent, {
        testId: "questions-layout-grid"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        padding: "space.200"
    }, mainContentHeader, mainContent), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        padding: "space.200"
    }, asideContent));
};
module.exports["Layout"] = $ae798e585bbeb555$export$c84671f46d6a1ca;

});

parcelRegister("bU366", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $ccHMk = parcelRequire("ccHMk");


var $bUlM5 = parcelRequire("bUlM5");

const $2978298c3b91fa54$var$i18n = (0, $cgtv4.defineMessages)({
    showMoreButton: {
        id: "questions.pagination.show-more-button",
        defaultMessage: "Show More"
    }
});
const $2978298c3b91fa54$var$getNestedValue = (data, path)=>{
    return path.split('.').reduce((acc, part)=>acc && acc[part], data);
};
const $2978298c3b91fa54$export$68f5e1453c188a82 = ({ pageInfo: pageInfo, fetchMore: fetchMore, queryVariables: queryVariables, connectionPath: connectionPath })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [isLoadingMore, setIsLoadingMore] = (0, $42omo.useState)(false);
    const { hasNextPage: hasNextPage, endCursor: endCursor } = pageInfo;
    const handleLoadMore = (0, $42omo.useCallback)(async ()=>{
        if (!hasNextPage || isLoadingMore) return;
        setIsLoadingMore(true);
        try {
            await fetchMore({
                variables: {
                    ...queryVariables,
                    after: endCursor
                },
                updateQuery: (previousResult, { fetchMoreResult: fetchMoreResult })=>{
                    if (!fetchMoreResult) return previousResult;
                    const prevConnection = $2978298c3b91fa54$var$getNestedValue(previousResult, connectionPath);
                    const nextConnection = $2978298c3b91fa54$var$getNestedValue(fetchMoreResult, connectionPath);
                    if (!prevConnection || !nextConnection) return fetchMoreResult;
                    return {
                        ...fetchMoreResult,
                        [connectionPath]: {
                            ...nextConnection,
                            nodes: [
                                ...prevConnection.nodes || [],
                                ...nextConnection.nodes || []
                            ]
                        }
                    };
                }
            });
        } catch (error) {
        // Error handling is delegated to the parent query hook
        } finally{
            setIsLoadingMore(false);
        }
    }, [
        hasNextPage,
        isLoadingMore,
        fetchMore,
        queryVariables,
        endCursor,
        connectionPath
    ]);
    if (!hasNextPage) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
        justifyContent: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        isLoading: isLoadingMore,
        onClick: handleLoadMore
    }, formatMessage($2978298c3b91fa54$var$i18n.showMoreButton)));
};
module.exports["Pagination"] = $2978298c3b91fa54$export$68f5e1453c188a82;

});

parcelRegister("6ZQ5i", function(module, exports) {
/**
 * @generated SignedSource<<de2d5420966eaebbe0bce1d9450c6fcb>>
 * @relayHash 03141bab41f294dbd4ef110b0dfd3b82
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5039e3f7d11f191ab3ef74dcfd79d3bee6023ac2a82df19346a5cafaaa3b25bf
const $e8beacecb21685ac$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                }
            ],
            "concreteType": "ConfluenceQuestionsConfiguration",
            "kind": "LinkedField",
            "name": "confluence_questionsConfiguration",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "confluenceQuestionsGlobalSpaceKey"
                },
                {
                    "kind": "ScalarField",
                    "name": "hasConfluenceQuestionsAccess"
                },
                {
                    "kind": "ScalarField",
                    "name": "confluenceQuestionsGlobalSpaceId"
                },
                {
                    "kind": "ScalarField",
                    "name": "isConfluenceQuestionsInstalled"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "GlobalSpaceQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "GlobalSpaceQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "03141bab41f294dbd4ef110b0dfd3b82",
            "id": "5039e3f7d11f191ab3ef74dcfd79d3bee6023ac2a82df19346a5cafaaa3b25bf",
            "metadata": {},
            "name": "GlobalSpaceQuery",
            "operationKind": "query",
            "text": "query GlobalSpaceQuery($cloudId:ID!){confluence_questionsConfiguration(cloudId:$cloudId){confluenceQuestionsGlobalSpaceKey,hasConfluenceQuestionsAccess,confluenceQuestionsGlobalSpaceId,isConfluenceQuestionsInstalled}}"
        }
    };
}();
$e8beacecb21685ac$var$node.hash = "be64fbb1a28b54db1d9b6f0a24cf36d5";
var $e8beacecb21685ac$export$2e2bcd8739ae039 = $e8beacecb21685ac$var$node;
module.exports["default"] = $e8beacecb21685ac$export$2e2bcd8739ae039;

});

parcelRegister("c8uPc", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $jdPfT = parcelRequire("jdPfT");


var $lAFHW = parcelRequire("lAFHW");


var $5kjCz = parcelRequire("5kjCz");


var $bX5uj = parcelRequire("bX5uj");


var $8pcS0 = parcelRequire("8pcS0");

class $bc21811740180c1d$export$af7ab11fa3a3d026 extends (0, $42omo.Component) {
    render() {
        const { node: node, mode: mode, extensionKey: extensionKey, contentId: contentId } = this.props;
        const attributes = (0, $5kjCz.getMacroAttributesFromADFNode)(node);
        const label = node?.parameters?.macroMetadata?.title;
        const isJiraMacro = node.extensionKey.indexOf('jira') !== -1;
        const icon = isJiraMacro ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lAFHW.JiraIcon), {
            size: "small",
            label: label
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jdPfT))), {
            label: label
        });
        const Element = 'div';
        // this seems counterintuitive, but all inline extensions have a parent <span> with a small width (~38px),
        // so setting 100% width on it only makes it 38px wide and doesn't allow us to include the name of the extension.
        // So, let's force it to be sufficiently large.
        const isInline = node.type === (0, $8pcS0.INLINE_EXTENSION_TYPE);
        const width = isInline ? '680px' : '100%';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Element, {
            "data-testid": "dead-macro-icon",
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                display: 'inline-block',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                backgroundColor: "var(--ds-icon-inverse, #FFFFFF)",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                borderRadius: 5,
                width: // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                width,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                height: 25,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                padding: "var(--ds-space-050, 4px)"
            }
        }, icon, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                paddingLeft: "var(--ds-space-050, 4px)",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                position: 'absolute'
            }
        }, label)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bX5uj.MacroExperienceSuccess), {
            name: (0, $5kjCz.getExperienceName)(mode, node),
            contentId: contentId,
            extensionKey: extensionKey,
            mode: mode,
            attributes: attributes
        }));
    }
}
module.exports["DeadMacroRenderer"] = $bc21811740180c1d$export$af7ab11fa3a3d026;

});

parcelRegister("5h7sn", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $eS4Za = parcelRequire("eS4Za");


var $8pcS0 = parcelRequire("8pcS0");


var $5kjCz = parcelRequire("5kjCz");


var $4KFTW = parcelRequire("4KFTW");


var $aJPUt = parcelRequire("aJPUt");


var $fPNzj = parcelRequire("fPNzj");


var $7y0YZ = parcelRequire("7y0YZ");


var $6842f = parcelRequire("6842f");


var $gmxua = parcelRequire("gmxua");

const $9ac0f262dcfc95d3$export$28dc7f04b737fd63 = ({ contentId: contentId, contextProviders: contextProviders })=>(0, $eS4Za.createMacroExtensionHandler)((extension)=>{
        if (!extension) return null;
        const { extensionKey: extensionKey, parameters: parameters } = extension;
        const { ClassicEditorContextProvider: ClassicEditorContextProvider = ({ children: children })=>children } = contextProviders;
        const attributes = (0, $5kjCz.getMacroAttributesFromADFNode)(extension);
        let implementation;
        const defaultProps = {
            contentId: contentId,
            mode: (0, $5kjCz.EDITOR),
            extensionKey: extensionKey,
            node: extension
        };
        switch(extensionKey){
            case (0, $8pcS0.EXTENSION_KEY).INVALID:
                // extension is rendered outside of React DOM tree and require access to the ClassicEditorContext
                implementation = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ClassicEditorContextProvider, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7y0YZ.InvalidExtensionLoader), {
                    parameters: parameters,
                    ...defaultProps
                }));
                break;
            case (0, $8pcS0.EXTENSION_KEY).INLINE_EXTERNAL_IMAGE:
                const inlineExtImageProps = parameters;
                implementation = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fPNzj.InlineExternalImage), {
                    ...inlineExtImageProps,
                    ...defaultProps
                });
                break;
            case (0, $8pcS0.EXTENSION_KEY).INLINE_MEDIA_IMAGE:
                const inlineMediaImageProps = parameters;
                const { link: link } = parameters;
                implementation = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6842f.InlineImage), {
                    ...inlineMediaImageProps,
                    ...defaultProps,
                    link: link
                });
                break;
            case (0, $8pcS0.EXTENSION_KEY).LEGACY_CONTENT:
                implementation = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gmxua.LegacyContentExtensionHandler), defaultProps);
                break;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4KFTW.MacroExperienceStart), {
            name: (0, $5kjCz.getExperienceName)((0, $5kjCz.EDITOR), extension),
            contentId: contentId,
            mode: (0, $5kjCz.EDITOR),
            extensionKey: extensionKey,
            attributes: attributes,
            timeout: (0, $aJPUt.ExperienceTimeout).MACRO_LOAD
        }), implementation);
    });
module.exports["getMigrationExtHandlerForEditor"] = $9ac0f262dcfc95d3$export$28dc7f04b737fd63;

});

parcelRegister("8TisB", function(module, exports) {

let $6791c7a47fbe639b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6791c7a47fbe639b$var$load("8iZfW"),
    $6791c7a47fbe639b$var$load("6uX9q"),
    $6791c7a47fbe639b$var$load("hOaAV"),
    $6791c7a47fbe639b$var$load("kKvGf"),
    $6791c7a47fbe639b$var$load("9f5Sw"),
    $6791c7a47fbe639b$var$load("1okAQ"),
    $6791c7a47fbe639b$var$load("g5HUX"),
    $6791c7a47fbe639b$var$load("5BEZW"),
    $6791c7a47fbe639b$var$load("11lCS"),
    $6791c7a47fbe639b$var$load("2GhbU"),
    $6791c7a47fbe639b$var$load("4BnVn"),
    $6791c7a47fbe639b$var$load("4f5Vx"),
    $6791c7a47fbe639b$var$load("Wowvf"),
    $6791c7a47fbe639b$var$load("1kEXt"),
    $6791c7a47fbe639b$var$load("8A3nE"),
    $6791c7a47fbe639b$var$load("3j1kT"),
    $6791c7a47fbe639b$var$load("kEwWf"),
    $6791c7a47fbe639b$var$load("2nlDO"),
    $6791c7a47fbe639b$var$load("57DtC"),
    $6791c7a47fbe639b$var$load("cEqm7"),
    $6791c7a47fbe639b$var$load("hhss7"),
    $6791c7a47fbe639b$var$load("jplsw"),
    $6791c7a47fbe639b$var$load("6XCf4"),
    $6791c7a47fbe639b$var$load("9S9Mz"),
    $6791c7a47fbe639b$var$load("g5leU"),
    $6791c7a47fbe639b$var$load("7EorR"),
    $6791c7a47fbe639b$var$load("aJ9z1"),
    $6791c7a47fbe639b$var$load("glvWr"),
    $6791c7a47fbe639b$var$load("e4wOQ"),
    $6791c7a47fbe639b$var$load("5pvpJ"),
    $6791c7a47fbe639b$var$load("e1qbZ"),
    $6791c7a47fbe639b$var$load("87xQF"),
    $6791c7a47fbe639b$var$load("2euij"),
    $6791c7a47fbe639b$var$load("kZMnh"),
    $6791c7a47fbe639b$var$load("855o0"),
    $6791c7a47fbe639b$var$load("8MfZE"),
    $6791c7a47fbe639b$var$load("dek7I"),
    $6791c7a47fbe639b$var$load("9aQIt"),
    $6791c7a47fbe639b$var$load("XZauT"),
    $6791c7a47fbe639b$var$load("4S1SF"),
    $6791c7a47fbe639b$var$load("lm9Lt"),
    $6791c7a47fbe639b$var$load("9wPDc"),
    $6791c7a47fbe639b$var$load("1MWOL"),
    $6791c7a47fbe639b$var$load("6fQco"),
    $6791c7a47fbe639b$var$load("aOY32"),
    $6791c7a47fbe639b$var$load("dYtBN"),
    $6791c7a47fbe639b$var$load("kNV5Y"),
    $6791c7a47fbe639b$var$load("6wr18"),
    $6791c7a47fbe639b$var$load("kjZZD"),
    $6791c7a47fbe639b$var$load("e6ams"),
    $6791c7a47fbe639b$var$load("iVgrO"),
    $6791c7a47fbe639b$var$load("ffEVr"),
    $6791c7a47fbe639b$var$load("1qlDN"),
    $6791c7a47fbe639b$var$load("1yVM6"),
    $6791c7a47fbe639b$var$load("dTsOE"),
    $6791c7a47fbe639b$var$load("lE7kL"),
    $6791c7a47fbe639b$var$load("gbKmf"),
    $6791c7a47fbe639b$var$load("h3G8d")
]).then(()=>parcelRequire('cul1e'));

});

parcelRegister("gmxua", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $3IBnw = parcelRequire("3IBnw");


var $4PPzL = parcelRequire("4PPzL");


var $ep3mz = parcelRequire("ep3mz");

/* NBMRenderer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");





var $8C5kA = parcelRequire("8C5kA");


var $lspPP = parcelRequire("lspPP");


var $4FxUL = parcelRequire("4FxUL");


var $inPa6 = parcelRequire("inPa6");


var $iZq0X = parcelRequire("iZq0X");


var $3JtSu = parcelRequire("3JtSu");


var $8Ij3v = parcelRequire("8Ij3v");


var $7QM6o = parcelRequire("7QM6o");


var $cLo2u = parcelRequire("cLo2u");





var $bQm3c = parcelRequire("bQm3c");


var $hEeUR = parcelRequire("hEeUR");


var $hMRhJ = parcelRequire("hMRhJ");


var $gGHFp = parcelRequire("gGHFp");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");

const $747431ca82b27ac2$var$DEFAULT_DOCUMENT = {
    version: 1,
    type: 'doc',
    content: [
        {
            type: 'paragraph',
            content: []
        }
    ]
};
const $747431ca82b27ac2$var$collapsedEmptyLists = null; // Remove this wrapper when cleaning up feature gate `platform_editor_lce_collapse_bullets` and wrap with the div directly instead
const $747431ca82b27ac2$var$GatedStyleWrapper = ({ children: children })=>{
    if ((0, $9wGTI.fg)('platform_editor_lce_collapse_bullets')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_1t4wglyw _1syfglyw _1pnoidpf _1gocidpf"
        ])
    }, children);
    return children;
};
const $747431ca82b27ac2$export$8fcd935e1198b8e1 = /*#__PURE__*/ (0, $42omo.memo)(({ node: node })=>{
    const spaceId = (0, $7QM6o.useSpaceId)();
    const spaceKey = (0, $cLo2u.useSpaceKey)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const [contentType = 'page'] = (0, $ep3mz.useContentType)();
    const { environment: environment, cloudId: cloudId, userId: userId, activationId: activationId } = (0, $bQm3c.useSessionData)();
    const { getExtensionHandlers: getExtensionHandlers, populateExtensionProviders: populateExtensionProviders } = (0, $42omo.useContext)((0, $hMRhJ.RendererExtensionContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const intl = (0, $8C5kA.default)();
    const { mode: editorContentMode } = (0, $gGHFp.useEditorContentModeValue)({
        contentId: contentId
    });
    const document = node?.parameters?.nestedContent || $747431ca82b27ac2$var$DEFAULT_DOCUMENT;
    const appearance = (0, $6mKj3.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true) || (0, $6mKj3.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true) ? 'max' : 'full-width';
    /**
   * Both `getExtensionHandlers` & `populateExtensionProviders` don't type check properly because in
   * `confluence/next/packages/content-renderer-extension-context/src/RendererExtensionContext.tsx`
   * the `options` is set to `any`. The reason most like is because the type lives inside classic codebase, here:
   * `confluence/packages/confluence-fabric-editor/src/lib/renderer-extensions/renderer-macro-extension-handler.tsx`
   */ const extensionHandlers = (0, $42omo.useMemo)(()=>getExtensionHandlers?.({
            adf: document,
            contentId: contentId,
            spaceKey: spaceKey,
            contentType: contentType,
            // This has not yet been set to adopt 'max' appearance by default as it will not have been adopted by extensions
            // instead setting to the largest supported width.
            // This will need to be revisited for "max width" GA release. (https://home.atlassian.com/o/2346a038-3c8c-498b-a79b-e7847859868d/s/a436116f-02ce-4520-8fbb-7301462a1674/project/ATLAS-107792/about)
            appearance: 'full-width',
            referentialityDataSourceProvider: {}
        }, createAnalyticsEvent), [
        contentId,
        contentType,
        createAnalyticsEvent,
        document,
        getExtensionHandlers,
        spaceKey
    ]);
    const annotationProvider = (0, $8Ij3v.useRendererAnnotationProviderOptions)({
        pageId: contentId ?? '',
        validAnnotationsCallback: ()=>{},
        triggerAnalyticsEvent: createAnalyticsEvent,
        updateDocument: ()=>{},
        isArchived: false
    });
    const getDataProviders = (0, $42omo.useCallback)(()=>{
        const providerFactory = (0, $4FxUL.default).create({});
        if (populateExtensionProviders) populateExtensionProviders(providerFactory, {
            activationId: activationId,
            accountId: userId,
            cloudId: cloudId,
            containerId: spaceKey,
            contentId: contentId,
            contentType: contentType,
            createAnalyticsEvent: createAnalyticsEvent,
            environment: environment,
            extensionHandlers: extensionHandlers,
            intl: intl,
            spaceKey: spaceKey,
            spaceId: spaceId
        });
        return providerFactory;
    }, [
        populateExtensionProviders,
        activationId,
        userId,
        cloudId,
        spaceKey,
        contentId,
        contentType,
        createAnalyticsEvent,
        environment,
        extensionHandlers,
        intl,
        spaceId
    ]);
    const validationContextValue = (0, $42omo.useMemo)(()=>({
            skipValidation: true
        }), []);
    (0, $42omo.useEffect)(()=>{
        if (contentId && createAnalyticsEvent && document) createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                action: 'rendererInitialised',
                actionSubject: 'legacyContentMacro',
                source: 'legacyContentMacro',
                attributes: {
                    objectId: contentId,
                    pageElementCounts: (0, $3JtSu.getPageElementCounts)(document)
                }
            }
        }).fire();
    }, [
        contentId,
        createAnalyticsEvent,
        document,
        node.localId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iZq0X.ValidationContextProvider), {
        value: validationContextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lspPP.RendererActionsContext), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($747431ca82b27ac2$var$GatedStyleWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hEeUR.ADFRenderer), {
        annotationProvider: annotationProvider,
        allowAnnotations: true,
        appearance: appearance,
        allowHeadingAnchorLinks: false,
        contentId: contentId,
        dataProviders: getDataProviders(),
        document: document,
        extensionHandlers: (0, $9wGTI.fg)('platform_editor_lce_dataprovider-only_handlers') ? undefined : extensionHandlers,
        contentMode: editorContentMode
    }))));
});


const $90e09e5972c02f7f$export$91aed7d8dfc4aa1f = (props)=>{
    const [contentId] = (0, $ep3mz.usePageContentId)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).CC_EDITOR_AI,
        attributes: {
            contentId: contentId,
            nodeLocalId: props.node?.localId
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $747431ca82b27ac2$export$8fcd935e1198b8e1), {
        node: props.node
    }));
};
module.exports["LegacyContentExtensionHandler"] = $90e09e5972c02f7f$export$91aed7d8dfc4aa1f;

});

parcelRegister("7NX4e", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $2HGN8 = parcelRequire("2HGN8");


var $hMRhJ = parcelRequire("hMRhJ");


var $giS6h = parcelRequire("giS6h");


var $jJli4 = parcelRequire("jJli4");

/**
 * Extension handler for "excerpt-include" macro.
 *
 * This macro, when given a target page, will attempt to fetch and display
 * the first excerpt found on the target page.
 */ const $98ab978010b85277$var$ExcerptIncludeExtensionHandlerImpl = (props)=>{
    const { contentId: contentId, spaceKey: spaceKey, extensionKey: extensionKey, node: node, mode: mode, Renderer: Renderer, isLivePage: isLivePage } = props;
    const { contentAppearance: { appearance: appearance } } = (0, $2HGN8.useContentAppearance)();
    const RendererWrapper = (0, $42omo.useMemo)(()=>({ targetContentId: targetContentId, adf: adf, mediaToken: mediaToken, isInsideOfInlineExtension: isInsideOfInlineExtension })=>{
            const rendererProps = {
                contentId: targetContentId,
                spaceKey: spaceKey,
                // Transform the adf data into something PageContentRenderer understands (matching with content API response)
                data: {
                    content: {
                        nodes: [
                            {
                                body: {
                                    dynamic: {
                                        representation: 'atlas_doc_format',
                                        value: JSON.stringify({
                                            content: adf,
                                            type: 'doc'
                                        })
                                    }
                                }
                            }
                        ]
                    }
                },
                appearance: appearance,
                hasInlineComments: false,
                mediaToken: mediaToken,
                annotationProvider: undefined,
                allowAnnotations: false,
                isInsideOfInlineExtension: isInsideOfInlineExtension
            };
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Renderer, rendererProps);
        }, [
        spaceKey,
        appearance,
        Renderer
    ]);
    const componentProps = {
        mode: mode,
        contentId: contentId,
        spaceKey: spaceKey,
        extensionKey: extensionKey,
        macroNode: node,
        RendererWrapper: RendererWrapper,
        isLegacyRenderer: true,
        isLivePage: isLivePage
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jJli4.ExcerptIncludeLoader), componentProps);
};
const $98ab978010b85277$export$c9121b65b8e7bfb = (props)=>{
    const { getExtensionHandlers: getExtensionHandlers, populateExtensionProviders: populateExtensionProviders } = (0, $42omo.useContext)((0, $giS6h.ClassicEditorContext));
    const rendererExtensionOptions = (0, $42omo.useMemo)(()=>({
            getExtensionHandlers: getExtensionHandlers,
            populateExtensionProviders: populateExtensionProviders
        }), [
        getExtensionHandlers,
        populateExtensionProviders
    ]);
    // ExcerptInclude use PageContentRenderer which depends on RendererExtensionContext
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hMRhJ.RendererExtensionContext).Provider, {
        value: rendererExtensionOptions
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2HGN8.ContentAppearanceContextProvider), {
        contentId: props.contentId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($98ab978010b85277$var$ExcerptIncludeExtensionHandlerImpl, props)));
};
module.exports["ExcerptIncludeExtensionHandler"] = $98ab978010b85277$export$c9121b65b8e7bfb;

});

parcelRegister("aIqlA", function(module, exports) {

var $4FxUL = parcelRequire("4FxUL");


var $h9yJL = parcelRequire("h9yJL");


var $dh538 = parcelRequire("dh538");


var $7MEO5 = parcelRequire("7MEO5");


var $fYGGr = parcelRequire("fYGGr");


var $1c598 = parcelRequire("1c598");

const $c8c0ee2f628d6095$export$5e2bcfbdd2ce465e = 'configUserPicker';
class $c8c0ee2f628d6095$export$2191b9da168c6cf0 extends Error {
    constructor(message){
        super(message);
        Object.setPrototypeOf(this, $c8c0ee2f628d6095$export$2191b9da168c6cf0.prototype);
    }
}
const $c8c0ee2f628d6095$export$d856d2d55ba6ad50 = `For this app to display, you need to press the Allow Access button in the
macro to allow the app to access Atlassian products on your behalf.`;
function $c8c0ee2f628d6095$var$findDefaultValue(options, isMulti) {
    const defaultValues = options.reduce((acc, { props: props })=>{
        if (props) for (const prop of [
            'defaultChecked',
            'defaultSelected'
        ]){
            if (prop in props) return [
                ...acc,
                props.value
            ];
        }
        return acc;
    }, []);
    return isMulti ? defaultValues : defaultValues[0];
}
const $c8c0ee2f628d6095$var$findItems = (options)=>options.map(({ props: props, type: type })=>{
        if (!props) throw new Error(`Props are undefined on ${type}`);
        return {
            label: props.label,
            value: props.value
        };
    });
const $c8c0ee2f628d6095$var$fieldMap = {
    TextField: (props)=>({
            type: 'string',
            name: props.name,
            label: props.label,
            description: props.description,
            defaultValue: props.defaultValue,
            isRequired: props.isRequired,
            isHidden: props.isHidden,
            placeholder: props.placeholder
        }),
    DatePicker: (props)=>({
            type: 'date',
            name: props.name,
            label: props.label,
            description: props.description,
            defaultValue: props.defaultValue,
            isRequired: props.isRequired,
            placeholder: props.placeholder
        }),
    Select: (props, children)=>({
            type: 'enum',
            name: props.name,
            label: props.label,
            description: props.description,
            isRequired: props.isRequired,
            style: 'select',
            isMultiple: props.isMulti,
            placeholder: props.placeholder,
            items: $c8c0ee2f628d6095$var$findItems(children),
            defaultValue: $c8c0ee2f628d6095$var$findDefaultValue(children, props.isMulti)
        }),
    CheckboxGroup: (props, children)=>({
            type: 'enum',
            name: props.name,
            label: props.label,
            description: props.description,
            isRequired: props.isRequired,
            style: 'checkbox',
            isMultiple: true,
            items: $c8c0ee2f628d6095$var$findItems(children),
            defaultValue: $c8c0ee2f628d6095$var$findDefaultValue(children, true)
        }),
    RadioGroup: (props, children)=>({
            type: 'enum',
            name: props.name,
            label: props.label,
            description: props.description,
            isRequired: props.isRequired,
            style: 'radio',
            isMultiple: false,
            items: $c8c0ee2f628d6095$var$findItems(children),
            defaultValue: $c8c0ee2f628d6095$var$findDefaultValue(children, false)
        }),
    UserPicker: (props)=>({
            type: 'user',
            name: props.name,
            label: props.label,
            isMultiple: props.isMulti,
            isRequired: props.isRequired,
            options: {
                provider: {
                    type: $c8c0ee2f628d6095$export$5e2bcfbdd2ce465e
                }
            },
            placeholder: props.placeholder,
            description: props.description,
            defaultValue: props.defaultValue
        }),
    TextArea: (props)=>({
            type: 'string',
            name: props.name,
            style: 'multiline',
            label: props.label,
            placeholder: props.placeholder,
            description: props.description,
            isRequired: props.isRequired,
            defaultValue: props.defaultValue
        })
};
const $c8c0ee2f628d6095$var$getSelectDefaultValue = (options, isMulti)=>{
    if (!options) return undefined;
    if (Array.isArray(options)) return isMulti ? options.map((option)=>option.value) : options[0].value;
    return options.value;
};
const $c8c0ee2f628d6095$var$codegenComponentFieldMap = {
    Textfield: (props)=>({
            type: 'string',
            name: props.name,
            label: props.label,
            description: props.description,
            defaultValue: props.defaultValue,
            isRequired: props.isRequired,
            isHidden: props.isHidden,
            placeholder: props.placeholder
        }),
    DatePicker: (props)=>({
            type: 'date',
            name: props.name,
            label: props.label,
            defaultValue: props.defaultValue,
            isRequired: props.isRequired,
            placeholder: props.placeholder
        }),
    Select: (props)=>({
            type: 'enum',
            name: props.name,
            label: props.label,
            description: props.description,
            isRequired: props.isRequired,
            style: 'select',
            isMultiple: props.isMulti,
            placeholder: props.placeholder,
            items: props.options,
            defaultValue: $c8c0ee2f628d6095$var$getSelectDefaultValue(props.defaultValue, props.isMulti)
        }),
    CheckboxGroup: (props)=>({
            type: 'enum',
            name: props.name,
            label: props.label,
            isRequired: props.isRequired,
            isMultiple: true,
            style: 'checkbox',
            items: props.options,
            defaultValue: props.defaultValue
        }),
    RadioGroup: (props)=>({
            type: 'enum',
            name: props.name,
            label: props.label,
            isRequired: props.isRequired,
            style: 'radio',
            isMultiple: false,
            items: props.options,
            defaultValue: props.defaultValue
        }),
    UserPicker: (props)=>({
            type: 'user',
            name: props.name,
            label: props.label,
            isMultiple: props.isMulti,
            isRequired: props.isRequired,
            options: {
                provider: {
                    type: $c8c0ee2f628d6095$export$5e2bcfbdd2ce465e
                }
            },
            placeholder: props.placeholder,
            description: props.description,
            defaultValue: props.defaultValue
        }),
    TextArea: (props)=>({
            type: 'string',
            name: props.name,
            style: 'multiline',
            label: props.label,
            placeholder: props.placeholder,
            isRequired: props.isRequired,
            defaultValue: props.defaultValue
        })
};
/** The shape of the XIS error is "Expected direct child of MacroConfig to be one of [...]. Received <component> component."
 * for each component, which is not ideal if the app contains multiple invalid components as the first part repeats.
 */ const $c8c0ee2f628d6095$var$formatErrorDetailsFromXIS = (errorDetails)=>{
    let invalidComponentArr = [];
    const regex = /Received (.*?) component/g;
    let match;
    while((match = regex.exec(errorDetails)) !== null){
        const [_, component] = match;
        invalidComponentArr.push(component);
    }
    return $c8c0ee2f628d6095$var$createValidationError(invalidComponentArr);
};
const $c8c0ee2f628d6095$var$createValidationError = (invalidComponentTypes)=>{
    // Filter out duplicate types. e.g. if there were multiple Images we only need to mention it once.
    // Error shouldn't look like: "Image and Image components are not supported in macro config"
    const types = [
        ...new Set(invalidComponentTypes)
    ];
    return `${types.length === 1 ? '' : `${types.slice(0, -1).join(', ')} and`} ${types.slice(-1)} components are not supported in macro config`;
};
const $c8c0ee2f628d6095$var$toLabelInferredForgeDoc = (configForgeDoc)=>{
    const newConfigForgeDoc = [];
    let previousNodeLabel = null;
    configForgeDoc.forEach(({ children: children, props: props, type: type, ...rest })=>{
        const newProps = {
            ...props
        };
        if (previousNodeLabel && type !== 'Label') {
            newProps.label = previousNodeLabel;
            previousNodeLabel = null;
        } else if (type === 'Label') previousNodeLabel = children[0]?.props?.text ?? null;
        else if (props && !props.label) newProps.label = '';
        newConfigForgeDoc.push({
            ...rest,
            children: children,
            type: type,
            props: newProps
        });
    });
    return newConfigForgeDoc;
};
const $c8c0ee2f628d6095$export$bc2ca0929473b0d4 = (configChildren, forgeReactMajorVersion)=>{
    /* For codegen components, the label prop does not exist on the component, so we are allowing users to add <Label/> components to format their config the same way.
     This requires the following mutation where the label text gets applied to the next component. Editor also requires a label component in their mapping
     (see https://product-fabric.atlassian.net/wiki/spaces/E/pages/1245610891/Extension+configuration) so we must mutate the props like so.
   */ const configChildrenClone = $c8c0ee2f628d6095$var$toLabelInferredForgeDoc(configChildren);
    const schema = forgeReactMajorVersion && forgeReactMajorVersion >= 10 ? configChildrenClone.filter((forgeDoc)=>forgeDoc.type !== 'Label').map(({ children: children, props: props, type: type })=>{
        if (!$c8c0ee2f628d6095$var$codegenComponentFieldMap[type]) return type;
        return $c8c0ee2f628d6095$var$codegenComponentFieldMap[type](props || {}, children);
    }) : configChildren.map(({ children: children, props: props, type: type })=>{
        if (!$c8c0ee2f628d6095$var$fieldMap[type]) return type;
        return $c8c0ee2f628d6095$var$fieldMap[type](props || {}, children);
    });
    // Check if any validation errors occured
    const invalidComponentTypes = schema.filter((field)=>typeof field === 'string');
    if (invalidComponentTypes.length > 0) throw new $c8c0ee2f628d6095$export$2191b9da168c6cf0($c8c0ee2f628d6095$var$createValidationError(invalidComponentTypes));
    return schema;
};
const $c8c0ee2f628d6095$export$1f45aada55d3f94 = (forgeDoc)=>{
    const forgeReactMajorVersion = forgeDoc.children[0]?.forgeReactMajorVersion;
    for (const { type: type, props: props, children: children } of forgeDoc.children){
        if (type === 'ErrorPanel' && props) {
            const { error: { errorMessage: errorMessage, errorDetails: errorDetails } } = props;
            if (errorMessage.includes('Validation error') && errorDetails.includes('Expected direct child of MacroConfig to be one of')) throw new $c8c0ee2f628d6095$export$2191b9da168c6cf0($c8c0ee2f628d6095$var$formatErrorDetailsFromXIS(errorDetails));
            throw new Error(`${errorDetails || errorMessage || ''}`);
        }
        if (type === 'ThreeLOPrompt') throw new Error($c8c0ee2f628d6095$export$d856d2d55ba6ad50);
        if (type === 'MacroConfig') return $c8c0ee2f628d6095$export$bc2ca0929473b0d4(children, forgeReactMajorVersion);
    }
    throw new Error('<MacroConfig> must be used at the root');
};


var $7TH2w = parcelRequire("7TH2w");


var $45DA9 = parcelRequire("45DA9");

var $3Spjc = parcelRequire("3Spjc");


var $luNHV = parcelRequire("luNHV");


var $eSUdr = parcelRequire("eSUdr");

const $3a02e5f9ae610962$export$fc98ec826c78a30a = (0, $eSUdr.default)`mutation forge_ui_invokeAuxEffects($input:InvokeAuxEffectsInput!){invokeAuxEffects(input:$input){success errors{message extensions{errorType statusCode}}result{effects contextToken{jwt expiresAt}metrics{appTimeMs}}}}`;
class $3a02e5f9ae610962$export$3e5b797e39668f84 extends Error {
    constructor(message){
        super(message);
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $3a02e5f9ae610962$export$3e5b797e39668f84.prototype);
    }
}

const $a82f99ddad604af5$export$6c64e011838f4702 = (state, coreData, extensionData)=>({
        type: 'render',
        state: state,
        coreData: coreData,
        extensionData: extensionData
    });
const $a82f99ddad604af5$export$a25b161784eeaea3 = (state, coreData, extensionData, handler, args)=>({
        type: 'event',
        state: state,
        coreData: coreData,
        extensionData: extensionData,
        handler: handler,
        args: args
    });


function $ccb68903a0701efb$export$87e7ecd3c677fc5a(extensionInstanceIds, graphqlPayload, extensionData) {
    const { contextIds: contextIds, extensionId: extensionId, localId: localId, functionId: functionId } = extensionInstanceIds;
    const { context: context, ...payload } = graphqlPayload;
    return {
        contextIds: contextIds,
        extensionId: extensionId,
        ...functionId ? {
            entryPoint: functionId
        } : {},
        payload: {
            ...payload,
            context: {
                ...context,
                extensionData: extensionData,
                localId: localId
            }
        }
    };
}
function $ccb68903a0701efb$export$468ca752219bf1f(extensionInstanceIds, graphqlPayload, extensionData) {
    const { contextIds: contextIds, extensionId: extensionId } = extensionInstanceIds;
    const { context: context, contextToken: contextToken, ...payload } = graphqlPayload;
    return {
        contextIds: contextIds,
        extensionId: extensionId,
        payload: {
            effects: payload.effects.map((effect)=>{
                switch(effect.type){
                    case 'event':
                        {
                            const { cloudId: cloudId, localId: localId, ...rest } = context;
                            return (0, $a82f99ddad604af5$export$a25b161784eeaea3)(payload.state, {
                                cloudId: cloudId,
                                localId: localId
                            }, extensionData || rest, effect.handler, effect.args);
                        }
                    case 'initialize':
                        {
                            const { cloudId: cloudId, localId: localId, ...rest } = context;
                            return (0, $a82f99ddad604af5$export$6c64e011838f4702)(payload.state, {
                                cloudId: cloudId,
                                localId: localId
                            }, extensionData || rest);
                        }
                    default:
                        return effect;
                }
            }),
            contextToken: contextToken,
            state: {},
            context: {}
        }
    };
}


function $2516d68c90a4eb76$var$isRenderEffect(effect) {
    return effect.type === 'render' && !!effect.aux && !!effect.state;
}
function $2516d68c90a4eb76$var$isResultEffect(effect) {
    return effect.type === 'result' && !!effect.forgeDoc && !!effect.state;
}
function $2516d68c90a4eb76$export$e1cc320ad208a904(effect) {
    return $2516d68c90a4eb76$var$isRenderEffect(effect) || $2516d68c90a4eb76$var$isResultEffect(effect);
}
function $2516d68c90a4eb76$export$d8d6c2eccfad5495(effects) {
    return effects.every($2516d68c90a4eb76$export$e1cc320ad208a904);
}
function $2516d68c90a4eb76$var$isGQLInvokeAuxEffectsResponseSucceeded(response) {
    return response.success;
}
function $2516d68c90a4eb76$export$1b8128d58c803707(mutationResult, onAPIError) {
    /**
	 * If we pass onError to useMutation, with the default error policy
	 * the promise will always resolve but could be undefined
	 * See https://stackoverflow.com/questions/59465864/handling-errors-with-react-apollo-usemutation-hook
	 */ if (!mutationResult) return [];
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const response = mutationResult.data.invokeAuxEffects || {};
    const { result: result = {} } = response;
    if (!$2516d68c90a4eb76$var$isGQLInvokeAuxEffectsResponseSucceeded(response)) {
        const error = response.errors?.[0];
        const statusCode = error?.extensions?.statusCode;
        // 3LO prompt or user code error
        if (statusCode === 400 || statusCode === 500) {
            if (!result.effects) return onAPIError(error?.message);
        } else return onAPIError(error?.message);
    }
    if (!$2516d68c90a4eb76$export$d8d6c2eccfad5495(result.effects)) return onAPIError('received a non-client effect');
    return result.effects;
}
function $2516d68c90a4eb76$export$d47116ac6b50eb31(extensionInstanceIds, mutationFn, onAPIError, extensionData) {
    let payloadVersion = 1;
    // We only need the mutFn, not the data as we get that later
    return async (backendRuntimePayload)=>{
        const mutationResult = await mutationFn({
            variables: {
                input: payloadVersion === 1 ? (0, $ccb68903a0701efb$export$87e7ecd3c677fc5a)(extensionInstanceIds, backendRuntimePayload, extensionData) : (0, $ccb68903a0701efb$export$468ca752219bf1f)(extensionInstanceIds, backendRuntimePayload, extensionData)
            }
        });
        const effects = $2516d68c90a4eb76$export$1b8128d58c803707(mutationResult, onAPIError);
        return effects.map((e)=>{
            // if we receive 'result' effect this means the app is using a version of @forge/ui with the updated effect shape
            // the ideal way to do this would be to version the payload and response
            if (e.type === 'result') {
                payloadVersion = 2;
                return {
                    type: 'render',
                    aux: e.forgeDoc,
                    state: e.state
                };
            }
            return e;
        });
    };
}






function $4cd75da05087f7d2$export$4ea6c6225eccc91(parameters) {
    return parameters?.macroMetadata?.macroId?.value;
}











var $31HPn = parcelRequire("31HPn");

const $91ea3b98b23f5ddc$export$30c16f5c43437fd7 = {
    FORGE_EXTENSION_INSERTED: 'inserted',
    FORGE_EXTENSION_FAILED: 'failed',
    FORGE_EXTENSION_ERRORED: 'errored',
    FORGE_MACRO_AUTO_CONVERT_SUCCESS: 'auto_convert_success',
    FORGE_MACRO_AUTO_CONVERT_TO_SMARTLINK: 'auto_convert_to_smartlink',
    H11N_CONFIG_WARNING: 'h11n_macro_config_warning',
    H11N_CONFIG_ERROR: 'h11n_macro_config_error',
    H11N_RESOLVE_FAILED: 'h11n_macro_resolve_failed',
    H11N_UPGRADE_RICH_TEST_SKIPPED: 'h11n_macro_upgrade_rich_text_skipped',
    H11N_UPGRADE_SUCCESS: 'h11n_macro_upgrade_success',
    H11N_UPGRADE_FAILED: 'h11n_macro_upgrade_failed',
    H11N_RENDER_SUCCESS: 'h11n_macro_render_success',
    H11N_RENDER_FAILED: 'h11n_macro_render_success',
    APP_MIGRATION_P2_MACRO_RESOLVED: 'app_migration_p2_macro_resolved',
    APP_MIGRATION_P2_MACRO_UPGRADE: 'app_migration_p2_macro_upgrade'
};
const $91ea3b98b23f5ddc$export$3d970ca206012d6b = ({ analyticsWebClient: analyticsWebClient, forgeUIAnalyticsContext: forgeUIAnalyticsContext, source: source })=>{
    const analyticsClient = {
        sendEvent: (action, params)=>{
            const { localId: localId, nodeLocalId: nodeLocalId, extension: extension, extensionId: id, extensionKey: extensionKey, extensionType: extensionType, error: error, macroId: macroId, macroTitle: macroTitle, link: link, forgeEnvironment: forgeEnvironment, render: render } = params;
            const extensionId = id || extension?.id;
            const { environmentType: environmentType } = extension || {};
            const commonAttributes = {
                ...(0, $45DA9.extensionIdToAnalyticsAttributes)(extensionId),
                ...extension?.environmentType ? {
                    forgeEnvironment: environmentType
                } : {}
            };
            const errorMessage = error instanceof Error ? error.message : String(error);
            const errorName = error instanceof Error ? error.name : String(error);
            const eventProperties = action.startsWith('h11n') ? {
                action: action,
                actionSubject: (0, $31HPn.CONNECT_ADDON_ACTION_SUBJECT),
                actionSubjectId: commonAttributes.extensionKey,
                eventType: (0, $7TH2w.OPERATIONAL_EVENT_TYPE),
                source: source,
                ...forgeUIAnalyticsContext
            } : action.startsWith('app_migration') ? {
                action: action,
                actionSubject: (0, $31HPn.MIGRATED_SERVER_P2_ADDON_ACTION_SUBJECT),
                actionSubjectId: commonAttributes.extensionKey,
                eventType: (0, $7TH2w.OPERATIONAL_EVENT_TYPE),
                source: source,
                ...forgeUIAnalyticsContext
            } : {
                action: action,
                actionSubject: (0, $31HPn.FORGE_EXTENSION),
                actionSubjectId: extensionId,
                eventType: (0, $7TH2w.OPERATIONAL_EVENT_TYPE),
                source: source,
                ...forgeUIAnalyticsContext
            };
            switch(action){
                case $91ea3b98b23f5ddc$export$30c16f5c43437fd7.H11N_UPGRADE_SUCCESS:
                    (0, $3Spjc.sendEvent)(analyticsWebClient)({
                        ...eventProperties,
                        eventType: (0, $7TH2w.TRACK_EVENT_TYPE),
                        attributes: {
                            ...commonAttributes,
                            localId: localId,
                            nodeLocalId: nodeLocalId,
                            extensionType: extensionType
                        }
                    });
                    return;
                case $91ea3b98b23f5ddc$export$30c16f5c43437fd7.H11N_RENDER_SUCCESS:
                    (0, $3Spjc.sendEvent)(analyticsWebClient)({
                        ...eventProperties,
                        attributes: {
                            ...commonAttributes,
                            nodeLocalId: nodeLocalId
                        }
                    });
                    return;
                case $91ea3b98b23f5ddc$export$30c16f5c43437fd7.H11N_RENDER_FAILED:
                    (0, $3Spjc.sendEvent)(analyticsWebClient)({
                        ...eventProperties,
                        attributes: {
                            ...commonAttributes,
                            nodeLocalId: nodeLocalId,
                            errorMessage: errorMessage
                        }
                    });
                    return;
                case $91ea3b98b23f5ddc$export$30c16f5c43437fd7.H11N_UPGRADE_FAILED:
                    (0, $3Spjc.sendEvent)(analyticsWebClient)({
                        ...eventProperties,
                        actionSubjectId: extensionKey,
                        attributes: {
                            ...commonAttributes,
                            nodeLocalId: nodeLocalId,
                            errorMessage: errorMessage,
                            extensionKey: extensionKey,
                            extensionType: extensionType
                        }
                    });
                    return;
                case $91ea3b98b23f5ddc$export$30c16f5c43437fd7.H11N_UPGRADE_RICH_TEST_SKIPPED:
                    (0, $3Spjc.sendEvent)(analyticsWebClient)({
                        ...eventProperties,
                        attributes: {
                            ...commonAttributes,
                            nodeLocalId: nodeLocalId,
                            extensionType: (0, $31HPn.EXTENSION_NAMESPACE)
                        }
                    });
                    return;
                case $91ea3b98b23f5ddc$export$30c16f5c43437fd7.H11N_RESOLVE_FAILED:
                    (0, $3Spjc.sendEvent)(analyticsWebClient)({
                        ...eventProperties,
                        attributes: {
                            ...commonAttributes,
                            errorMessage: errorMessage,
                            extensionKey: extensionKey
                        }
                    });
                    return;
                case $91ea3b98b23f5ddc$export$30c16f5c43437fd7.APP_MIGRATION_P2_MACRO_RESOLVED:
                    (0, $3Spjc.sendEvent)(analyticsWebClient)({
                        ...eventProperties,
                        attributes: {
                            ...commonAttributes,
                            extensionType: extensionType,
                            extensionKey: extensionKey
                        }
                    });
                    return;
                case $91ea3b98b23f5ddc$export$30c16f5c43437fd7.APP_MIGRATION_P2_MACRO_UPGRADE:
                    (0, $3Spjc.sendEvent)(analyticsWebClient)({
                        ...eventProperties,
                        attributes: {
                            ...commonAttributes,
                            localId: localId,
                            nodeLocalId: nodeLocalId,
                            extensionId: extensionId,
                            extensionType: extensionType,
                            extensionKey: extensionKey
                        }
                    });
                    return;
                case $91ea3b98b23f5ddc$export$30c16f5c43437fd7.H11N_CONFIG_WARNING:
                case $91ea3b98b23f5ddc$export$30c16f5c43437fd7.H11N_CONFIG_ERROR:
                    (0, $3Spjc.sendEvent)(analyticsWebClient)({
                        ...eventProperties,
                        actionSubjectId: extensionId,
                        attributes: {
                            errorMessage: errorMessage,
                            macroId: macroId,
                            macroTitle: macroTitle,
                            macroKey: extension?.key,
                            extensionId: extensionId,
                            migrationKey: extension?.migrationKey
                        }
                    });
                    return;
                case $91ea3b98b23f5ddc$export$30c16f5c43437fd7.FORGE_EXTENSION_INSERTED:
                    (0, $3Spjc.sendEvent)(analyticsWebClient)({
                        ...eventProperties,
                        attributes: {
                            ...commonAttributes,
                            localId: localId,
                            extensionType: (0, $31HPn.EXTENSION_NAMESPACE)
                        }
                    });
                    return;
                case $91ea3b98b23f5ddc$export$30c16f5c43437fd7.FORGE_EXTENSION_FAILED:
                    (0, $3Spjc.sendEvent)(analyticsWebClient)({
                        ...eventProperties,
                        actionSubjectId: extensionId,
                        attributes: {
                            ...commonAttributes,
                            method: 'convertNodeToForgeExtension',
                            localId: localId,
                            errorMessage: errorMessage
                        }
                    });
                    return;
                case $91ea3b98b23f5ddc$export$30c16f5c43437fd7.FORGE_EXTENSION_ERRORED:
                    (0, $3Spjc.sendEvent)(analyticsWebClient)({
                        ...eventProperties,
                        actionSubjectId: extensionId,
                        attributes: {
                            ...commonAttributes,
                            errorName: errorName,
                            errorMessage: errorMessage,
                            extensionType: (0, $31HPn.EXTENSION_NAMESPACE)
                        }
                    });
                    return;
                case $91ea3b98b23f5ddc$export$30c16f5c43437fd7.FORGE_MACRO_AUTO_CONVERT_SUCCESS:
                    // Event registered at https://data-portal.internal.atlassian.com/analytics/registry/77268?tabIndex=Details
                    (0, $3Spjc.sendEvent)(analyticsWebClient)({
                        ...eventProperties,
                        actionSubjectId: extensionId,
                        attributes: {
                            ...commonAttributes,
                            link: link,
                            macroTitle: macroTitle,
                            forgeEnvironment: forgeEnvironment,
                            render: render
                        }
                    });
                    return;
                default:
                    return;
            }
        }
    };
    return analyticsClient;
};


// We keep track of the macro IDs that were rendered as Forge macros, for analytics purposes
const $9e4c06087ba25b96$var$connectRenderedAsForgeMacroIds = new Set();
const $9e4c06087ba25b96$export$44487a86467333c3 = ({ config: config, guestParams: guestParams })=>guestParams || config;
const $9e4c06087ba25b96$var$retirementMessage = `The app's version is outdated due to a deprecated platform component.\nThe app developer needs to update it to a compatible version.\nPlease ask your admin to check for updates or contact the app developer.`;
const $9e4c06087ba25b96$export$b76d6fd67df268aa = ({ analyticsWebClient: analyticsWebClient, apolloClient: apolloClient, contextIds: contextIds, cloudId: cloudId, extensionData: extensionData })=>async (data)=>{
        const { extensionId: extensionId, localId: localId, extension: extension } = data;
        if ((0, $dh538.fg)('platform_disable_ui_kit_1_config_renderer')) throw new Error($9e4c06087ba25b96$var$retirementMessage);
        const config = $9e4c06087ba25b96$export$44487a86467333c3(data);
        try {
            const input = (0, $ccb68903a0701efb$export$87e7ecd3c677fc5a)({
                contextIds: contextIds,
                extensionId: extensionId,
                localId: localId,
                functionId: 'config'
            }, {
                effects: [
                    {
                        type: 'initialize'
                    }
                ],
                state: {},
                config: config,
                context: {
                    isConfig: true,
                    cloudId: cloudId
                }
            }, {
                ...extensionData,
                config: config,
                isConfig: true
            });
            const mutationResult = await apolloClient.mutate({
                mutation: (0, $3a02e5f9ae610962$export$fc98ec826c78a30a),
                variables: {
                    input: input
                }
            });
            const effect = (0, $2516d68c90a4eb76$export$1b8128d58c803707)(mutationResult, (message)=>{
                throw new (0, $3a02e5f9ae610962$export$3e5b797e39668f84)(message);
            })[0];
            return (0, $c8c0ee2f628d6095$export$1f45aada55d3f94)(effect.type === 'result' ? effect.forgeDoc : effect.aux);
        } catch (error) {
            const { name: name, message: message } = error;
            if (!(error instanceof (0, $c8c0ee2f628d6095$export$2191b9da168c6cf0))) analyticsWebClient && (0, $3Spjc.sendEvent)(analyticsWebClient)({
                eventType: (0, $7TH2w.OPERATIONAL_EVENT_TYPE),
                action: 'errored',
                actionSubject: 'forge.ui.extension',
                source: 'editPageScreen',
                attributes: {
                    errorName: name,
                    errorMessage: message,
                    ...(0, $45DA9.extensionIdToAnalyticsAttributes)(extensionId),
                    extensionType: extension?.type,
                    forgeEnvironment: extension?.environmentType
                }
            });
            throw new Error(message || '');
        }
    };
const $9e4c06087ba25b96$export$affb7f1b8986663b = ({ analyticsClient: analyticsClient, extension: extension, hasCustomConfig: hasCustomConfig })=>async (parameters)=>{
        const { extensionId: extensionId, localId: localId } = parameters;
        const config = $9e4c06087ba25b96$export$44487a86467333c3(parameters);
        const id = `${extensionId}-${localId}`;
        // Until Editor forceably closes the config panel, we need to clear the fields in the panel otherwise
        // config values will be overwritten by previous fields
        if (hasCustomConfig) return [];
        const getForgeDoc = new Promise((resolve, reject)=>{
            (0, $luNHV.emit)(`GET_CONFIG_FORGE_DOC_${id}`, {
                resolve: resolve,
                reject: reject,
                config: config
            });
        });
        try {
            const forgeDoc = await getForgeDoc;
            const forgeReactMajorVersion = forgeDoc.children[0]?.forgeReactMajorVersion;
            if (!forgeReactMajorVersion && (0, $dh538.fg)('platform_disable_ui_kit_1_config_renderer')) throw new Error($9e4c06087ba25b96$var$retirementMessage);
            return (0, $c8c0ee2f628d6095$export$1f45aada55d3f94)(forgeDoc);
        } catch (error) {
            const { message: message } = error;
            if (!(error instanceof (0, $c8c0ee2f628d6095$export$2191b9da168c6cf0))) {
                const { sendEvent: sendEvent } = analyticsClient;
                sendEvent((0, $91ea3b98b23f5ddc$export$30c16f5c43437fd7).FORGE_EXTENSION_ERRORED, {
                    extension: extension,
                    error: error
                });
            }
            throw new Error(message || '');
        }
    };
const $9e4c06087ba25b96$export$55efa0cfd3b99204 = ({ analyticsClient: analyticsClient, connectToForgeBlockedExtensions: connectToForgeBlockedExtensions, eventSource: eventSource, extension: extension, hasCustomConfig: hasCustomConfig, hasUiKitOneConfig: hasUiKitOneConfig, isCustomUI: isCustomUI, isUiKitTwo: isUiKitTwo, uiKitOneGetFieldsDefinitionFunction: uiKitOneGetFieldsDefinitionFunction })=>async (parameters)=>{
        const macroId = (0, $4cd75da05087f7d2$export$4ea6c6225eccc91)(parameters);
        if (!parameters.extensionId) {
            /* If extensionId is missing, then we are dealing with a Connect or core macro instead of Forge
			 * This can happen when
			 *  - reverting a page with an upgraded Connect -> Forge addon back to Connect,
			 *  - if the Connect macro wasn't upgraded for some reason (eg. bodiedExtension / rich text macro)
			 *  - there is also a bug when loading a Forge macro, then clicking on a Connect macro that is uninstalled - https://product-fabric.atlassian.net/jira/servicedesk/projects/DTR/queues/issue/DTR-2569
			 *
			 * We can't edit/store the config in this state, so safer to just prevent panel loading
			 */ // We start by assuming it's a core macro
            let userMessage = 'Macro configuration failed to load. Please close this panel and try again.';
            let errorMessage = 'non-forge-macro';
            // Macro ID is only defined for Connect/core macros, not Forge macros (for now, this is subject to change)
            if (!macroId) throw new Error(userMessage);
            // Whether we report this as a warning (expected) or an error (unexpected)
            let isWarning = false;
            const isBodied = connectToForgeBlockedExtensions.has(macroId);
            if (isBodied) {
                userMessage = `Editing multi-bodied macros is not currently supported.`;
                errorMessage = 'bodied-macro-blocked';
                isWarning = true;
            } else if ($9e4c06087ba25b96$var$connectRenderedAsForgeMacroIds.has(macroId)) {
                // We know that at some point this macro was rendered as a Forge macro, so it must have been reverted
                userMessage = 'This macro has been reverted. Please close this panel and try again.';
                errorMessage = 'macro-reverted';
                isWarning = true;
            }
            // Only report h11n errors for harmonised Connect macros
            if (extension.migrationKey) {
                const { sendEvent: sendEvent } = analyticsClient;
                if (isWarning) sendEvent((0, $91ea3b98b23f5ddc$export$30c16f5c43437fd7).H11N_CONFIG_WARNING, {
                    extension: extension,
                    error: errorMessage,
                    macroId: macroId,
                    macroTitle: parameters.macroMetadata?.title
                });
                else sendEvent((0, $91ea3b98b23f5ddc$export$30c16f5c43437fd7).H11N_CONFIG_ERROR, {
                    extension: extension,
                    error: errorMessage,
                    macroId: macroId,
                    macroTitle: parameters.macroMetadata?.title
                });
            }
        }
        // If we make it here, we are dealing with a Forge macro with an extensionId
        if (macroId) $9e4c06087ba25b96$var$connectRenderedAsForgeMacroIds.add(macroId);
        const uiKitTwoGetFieldsDefinitionFunction = $9e4c06087ba25b96$export$affb7f1b8986663b({
            analyticsClient: analyticsClient,
            extension: extension,
            hasCustomConfig: hasCustomConfig
        });
        return (isCustomUI || isUiKitTwo) && !hasUiKitOneConfig ? uiKitTwoGetFieldsDefinitionFunction(parameters) : uiKitOneGetFieldsDefinitionFunction(parameters);
    };


var $fbPMY = parcelRequire("fbPMY");
const $e2cd313e500316d2$export$44487a86467333c3 = ({ config: config, guestParams: guestParams })=>guestParams || config;
const $e2cd313e500316d2$export$c995c5854d98b6ef = (parameters)=>$e2cd313e500316d2$export$44487a86467333c3(parameters);
const $e2cd313e500316d2$export$33006db0d9b837ff = (parameters)=>({
        guestParams: parameters
    });


var $iyDxB = parcelRequire("iyDxB");


var $1MUpo = parcelRequire("1MUpo");

var $caRYB = parcelRequire("caRYB");


var $jqXx5 = parcelRequire("jqXx5");


var $gLLcz = parcelRequire("gLLcz");

// lib/isZodErrorLike.ts

var $6acb5 = parcelRequire("6acb5");




function $d566c53acd9fe8df$export$1a9c93cf4c5ae6b(err) {
    return err instanceof Error && err.name === "ZodError" && "issues" in err && Array.isArray(err.issues);
}
// lib/ValidationError.ts
var $d566c53acd9fe8df$export$2191b9da168c6cf0 = class extends Error {
    toString() {
        return this.message;
    }
    constructor(message, options){
        super(message, options), (0, $6acb5._)(this, "name", void 0), (0, $6acb5._)(this, "details", void 0);
        this.name = "ZodValidationError";
        this.details = $d566c53acd9fe8df$var$getIssuesFromErrorOptions(options);
    }
};
function $d566c53acd9fe8df$var$getIssuesFromErrorOptions(options) {
    if (options) {
        const cause = options.cause;
        if ($d566c53acd9fe8df$export$1a9c93cf4c5ae6b(cause)) return cause.issues;
    }
    return [];
}
// lib/isValidationError.ts
function $d566c53acd9fe8df$export$f715db496ec47204(err) {
    return err instanceof $d566c53acd9fe8df$export$2191b9da168c6cf0;
}
// lib/isValidationErrorLike.ts
function $d566c53acd9fe8df$export$cb29fc10431ed2ef(err) {
    return err instanceof Error && err.name === "ZodValidationError";
}
// lib/utils/NonEmptyArray.ts
function $d566c53acd9fe8df$var$isNonEmptyArray(value) {
    return value.length !== 0;
}
// lib/utils/joinPath.ts
var $d566c53acd9fe8df$var$identifierRegex = RegExp("[$_\\p{ID_Start}][$\\u200c\\u200d\\p{ID_Continue}]*", "u");
function $d566c53acd9fe8df$var$joinPath(path) {
    if (path.length === 1) return path[0].toString();
    return path.reduce((acc, item)=>{
        if (typeof item === "number") return acc + "[" + item.toString() + "]";
        if (item.includes('"')) return acc + '["' + $d566c53acd9fe8df$var$escapeQuotes(item) + '"]';
        if (!$d566c53acd9fe8df$var$identifierRegex.test(item)) return acc + '["' + item + '"]';
        const separator = acc.length === 0 ? "" : ".";
        return acc + separator + item;
    }, "");
}
function $d566c53acd9fe8df$var$escapeQuotes(str) {
    return str.replace(/"/g, '\\"');
}
// lib/config.ts
var $d566c53acd9fe8df$var$ISSUE_SEPARATOR = "; ";
var $d566c53acd9fe8df$var$MAX_ISSUES_IN_MESSAGE = 99;
var $d566c53acd9fe8df$var$PREFIX = "Validation error";
var $d566c53acd9fe8df$var$PREFIX_SEPARATOR = ": ";
var $d566c53acd9fe8df$var$UNION_SEPARATOR = ", or ";
// lib/MessageBuilder.ts
function $d566c53acd9fe8df$export$3b08560649d6c7b9(props = {}) {
    const { issueSeparator: issueSeparator = $d566c53acd9fe8df$var$ISSUE_SEPARATOR, unionSeparator: unionSeparator = $d566c53acd9fe8df$var$UNION_SEPARATOR, prefixSeparator: prefixSeparator = $d566c53acd9fe8df$var$PREFIX_SEPARATOR, prefix: prefix = $d566c53acd9fe8df$var$PREFIX, includePath: includePath = true, maxIssuesInMessage: maxIssuesInMessage = $d566c53acd9fe8df$var$MAX_ISSUES_IN_MESSAGE } = props;
    return (issues)=>{
        const message = issues.slice(0, maxIssuesInMessage).map((issue)=>$d566c53acd9fe8df$var$getMessageFromZodIssue({
                issue: issue,
                issueSeparator: issueSeparator,
                unionSeparator: unionSeparator,
                includePath: includePath
            })).join(issueSeparator);
        return $d566c53acd9fe8df$var$prefixMessage(message, prefix, prefixSeparator);
    };
}
function $d566c53acd9fe8df$var$getMessageFromZodIssue(props) {
    const { issue: issue, issueSeparator: issueSeparator, unionSeparator: unionSeparator, includePath: includePath } = props;
    if (issue.code === $gLLcz.ZodIssueCode.invalid_union) return issue.unionErrors.reduce((acc, zodError)=>{
        const newIssues = zodError.issues.map((issue2)=>$d566c53acd9fe8df$var$getMessageFromZodIssue({
                issue: issue2,
                issueSeparator: issueSeparator,
                unionSeparator: unionSeparator,
                includePath: includePath
            })).join(issueSeparator);
        if (!acc.includes(newIssues)) acc.push(newIssues);
        return acc;
    }, []).join(unionSeparator);
    if (issue.code === $gLLcz.ZodIssueCode.invalid_arguments) return [
        issue.message,
        ...issue.argumentsError.issues.map((issue2)=>$d566c53acd9fe8df$var$getMessageFromZodIssue({
                issue: issue2,
                issueSeparator: issueSeparator,
                unionSeparator: unionSeparator,
                includePath: includePath
            }))
    ].join(issueSeparator);
    if (issue.code === $gLLcz.ZodIssueCode.invalid_return_type) return [
        issue.message,
        ...issue.returnTypeError.issues.map((issue2)=>$d566c53acd9fe8df$var$getMessageFromZodIssue({
                issue: issue2,
                issueSeparator: issueSeparator,
                unionSeparator: unionSeparator,
                includePath: includePath
            }))
    ].join(issueSeparator);
    if (includePath && $d566c53acd9fe8df$var$isNonEmptyArray(issue.path)) {
        if (issue.path.length === 1) {
            const identifier = issue.path[0];
            if (typeof identifier === "number") return `${issue.message} at index ${identifier}`;
        }
        return `${issue.message} at "${$d566c53acd9fe8df$var$joinPath(issue.path)}"`;
    }
    return issue.message;
}
function $d566c53acd9fe8df$var$prefixMessage(message, prefix, prefixSeparator) {
    if (prefix !== null) {
        if (message.length > 0) return [
            prefix,
            message
        ].join(prefixSeparator);
        return prefix;
    }
    if (message.length > 0) return message;
    return $d566c53acd9fe8df$var$PREFIX;
}
// lib/fromZodIssue.ts
function $d566c53acd9fe8df$export$c7733c549e56da8b(issue, options = {}) {
    const messageBuilder = $d566c53acd9fe8df$var$createMessageBuilderFromOptions(options);
    const message = messageBuilder([
        issue
    ]);
    return new $d566c53acd9fe8df$export$2191b9da168c6cf0(message, {
        cause: new $gLLcz.ZodError([
            issue
        ])
    });
}
function $d566c53acd9fe8df$var$createMessageBuilderFromOptions(options) {
    if ("messageBuilder" in options) return options.messageBuilder;
    return $d566c53acd9fe8df$export$3b08560649d6c7b9(options);
}
// lib/errorMap.ts
var $d566c53acd9fe8df$export$2c018edeeb9ce969 = (issue, ctx)=>{
    const error = $d566c53acd9fe8df$export$c7733c549e56da8b({
        ...issue,
        // fallback to the default error message
        // when issue does not have a message
        message: issue.message ?? ctx.defaultError
    });
    return {
        message: error.message
    };
};
// lib/fromZodError.ts
function $d566c53acd9fe8df$export$7952627fdcb1e348(zodError, options = {}) {
    if (!$d566c53acd9fe8df$export$1a9c93cf4c5ae6b(zodError)) throw new TypeError(`Invalid zodError param; expected instance of ZodError. Did you mean to use the "${$d566c53acd9fe8df$export$4fd972edbe7450d3.name}" method instead?`);
    return $d566c53acd9fe8df$var$fromZodErrorWithoutRuntimeCheck(zodError, options);
}
function $d566c53acd9fe8df$var$fromZodErrorWithoutRuntimeCheck(zodError, options = {}) {
    const zodIssues = zodError.errors;
    let message;
    if ($d566c53acd9fe8df$var$isNonEmptyArray(zodIssues)) {
        const messageBuilder = $d566c53acd9fe8df$var$createMessageBuilderFromOptions2(options);
        message = messageBuilder(zodIssues);
    } else message = zodError.message;
    return new $d566c53acd9fe8df$export$2191b9da168c6cf0(message, {
        cause: zodError
    });
}
function $d566c53acd9fe8df$var$createMessageBuilderFromOptions2(options) {
    if ("messageBuilder" in options) return options.messageBuilder;
    return $d566c53acd9fe8df$export$3b08560649d6c7b9(options);
}
// lib/toValidationError.ts
var $d566c53acd9fe8df$export$4995a8d075259da0 = (options = {})=>(err)=>{
        if ($d566c53acd9fe8df$export$1a9c93cf4c5ae6b(err)) return $d566c53acd9fe8df$var$fromZodErrorWithoutRuntimeCheck(err, options);
        if (err instanceof Error) return new $d566c53acd9fe8df$export$2191b9da168c6cf0(err.message, {
            cause: err
        });
        return new $d566c53acd9fe8df$export$2191b9da168c6cf0("Unknown error");
    };
// lib/fromError.ts
function $d566c53acd9fe8df$export$4fd972edbe7450d3(err, options = {}) {
    return $d566c53acd9fe8df$export$4995a8d075259da0(options)(err);
}





const $4460d49fe1c967ee$export$d6710954d38d35b9 = (data, { isBodiedExtension: isBodiedExtension, isInitialInsertion: isInitialInsertion, schema: schema })=>{
    if (!$4460d49fe1c967ee$var$isObject(data)) throw new $4460d49fe1c967ee$export$62e82e1130ec89d2('Must provide payload object', 'INVALID_PAYLOAD');
    const { config: config, keepEditing: keepEditing } = data;
    const body = data.body || data.insertBody;
    if (!$4460d49fe1c967ee$var$isObject(config)) throw new $4460d49fe1c967ee$export$62e82e1130ec89d2('Invalid "config" provided. Expected object', 'INVALID_CONFIG');
    try {
        $4460d49fe1c967ee$var$validateMacroConfig(config);
    } catch (error) {
        throw new $4460d49fe1c967ee$export$62e82e1130ec89d2($4460d49fe1c967ee$var$processMacroConfigError(error), 'INVALID_CONFIG');
    }
    // Only worth validating the body if it's actually going to be used
    if (body) {
        if (!isBodiedExtension) throw new $4460d49fe1c967ee$export$62e82e1130ec89d2('Cannot set "body" for non bodied extension', 'INVALID_EXTENSION_TYPE');
        // We need to do basic validation of the body before we can safely do proper ADF validation
        if (!$4460d49fe1c967ee$var$isDocNodeShape(body)) throw new $4460d49fe1c967ee$export$62e82e1130ec89d2('Invalid ADF "body" provided. Expected node of type doc with content', 'INVALID_BODY');
        const { valid: valid, errors: errors } = $4460d49fe1c967ee$var$validateAdfBody(body, schema);
        if (!valid || errors.length) throw new $4460d49fe1c967ee$export$62e82e1130ec89d2(`Invalid ADF "body" provided.\n${errors.map((e)=>`${e.code}: ${e.message}`).join('\n')}`, 'INVALID_BODY');
    }
    return {
        config: config,
        keepEditing: Boolean(keepEditing),
        body: body ? body : undefined
    };
};
const $4460d49fe1c967ee$export$4537e246a5edda0a = (error)=>{
    if (error instanceof Error && error.message.includes('Could not find node')) throw new $4460d49fe1c967ee$export$62e82e1130ec89d2('Macro not found.', 'MACRO_NOT_FOUND');
    throw error;
};
const $4460d49fe1c967ee$var$isObject = (obj)=>{
    return obj !== null && typeof obj === 'object' && !Array.isArray(obj);
};
const $4460d49fe1c967ee$var$isDocNodeShape = (body)=>{
    return $4460d49fe1c967ee$var$isObject(body) && body.type === 'doc' && Array.isArray(body.content);
};
class $4460d49fe1c967ee$export$62e82e1130ec89d2 extends Error {
    constructor(message, code){
        super($4460d49fe1c967ee$var$prefixMessage(message));
        this.code = void 0;
        this.code = code;
    }
}
/**
 * Recursively finds the deepest "invalid_union" issue in the unionErrors array.
 * @param unionErrors The unionErrors array to search
 * @returns The error message and path of the deepest "invalid_union" issue
 */ const $4460d49fe1c967ee$var$findDeepestUnionError = (unionErrors)=>{
    // Check if there are nested union errors:
    const nestedIssues = unionErrors.filter((error)=>error?.issues.some((issue)=>issue.code === 'invalid_union'));
    if (nestedIssues.length) {
        // Grab the first issue (it doesn't matter for union errors which one we pick)
        const firstNestedIssue = nestedIssues[0].issues[0];
        if (firstNestedIssue.code === 'invalid_union') return $4460d49fe1c967ee$var$findDeepestUnionError(firstNestedIssue.unionErrors);
    }
    // This works due to the way zod generates error messages for union types:
    // For a union type, zod generates one error message for each entry in the union
    // So we know that there will be at least one entry in the "issues" array
    return {
        message: unionErrors[0].issues[0].message,
        path: unionErrors[0].issues[0].path
    };
};
/**
 * Builds a user-friendly error message from the zod validation issues.
 * @param issues The issues generated by the zod validation
 * @returns A list of user-friendly error messages
 */ const $4460d49fe1c967ee$var$simplifyErrorMessage = (issues)=>{
    // There are two problems with the way that zod creates error messages
    // 1. For nested entries, one error message is generated for each level of nesting.
    // 2. For union types, one error message is generated for each entry in the union.
    // This code attempts to improve the error message by:
    // 1. For nested entries, only using the error message for the deepest level of nesting.
    // 2. For union types, only using the error message for the first entry in the union.
    return issues.reduce((acc, issue)=>{
        // We're only interested in changing the format for "invalid_union" issues
        if (issue.code === 'invalid_union') {
            const deepestError = $4460d49fe1c967ee$var$findDeepestUnionError(issue.unionErrors);
            acc.push({
                message: deepestError.message,
                path: deepestError.path
            });
        } else acc.push({
            message: issue.message,
            path: issue.path
        });
        return acc;
    }, []).reduce((prev, { message: message, path: path })=>prev + `${message} at "${path.join('.')}"\n`, '');
};
/**
 * Processes the error thrown by the zod validation and returns a user-friendly error message.
 * @param error The error thrown by the zod validation
 * @returns A user-friendly error message
 */ const $4460d49fe1c967ee$var$processMacroConfigError = (error)=>{
    const validationError = (0, $d566c53acd9fe8df$export$4fd972edbe7450d3)(error, {
        messageBuilder: $4460d49fe1c967ee$var$simplifyErrorMessage,
        prefix: null
    });
    return validationError.message;
};
/**
 * Validates the macro config object using zod.
 * @param config The macro config object to validate
 * @throws If the config object is invalid
 * @returns void
 */ const $4460d49fe1c967ee$var$validateMacroConfig = (config)=>{
    // These are the rules for the zod schema:
    // 1. Allowed values are: string, number, boolean, array, object
    // 2. When arrays are used, all entries must contain the same data type
    // 3. Objects can be nested and contain any of the allowed values
    // 4. Arrays can not be nested
    // Define a recursive schema to handle nested objects and arrays
    const jsonSchema = (0, $gLLcz.z).lazy(()=>(0, $gLLcz.z).union([
            (0, $gLLcz.z).undefined(),
            (0, $gLLcz.z).string(),
            (0, $gLLcz.z).number(),
            (0, $gLLcz.z).boolean(),
            (0, $gLLcz.z).object({}).catchall(jsonSchema),
            // Objects can contain any of the allowed values, including nested objects
            (0, $gLLcz.z).array((0, $gLLcz.z).union([
                (0, $gLLcz.z).string(),
                (0, $gLLcz.z).number(),
                (0, $gLLcz.z).boolean(),
                (0, $gLLcz.z).object({}).catchall(jsonSchema)
            ])).superRefine((value, ctx)=>{
                // Check if all items in the array have the same type
                if (value.length > 0) {
                    const typeOfFirstItem = typeof value[0];
                    if (!value.every((item)=>typeof item === typeOfFirstItem)) ctx.addIssue({
                        code: 'custom',
                        // using "z.ZodIssueCode.custom" here breaks the "yarn workspace @af/mono-typecheck" task somehow ¯\_(ツ)_/¯
                        message: 'All array items must be of the same type'
                    });
                }
            })
        ]));
    const configSchema = (0, $gLLcz.z).record(jsonSchema);
    configSchema.parse(config);
};
const $4460d49fe1c967ee$var$prefixMessage = (message)=>{
    return `view.submit(): ${message}`;
};
const $4460d49fe1c967ee$var$validateAdfBody = (body, editorSchema)=>{
    const schema = editorSchema || (0, $iyDxB.defaultSchema);
    const marks = Object.keys(schema.marks);
    const nodes = Object.keys(schema.nodes);
    const validate = (0, $jqXx5.validator)(nodes, marks, {
        mode: 'strict'
    });
    const { content: content } = body;
    // Make sure we're validating in the context of the extension node, to prevent invalid nested extensions
    const extension = (0, $1MUpo.bodiedExtension)({
        extensionType: (0, $31HPn.EXTENSION_NAMESPACE),
        extensionKey: 'dummy-validate-only'
    })(...content);
    const errors = [];
    const { valid: valid } = validate((0, $caRYB.doc)(extension), (_entity, error)=>{
        errors.push(error);
        return undefined;
    });
    return {
        valid: valid,
        errors: errors
    };
};



var $42omo = parcelRequire("42omo");


var $aoVih = parcelRequire("aoVih");

var $iHPbg = parcelRequire("iHPbg");


var $dedJV = parcelRequire("dedJV");


var $5dK2X = parcelRequire("5dK2X");


var $gtD4K = parcelRequire("gtD4K");

var $8C5kA = parcelRequire("8C5kA");


var $cgtv4 = parcelRequire("cgtv4");

const $ed423835ef0a1de8$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    blockedMacroTitle: {
        id: "xen-editor-provider.app-access-blocked-macro.title",
        defaultMessage: "An administrator blocked this app"
    },
    blockedMacroBodyWithAppName: {
        id: "xen-editor-provider.app-access-blocked-macro.bodyWithAppName",
        defaultMessage: "<strong>{extensionName}</strong> has been blocked by your administrator in this space. For any questions, reach out to your organization admin."
    },
    blockedMacroBodyWithoutAppName: {
        id: "xen-editor-provider.app-access-blocked-macro.bodyWithoutAppName",
        defaultMessage: "<strong>This app</strong> has been blocked by your administrator in this space. For any questions, reach out to your organization admin."
    },
    blockedMacroLearnMore: {
        id: "xen-editor-provider.app-access-blocked-macro.learnMoreAction",
        defaultMessage: "Learn more about which apps are blocked"
    },
    exportMacroError: {
        id: "xen-editor-provider.export-macro.error",
        defaultMessage: "We've encountered an issue exporting this macro. Please try exporting this page again later"
    }
});


const $32d592094b83de00$export$c168e7f7a7836a1 = ({ extensionName: extensionName })=>{
    const intl = (0, $8C5kA.default)();
    const sharedFormattedMessageValues = {
        strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
                as: "strong"
            }, chunks)
    };
    const formattedMessage = extensionName ? intl.formatMessage((0, $ed423835ef0a1de8$export$defe85febe8b728c).blockedMacroBodyWithAppName, {
        extensionName: extensionName,
        ...sharedFormattedMessageValues
    }) : intl.formatMessage((0, $ed423835ef0a1de8$export$defe85febe8b728c).blockedMacroBodyWithoutAppName, {
        ...sharedFormattedMessageValues
    });
    const identityDomain = (0, $dedJV.getATLContextDomain)('id');
    const learnMoreURL = `https://${identityDomain}/manage-profile/apps`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aoVih.default), {
        title: intl.formatMessage((0, $ed423835ef0a1de8$export$defe85febe8b728c).blockedMacroTitle),
        actions: [
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iHPbg.default), {
                href: learnMoreURL
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $ed423835ef0a1de8$export$defe85febe8b728c).blockedMacroLearnMore))
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
        as: "p"
    }, formattedMessage));
};
const $32d592094b83de00$export$17b6162b15b3194c = ({ extension: extension })=>()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($32d592094b83de00$export$c168e7f7a7836a1, {
            extensionName: extension.properties.title
        });
const $32d592094b83de00$export$61f675db88ce9814 = (extension)=>extension.type === 'xen:macro' && extension.dataClassificationPolicyDecision?.status === 'BLOCKED';





var $2XqLN = parcelRequire("2XqLN");


var $hrSFW = parcelRequire("hrSFW");









/* ForgeEditorExtension.tsx generated by @compiled/babel-plugin v0.36.1 */ 



var $gMc0m = parcelRequire("gMc0m");

/* ForgeErrorBoundary.tsx generated by @compiled/babel-plugin v0.36.1 */ 



var $7KMPr = parcelRequire("7KMPr");


var $jIiuI = parcelRequire("jIiuI");

var $5U2YR = parcelRequire("5U2YR");



var $inPa6 = parcelRequire("inPa6");










function $5c916dea5625a8d4$var$_defineProperty(e, r, t) {
    return (r = $5c916dea5625a8d4$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $5c916dea5625a8d4$var$_toPropertyKey(t) {
    var i = $5c916dea5625a8d4$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $5c916dea5625a8d4$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
class $5c916dea5625a8d4$var$ForgeErrorBoundary extends (0, $42omo.Component) {
    componentDidCatch(error, errorInfo) {
        this.setState({
            thrownError: {
                error: error,
                errorInfo: errorInfo
            }
        });
        const { page: page } = this.props;
        const environment = this.props.environment;
        (0, $7KMPr.captureAndReportError)({
            error: error,
            errorExtensionDetails: this.props.extension ? {
                type: this.props.extension.type,
                environmentType: this.props.extension.environmentType,
                appOwnerAccountId: this.props.extension.appOwner?.accountId,
                properties: this.props.extension.properties,
                id: this.props.extension?.id
            } : undefined,
            errorInfo: errorInfo,
            page: page,
            environment: environment
        });
        if (!(error instanceof (0, $3a02e5f9ae610962$export$3e5b797e39668f84))) this.props.createAnalyticsEvent({
            eventType: (0, $7TH2w.OPERATIONAL_EVENT_TYPE),
            data: {
                action: 'failed',
                actionSubject: 'forge.ui.renderer',
                source: page,
                tags: [
                    'forge'
                ],
                attributes: {
                    target: 'errorBoundary',
                    errorName: error.name
                }
            }
        }).fire((0, $3Spjc.FORGE_UI_ANALYTICS_CHANNEL));
    }
    render() {
        const { thrownError: thrownError } = this.state;
        if (!thrownError) return this.props.children;
        return /*#__PURE__*/ $42omo.createElement("div", {
            "data-testid": "ForgeErrorBoundary"
        }, /*#__PURE__*/ $42omo.createElement((0, $aoVih.default), {
            appearance: "error",
            title: "Error rendering app"
        }, thrownError.error.message));
    }
    constructor(...args){
        super(...args);
        $5c916dea5625a8d4$var$_defineProperty(this, "state", {
            thrownError: undefined
        });
    }
}
const $5c916dea5625a8d4$var$withAnalyticsContext = (Component)=>({ extension: extension, children: children })=>{
        const { page: page, environment: envFromContext } = (0, $5U2YR.useMetricsContext)();
        const environment = (0, $42omo.useContext)((0, $jIiuI.EnvironmentContext));
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
        return /*#__PURE__*/ $42omo.createElement(Component, {
            environment: envFromContext ?? environment,
            extension: extension,
            page: page,
            createAnalyticsEvent: createAnalyticsEvent
        }, children);
    };
const $5c916dea5625a8d4$var$_default_1 = $5c916dea5625a8d4$var$withAnalyticsContext($5c916dea5625a8d4$var$ForgeErrorBoundary);
var $5c916dea5625a8d4$export$2e2bcd8739ae039 = $5c916dea5625a8d4$var$_default_1;


var $HEA67 = parcelRequire("HEA67");


var $iqcSr = parcelRequire("iqcSr");





var $62fWd = parcelRequire("62fWd");








/* AdfExportRenderer.tsx generated by @compiled/babel-plugin v0.36.1 */ 









var $dj2Gr = parcelRequire("dj2Gr");

function $5743483b761563b0$var$parseExtensionId(extensionId) {
    const ari = (0, $7MEO5.parse)(extensionId);
    const [appId, environmentId, groupId, moduleKey] = ari.resourceId.split('/');
    return {
        appId: appId,
        environmentId: environmentId,
        groupId: groupId,
        moduleKey: moduleKey
    };
}
const $5743483b761563b0$export$62e4612940199d99 = ({ accountId: accountId, apolloClient: apolloClient, contextIds: contextIds, extensionId: extensionId, coreData: coreData, extensionData: extensionData, extensionPayload: extensionPayload })=>{
    const [adfDoc, setAdfDoc] = (0, $42omo.useState)(undefined);
    const [isLoading, setIsLoading] = (0, $42omo.useState)(false);
    const [error, setError] = (0, $42omo.useState)(undefined);
    const memoedContextIds = (0, $42omo.useMemo)(()=>contextIds, [
        contextIds
    ]);
    const { moduleKey: moduleKey } = $5743483b761563b0$var$parseExtensionId(extensionId);
    const siteUrl = window.location.origin;
    const memoedCoreData = (0, $42omo.useMemo)(()=>({
            accountId: accountId,
            ...coreData,
            ...extensionData,
            moduleKey: moduleKey,
            siteUrl: siteUrl
        }), [
        coreData,
        extensionData,
        moduleKey,
        siteUrl,
        accountId
    ]);
    const invoker = (0, $dj2Gr.useInvokeExtension)(memoedContextIds, extensionId, {
        client: apolloClient
    });
    (0, $42omo.useEffect)(()=>{
        const context = {
            ...memoedCoreData
        };
        const fetchAdfExport = async ()=>{
            setIsLoading(true);
            try {
                const mutationResult = await invoker({
                    context: context,
                    extensionPayload: extensionPayload,
                    exportType: 'pdf'
                }, 'adfExport');
                const response = mutationResult.data.invokeExtension.response || {};
                if (response?.body) setAdfDoc(response.body);
                setError(response?.error);
            } catch (error) {
                setError(error && error.message);
            }
            setIsLoading(false);
        };
        fetchAdfExport();
    }, [
        apolloClient,
        invoker,
        memoedCoreData,
        extensionPayload
    ]);
    return {
        adfDoc: adfDoc,
        isLoading: isLoading,
        error: error
    };
};



var $67O0h = parcelRequire("67O0h");


var $lspPP = parcelRequire("lspPP");


var $CMcde = parcelRequire("CMcde");








const $80cfae1bb0e465b8$export$f4fa252563062f56 = ({ accountId: accountId, apolloClient: apolloClient, contextIds: contextIds, coreData: coreData, dataProviders: dataProviders, extensionData: extensionData, extensionId: extensionId, extensionPayload: extensionPayload })=>{
    const { adfDoc: adfDoc, error: error, isLoading: isLoading } = (0, $5743483b761563b0$export$62e4612940199d99)({
        accountId: accountId,
        apolloClient: apolloClient,
        contextIds: contextIds,
        extensionId: extensionId,
        coreData: coreData,
        extensionData: extensionData,
        extensionPayload: extensionPayload
    });
    const intl = (0, $8C5kA.default)();
    if (error) return /*#__PURE__*/ $42omo.createElement((0, $aoVih.default), {
        appearance: "error"
    }, intl.formatMessage((0, $ed423835ef0a1de8$export$defe85febe8b728c).exportMacroError));
    if (isLoading) return /*#__PURE__*/ $42omo.createElement((0, $CMcde.Loader), null);
    if (!adfDoc) return null;
    return /*#__PURE__*/ $42omo.createElement((0, $lspPP.RendererActionsContext), null, /*#__PURE__*/ $42omo.createElement((0, $67O0h.default), {
        dataProviders: dataProviders,
        document: adfDoc
    }));
};

/* ForgeUIExtension.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $jXDcc = parcelRequire("jXDcc");

var $4233ec2836958fc5$export$d779b02e6b68c3e8;
var $4233ec2836958fc5$export$719c70722b10e5ff;
var $4233ec2836958fc5$export$ab1029bcae9ddb4a;
var $4233ec2836958fc5$export$8916d2c8119541bb;
var $4233ec2836958fc5$export$d6b40c95035461c7;
var $4233ec2836958fc5$export$91115bdd8709945f;
var $4233ec2836958fc5$export$9e55760d3282e08c;
var $4233ec2836958fc5$export$3dede90624df3ba9;
var $4233ec2836958fc5$export$29ae691b7de52fe3;
var $4233ec2836958fc5$export$77fa7d86f5204e8a;
var $4233ec2836958fc5$export$ee1b3e54f0441b22;
var $4233ec2836958fc5$export$b314777ae20abca9;
var $4233ec2836958fc5$export$c28c8388be0ab31a;
var $4233ec2836958fc5$export$82fbd7a2841d2484;
var $4233ec2836958fc5$export$85b9a36db797e02b;
var $4233ec2836958fc5$export$61fc7d43ac8f84b0;
var $4233ec2836958fc5$export$7843a4469d64c07e;
var $4233ec2836958fc5$export$e4ca6d7b7a6dcf9b;
var $4233ec2836958fc5$export$1391212d75b2ee65;
var $4233ec2836958fc5$export$286ca829307725c9;
var $4233ec2836958fc5$export$ab9a5985b741fa7a;
var $4233ec2836958fc5$export$983a3b5fb2f7202e;
var $4233ec2836958fc5$export$779c5fb865a0172e;
var $4233ec2836958fc5$export$571da16e28367bde;
var $4233ec2836958fc5$export$91d69c7761a17bbc;
var $4233ec2836958fc5$export$7ecc1a3b11b57dab;
var $4233ec2836958fc5$export$31039f1fbd797b9c;
var $4233ec2836958fc5$export$d70d492cd31004c0;
var $4233ec2836958fc5$export$9f77e0932fb78f72;
var $4233ec2836958fc5$export$3dea766d36a8935f;
var $4233ec2836958fc5$export$578723aef62d92f5;
var $4233ec2836958fc5$export$71aa6c912b956294;
var $4233ec2836958fc5$export$de3a4d4a0d731119;
var $4233ec2836958fc5$export$43128fadae87b74a;
var $4233ec2836958fc5$export$3f063810d7bf01bd;
var $4233ec2836958fc5$export$6953b97c7d866605;
var $4233ec2836958fc5$export$dd1bc94b04021eeb;
var $4233ec2836958fc5$export$4c7897fafd92b108;
var $4233ec2836958fc5$export$871de8747c9eaa88;
var $4233ec2836958fc5$export$e0eaf3a86c03b2ad;
var $4233ec2836958fc5$export$76dbd6ffd832405d;
var $4233ec2836958fc5$export$8960430cfd85939f;
var $4233ec2836958fc5$export$4950aa0f605343fb;
var $4233ec2836958fc5$export$18aef43295bbe906;
var $4233ec2836958fc5$export$6b9f6c0d32c093f9;
var $4233ec2836958fc5$export$5b8affa63fc6df16;
var $4233ec2836958fc5$export$bd7cfc9a42b8a412;
var $4233ec2836958fc5$export$c1fc905202bced53;
var $4233ec2836958fc5$export$96ec731ed4dcb222;
var $4233ec2836958fc5$export$1364843af8d5a963;
var $4233ec2836958fc5$export$9007f49c319d1ac7;
var $4233ec2836958fc5$export$5fba66d61591f42;
var $4233ec2836958fc5$export$8f9d79d42bff1aac;
var $4233ec2836958fc5$export$b29f828819edca8d;
var $4233ec2836958fc5$export$c44985b87d605eff;
var $4233ec2836958fc5$export$89b472e03be495df;
var $4233ec2836958fc5$export$16ae46fda9567053;
var $4233ec2836958fc5$export$42d9b6b38c68d989;
var $4233ec2836958fc5$export$1f3342bf81d92d52;
var $4233ec2836958fc5$export$236c05de452bec2;
var $4233ec2836958fc5$export$533b26079ad0b4b;
var $4233ec2836958fc5$export$76d90c956114f2c2;
var $4233ec2836958fc5$export$b39ac5b4ffd1415a;
var $4233ec2836958fc5$export$9369b12211e1fce4;
var $4233ec2836958fc5$export$1281551253cfee02;
var $4233ec2836958fc5$export$18d0766d894cba0c;
var $4233ec2836958fc5$export$4812e460280c6ef2;
var $4233ec2836958fc5$export$fe33c7b2002d97b0;
var $4233ec2836958fc5$export$c87d910e63d22ed6;
var $4233ec2836958fc5$export$d0a07e60ae428313;
var $4233ec2836958fc5$export$ed80d9de1d9df928;
var $4233ec2836958fc5$export$db61d692014e534e;
var $4233ec2836958fc5$export$863d7ca51b416cee;
var $4233ec2836958fc5$export$955fc4a6c4be454d;
var $4233ec2836958fc5$export$635f6273df29ea1c;
var $4233ec2836958fc5$export$facc584867c26fde;
var $4233ec2836958fc5$export$175dedd748069215;
var $4233ec2836958fc5$export$a4fe86229b0e9bdd;
var $4233ec2836958fc5$export$6a45284a4b0bf33a;
var $4233ec2836958fc5$export$9f6ea8e48bc26eab;
var $4233ec2836958fc5$export$a439dc30c845238;
var $4233ec2836958fc5$export$b7df5d561049483a;
var $4233ec2836958fc5$export$1b47ad771ce5af5e;
var $4233ec2836958fc5$export$ac8dfd3a7ad06e80;
var $4233ec2836958fc5$export$9384c7afe4015e42;
var $4233ec2836958fc5$export$3f23594af5f37336;
var $4233ec2836958fc5$export$de363e709c412c8a;
var $4233ec2836958fc5$export$4efe28f192921dd4;
var $4233ec2836958fc5$export$1a539c8b2950ab40;
var $4233ec2836958fc5$export$83e74882c5df8fe1;
var $4233ec2836958fc5$export$86fe999fba7953f2;
var $4233ec2836958fc5$export$fc00ee57782020aa;
var $4233ec2836958fc5$export$45b10814cc054894;
var $4233ec2836958fc5$export$8291e5b88f90ce4;
var $4233ec2836958fc5$export$f3a19e933f377396;
var $4233ec2836958fc5$export$1284415effa79ee0;
var $4233ec2836958fc5$export$3182be990e0eeaad;
var $4233ec2836958fc5$export$6a5dea797879f644;
var $4233ec2836958fc5$export$d449030e5c10edf7;
var $4233ec2836958fc5$export$8901015135f2fb22;
var $4233ec2836958fc5$export$adddb6a2fa3864e9;
"use strict";

var $bfgJH = parcelRequire("bfgJH");

$4233ec2836958fc5$export$d779b02e6b68c3e8 = $bfgJH.audit;
var $aaf6b2faa4deb608$export$719c70722b10e5ff;
"use strict";

var $3u6GG = parcelRequire("3u6GG");




var $34c30826dca309ef$export$9dc4ecf953986f04;
"use strict";

var $3POu8 = parcelRequire("3POu8");

$34c30826dca309ef$export$9dc4ecf953986f04 = $3POu8.TimerObservable.create;


/**
 * Ignores source values for `duration` milliseconds, then emits the most recent
 * value from the source Observable, then repeats this process.
 *
 * <span class="informal">When it sees a source values, it ignores that plus
 * the next ones for `duration` milliseconds, and then it emits the most recent
 * value from the source.</span>
 *
 * <img src="./img/auditTime.png" width="100%">
 *
 * `auditTime` is similar to `throttleTime`, but emits the last value from the
 * silenced time window, instead of the first value. `auditTime` emits the most
 * recent value from the source Observable on the output Observable as soon as
 * its internal timer becomes disabled, and ignores source values while the
 * timer is enabled. Initially, the timer is disabled. As soon as the first
 * source value arrives, the timer is enabled. After `duration` milliseconds (or
 * the time unit determined internally by the optional `scheduler`) has passed,
 * the timer is disabled, then the most recent source value is emitted on the
 * output Observable, and this process repeats for the next source value.
 * Optionally takes a {@link IScheduler} for managing timers.
 *
 * @example <caption>Emit clicks at a rate of at most one click per second</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.auditTime(1000);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link audit}
 * @see {@link debounceTime}
 * @see {@link delay}
 * @see {@link sampleTime}
 * @see {@link throttleTime}
 *
 * @param {number} duration Time to wait before emitting the most recent source
 * value, measured in milliseconds or the time unit determined internally
 * by the optional `scheduler`.
 * @param {Scheduler} [scheduler=async] The {@link IScheduler} to use for
 * managing the timers that handle the rate-limiting behavior.
 * @return {Observable<T>} An Observable that performs rate-limiting of
 * emissions from the source Observable.
 * @method auditTime
 * @owner Observable
 */ function $aaf6b2faa4deb608$var$auditTime(duration, scheduler) {
    if (scheduler === void 0) scheduler = $3u6GG.async;
    return $bfgJH.audit(function() {
        return $34c30826dca309ef$export$9dc4ecf953986f04(duration, scheduler);
    });
}
$aaf6b2faa4deb608$export$719c70722b10e5ff = $aaf6b2faa4deb608$var$auditTime;


$4233ec2836958fc5$export$719c70722b10e5ff = $aaf6b2faa4deb608$export$719c70722b10e5ff;

var $5SNLA = parcelRequire("5SNLA");

$4233ec2836958fc5$export$ab1029bcae9ddb4a = $5SNLA.buffer;

var $e2TX1 = parcelRequire("e2TX1");

$4233ec2836958fc5$export$8916d2c8119541bb = $e2TX1.bufferCount;

var $ha2Ff = parcelRequire("ha2Ff");

$4233ec2836958fc5$export$d6b40c95035461c7 = $ha2Ff.bufferTime;

var $hvtnc = parcelRequire("hvtnc");

$4233ec2836958fc5$export$91115bdd8709945f = $hvtnc.bufferToggle;

var $7Jon0 = parcelRequire("7Jon0");

$4233ec2836958fc5$export$9e55760d3282e08c = $7Jon0.bufferWhen;

var $8QQGs = parcelRequire("8QQGs");

$4233ec2836958fc5$export$3dede90624df3ba9 = $8QQGs.catchError;
var $64df8cccb7879514$export$29ae691b7de52fe3;
"use strict";

var $gonhO = parcelRequire("gonhO");

function $64df8cccb7879514$var$combineAll(project) {
    return function(source) {
        return source.lift(new $gonhO.CombineLatestOperator(project));
    };
}
$64df8cccb7879514$export$29ae691b7de52fe3 = $64df8cccb7879514$var$combineAll;


$4233ec2836958fc5$export$29ae691b7de52fe3 = $64df8cccb7879514$export$29ae691b7de52fe3;



$4233ec2836958fc5$export$77fa7d86f5204e8a = $gonhO.combineLatest;
var $007cab3af5af50d6$export$9343b684b018b33a;
var $007cab3af5af50d6$export$ee1b3e54f0441b22;
"use strict";
var $77a23d400cf359fa$export$ee1b3e54f0441b22;
"use strict";

var $5Dgek = parcelRequire("5Dgek");


var $hu8We = parcelRequire("hu8We");


var $gosUm = parcelRequire("gosUm");

var $27ef876ba33d738a$export$b314777ae20abca9;
"use strict";

var $kQ0lo = parcelRequire("kQ0lo");

/**
 * Converts a higher-order Observable into a first-order Observable by
 * concatenating the inner Observables in order.
 *
 * <span class="informal">Flattens an Observable-of-Observables by putting one
 * inner Observable after the other.</span>
 *
 * <img src="./img/concatAll.png" width="100%">
 *
 * Joins every Observable emitted by the source (a higher-order Observable), in
 * a serial fashion. It subscribes to each inner Observable only after the
 * previous inner Observable has completed, and merges all of their values into
 * the returned observable.
 *
 * __Warning:__ If the source Observable emits Observables quickly and
 * endlessly, and the inner Observables it emits generally complete slower than
 * the source emits, you can run into memory issues as the incoming Observables
 * collect in an unbounded buffer.
 *
 * Note: `concatAll` is equivalent to `mergeAll` with concurrency parameter set
 * to `1`.
 *
 * @example <caption>For each click event, tick every second from 0 to 3, with no concurrency</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var higherOrder = clicks.map(ev => Rx.Observable.interval(1000).take(4));
 * var firstOrder = higherOrder.concatAll();
 * firstOrder.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // (results are not concurrent)
 * // For every click on the "document" it will emit values 0 to 3 spaced
 * // on a 1000ms interval
 * // one click = 1000ms-> 0 -1000ms-> 1 -1000ms-> 2 -1000ms-> 3
 *
 * @see {@link combineAll}
 * @see {@link concat}
 * @see {@link concatMap}
 * @see {@link concatMapTo}
 * @see {@link exhaust}
 * @see {@link mergeAll}
 * @see {@link switch}
 * @see {@link zipAll}
 *
 * @return {Observable} An Observable emitting values from all the inner
 * Observables concatenated.
 * @method concatAll
 * @owner Observable
 */ function $27ef876ba33d738a$var$concatAll() {
    return $kQ0lo.mergeAll(1);
}
$27ef876ba33d738a$export$b314777ae20abca9 = $27ef876ba33d738a$var$concatAll;


/* tslint:enable:max-line-length */ /**
 * Creates an output Observable which sequentially emits all values from given
 * Observable and then moves on to the next.
 *
 * <span class="informal">Concatenates multiple Observables together by
 * sequentially emitting their values, one Observable after the other.</span>
 *
 * <img src="./img/concat.png" width="100%">
 *
 * `concat` joins multiple Observables together, by subscribing to them one at a time and
 * merging their results into the output Observable. You can pass either an array of
 * Observables, or put them directly as arguments. Passing an empty array will result
 * in Observable that completes immediately.
 *
 * `concat` will subscribe to first input Observable and emit all its values, without
 * changing or affecting them in any way. When that Observable completes, it will
 * subscribe to then next Observable passed and, again, emit its values. This will be
 * repeated, until the operator runs out of Observables. When last input Observable completes,
 * `concat` will complete as well. At any given moment only one Observable passed to operator
 * emits values. If you would like to emit values from passed Observables concurrently, check out
 * {@link merge} instead, especially with optional `concurrent` parameter. As a matter of fact,
 * `concat` is an equivalent of `merge` operator with `concurrent` parameter set to `1`.
 *
 * Note that if some input Observable never completes, `concat` will also never complete
 * and Observables following the one that did not complete will never be subscribed. On the other
 * hand, if some Observable simply completes immediately after it is subscribed, it will be
 * invisible for `concat`, which will just move on to the next Observable.
 *
 * If any Observable in chain errors, instead of passing control to the next Observable,
 * `concat` will error immediately as well. Observables that would be subscribed after
 * the one that emitted error, never will.
 *
 * If you pass to `concat` the same Observable many times, its stream of values
 * will be "replayed" on every subscription, which means you can repeat given Observable
 * as many times as you like. If passing the same Observable to `concat` 1000 times becomes tedious,
 * you can always use {@link repeat}.
 *
 * @example <caption>Concatenate a timer counting from 0 to 3 with a synchronous sequence from 1 to 10</caption>
 * var timer = Rx.Observable.interval(1000).take(4);
 * var sequence = Rx.Observable.range(1, 10);
 * var result = Rx.Observable.concat(timer, sequence);
 * result.subscribe(x => console.log(x));
 *
 * // results in:
 * // 0 -1000ms-> 1 -1000ms-> 2 -1000ms-> 3 -immediate-> 1 ... 10
 *
 *
 * @example <caption>Concatenate an array of 3 Observables</caption>
 * var timer1 = Rx.Observable.interval(1000).take(10);
 * var timer2 = Rx.Observable.interval(2000).take(6);
 * var timer3 = Rx.Observable.interval(500).take(10);
 * var result = Rx.Observable.concat([timer1, timer2, timer3]); // note that array is passed
 * result.subscribe(x => console.log(x));
 *
 * // results in the following:
 * // (Prints to console sequentially)
 * // -1000ms-> 0 -1000ms-> 1 -1000ms-> ... 9
 * // -2000ms-> 0 -2000ms-> 1 -2000ms-> ... 5
 * // -500ms-> 0 -500ms-> 1 -500ms-> ... 9
 *
 *
 * @example <caption>Concatenate the same Observable to repeat it</caption>
 * const timer = Rx.Observable.interval(1000).take(2);
 *
 * Rx.Observable.concat(timer, timer) // concating the same Observable!
 * .subscribe(
 *   value => console.log(value),
 *   err => {},
 *   () => console.log('...and it is done!')
 * );
 *
 * // Logs:
 * // 0 after 1s
 * // 1 after 2s
 * // 0 after 3s
 * // 1 after 4s
 * // "...and it is done!" also after 4s
 *
 * @see {@link concatAll}
 * @see {@link concatMap}
 * @see {@link concatMapTo}
 *
 * @param {ObservableInput} input1 An input Observable to concatenate with others.
 * @param {ObservableInput} input2 An input Observable to concatenate with others.
 * More than one input Observables may be given as argument.
 * @param {Scheduler} [scheduler=null] An optional IScheduler to schedule each
 * Observable subscription on.
 * @return {Observable} All values of each passed Observable merged into a
 * single Observable, in order, in serial fashion.
 * @static true
 * @name concat
 * @owner Observable
 */ function $77a23d400cf359fa$var$concat() {
    var observables = [];
    for(var _i = 0; _i < arguments.length; _i++)observables[_i - 0] = arguments[_i];
    if (observables.length === 1 || observables.length === 2 && $5Dgek.isScheduler(observables[1])) return $gosUm.from(observables[0]);
    return $27ef876ba33d738a$export$b314777ae20abca9()($hu8We.of.apply(void 0, observables));
}
$77a23d400cf359fa$export$ee1b3e54f0441b22 = $77a23d400cf359fa$var$concat;



$007cab3af5af50d6$export$9343b684b018b33a = $77a23d400cf359fa$export$ee1b3e54f0441b22;
/* tslint:enable:max-line-length */ /**
 * Creates an output Observable which sequentially emits all values from every
 * given input Observable after the current Observable.
 *
 * <span class="informal">Concatenates multiple Observables together by
 * sequentially emitting their values, one Observable after the other.</span>
 *
 * <img src="./img/concat.png" width="100%">
 *
 * Joins this Observable with multiple other Observables by subscribing to them
 * one at a time, starting with the source, and merging their results into the
 * output Observable. Will wait for each Observable to complete before moving
 * on to the next.
 *
 * @example <caption>Concatenate a timer counting from 0 to 3 with a synchronous sequence from 1 to 10</caption>
 * var timer = Rx.Observable.interval(1000).take(4);
 * var sequence = Rx.Observable.range(1, 10);
 * var result = timer.concat(sequence);
 * result.subscribe(x => console.log(x));
 *
 * // results in:
 * // 1000ms-> 0 -1000ms-> 1 -1000ms-> 2 -1000ms-> 3 -immediate-> 1 ... 10
 *
 * @example <caption>Concatenate 3 Observables</caption>
 * var timer1 = Rx.Observable.interval(1000).take(10);
 * var timer2 = Rx.Observable.interval(2000).take(6);
 * var timer3 = Rx.Observable.interval(500).take(10);
 * var result = timer1.concat(timer2, timer3);
 * result.subscribe(x => console.log(x));
 *
 * // results in the following:
 * // (Prints to console sequentially)
 * // -1000ms-> 0 -1000ms-> 1 -1000ms-> ... 9
 * // -2000ms-> 0 -2000ms-> 1 -2000ms-> ... 5
 * // -500ms-> 0 -500ms-> 1 -500ms-> ... 9
 *
 * @see {@link concatAll}
 * @see {@link concatMap}
 * @see {@link concatMapTo}
 *
 * @param {ObservableInput} other An input Observable to concatenate after the source
 * Observable. More than one input Observables may be given as argument.
 * @param {Scheduler} [scheduler=null] An optional IScheduler to schedule each
 * Observable subscription on.
 * @return {Observable} All values of each passed Observable merged into a
 * single Observable, in order, in serial fashion.
 * @method concat
 * @owner Observable
 */ function $007cab3af5af50d6$var$concat() {
    var observables = [];
    for(var _i = 0; _i < arguments.length; _i++)observables[_i - 0] = arguments[_i];
    return function(source) {
        return source.lift.call($77a23d400cf359fa$export$ee1b3e54f0441b22.apply(void 0, [
            source
        ].concat(observables)));
    };
}
$007cab3af5af50d6$export$ee1b3e54f0441b22 = $007cab3af5af50d6$var$concat;


$4233ec2836958fc5$export$ee1b3e54f0441b22 = $007cab3af5af50d6$export$ee1b3e54f0441b22;

$4233ec2836958fc5$export$b314777ae20abca9 = $27ef876ba33d738a$export$b314777ae20abca9;

var $iBgx8 = parcelRequire("iBgx8");

$4233ec2836958fc5$export$c28c8388be0ab31a = $iBgx8.concatMap;
var $eaad487dda541cbc$export$82fbd7a2841d2484;
"use strict";



/* tslint:enable:max-line-length */ /**
 * Projects each source value to the same Observable which is merged multiple
 * times in a serialized fashion on the output Observable.
 *
 * <span class="informal">It's like {@link concatMap}, but maps each value
 * always to the same inner Observable.</span>
 *
 * <img src="./img/concatMapTo.png" width="100%">
 *
 * Maps each source value to the given Observable `innerObservable` regardless
 * of the source value, and then flattens those resulting Observables into one
 * single Observable, which is the output Observable. Each new `innerObservable`
 * instance emitted on the output Observable is concatenated with the previous
 * `innerObservable` instance.
 *
 * __Warning:__ if source values arrive endlessly and faster than their
 * corresponding inner Observables can complete, it will result in memory issues
 * as inner Observables amass in an unbounded buffer waiting for their turn to
 * be subscribed to.
 *
 * Note: `concatMapTo` is equivalent to `mergeMapTo` with concurrency parameter
 * set to `1`.
 *
 * @example <caption>For each click event, tick every second from 0 to 3, with no concurrency</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.concatMapTo(Rx.Observable.interval(1000).take(4));
 * result.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // (results are not concurrent)
 * // For every click on the "document" it will emit values 0 to 3 spaced
 * // on a 1000ms interval
 * // one click = 1000ms-> 0 -1000ms-> 1 -1000ms-> 2 -1000ms-> 3
 *
 * @see {@link concat}
 * @see {@link concatAll}
 * @see {@link concatMap}
 * @see {@link mergeMapTo}
 * @see {@link switchMapTo}
 *
 * @param {ObservableInput} innerObservable An Observable to replace each value from
 * the source Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @return {Observable} An observable of values merged together by joining the
 * passed observable with itself, one after the other, for each value emitted
 * from the source.
 * @method concatMapTo
 * @owner Observable
 */ function $eaad487dda541cbc$var$concatMapTo(innerObservable, resultSelector) {
    return $iBgx8.concatMap(function() {
        return innerObservable;
    }, resultSelector);
}
$eaad487dda541cbc$export$82fbd7a2841d2484 = $eaad487dda541cbc$var$concatMapTo;


$4233ec2836958fc5$export$82fbd7a2841d2484 = $eaad487dda541cbc$export$82fbd7a2841d2484;

var $j2Sfh = parcelRequire("j2Sfh");

$4233ec2836958fc5$export$85b9a36db797e02b = $j2Sfh.count;

var $3EdwZ = parcelRequire("3EdwZ");

$4233ec2836958fc5$export$61fc7d43ac8f84b0 = $3EdwZ.debounce;

var $dGzwg = parcelRequire("dGzwg");

$4233ec2836958fc5$export$7843a4469d64c07e = $dGzwg.debounceTime;

var $avZwt = parcelRequire("avZwt");

$4233ec2836958fc5$export$e4ca6d7b7a6dcf9b = $avZwt.defaultIfEmpty;

var $fulrs = parcelRequire("fulrs");

$4233ec2836958fc5$export$1391212d75b2ee65 = $fulrs.delay;

var $3YBdK = parcelRequire("3YBdK");

$4233ec2836958fc5$export$286ca829307725c9 = $3YBdK.delayWhen;

var $5vrRW = parcelRequire("5vrRW");

$4233ec2836958fc5$export$ab9a5985b741fa7a = $5vrRW.dematerialize;

var $jKOLV = parcelRequire("jKOLV");

$4233ec2836958fc5$export$983a3b5fb2f7202e = $jKOLV.distinct;

var $2mnXV = parcelRequire("2mnXV");

$4233ec2836958fc5$export$779c5fb865a0172e = $2mnXV.distinctUntilChanged;
var $fac5c3286fc268b7$export$571da16e28367bde;
"use strict";



/* tslint:enable:max-line-length */ /**
 * Returns an Observable that emits all items emitted by the source Observable that are distinct by comparison from the previous item,
 * using a property accessed by using the key provided to check if the two items are distinct.
 *
 * If a comparator function is provided, then it will be called for each item to test for whether or not that value should be emitted.
 *
 * If a comparator function is not provided, an equality check is used by default.
 *
 * @example <caption>An example comparing the name of persons</caption>
 *
 *  interface Person {
 *     age: number,
 *     name: string
 *  }
 *
 * Observable.of<Person>(
 *     { age: 4, name: 'Foo'},
 *     { age: 7, name: 'Bar'},
 *     { age: 5, name: 'Foo'},
 *     { age: 6, name: 'Foo'})
 *     .distinctUntilKeyChanged('name')
 *     .subscribe(x => console.log(x));
 *
 * // displays:
 * // { age: 4, name: 'Foo' }
 * // { age: 7, name: 'Bar' }
 * // { age: 5, name: 'Foo' }
 *
 * @example <caption>An example comparing the first letters of the name</caption>
 *
 * interface Person {
 *     age: number,
 *     name: string
 *  }
 *
 * Observable.of<Person>(
 *     { age: 4, name: 'Foo1'},
 *     { age: 7, name: 'Bar'},
 *     { age: 5, name: 'Foo2'},
 *     { age: 6, name: 'Foo3'})
 *     .distinctUntilKeyChanged('name', (x: string, y: string) => x.substring(0, 3) === y.substring(0, 3))
 *     .subscribe(x => console.log(x));
 *
 * // displays:
 * // { age: 4, name: 'Foo1' }
 * // { age: 7, name: 'Bar' }
 * // { age: 5, name: 'Foo2' }
 *
 * @see {@link distinct}
 * @see {@link distinctUntilChanged}
 *
 * @param {string} key String key for object property lookup on each item.
 * @param {function} [compare] Optional comparison function called to test if an item is distinct from the previous item in the source.
 * @return {Observable} An Observable that emits items from the source Observable with distinct values based on the key specified.
 * @method distinctUntilKeyChanged
 * @owner Observable
 */ function $fac5c3286fc268b7$var$distinctUntilKeyChanged(key, compare) {
    return $2mnXV.distinctUntilChanged(function(x, y) {
        return compare ? compare(x[key], y[key]) : x[key] === y[key];
    });
}
$fac5c3286fc268b7$export$571da16e28367bde = $fac5c3286fc268b7$var$distinctUntilKeyChanged;


$4233ec2836958fc5$export$571da16e28367bde = $fac5c3286fc268b7$export$571da16e28367bde;

var $j5i71 = parcelRequire("j5i71");

$4233ec2836958fc5$export$91d69c7761a17bbc = $j5i71.elementAt;

var $8eQTU = parcelRequire("8eQTU");

$4233ec2836958fc5$export$7ecc1a3b11b57dab = $8eQTU.every;

var $d2JY2 = parcelRequire("d2JY2");

$4233ec2836958fc5$export$31039f1fbd797b9c = $d2JY2.exhaust;

var $kjCE7 = parcelRequire("kjCE7");

$4233ec2836958fc5$export$d70d492cd31004c0 = $kjCE7.exhaustMap;

var $dbHcj = parcelRequire("dbHcj");

$4233ec2836958fc5$export$9f77e0932fb78f72 = $dbHcj.expand;

var $eVpDl = parcelRequire("eVpDl");

$4233ec2836958fc5$export$3dea766d36a8935f = $eVpDl.filter;

var $5JBQy = parcelRequire("5JBQy");

$4233ec2836958fc5$export$578723aef62d92f5 = $5JBQy.finalize;

var $dUt6W = parcelRequire("dUt6W");

$4233ec2836958fc5$export$71aa6c912b956294 = $dUt6W.find;
var $ac146c81403e87c3$export$de3a4d4a0d731119;
"use strict";



/**
 * Emits only the index of the first value emitted by the source Observable that
 * meets some condition.
 *
 * <span class="informal">It's like {@link find}, but emits the index of the
 * found value, not the value itself.</span>
 *
 * <img src="./img/findIndex.png" width="100%">
 *
 * `findIndex` searches for the first item in the source Observable that matches
 * the specified condition embodied by the `predicate`, and returns the
 * (zero-based) index of the first occurrence in the source. Unlike
 * {@link first}, the `predicate` is required in `findIndex`, and does not emit
 * an error if a valid value is not found.
 *
 * @example <caption>Emit the index of first click that happens on a DIV element</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.findIndex(ev => ev.target.tagName === 'DIV');
 * result.subscribe(x => console.log(x));
 *
 * @see {@link filter}
 * @see {@link find}
 * @see {@link first}
 * @see {@link take}
 *
 * @param {function(value: T, index: number, source: Observable<T>): boolean} predicate
 * A function called with each item to test for condition matching.
 * @param {any} [thisArg] An optional argument to determine the value of `this`
 * in the `predicate` function.
 * @return {Observable} An Observable of the index of the first item that
 * matches the condition.
 * @method find
 * @owner Observable
 */ function $ac146c81403e87c3$var$findIndex(predicate, thisArg) {
    return function(source) {
        return source.lift(new $dUt6W.FindValueOperator(predicate, source, true, thisArg));
    };
}
$ac146c81403e87c3$export$de3a4d4a0d731119 = $ac146c81403e87c3$var$findIndex;


$4233ec2836958fc5$export$de3a4d4a0d731119 = $ac146c81403e87c3$export$de3a4d4a0d731119;

var $iVKw6 = parcelRequire("iVKw6");

$4233ec2836958fc5$export$43128fadae87b74a = $iVKw6.first;

var $6sXAX = parcelRequire("6sXAX");

$4233ec2836958fc5$export$3f063810d7bf01bd = $6sXAX.groupBy;

var $3WLBy = parcelRequire("3WLBy");

$4233ec2836958fc5$export$6953b97c7d866605 = $3WLBy.ignoreElements;

var $6FTyv = parcelRequire("6FTyv");

$4233ec2836958fc5$export$dd1bc94b04021eeb = $6FTyv.isEmpty;

var $bOaaj = parcelRequire("bOaaj");

$4233ec2836958fc5$export$4c7897fafd92b108 = $bOaaj.last;

var $2QGAA = parcelRequire("2QGAA");

$4233ec2836958fc5$export$871de8747c9eaa88 = $2QGAA.map;

var $dsb2s = parcelRequire("dsb2s");

$4233ec2836958fc5$export$e0eaf3a86c03b2ad = $dsb2s.mapTo;

var $b5JJ1 = parcelRequire("b5JJ1");

$4233ec2836958fc5$export$76dbd6ffd832405d = $b5JJ1.materialize;
var $edaa53b9947019cd$export$8960430cfd85939f;
"use strict";

var $244gB = parcelRequire("244gB");

/**
 * The Max operator operates on an Observable that emits numbers (or items that can be compared with a provided function),
 * and when source Observable completes it emits a single item: the item with the largest value.
 *
 * <img src="./img/max.png" width="100%">
 *
 * @example <caption>Get the maximal value of a series of numbers</caption>
 * Rx.Observable.of(5, 4, 7, 2, 8)
 *   .max()
 *   .subscribe(x => console.log(x)); // -> 8
 *
 * @example <caption>Use a comparer function to get the maximal item</caption>
 * interface Person {
 *   age: number,
 *   name: string
 * }
 * Observable.of<Person>({age: 7, name: 'Foo'},
 *                       {age: 5, name: 'Bar'},
 *                       {age: 9, name: 'Beer'})
 *           .max<Person>((a: Person, b: Person) => a.age < b.age ? -1 : 1)
 *           .subscribe((x: Person) => console.log(x.name)); // -> 'Beer'
 * }
 *
 * @see {@link min}
 *
 * @param {Function} [comparer] - Optional comparer function that it will use instead of its default to compare the
 * value of two items.
 * @return {Observable} An Observable that emits item with the largest value.
 * @method max
 * @owner Observable
 */ function $edaa53b9947019cd$var$max(comparer) {
    var max = typeof comparer === 'function' ? function(x, y) {
        return comparer(x, y) > 0 ? x : y;
    } : function(x, y) {
        return x > y ? x : y;
    };
    return $244gB.reduce(max);
}
$edaa53b9947019cd$export$8960430cfd85939f = $edaa53b9947019cd$var$max;


$4233ec2836958fc5$export$8960430cfd85939f = $edaa53b9947019cd$export$8960430cfd85939f;
var $77920c9eba3aea2a$export$9f199afc30ae2269;
var $77920c9eba3aea2a$export$4950aa0f605343fb;
"use strict";

var $7HI7Y = parcelRequire("7HI7Y");




$77920c9eba3aea2a$export$9f199afc30ae2269 = $7HI7Y.merge;
/* tslint:enable:max-line-length */ /**
 * Creates an output Observable which concurrently emits all values from every
 * given input Observable.
 *
 * <span class="informal">Flattens multiple Observables together by blending
 * their values into one Observable.</span>
 *
 * <img src="./img/merge.png" width="100%">
 *
 * `merge` subscribes to each given input Observable (either the source or an
 * Observable given as argument), and simply forwards (without doing any
 * transformation) all the values from all the input Observables to the output
 * Observable. The output Observable only completes once all input Observables
 * have completed. Any error delivered by an input Observable will be immediately
 * emitted on the output Observable.
 *
 * @example <caption>Merge together two Observables: 1s interval and clicks</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var timer = Rx.Observable.interval(1000);
 * var clicksOrTimer = clicks.merge(timer);
 * clicksOrTimer.subscribe(x => console.log(x));
 *
 * @example <caption>Merge together 3 Observables, but only 2 run concurrently</caption>
 * var timer1 = Rx.Observable.interval(1000).take(10);
 * var timer2 = Rx.Observable.interval(2000).take(6);
 * var timer3 = Rx.Observable.interval(500).take(10);
 * var concurrent = 2; // the argument
 * var merged = timer1.merge(timer2, timer3, concurrent);
 * merged.subscribe(x => console.log(x));
 *
 * @see {@link mergeAll}
 * @see {@link mergeMap}
 * @see {@link mergeMapTo}
 * @see {@link mergeScan}
 *
 * @param {ObservableInput} other An input Observable to merge with the source
 * Observable. More than one input Observables may be given as argument.
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
 * Observables being subscribed to concurrently.
 * @param {Scheduler} [scheduler=null] The IScheduler to use for managing
 * concurrency of input Observables.
 * @return {Observable} An Observable that emits items that are the result of
 * every input Observable.
 * @method merge
 * @owner Observable
 */ function $77920c9eba3aea2a$var$merge() {
    var observables = [];
    for(var _i = 0; _i < arguments.length; _i++)observables[_i - 0] = arguments[_i];
    return function(source) {
        return source.lift.call($7HI7Y.merge.apply(void 0, [
            source
        ].concat(observables)));
    };
}
$77920c9eba3aea2a$export$4950aa0f605343fb = $77920c9eba3aea2a$var$merge;


$4233ec2836958fc5$export$4950aa0f605343fb = $77920c9eba3aea2a$export$4950aa0f605343fb;



$4233ec2836958fc5$export$18aef43295bbe906 = $kQ0lo.mergeAll;

var $XrDsM = parcelRequire("XrDsM");

$4233ec2836958fc5$export$6b9f6c0d32c093f9 = $XrDsM.mergeMap;



$4233ec2836958fc5$export$5b8affa63fc6df16 = $XrDsM.mergeMap;

var $btvNM = parcelRequire("btvNM");

$4233ec2836958fc5$export$bd7cfc9a42b8a412 = $btvNM.mergeMapTo;

var $8fVz5 = parcelRequire("8fVz5");

$4233ec2836958fc5$export$c1fc905202bced53 = $8fVz5.mergeScan;
var $1be998c37c23d3b9$export$96ec731ed4dcb222;
"use strict";



/**
 * The Min operator operates on an Observable that emits numbers (or items that can be compared with a provided function),
 * and when source Observable completes it emits a single item: the item with the smallest value.
 *
 * <img src="./img/min.png" width="100%">
 *
 * @example <caption>Get the minimal value of a series of numbers</caption>
 * Rx.Observable.of(5, 4, 7, 2, 8)
 *   .min()
 *   .subscribe(x => console.log(x)); // -> 2
 *
 * @example <caption>Use a comparer function to get the minimal item</caption>
 * interface Person {
 *   age: number,
 *   name: string
 * }
 * Observable.of<Person>({age: 7, name: 'Foo'},
 *                       {age: 5, name: 'Bar'},
 *                       {age: 9, name: 'Beer'})
 *           .min<Person>( (a: Person, b: Person) => a.age < b.age ? -1 : 1)
 *           .subscribe((x: Person) => console.log(x.name)); // -> 'Bar'
 * }
 *
 * @see {@link max}
 *
 * @param {Function} [comparer] - Optional comparer function that it will use instead of its default to compare the
 * value of two items.
 * @return {Observable<R>} An Observable that emits item with the smallest value.
 * @method min
 * @owner Observable
 */ function $1be998c37c23d3b9$var$min(comparer) {
    var min = typeof comparer === 'function' ? function(x, y) {
        return comparer(x, y) < 0 ? x : y;
    } : function(x, y) {
        return x < y ? x : y;
    };
    return $244gB.reduce(min);
}
$1be998c37c23d3b9$export$96ec731ed4dcb222 = $1be998c37c23d3b9$var$min;


$4233ec2836958fc5$export$96ec731ed4dcb222 = $1be998c37c23d3b9$export$96ec731ed4dcb222;
var $d04d31de299e1b68$export$1364843af8d5a963;
var $d04d31de299e1b68$export$150d52413393bf2c;
"use strict";

var $f5yaK = parcelRequire("f5yaK");

/* tslint:enable:max-line-length */ /**
 * Returns an Observable that emits the results of invoking a specified selector on items
 * emitted by a ConnectableObservable that shares a single subscription to the underlying stream.
 *
 * <img src="./img/multicast.png" width="100%">
 *
 * @param {Function|Subject} subjectOrSubjectFactory - Factory function to create an intermediate subject through
 * which the source sequence's elements will be multicast to the selector function
 * or Subject to push source elements into.
 * @param {Function} [selector] - Optional selector function that can use the multicasted source stream
 * as many times as needed, without causing multiple subscriptions to the source stream.
 * Subscribers to the given source will receive all notifications of the source from the
 * time of the subscription forward.
 * @return {Observable} An Observable that emits the results of invoking the selector
 * on the items emitted by a `ConnectableObservable` that shares a single subscription to
 * the underlying stream.
 * @method multicast
 * @owner Observable
 */ function $d04d31de299e1b68$var$multicast(subjectOrSubjectFactory, selector) {
    return function multicastOperatorFunction(source) {
        var subjectFactory;
        if (typeof subjectOrSubjectFactory === 'function') subjectFactory = subjectOrSubjectFactory;
        else subjectFactory = function subjectFactory() {
            return subjectOrSubjectFactory;
        };
        if (typeof selector === 'function') return source.lift(new $d04d31de299e1b68$var$MulticastOperator(subjectFactory, selector));
        var connectable = Object.create(source, $f5yaK.connectableObservableDescriptor);
        connectable.source = source;
        connectable.subjectFactory = subjectFactory;
        return connectable;
    };
}
$d04d31de299e1b68$export$1364843af8d5a963 = $d04d31de299e1b68$var$multicast;
var $d04d31de299e1b68$var$MulticastOperator = function() {
    function MulticastOperator(subjectFactory, selector) {
        this.subjectFactory = subjectFactory;
        this.selector = selector;
    }
    MulticastOperator.prototype.call = function(subscriber, source) {
        var selector = this.selector;
        var subject = this.subjectFactory();
        var subscription = selector(subject).subscribe(subscriber);
        subscription.add(source.subscribe(subject));
        return subscription;
    };
    return MulticastOperator;
}();
$d04d31de299e1b68$export$150d52413393bf2c = $d04d31de299e1b68$var$MulticastOperator;


$4233ec2836958fc5$export$1364843af8d5a963 = $d04d31de299e1b68$export$1364843af8d5a963;

var $jHUX7 = parcelRequire("jHUX7");

$4233ec2836958fc5$export$9007f49c319d1ac7 = $jHUX7.observeOn;

var $c17EK = parcelRequire("c17EK");

$4233ec2836958fc5$export$5fba66d61591f42 = $c17EK.onErrorResumeNext;

var $5hER9 = parcelRequire("5hER9");

$4233ec2836958fc5$export$8f9d79d42bff1aac = $5hER9.pairwise;
var $4b888bb051fb1a1b$export$b29f828819edca8d;
"use strict";
var $e7529a5140a065e8$export$6003a5f097c73977;
"use strict";
function $e7529a5140a065e8$var$not(pred, thisArg) {
    function notPred() {
        return !notPred.pred.apply(notPred.thisArg, arguments);
    }
    notPred.pred = pred;
    notPred.thisArg = thisArg;
    return notPred;
}
$e7529a5140a065e8$export$6003a5f097c73977 = $e7529a5140a065e8$var$not;





/**
 * Splits the source Observable into two, one with values that satisfy a
 * predicate, and another with values that don't satisfy the predicate.
 *
 * <span class="informal">It's like {@link filter}, but returns two Observables:
 * one like the output of {@link filter}, and the other with values that did not
 * pass the condition.</span>
 *
 * <img src="./img/partition.png" width="100%">
 *
 * `partition` outputs an array with two Observables that partition the values
 * from the source Observable through the given `predicate` function. The first
 * Observable in that array emits source values for which the predicate argument
 * returns true. The second Observable emits source values for which the
 * predicate returns false. The first behaves like {@link filter} and the second
 * behaves like {@link filter} with the predicate negated.
 *
 * @example <caption>Partition click events into those on DIV elements and those elsewhere</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var parts = clicks.partition(ev => ev.target.tagName === 'DIV');
 * var clicksOnDivs = parts[0];
 * var clicksElsewhere = parts[1];
 * clicksOnDivs.subscribe(x => console.log('DIV clicked: ', x));
 * clicksElsewhere.subscribe(x => console.log('Other clicked: ', x));
 *
 * @see {@link filter}
 *
 * @param {function(value: T, index: number): boolean} predicate A function that
 * evaluates each value emitted by the source Observable. If it returns `true`,
 * the value is emitted on the first Observable in the returned array, if
 * `false` the value is emitted on the second Observable in the array. The
 * `index` parameter is the number `i` for the i-th source emission that has
 * happened since the subscription, starting from the number `0`.
 * @param {any} [thisArg] An optional argument to determine the value of `this`
 * in the `predicate` function.
 * @return {[Observable<T>, Observable<T>]} An array with two Observables: one
 * with values that passed the predicate, and another with values that did not
 * pass the predicate.
 * @method partition
 * @owner Observable
 */ function $4b888bb051fb1a1b$var$partition(predicate, thisArg) {
    return function(source) {
        return [
            $eVpDl.filter(predicate, thisArg)(source),
            $eVpDl.filter($e7529a5140a065e8$export$6003a5f097c73977(predicate, thisArg))(source)
        ];
    };
}
$4b888bb051fb1a1b$export$b29f828819edca8d = $4b888bb051fb1a1b$var$partition;


$4233ec2836958fc5$export$b29f828819edca8d = $4b888bb051fb1a1b$export$b29f828819edca8d;
var $ed37734c66fc438b$export$c44985b87d605eff;
"use strict";



/**
 * Maps each source value (an object) to its specified nested property.
 *
 * <span class="informal">Like {@link map}, but meant only for picking one of
 * the nested properties of every emitted object.</span>
 *
 * <img src="./img/pluck.png" width="100%">
 *
 * Given a list of strings describing a path to an object property, retrieves
 * the value of a specified nested property from all values in the source
 * Observable. If a property can't be resolved, it will return `undefined` for
 * that value.
 *
 * @example <caption>Map every click to the tagName of the clicked target element</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var tagNames = clicks.pluck('target', 'tagName');
 * tagNames.subscribe(x => console.log(x));
 *
 * @see {@link map}
 *
 * @param {...string} properties The nested properties to pluck from each source
 * value (an object).
 * @return {Observable} A new Observable of property values from the source values.
 * @method pluck
 * @owner Observable
 */ function $ed37734c66fc438b$var$pluck() {
    var properties = [];
    for(var _i = 0; _i < arguments.length; _i++)properties[_i - 0] = arguments[_i];
    var length = properties.length;
    if (length === 0) throw new Error('list of properties cannot be empty.');
    return function(source) {
        return $2QGAA.map($ed37734c66fc438b$var$plucker(properties, length))(source);
    };
}
$ed37734c66fc438b$export$c44985b87d605eff = $ed37734c66fc438b$var$pluck;
function $ed37734c66fc438b$var$plucker(props, length) {
    var mapper = function(x) {
        var currentProp = x;
        for(var i = 0; i < length; i++){
            var p = currentProp[props[i]];
            if (typeof p !== 'undefined') currentProp = p;
            else return undefined;
        }
        return currentProp;
    };
    return mapper;
}


$4233ec2836958fc5$export$c44985b87d605eff = $ed37734c66fc438b$export$c44985b87d605eff;
var $ea22cfe6b5f5175a$export$89b472e03be495df;
"use strict";

var $augeV = parcelRequire("augeV");


/* tslint:enable:max-line-length */ /**
 * Returns a ConnectableObservable, which is a variety of Observable that waits until its connect method is called
 * before it begins emitting items to those Observers that have subscribed to it.
 *
 * <img src="./img/publish.png" width="100%">
 *
 * @param {Function} [selector] - Optional selector function which can use the multicasted source sequence as many times
 * as needed, without causing multiple subscriptions to the source sequence.
 * Subscribers to the given source will receive all notifications of the source from the time of the subscription on.
 * @return A ConnectableObservable that upon connection causes the source Observable to emit items to its Observers.
 * @method publish
 * @owner Observable
 */ function $ea22cfe6b5f5175a$var$publish(selector) {
    return selector ? $d04d31de299e1b68$export$1364843af8d5a963(function() {
        return new $augeV.Subject();
    }, selector) : $d04d31de299e1b68$export$1364843af8d5a963(new $augeV.Subject());
}
$ea22cfe6b5f5175a$export$89b472e03be495df = $ea22cfe6b5f5175a$var$publish;


$4233ec2836958fc5$export$89b472e03be495df = $ea22cfe6b5f5175a$export$89b472e03be495df;
var $f085fb033916b38b$export$16ae46fda9567053;
"use strict";

var $5h38X = parcelRequire("5h38X");


/**
 * @param value
 * @return {ConnectableObservable<T>}
 * @method publishBehavior
 * @owner Observable
 */ function $f085fb033916b38b$var$publishBehavior(value) {
    return function(source) {
        return $d04d31de299e1b68$export$1364843af8d5a963(new $5h38X.BehaviorSubject(value))(source);
    };
}
$f085fb033916b38b$export$16ae46fda9567053 = $f085fb033916b38b$var$publishBehavior;


$4233ec2836958fc5$export$16ae46fda9567053 = $f085fb033916b38b$export$16ae46fda9567053;
var $40aebfe5f6880fb5$export$42d9b6b38c68d989;
"use strict";

var $5JYSv = parcelRequire("5JYSv");


function $40aebfe5f6880fb5$var$publishLast() {
    return function(source) {
        return $d04d31de299e1b68$export$1364843af8d5a963(new $5JYSv.AsyncSubject())(source);
    };
}
$40aebfe5f6880fb5$export$42d9b6b38c68d989 = $40aebfe5f6880fb5$var$publishLast;


$4233ec2836958fc5$export$42d9b6b38c68d989 = $40aebfe5f6880fb5$export$42d9b6b38c68d989;
var $457ccc0f9183816d$export$1f3342bf81d92d52;
"use strict";




/* tslint:enable:max-line-length */ function $457ccc0f9183816d$var$publishReplay(bufferSize, windowTime, selectorOrScheduler, scheduler) {
    if (selectorOrScheduler && typeof selectorOrScheduler !== 'function') scheduler = selectorOrScheduler;
    var selector = typeof selectorOrScheduler === 'function' ? selectorOrScheduler : undefined;
    var subject = new $jXDcc.ReplaySubject(bufferSize, windowTime, scheduler);
    return function(source) {
        return $d04d31de299e1b68$export$1364843af8d5a963(function() {
            return subject;
        }, selector)(source);
    };
}
$457ccc0f9183816d$export$1f3342bf81d92d52 = $457ccc0f9183816d$var$publishReplay;


$4233ec2836958fc5$export$1f3342bf81d92d52 = $457ccc0f9183816d$export$1f3342bf81d92d52;
var $8175d93de21ab73d$export$236c05de452bec2;
"use strict";

var $fvPwd = parcelRequire("fvPwd");


var $iiAcs = parcelRequire("iiAcs");

/* tslint:enable:max-line-length */ /**
 * Returns an Observable that mirrors the first source Observable to emit an item
 * from the combination of this Observable and supplied Observables.
 * @param {...Observables} ...observables Sources used to race for which Observable emits first.
 * @return {Observable} An Observable that mirrors the output of the first Observable to emit an item.
 * @method race
 * @owner Observable
 */ function $8175d93de21ab73d$var$race() {
    var observables = [];
    for(var _i = 0; _i < arguments.length; _i++)observables[_i - 0] = arguments[_i];
    return function raceOperatorFunction(source) {
        // if the only argument is an array, it was most likely called with
        // `pair([obs1, obs2, ...])`
        if (observables.length === 1 && $fvPwd.isArray(observables[0])) observables = observables[0];
        return source.lift.call($iiAcs.race.apply(void 0, [
            source
        ].concat(observables)));
    };
}
$8175d93de21ab73d$export$236c05de452bec2 = $8175d93de21ab73d$var$race;


$4233ec2836958fc5$export$236c05de452bec2 = $8175d93de21ab73d$export$236c05de452bec2;



$4233ec2836958fc5$export$533b26079ad0b4b = $244gB.reduce;

var $5AGP5 = parcelRequire("5AGP5");

$4233ec2836958fc5$export$76d90c956114f2c2 = $5AGP5.repeat;

var $6GFHk = parcelRequire("6GFHk");

$4233ec2836958fc5$export$b39ac5b4ffd1415a = $6GFHk.repeatWhen;

var $e6s15 = parcelRequire("e6s15");

$4233ec2836958fc5$export$9369b12211e1fce4 = $e6s15.retry;

var $igrC3 = parcelRequire("igrC3");

$4233ec2836958fc5$export$1281551253cfee02 = $igrC3.retryWhen;

var $iY7u4 = parcelRequire("iY7u4");

$4233ec2836958fc5$export$18d0766d894cba0c = $iY7u4.refCount;

var $4LrJQ = parcelRequire("4LrJQ");

$4233ec2836958fc5$export$4812e460280c6ef2 = $4LrJQ.sample;

var $jAcJW = parcelRequire("jAcJW");

$4233ec2836958fc5$export$fe33c7b2002d97b0 = $jAcJW.sampleTime;

var $kiSup = parcelRequire("kiSup");

$4233ec2836958fc5$export$c87d910e63d22ed6 = $kiSup.scan;

var $4Lrrt = parcelRequire("4Lrrt");

$4233ec2836958fc5$export$d0a07e60ae428313 = $4Lrrt.sequenceEqual;
var $a3667c61424cc991$export$ed80d9de1d9df928;
"use strict";







function $a3667c61424cc991$var$shareSubjectFactory() {
    return new $augeV.Subject();
}
/**
 * Returns a new Observable that multicasts (shares) the original Observable. As long as there is at least one
 * Subscriber this Observable will be subscribed and emitting data. When all subscribers have unsubscribed it will
 * unsubscribe from the source Observable. Because the Observable is multicasting it makes the stream `hot`.
 * This is an alias for .multicast(() => new Subject()).refCount().
 *
 * <img src="./img/share.png" width="100%">
 *
 * @return {Observable<T>} An Observable that upon connection causes the source Observable to emit items to its Observers.
 * @method share
 * @owner Observable
 */ function $a3667c61424cc991$var$share() {
    return function(source) {
        return $iY7u4.refCount()($d04d31de299e1b68$export$1364843af8d5a963($a3667c61424cc991$var$shareSubjectFactory)(source));
    };
}
$a3667c61424cc991$export$ed80d9de1d9df928 = $a3667c61424cc991$var$share;


$4233ec2836958fc5$export$ed80d9de1d9df928 = $a3667c61424cc991$export$ed80d9de1d9df928;
var $9c81f822b246afa1$export$db61d692014e534e;
"use strict";



/**
 * @method shareReplay
 * @owner Observable
 */ function $9c81f822b246afa1$var$shareReplay(bufferSize, windowTime, scheduler) {
    return function(source) {
        return source.lift($9c81f822b246afa1$var$shareReplayOperator(bufferSize, windowTime, scheduler));
    };
}
$9c81f822b246afa1$export$db61d692014e534e = $9c81f822b246afa1$var$shareReplay;
function $9c81f822b246afa1$var$shareReplayOperator(bufferSize, windowTime, scheduler) {
    var subject;
    var refCount = 0;
    var subscription;
    var hasError = false;
    var isComplete = false;
    return function shareReplayOperation(source) {
        refCount++;
        if (!subject || hasError) {
            hasError = false;
            subject = new $jXDcc.ReplaySubject(bufferSize, windowTime, scheduler);
            subscription = source.subscribe({
                next: function(value) {
                    subject.next(value);
                },
                error: function(err) {
                    hasError = true;
                    subject.error(err);
                },
                complete: function() {
                    isComplete = true;
                    subject.complete();
                }
            });
        }
        var innerSub = subject.subscribe(this);
        return function() {
            refCount--;
            innerSub.unsubscribe();
            if (subscription && refCount === 0 && isComplete) subscription.unsubscribe();
        };
    };
}


$4233ec2836958fc5$export$db61d692014e534e = $9c81f822b246afa1$export$db61d692014e534e;

var $gVc40 = parcelRequire("gVc40");

$4233ec2836958fc5$export$863d7ca51b416cee = $gVc40.single;

var $bFxBy = parcelRequire("bFxBy");

$4233ec2836958fc5$export$955fc4a6c4be454d = $bFxBy.skip;

var $3nfDH = parcelRequire("3nfDH");

$4233ec2836958fc5$export$635f6273df29ea1c = $3nfDH.skipLast;

var $lDurq = parcelRequire("lDurq");

$4233ec2836958fc5$export$facc584867c26fde = $lDurq.skipUntil;

var $3VDUL = parcelRequire("3VDUL");

$4233ec2836958fc5$export$175dedd748069215 = $3VDUL.skipWhile;
var $a37fa6a2af583df2$export$a4fe86229b0e9bdd;
"use strict";

var $HHFyQ = parcelRequire("HHFyQ");


var $5OUhL = parcelRequire("5OUhL");


var $b5CQv = parcelRequire("b5CQv");





/* tslint:enable:max-line-length */ /**
 * Returns an Observable that emits the items you specify as arguments before it begins to emit
 * items emitted by the source Observable.
 *
 * <img src="./img/startWith.png" width="100%">
 *
 * @param {...T} values - Items you want the modified Observable to emit first.
 * @param {Scheduler} [scheduler] - A {@link IScheduler} to use for scheduling
 * the emissions of the `next` notifications.
 * @return {Observable} An Observable that emits the items in the specified Iterable and then emits the items
 * emitted by the source Observable.
 * @method startWith
 * @owner Observable
 */ function $a37fa6a2af583df2$var$startWith() {
    var array = [];
    for(var _i = 0; _i < arguments.length; _i++)array[_i - 0] = arguments[_i];
    return function(source) {
        var scheduler = array[array.length - 1];
        if ($5Dgek.isScheduler(scheduler)) array.pop();
        else scheduler = null;
        var len = array.length;
        if (len === 1) return $77a23d400cf359fa$export$ee1b3e54f0441b22(new $5OUhL.ScalarObservable(array[0], scheduler), source);
        else if (len > 1) return $77a23d400cf359fa$export$ee1b3e54f0441b22(new $HHFyQ.ArrayObservable(array, scheduler), source);
        else return $77a23d400cf359fa$export$ee1b3e54f0441b22(new $b5CQv.EmptyObservable(scheduler), source);
    };
}
$a37fa6a2af583df2$export$a4fe86229b0e9bdd = $a37fa6a2af583df2$var$startWith;


$4233ec2836958fc5$export$a4fe86229b0e9bdd = $a37fa6a2af583df2$export$a4fe86229b0e9bdd;
var $a13603b461fcaabd$export$6a45284a4b0bf33a;
"use strict";

var $j8M4E = parcelRequire("j8M4E");


var $hsCka = parcelRequire("hsCka");

function $a13603b461fcaabd$var$switchAll() {
    return $j8M4E.switchMap($hsCka.identity);
}
$a13603b461fcaabd$export$6a45284a4b0bf33a = $a13603b461fcaabd$var$switchAll;


$4233ec2836958fc5$export$6a45284a4b0bf33a = $a13603b461fcaabd$export$6a45284a4b0bf33a;



$4233ec2836958fc5$export$9f6ea8e48bc26eab = $j8M4E.switchMap;

var $a1Ene = parcelRequire("a1Ene");

$4233ec2836958fc5$export$a439dc30c845238 = $a1Ene.switchMapTo;

var $kXEyd = parcelRequire("kXEyd");

$4233ec2836958fc5$export$b7df5d561049483a = $kXEyd.take;

var $ib5HR = parcelRequire("ib5HR");

$4233ec2836958fc5$export$1b47ad771ce5af5e = $ib5HR.takeLast;

var $ghTt7 = parcelRequire("ghTt7");

$4233ec2836958fc5$export$ac8dfd3a7ad06e80 = $ghTt7.takeUntil;

var $6ssFC = parcelRequire("6ssFC");

$4233ec2836958fc5$export$9384c7afe4015e42 = $6ssFC.takeWhile;

var $5NXxU = parcelRequire("5NXxU");

$4233ec2836958fc5$export$3f23594af5f37336 = $5NXxU.tap;

var $jb2dN = parcelRequire("jb2dN");

$4233ec2836958fc5$export$de363e709c412c8a = $jb2dN.throttle;

var $9Kcfz = parcelRequire("9Kcfz");

$4233ec2836958fc5$export$4efe28f192921dd4 = $9Kcfz.throttleTime;

var $i3vZV = parcelRequire("i3vZV");

$4233ec2836958fc5$export$1a539c8b2950ab40 = $i3vZV.timeInterval;

var $ePuNq = parcelRequire("ePuNq");

$4233ec2836958fc5$export$83e74882c5df8fe1 = $ePuNq.timeout;

var $hkdng = parcelRequire("hkdng");

$4233ec2836958fc5$export$86fe999fba7953f2 = $hkdng.timeoutWith;

var $2eCs8 = parcelRequire("2eCs8");

$4233ec2836958fc5$export$fc00ee57782020aa = $2eCs8.timestamp;

var $1Ria2 = parcelRequire("1Ria2");

$4233ec2836958fc5$export$45b10814cc054894 = $1Ria2.toArray;

var $7fTeW = parcelRequire("7fTeW");

$4233ec2836958fc5$export$8291e5b88f90ce4 = $7fTeW.window;

var $4MF2G = parcelRequire("4MF2G");

$4233ec2836958fc5$export$f3a19e933f377396 = $4MF2G.windowCount;

var $7ssQI = parcelRequire("7ssQI");

$4233ec2836958fc5$export$1284415effa79ee0 = $7ssQI.windowTime;

var $Cr5z9 = parcelRequire("Cr5z9");

$4233ec2836958fc5$export$3182be990e0eeaad = $Cr5z9.windowToggle;

var $5A6fs = parcelRequire("5A6fs");

$4233ec2836958fc5$export$6a5dea797879f644 = $5A6fs.windowWhen;

var $6zLY4 = parcelRequire("6zLY4");

$4233ec2836958fc5$export$d449030e5c10edf7 = $6zLY4.withLatestFrom;

var $iCyab = parcelRequire("iCyab");

$4233ec2836958fc5$export$8901015135f2fb22 = $iCyab.zip;
var $35e01e3b42fd3186$export$adddb6a2fa3864e9;
"use strict";



function $35e01e3b42fd3186$var$zipAll(project) {
    return function(source) {
        return source.lift(new $iCyab.ZipOperator(project));
    };
}
$35e01e3b42fd3186$export$adddb6a2fa3864e9 = $35e01e3b42fd3186$var$zipAll;


$4233ec2836958fc5$export$adddb6a2fa3864e9 = $35e01e3b42fd3186$export$adddb6a2fa3864e9;








var $fgm2d = parcelRequire("fgm2d");








var $ha5sn = parcelRequire("ha5sn");


var $4kfV4 = parcelRequire("4kfV4");


var $caX7N = parcelRequire("caX7N");


var $dTk3A = parcelRequire("dTk3A");


var $9hlns = parcelRequire("9hlns");


var $aD1SW = parcelRequire("aD1SW");

const $73826c82c3a1aad9$export$723a1497b2536563 = ({ showFlag: showFlag, hideFlag: hideFlag })=>{
    if (!showFlag || !hideFlag) return {};
    const createFlag = (flagOptions)=>{
        const { isAutoDismiss: isAutoDismiss, ...restOptions } = flagOptions;
        const { type: type, appearance: appearance, actions: actions } = flagOptions;
        const shouldAutoDismiss = isAutoDismiss ?? (appearance === 'info' || appearance === 'success');
        showFlag({
            ...restOptions,
            type: appearance ?? type,
            actions: actions?.map(({ text: content, onClick: onClick })=>({
                    onClick: ()=>onClick(),
                    content: content
                })),
            customComponent: shouldAutoDismiss ? (0, $aD1SW.default) : undefined
        });
        return true;
    };
    const closeFlag = ({ id: id })=>{
        hideFlag(id);
        return true;
    };
    return {
        showFlag: createFlag,
        closeFlag: closeFlag
    };
};





const $ca7484dd1592c62d$export$823759185d8a77e8 = ({ isEditing: isEditing, localId: localId, editorAPI: editorAPI })=>{
    if (!isEditing) return undefined;
    const getEditorContent = async ()=>{
        return new Promise((resolve)=>{
            editorAPI?.core?.actions.requestDocument((doc)=>{
                if (!doc) resolve({
                    data: ''
                });
                else resolve({
                    data: JSON.stringify(doc)
                });
            });
        });
    };
    const getMacroContent = async (bridgeData)=>{
        const extensionAPI = editorAPI?.extension?.actions?.api();
        if (!extensionAPI) throw new Error('Unable to get macro content: extensionAPI is not available');
        try {
            const macroLocalId = bridgeData?.embeddedMacroLocalId ?? localId;
            const nodeWithPos = extensionAPI.getNodeWithPosByLocalId(macroLocalId);
            const { node: node } = nodeWithPos;
            return {
                data: JSON.stringify(node)
            };
        } catch (error) {
            throw new Error(`Failed to get macro: ${error}`);
        }
    };
    const updateMacro = async (newExtensionContent)=>{
        if (!newExtensionContent?.data) return false;
        try {
            const macroLocalId = newExtensionContent?.embeddedMacroLocalId ?? localId;
            const newExtensionData = JSON.parse(newExtensionContent.data);
            const extensionAPI = editorAPI?.extension?.actions?.api();
            if (extensionAPI && newExtensionData) {
                extensionAPI.doc?.update(macroLocalId, ()=>newExtensionData);
                return true;
            }
        } catch (error) {
            throw new Error(`Failed to update macro: ${error}`);
        }
        return false;
    };
    const setMacroViewportHeight = async (height)=>{
        if (!(0, $dh538.fg)('platform_measure_macro_height')) throw new Error('setMacroViewportHeight is not available');
        try {
            const extensionAPI = editorAPI?.extension?.actions?.api();
            if (extensionAPI) {
                extensionAPI.doc?.update(localId, (currNode)=>{
                    const newNode = {
                        attrs: {
                            ...currNode.attrs,
                            parameters: {
                                ...currNode.attrs?.parameters,
                                viewportHeight: height
                            }
                        }
                    };
                    return newNode;
                });
                return true;
            }
        } catch (error) {
            throw new Error(`Failed to set the macro's viewport height: ${error}`);
        }
        return false;
    };
    return {
        getEditorContent: getEditorContent,
        getMacroContent: getMacroContent,
        updateMacro: updateMacro,
        setMacroViewportHeight: setMacroViewportHeight
    };
};


const $848ed95e7445259e$var$macroHeights = {
    small: '112px',
    medium: '262px',
    default: '262px',
    large: '524px',
    xlarge: '1048px'
};
const $848ed95e7445259e$export$d27eb2c49eeaf1b4 = (size)=>{
    return $848ed95e7445259e$var$macroHeights[size ?? 'default'];
};











const $1eea1d427cf750b6$export$7fa3a225a8945f98 = (enabled)=>{
    (0, $42omo.useEffect)(()=>{
        if (!enabled) return;
        const origin = window.location.origin;
        const readyEventSub = (0, $luNHV.on)('EXTENSION_READY', async ({ localId: localId })=>{
            window.postMessage({
                source: 'forge-extension',
                type: 'EXTENSION_READY',
                localId: localId
            }, origin);
        });
        return ()=>{
            readyEventSub.unsubscribe();
        };
    }, [
        enabled
    ]);
};



var $7pHhJ = parcelRequire("7pHhJ");

var $ivfUe = parcelRequire("ivfUe");


var $49YLc = parcelRequire("49YLc");







const $f4c506847cd85511$var$GET_CUSTOM_CONTENT = (0, $eSUdr.default)`query CustomContent($id:ID!$type:String!){content(id:$id){nodes{ari children(type:$type){nodes{body{atlas_doc_format{value}}title}}}}}`;
const $f4c506847cd85511$var$formatResponseNodes = (content)=>{
    return content.reduce((acc, node)=>{
        return {
            ...acc,
            [node.title]: JSON.parse(node.body.atlas_doc_format.value)
        };
    }, {});
};
// Content type -> container ID -> keyed children (value)
const $f4c506847cd85511$var$containerChildrenContentCache = {};
const $f4c506847cd85511$export$34e4a3147c43af65 = ({ contentContainerId: contentContainerId, childContentType: childContentType })=>{
    return $f4c506847cd85511$var$containerChildrenContentCache[childContentType]?.[contentContainerId]?.values;
};
const $f4c506847cd85511$export$c027be1ebfc40079 = async ({ apolloClient: apolloClient, contentContainerId: contentContainerId, childContentType: childContentType })=>{
    var _containerChildrenContentCache, _childContentType, _containerCache, _contentContainerId, _contentCache;
    const containerCache = (_containerChildrenContentCache = $f4c506847cd85511$var$containerChildrenContentCache)[_childContentType = childContentType] ?? (_containerChildrenContentCache[_childContentType] = {});
    const contentCache = (_containerCache = containerCache)[_contentContainerId = contentContainerId] ?? (_containerCache[_contentContainerId] = {
        promise: null,
        values: null
    });
    const children = (_contentCache = contentCache).promise ?? (_contentCache.promise = apolloClient.query({
        query: $f4c506847cd85511$var$GET_CUSTOM_CONTENT,
        variables: {
            id: contentContainerId,
            type: childContentType
        },
        // Manual cache management in place.
        fetchPolicy: 'network-only'
    }).then(({ data: data })=>data.content?.nodes?.[0]?.children?.nodes || []).then((responseNodes)=>{
        if (!responseNodes) return null;
        const content = $f4c506847cd85511$var$formatResponseNodes(responseNodes);
        contentCache.values = content;
        return content;
    }).catch(()=>null));
    return children;
};


const $c14f3f369f3273ff$var$getCustomContentType = (extension)=>{
    const appId = extension?.appId, envId = extension?.environmentId, customContentKey = extension?.properties?.staticView?.customContentTypeKey;
    if (!appId || !envId || !customContentKey) return null;
    return `forge:${appId}:${envId}:${customContentKey}`;
};
const $c14f3f369f3273ff$var$useMacroStaticContentViewImpl = ({ client: client, extension: extension, contentContainerId: contentContainerId, contentKey: contentKey })=>{
    const childContentType = $c14f3f369f3273ff$var$getCustomContentType(extension);
    const hasStaticViewDefinition = !!extension?.properties?.staticView && !!childContentType;
    const cachedContentValue = hasStaticViewDefinition ? (0, $f4c506847cd85511$export$34e4a3147c43af65)({
        contentContainerId: contentContainerId,
        childContentType: childContentType
    })?.[contentKey] : null;
    const [{ isLoading: isLoading, content: content }, setState] = (0, $42omo.useState)({
        isLoading: hasStaticViewDefinition && !cachedContentValue,
        content: cachedContentValue
    });
    (0, $42omo.useEffect)(()=>{
        // First render matches content.
        if (!!cachedContentValue && cachedContentValue === content) return;
        // No content -> content found (e.g. contentKey changed).
        if (!!cachedContentValue && !content) {
            setState({
                isLoading: false,
                content: cachedContentValue
            });
            return;
        }
        let cancelled = false;
        // Content type not yet queried.
        (async ()=>{
            if (!childContentType) return;
            const childrenContent = await (0, $f4c506847cd85511$export$c027be1ebfc40079)({
                apolloClient: client,
                contentContainerId: contentContainerId,
                childContentType: childContentType
            }).catch(()=>null);
            if (cancelled || !childrenContent) return;
            setState({
                isLoading: false,
                content: childrenContent[contentKey]
            });
        })();
        return ()=>{
            cancelled = true;
        };
    }, [
        content,
        cachedContentValue,
        contentKey,
        childContentType,
        client,
        contentContainerId
    ]);
    return {
        isLoading: isLoading,
        content: content
    };
};
const $c14f3f369f3273ff$var$defaultImpl = (_)=>({
        isLoading: false,
        content: null
    });
const $c14f3f369f3273ff$export$fa4a375558cec54f = (0, $49YLc.functionWithFG)('forge-ui-static-macros', $c14f3f369f3273ff$var$useMacroStaticContentViewImpl, $c14f3f369f3273ff$var$defaultImpl);





const $327e82c74ae2ed5d$export$144453187d3223d6 = (extension)=>extension?.properties?.staticView;
const $327e82c74ae2ed5d$var$defaultStaticViewProperties = {
    isContentViewAvailable: false,
    contentKey: 'default'
};
const $327e82c74ae2ed5d$var$extractExtensionStaticViewPropertiesImpl = (extension, properties)=>{
    if (!extension || !properties) return $327e82c74ae2ed5d$var$defaultStaticViewProperties;
    const staticView = $327e82c74ae2ed5d$export$144453187d3223d6(extension);
    if (!staticView) return $327e82c74ae2ed5d$var$defaultStaticViewProperties;
    const contentKeyConfigLookupField = staticView.contentTitleConfigKey;
    const contentKey = properties[contentKeyConfigLookupField];
    return {
        isContentViewAvailable: !!contentKey,
        contentKey: contentKey ?? $327e82c74ae2ed5d$var$defaultStaticViewProperties.contentKey
    };
};
const $327e82c74ae2ed5d$var$defaultImpl = ()=>$327e82c74ae2ed5d$var$defaultStaticViewProperties;
const $327e82c74ae2ed5d$export$44e1e942f87ec1e9 = (0, $49YLc.functionWithFG)('forge-ui-static-macros', $327e82c74ae2ed5d$var$extractExtensionStaticViewPropertiesImpl, $327e82c74ae2ed5d$var$defaultImpl);





const $bf7c574cb03a0445$var$spinnerContainerStyles = null;
const $bf7c574cb03a0445$export$a61c6459586c5198 = ({ accountId: accountId, apolloClient: apolloClient, coreData: coreData, extensionData: extensionData, extensionViewData: extensionViewData, extensionPayload: extensionPayload, environment: environment, extension: extension, locale: locale, flags: flags, getContextToken: getContextToken, customEditContext: customEditContext, isEditing: isEditing, editorAPI: editorAPI, onForgeDocUpdated: onForgeDocUpdated, viewportDimensions: viewportDimensions, useRouteActions: useRouteActions })=>{
    const { cloudId: cloudId, localId: localId } = coreData;
    const modalExtension = customEditContext?.modalExtension;
    const bridge = customEditContext?.bridge;
    const memoizedCustomBridgeMethods = (0, $42omo.useMemo)(()=>{
        return (0, $ca7484dd1592c62d$export$823759185d8a77e8)({
            isEditing: isEditing,
            localId: localId,
            editorAPI: editorAPI
        });
    }, [
        isEditing,
        localId,
        editorAPI
    ]);
    const confluenceSpa = useRouteActions?.();
    const [macroConfigForgeDocSubject$] = (0, $42omo.useState)(()=>new (0, $jXDcc.ReplaySubject)(10));
    const configValueRef = (0, $42omo.useRef)(undefined); // Stores the forgeDoc for the macro config schema. The ref is often a render behind
    // the actual schema, so should only be used on the initial load.
    const macroConfigForgeDocRef = (0, $42omo.useRef)(undefined); // This sets up an event listener to respond to Editor's requests for the macro config schema.
    // When the GET_CONFIG_FORGE_DOC_${id} event is emitted, the payload includes the current
    // config value, and the resolve and reject functions of a Promise. The listener should be
    // resolving the promise with the value of the macro config forgeDoc.
    const id = `${extension.id}-${coreData.localId}`;
    const reconcile = (0, $42omo.useCallback)(({ forgeDoc: forgeDoc })=>{
        Object.freeze(forgeDoc);
        macroConfigForgeDocRef.current = forgeDoc;
        macroConfigForgeDocSubject$.next(forgeDoc);
        (0, $luNHV.emit)(`CONFIG_FORGE_DOC_UPDATED_${id}`);
    }, [
        id,
        macroConfigForgeDocSubject$
    ]);
    (0, $42omo.useEffect)(()=>{
        const macroConfigForgeDocSubscription = (0, $luNHV.on)(`GET_CONFIG_FORGE_DOC_${id}`, async ({ resolve: resolve, config: config })=>{
            const subscription = macroConfigForgeDocSubject$.pipe((0, $4233ec2836958fc5$export$7843a4469d64c07e)(200)).subscribe({
                next: (forgeDoc)=>{
                    resolve({
                        type: 'Root',
                        props: {},
                        children: [
                            forgeDoc
                        ]
                    });
                    subscription.unsubscribe();
                }
            });
            configValueRef.current = config;
        });
        return ()=>{
            macroConfigForgeDocSubscription.unsubscribe();
        };
    }, [
        id,
        macroConfigForgeDocSubject$
    ]);
    /*the emitReadyEvent emited by the macro
  must be receive by cc-puppeteer an internal service responsible for
  generating PDFs from confluence pages, the issue is that it does not
  recieve events from other origins such as iframes, so we capture and
  reemit the event here */ (0, $1eea1d427cf750b6$export$7fa3a225a8945f98)((0, $dh538.fg)('forge-ui-reemit-ready-event'));
    const { showFlag: showFlag, closeFlag: closeFlag } = (0, $42omo.useMemo)(()=>(0, $73826c82c3a1aad9$export$723a1497b2536563)(flags), [
        flags
    ]);
    const bridgeConfig = (0, $42omo.useMemo)(()=>({
            ...bridge,
            showFlag: showFlag,
            closeFlag: closeFlag,
            reconcile: reconcile,
            spaPush: confluenceSpa?.push
        }), [
        bridge,
        showFlag,
        closeFlag,
        reconcile,
        confluenceSpa?.push
    ]);
    const AdfRendererWithEmbeddedMacros = (0, $42omo.useMemo)(()=>(0, $ha5sn.makeADFRenderer)({
            client: apolloClient,
            bridge: bridgeConfig,
            customBridgeMethods: memoizedCustomBridgeMethods,
            getContextToken: getContextToken,
            extensionData: extensionData,
            isEditing: isEditing
        }), [
        apolloClient,
        bridgeConfig,
        getContextToken,
        extensionData,
        memoizedCustomBridgeMethods,
        isEditing
    ]);
    let loadingComponent;
    if (!(0, $iqcSr.isCustomUI)(extension) && modalExtension) loadingComponent = /*#__PURE__*/ $42omo.createElement((0, $caX7N.default), {
        zIndex: (0, $dTk3A.layers).blanket()
    }, /*#__PURE__*/ $42omo.createElement((0, $4kfV4.default), {
        isTinted: true,
        onBlanketClicked: ()=>modalExtension.closeModalExtension()
    }, /*#__PURE__*/ $42omo.createElement("div", {
        className: (0, $gMc0m.default)([
            "_1e0c1txw _1bsb1osq _4t3i1osq _4cvr1h6o _1bah1h6o _lcxvglyw"
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $9hlns.default), {
        size: "large"
    }))));
     // Sets the forgeDoc for classic sidebar macro config
    const handleMacroConfigForgeDoc = (0, $42omo.useCallback)((forgeDoc)=>{
        if (forgeDoc.type === 'MacroConfig') {
            if (customEditContext) throw new Error('ForgeReconciler.addConfig() cannot be called from within a custom config resource');
            macroConfigForgeDocRef.current = forgeDoc;
            macroConfigForgeDocSubject$.next(forgeDoc);
            (0, $luNHV.emit)(`CONFIG_FORGE_DOC_UPDATED_${id}`);
        }
    }, [
        customEditContext,
        id,
        macroConfigForgeDocRef,
        macroConfigForgeDocSubject$
    ]);
    const { isContentViewAvailable: isContentViewAvailable, contentKey: contentKey } = (0, $327e82c74ae2ed5d$export$44e1e942f87ec1e9)(extension, extensionPayload.config);
    const { isLoading: isLoading, content: content } = (0, $c14f3f369f3273ff$export$fa4a375558cec54f)({
        client: apolloClient,
        extension: extension,
        contentContainerId: extensionData?.content?.id,
        contentKey: contentKey
    });
    const shouldRenderStaticContentView = !modalExtension && isContentViewAvailable && (isLoading || content);
    if (shouldRenderStaticContentView) return /*#__PURE__*/ $42omo.createElement((0, $lspPP.RendererActionsContext), null, content ? /*#__PURE__*/ $42omo.createElement((0, $67O0h.default), {
        document: content
    }) : /*#__PURE__*/ $42omo.createElement((0, $9hlns.default), {
        size: "small"
    }));
    return /*#__PURE__*/ $42omo.createElement((0, $jIiuI.EnvironmentContext).Provider, {
        value: environment
    }, /*#__PURE__*/ $42omo.createElement((0, $fgm2d.ForgeUIRenderer), {
        accountId: accountId,
        bridge: bridgeConfig,
        client: apolloClient,
        cloudId: cloudId,
        contextIds: [
            `ari:cloud:confluence::site/${cloudId}`
        ],
        components: {
            // Override to use latest renderer with embedded macro support for Confluence
            ...(0, $dh538.fg)('platform-forge-ui-kit-adf-renderer') ? {
                AdfRenderer: AdfRendererWithEmbeddedMacros
            } : {},
            ChromelessEditor: $7pHhJ.ChromelessEditor,
            CommentEditor: $ivfUe.CommentEditor
        },
        extension: extension,
        extensionData: extensionData,
        extensionViewData: extensionViewData,
        extensionPayload: extensionPayload,
        customBridgeMethods: memoizedCustomBridgeMethods,
        height: extension.properties.viewportSize ? (0, $848ed95e7445259e$export$d27eb2c49eeaf1b4)(extension.properties.viewportSize) : undefined,
        locale: locale,
        localId: localId,
        getContextToken: getContextToken,
        product: "confluence",
        onForgeDocUpdated: (forgeDoc)=>{
            onForgeDocUpdated?.(forgeDoc);
            handleMacroConfigForgeDoc(forgeDoc);
        },
        modalExtension: modalExtension,
        onModalExtensionClose: modalExtension?.closeModalExtension,
        loadingComponent: loadingComponent,
        viewportDimensions: viewportDimensions
    }));
};


const $a82d375ff746c950$var$PDF_URL = '/wiki/pdf/';
const $a82d375ff746c950$var$isCurrentLocationPdf = ()=>{
    return window?.location.href.includes($a82d375ff746c950$var$PDF_URL);
};
const $a82d375ff746c950$export$50f023e8da1e5a6b = (extension)=>{
    return $a82d375ff746c950$var$isCurrentLocationPdf() && extension?.properties?.export;
};
const $a82d375ff746c950$export$cb9938fa51e44b87 = (extension)=>{
    return $a82d375ff746c950$var$isCurrentLocationPdf() && extension?.properties?.adfExport;
};






const $1447faf601fb7e11$var$styles1 = null;
const $1447faf601fb7e11$var$styles2 = null;
const $1447faf601fb7e11$var$ReservedHeightWrapper = ({ extension: extension, children: children })=>{
    const extensionViewportSize = extension?.properties?.viewportSize; // Only apply reserved height if the feature flag is on AND actualViewportSize is defined
    if (extensionViewportSize && (0, $dh538.fg)('confluence_forge_early_render_reserve_height')) {
        const viewportSizeHeight = (0, $848ed95e7445259e$export$d27eb2c49eeaf1b4)(extensionViewportSize); // Custom UI extensions have full support for viewportSize, leading to a strict height.
        // UI Kit 2 extensions, while they can define viewportSize in their manifest, primarily
        // have dynamic sizing. This means viewportSize is not a strict constraint for them as it
        // is for Custom UI. Using minHeight based on a manifest-defined viewportSize is therefore
        // a best-effort approach to proactively reserve space. This aims to reduce layout shift
        // while still allowing the extension to grow dynamically if its content requires more space.
        if ((0, $iqcSr.isCustomUI)(extension)) return /*#__PURE__*/ $42omo.createElement("div", {
            style: {
                height: viewportSizeHeight
            },
            "data-testid": "reserved-height-wrapper-custom-ui"
        }, children);
        else return /*#__PURE__*/ $42omo.createElement("div", {
            style: {
                minHeight: viewportSizeHeight
            },
            "data-testid": "reserved-height-wrapper-uikit"
        }, children);
    } // If FF is off, or if actualViewportSize is undefined, render children directly
    return /*#__PURE__*/ $42omo.createElement((0, $42omo.Fragment), null, children);
};
const $1447faf601fb7e11$var$APP_CONTAINER_PADDING = "var(--ds-space-100, 8px)";
const $1447faf601fb7e11$var$useMemoedExtensionData = (extensionData)=>{
    const ref = (0, $42omo.useRef)(extensionData);
    if (!(0, $hrSFW.dequal)(ref.current, extensionData)) ref.current = extensionData;
    return ref.current;
};
const $1447faf601fb7e11$var$ForgeUIExtensionWrapper = ({ apolloClient: apolloClient, contextIds: contextIds, cloudId: cloudId, environment: environment, extensionData: extensionData, editorAPI: editorAPI, accountId: accountId, dataProviders: dataProviders, extension: extension, isEditing: isEditing, flags: flags, getContextToken: getContextToken, hideGlassPane: hideGlassPane, customEditContext: customEditContext, useRouteActions: useRouteActions })=>{
    const elRef = (0, $42omo.useRef)(null);
    const timerRef = (0, $42omo.useRef)(null);
    const { extension: gqlExtension, extensionId: extensionId, extensionTitle: extensionTitle, measuredHeight: measuredHeight, viewportHeight: viewportHeight // If `parameters` is missing, we'll let that bubble up to the extension's error boundary.
     } = extension.parameters;
    let localId = extension.parameters?.localId || ''; /**
                                                      * Macros created by auto convert flow does not generate a `localId`. `localId` is being created by `quickInsert` in convertToExtensionManifest.tsx and is stored in the extension object
                                                      * Extract `localId` here to be passed into `coreData` below.
                                                      *
                                                      */ 
    if (!localId) localId = extension.localId;
    const viewportDimensions = (0, $42omo.useMemo)(()=>(0, $dh538.fg)('platform_measure_macro_height') ? {
            measuredHeight: measuredHeight,
            viewportHeight: viewportHeight
        } : undefined, [
        measuredHeight,
        viewportHeight
    ]);
    const config = (0, $e2cd313e500316d2$export$44487a86467333c3)(extension.parameters);
    const isBodiedMacro = extension.type === 'bodiedExtension';
    const extensionViewData = (0, $42omo.useMemo)(()=>isBodiedMacro && !!extension.content ? {
            macro: {
                body: {
                    type: 'doc',
                    version: 1,
                    content: extension.content
                }
            }
        } : {}, [
        extension.content,
        isBodiedMacro
    ]);
    const isAdfExport = (0, $a82d375ff746c950$export$cb9938fa51e44b87)(gqlExtension);
    const isHostedResource = Boolean(gqlExtension?.properties?.resource);
    const isUiKitTwo = gqlExtension?.properties?.render === 'native';
    const isCustomUI = isHostedResource && !isUiKitTwo; // inline macro doesn't support Custom UI
    const isInline = gqlExtension?.properties?.layout === 'inline' && !isCustomUI;
    const coreData = {
        localId: localId,
        cloudId: cloudId
    };
    const macroExtensionData = {
        ...customEditContext ? {
            isConfiguring: true,
            isInserting: customEditContext.isInserting
        } : {},
        ...isBodiedMacro ? {
            layout: 'bodied'
        } : {}
    };
    const memoedExtensionData = $1447faf601fb7e11$var$useMemoedExtensionData((0, $dh538.fg)('platform_move_dynamic_macro_context') || (0, $dh538.fg)('only-include-macro-config-from-payload-in-reload') ? {
        ...extensionData
    } : {
        ...extensionData,
        isEditing: isEditing,
        config: config,
        ...Object.keys(macroExtensionData).length ? {
            macro: macroExtensionData
        } : {}
    });
    const extensionPayload = $1447faf601fb7e11$var$useMemoedExtensionData({
        config: config,
        isEditing: isEditing,
        ...Object.keys(macroExtensionData).length ? {
            macro: macroExtensionData
        } : {}
    });
    const { locale: locale } = (0, $8C5kA.default)();
    const handleOnMacroUpdated = (forgeDoc)=>{
        if (isBodiedMacro && forgeDoc?.children?.[0].type === 'AdfRenderer') {
            const event = new CustomEvent((0, $31HPn.FORGE_DOC_UPDATED_EVENT), {
                detail: {
                    forgeDoc: forgeDoc,
                    localId: localId
                },
                bubbles: true
            });
            document.dispatchEvent(event);
        }
        if ((0, $dh538.fg)('platform_measure_macro_height')) {
            const isContextPanelOpen = editorAPI?.extension?.sharedState?.currentState()?.showContextPanel;
            const actionsAPI = editorAPI?.extension?.actions?.api(); // Check if the context panel is open to filter for macro config updates
            if (!actionsAPI || !isContextPanelOpen) return;
             // Only call this function in edit/live page mode
            if (elRef.current && isEditing) {
                if (timerRef.current) clearTimeout(timerRef.current);
                timerRef.current = setTimeout(()=>{
                    const rectHeight = elRef?.current?.getBoundingClientRect().height; // allow three seconds for any async effects
                    try {
                        /**
             * This attribute will be Forge's effort to estimate and reserve rendered height
             * to achieve 0 CLS on behalf of vendors. Alongside this change will be some
             * heuristic measurements on view page to check the accuracy of this over time.
             */ actionsAPI.doc.update(localId, (currentNode)=>{
                            const newNode = {
                                attrs: {
                                    ...currentNode.attrs,
                                    parameters: {
                                        ...currentNode.attrs?.parameters,
                                        measuredHeight: rectHeight
                                    }
                                }
                            };
                            return newNode;
                        });
                    } catch  {}
                }, 3000);
            }
        }
    };
    const renderRenderer = ()=>{
        if (isAdfExport && isHostedResource) /**
       * For frontend macro rendering, we only pass the `extensionViewData` (macro body) to the iframe over the JS bridge.
       * This is to avoid it being included in the Forge Invocation Token (FIT) for remote endpoint resolver calls.
       * However, the `AdfExport` is a backend function, so we cannot pass it over the JS bridge.
       * Nevertheless, it won't be included in the FIT, because the export does not use a remote endpoint resolver.
       * It also won't be included in the Forge Compute Token (FCT), because the FCT only includes context--not `extensionPayload`.
       */ return /*#__PURE__*/ $42omo.createElement((0, $80cfae1bb0e465b8$export$f4fa252563062f56), {
            accountId: accountId,
            apolloClient: apolloClient,
            contextIds: contextIds,
            coreData: coreData,
            dataProviders: dataProviders,
            extension: gqlExtension,
            extensionData: memoedExtensionData,
            extensionPayload: (0, $dh538.fg)('platform_move_dynamic_macro_context') || (0, $dh538.fg)('only-include-macro-config-from-payload-in-reload') ? {
                ...extensionPayload,
                ...extensionViewData
            } : extensionViewData,
            extensionId: extensionId,
            extensionTitle: extensionTitle
        });
        return /*#__PURE__*/ $42omo.createElement($1447faf601fb7e11$var$ReservedHeightWrapper, {
            extension: gqlExtension
        }, /*#__PURE__*/ $42omo.createElement((0, $bf7c574cb03a0445$export$a61c6459586c5198), {
            accountId: accountId,
            apolloClient: apolloClient,
            contextIds: contextIds,
            environment: environment,
            extension: gqlExtension,
            coreData: coreData,
            extensionData: memoedExtensionData,
            extensionPayload: (0, $dh538.fg)('platform_move_dynamic_macro_context') || (0, $dh538.fg)('only-include-macro-config-from-payload-in-reload') ? extensionPayload : {},
            editorAPI: editorAPI,
            extensionViewData: extensionViewData,
            locale: locale,
            flags: flags,
            getContextToken: getContextToken,
            customEditContext: customEditContext,
            isEditing: isEditing,
            onForgeDocUpdated: handleOnMacroUpdated,
            viewportDimensions: viewportDimensions,
            useRouteActions: useRouteActions
        }));
    };
    return /*#__PURE__*/ $42omo.createElement("div", {
        "data-testid": "ForgeExtensionContainer",
        style: {
            background: isEditing ? "var(--ds-surface, #FFFFFF)" : 'transparent',
            padding: isEditing && !isInline ? $1447faf601fb7e11$var$APP_CONTAINER_PADDING : 0,
            display: isInline ? 'inline-block' : 'block',
            verticalAlign: isInline ? 'middle' : ''
        },
        ref: elRef,
        className: (0, $gMc0m.default)([
            "_kqswh2mm"
        ])
    }, renderRenderer(), isEditing && !hideGlassPane && /*#__PURE__*/ $42omo.createElement("div", {
        "data-testid": "GlassPane",
        className: (0, $gMc0m.default)([
            "_bfhk1j28 _80om13gf _1ltvidpf _kqswstnw _4t3i1osq _154iidpf _1bsb1osq _1pbykb7n"
        ])
    }));
};
const $1447faf601fb7e11$var$ForgeUIExtensionWrapperWithBoundary = (props)=>{
    const { extension: extension, product: product, environment: environment, page: page, analyticsWebClient: analyticsWebClient, customEditContext: customEditContext } = props;
    const children = /*#__PURE__*/ $42omo.createElement((0, $5c916dea5625a8d4$export$2e2bcd8739ae039), null, /*#__PURE__*/ $42omo.createElement($1447faf601fb7e11$var$ForgeUIExtensionWrapper, props));
    return(// This Suspense fallback is for the ForgeErrorBoundary
    /*#__PURE__*/ $42omo.createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ $42omo.createElement((0, $62fWd.ForgeUIExtensionPointProvider), {
        analyticsWebClient: analyticsWebClient,
        product: product,
        environment: environment,
        page: page,
        localId: extension.parameters?.localId,
        isCustomConfig: !!customEditContext
    }, extension.parameters ? /*#__PURE__*/ $42omo.createElement((0, $HEA67.ForgeUIExtensionAnalyticsContext), {
        localId: extension.parameters.localId,
        extensionId: extension.parameters.extensionId
    }, children) : children)));
};
var $1447faf601fb7e11$export$2e2bcd8739ae039 = $1447faf601fb7e11$var$ForgeUIExtensionWrapperWithBoundary;






function $e804e4ac91f66148$var$ContextTokenHandlerWrapper({ useGetContextToken: useGetContextToken, extension: extension, extensionData: extensionData, localId: localId, contextIds: contextIds, children: children }) {
    const getContextTokenHandler = useGetContextToken(extension, extensionData, localId, contextIds, true);
    return children(getContextTokenHandler);
}
const $e804e4ac91f66148$export$b7482bdc8aff85e4 = ({ accountId: accountId, apolloClient: apolloClient, analyticsWebClient: analyticsWebClient, cloudId: cloudId, contextIds: contextIds, environment: environment, extension: extension, extensionData: extensionData, extensionHandlerWithReference: extensionHandlerWithReference, forgeUIAnalyticsContext: forgeUIAnalyticsContext, isEditing: isEditing, page: page, product: product, dataProviders: dataProviders, FlagProvider: FlagProvider, hideGlassPane: hideGlassPane, editorAPI: editorAPI, customEditContext: customEditContext, useGetContextToken: useGetContextToken, useRouteActions: useRouteActions })=>(0, $2XqLN.default)(({ node: node, references: references })=>{
        const extensionWithParam = {
            ...node,
            parameters: {
                // we always insert with parameters
                ...node.parameters,
                extensionTitle: extension?.properties.title,
                extension: extension
            }
        };
        // If `localId` doesn't exist at this point, pass the `localId` on the node created from `quickInsert` into the parameters object
        // Required to render the correct config sidebar panel
        if (node.parameters && !node.parameters.localId) node.parameters.localId = node.localId;
        const augmentedExtensionData = {
            ...extensionData,
            autoConvertLink: node.parameters?.autoConvertLink
        };
        const connectMetadata = $e804e4ac91f66148$var$getConnectMacroMetadata(node.parameters);
        if (connectMetadata) augmentedExtensionData.connectMetadata = connectMetadata;
        const getForgeEditorExtensionComponent = ({ references: references })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(FlagProvider, null, (flags)=>useGetContextToken ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e804e4ac91f66148$var$ContextTokenHandlerWrapper, {
                    useGetContextToken: useGetContextToken,
                    extension: extensionWithParam?.parameters?.extension,
                    extensionData: augmentedExtensionData,
                    localId: node.parameters?.localId,
                    contextIds: contextIds
                }, (getContextTokenHandler)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1447faf601fb7e11$export$2e2bcd8739ae039), {
                        analyticsWebClient: analyticsWebClient,
                        accountId: accountId || '',
                        apolloClient: apolloClient,
                        cloudId: cloudId,
                        contextIds: contextIds,
                        environment: environment,
                        extension: $e804e4ac91f66148$var$transformConnectToForgeExtension(extensionWithParam, extension, {
                            analyticsWebClient: analyticsWebClient,
                            forgeUIAnalyticsContext: forgeUIAnalyticsContext,
                            isEditing: isEditing
                        }),
                        extensionData: {
                            ...augmentedExtensionData,
                            references: references
                        },
                        flags: flags,
                        isEditing: isEditing,
                        product: product,
                        dataProviders: dataProviders,
                        page: page,
                        hideGlassPane: hideGlassPane,
                        editorAPI: editorAPI,
                        getContextToken: getContextTokenHandler,
                        customEditContext: customEditContext,
                        useRouteActions: useRouteActions
                    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1447faf601fb7e11$export$2e2bcd8739ae039), {
                    analyticsWebClient: analyticsWebClient,
                    accountId: accountId || '',
                    apolloClient: apolloClient,
                    cloudId: cloudId,
                    contextIds: contextIds,
                    environment: environment,
                    extension: $e804e4ac91f66148$var$transformConnectToForgeExtension(extensionWithParam, extension, {
                        analyticsWebClient: analyticsWebClient,
                        forgeUIAnalyticsContext: forgeUIAnalyticsContext,
                        isEditing: isEditing
                    }),
                    extensionData: {
                        ...augmentedExtensionData,
                        references: references
                    },
                    flags: flags,
                    isEditing: isEditing,
                    product: product,
                    dataProviders: dataProviders,
                    page: page,
                    hideGlassPane: hideGlassPane,
                    editorAPI: editorAPI,
                    customEditContext: customEditContext,
                    useRouteActions: useRouteActions
                }));
        if (extensionHandlerWithReference) return extensionHandlerWithReference(node, ({ references: referencesFromHandler })=>getForgeEditorExtensionComponent({
                node: node,
                references: referencesFromHandler
            }));
        return getForgeEditorExtensionComponent({
            node: node,
            references: references
        });
    }, (0, $hrSFW.dequal));
function $e804e4ac91f66148$var$getConnectMacroMetadata(parameters) {
    const macroId = (0, $4cd75da05087f7d2$export$4ea6c6225eccc91)(parameters);
    const title = parameters?.macroMetadata?.title;
    if (!macroId) // We don't want this function to return anything if it didn't have a Connect macro ID,
    // to avoid implying that pure Forge macros were Connect
    return undefined;
    return {
        macroId: macroId,
        title: title
    };
}
function $e804e4ac91f66148$var$transformConnectToForgeExtension(attrs, extension, analyticsProps) {
    if (attrs.extensionType !== (0, $31HPn.P2_OR_CONNECT_CONFLUENCE_MACRO_EXTENSION_TYPE)) return attrs;
    const { analyticsWebClient: analyticsWebClient, forgeUIAnalyticsContext: forgeUIAnalyticsContext, isEditing: isEditing } = analyticsProps || {};
    const eventSource = isEditing ? 'editPageScreen' : 'viewPageScreen';
    const { extensionKey: extensionKey } = attrs;
    try {
        if (!extension?.id) throw new Error('No Forge extension for patching connect addon');
        if (attrs.parameters) {
            if (!attrs.parameters.extensionId) attrs.parameters.extensionId = extension.id;
            const macroId = (0, $4cd75da05087f7d2$export$4ea6c6225eccc91)(attrs.parameters);
            if (!attrs.parameters.localId && macroId) // Populate with Connect macroId
            attrs.parameters.localId = macroId;
        }
        // Transform Connect macroParams to Forge guestParams
        if (attrs.parameters?.macroParams) {
            attrs.parameters.guestParams = attrs.parameters.guestParams || {};
            const connectParams = attrs.parameters.macroParams;
            Object.entries(connectParams).forEach(([key, obj])=>{
                if (typeof attrs.parameters.guestParams[key] === 'undefined') attrs.parameters.guestParams[key] = obj.value;
            });
        }
        if (analyticsWebClient) (0, $3Spjc.sendEvent)(analyticsWebClient)({
            source: eventSource,
            ...forgeUIAnalyticsContext,
            eventType: (0, $7TH2w.OPERATIONAL_EVENT_TYPE),
            action: 'h11n_macro_render_success',
            actionSubject: (0, $31HPn.CONNECT_ADDON_ACTION_SUBJECT),
            actionSubjectId: extensionKey,
            attributes: {
                extensionKey: extensionKey,
                ...(0, $45DA9.extensionIdToAnalyticsAttributes)(extension?.id),
                nodeLocalId: attrs.localId
            }
        });
    } catch (e) {
        if (analyticsWebClient) (0, $3Spjc.sendEvent)(analyticsWebClient)({
            source: eventSource,
            ...forgeUIAnalyticsContext,
            eventType: (0, $7TH2w.OPERATIONAL_EVENT_TYPE),
            action: 'h11n_macro_render_failed',
            actionSubject: (0, $31HPn.CONNECT_ADDON_ACTION_SUBJECT),
            actionSubjectId: extensionKey,
            attributes: {
                extensionKey: extensionKey,
                ...(0, $45DA9.extensionIdToAnalyticsAttributes)(extension?.id),
                errorMessage: e instanceof Error ? e.message : String(e),
                nodeLocalId: attrs.localId
            }
        });
        throw e;
    }
    return attrs;
}










const $89d33f8c6eeca662$export$d302d43aa723dad0 = (node, extensionManifest)=>{
    const { attrs: attrs } = node;
    // Ensure extension hasn't been upgraded since the last check
    if (attrs?.extensionType === (0, $31HPn.P2_OR_CONNECT_CONFLUENCE_MACRO_EXTENSION_TYPE)) {
        // Use the existing Connect macro ID as the Forge localId
        const macroId = (0, $4cd75da05087f7d2$export$4ea6c6225eccc91)(attrs.parameters);
        const extensionProps = extensionManifest?.createExtensionProps(macroId);
        return {
            ...node,
            attrs: {
                ...attrs,
                ...extensionProps.attrs,
                // We shouldn't override the Editor localId of an existing node once it's been created
                localId: attrs.localId || extensionProps.attrs.localId,
                parameters: {
                    ...$89d33f8c6eeca662$var$convertConnectParametersToForge(attrs.parameters),
                    ...extensionProps.attrs.parameters
                }
            }
        };
    }
    return node;
};
const $89d33f8c6eeca662$var$convertConnectParametersToForge = ({ guestParams: guestParams = {}, macroParams: macroParams = {}, ...restParams } = {})=>{
    const migratedGuestParams = {
        ...guestParams
    };
    Object.entries(macroParams).forEach(([key, obj])=>{
        // Don't override existing entries
        if (typeof migratedGuestParams[key] === 'undefined' && obj && 'value' in obj) migratedGuestParams[key] = obj.value;
    });
    return {
        macroParams: macroParams,
        guestParams: migratedGuestParams,
        ...restParams
    };
};
const $89d33f8c6eeca662$var$upgradeConnectExtensionToForge = async (attrs, actions, extensionProvider)=>{
    const { localId: localId, extensionKey: extensionKey } = attrs;
    let extensionManifest = await extensionProvider.getConnectToForgeExtension(extensionKey);
    let originalMacroType = 'CONNECT';
    if (!extensionManifest && (0, $dh538.fg)('platform_upgrade_p2_to_forge_macro')) {
        const p2ToForgeExtensionManifest = await extensionProvider.getP2ToForgeExtension(extensionKey);
        originalMacroType = 'P2';
        extensionManifest = p2ToForgeExtensionManifest;
    }
    if (!extensionManifest || !extensionManifest.createExtensionProps) throw new Error(`Connect to Forge macro upgrade: No ${!extensionManifest ? 'extension manifest' : 'createExtensionProps function'} found`);
    return new Promise((resolve)=>{
        actions.doc.update(localId, (currentValue)=>{
            const updatedNode = $89d33f8c6eeca662$export$d302d43aa723dad0(currentValue, extensionManifest);
            resolve({
                updatedNode: updatedNode,
                originalMacroType: originalMacroType
            });
            return updatedNode;
        });
    });
};
const $89d33f8c6eeca662$export$142e3c584022ba7e = async ({ connectToForgeBlockedExtensions: connectToForgeBlockedExtensions, extensionProvider: extensionProvider, actions: actions, analyticsClient: analyticsClient, editorActions: editorActions })=>{
    // Only passed through when we are in the Editor view
    if (!editorActions) return;
    const { sendEvent: sendEvent } = analyticsClient;
    const node = editorActions.getSelectedNode();
    const attrs = node?.attrs;
    if (attrs?.extensionType === (0, $31HPn.P2_OR_CONNECT_CONFLUENCE_MACRO_EXTENSION_TYPE)) {
        const { extensionKey: extensionKey, localId: nodeLocalId } = attrs;
        const macroId = (0, $4cd75da05087f7d2$export$4ea6c6225eccc91)(attrs.parameters);
        const extensionType = node?.type.name;
        if (extensionType === (0, $31HPn.EXTENSION_TYPE_MULTI_BODIED)) {
            // Upgrade to forge blocked because:
            //     Extension is multi-bodied which forge doesn't support
            connectToForgeBlockedExtensions.add(macroId);
            sendEvent((0, $91ea3b98b23f5ddc$export$30c16f5c43437fd7).H11N_UPGRADE_RICH_TEST_SKIPPED, {
                nodeLocalId: nodeLocalId
            });
            return;
        }
        /* At this point, we know the extension should be upgraded from Connect to Forge
		 * If anything goes wrong after this point, it should be logged as an upgrade failure */ try {
            if (!actions?.doc?.update) throw new Error('Connect to Forge macro upgrade: Missing ExtensionAPI update action');
            const { updatedNode: updatedNode, originalMacroType: originalMacroType } = await $89d33f8c6eeca662$var$upgradeConnectExtensionToForge(attrs, actions, extensionProvider);
            const { localId: localId, extensionId: extensionId } = updatedNode.attrs.parameters;
            if (originalMacroType === 'CONNECT') sendEvent((0, $91ea3b98b23f5ddc$export$30c16f5c43437fd7).H11N_UPGRADE_SUCCESS, {
                extensionId: extensionId,
                extensionKey: extensionKey,
                localId: localId,
                nodeLocalId: nodeLocalId,
                extensionType: extensionType
            });
            else if (originalMacroType === 'P2') sendEvent((0, $91ea3b98b23f5ddc$export$30c16f5c43437fd7).APP_MIGRATION_P2_MACRO_UPGRADE, {
                extensionId: extensionId,
                extensionKey: extensionKey,
                localId: localId,
                nodeLocalId: nodeLocalId,
                extensionType: extensionType
            });
        } catch (error) {
            sendEvent((0, $91ea3b98b23f5ddc$export$30c16f5c43437fd7).H11N_UPGRADE_FAILED, {
                extensionKey: extensionKey,
                error: error,
                nodeLocalId: nodeLocalId,
                extensionType: extensionType
            });
            throw error;
        }
    }
};






/* convertToExtensionManifest.tsx generated by @compiled/babel-plugin v0.36.1 */ 







var $jc2GP = parcelRequire("jc2GP");




var $c6GJD = parcelRequire("c6GJD");





const $7366316c4ffedfad$export$a8391a3395b499ed = ()=>{
    return crypto.randomUUID();
};


const $2437e4eca8e1f4e6$var$extractPrefix = '/static/';
const $2437e4eca8e1f4e6$var$extractPrefixLength = $2437e4eca8e1f4e6$var$extractPrefix.length;
const $2437e4eca8e1f4e6$export$c47b515b4275a492 = (id)=>id.substr($2437e4eca8e1f4e6$var$extractPrefixLength + id.indexOf($2437e4eca8e1f4e6$var$extractPrefix));



var $jcPzc = parcelRequire("jcPzc");





const $b6012fec42c82617$export$b83e318aa057e7ad = (link, autoConvertDefinitions)=>{
    const matchedAutoConvertDefinition = autoConvertDefinitions?.find((acd)=>{
        return !!link.match(acd.matcher);
    });
    return matchedAutoConvertDefinition;
};
const $b6012fec42c82617$export$ba0026a66deb9f75 = (link, analyticsClient, autoConvertDefinitions, macroAttributesMap, autoConvertMatcherToExtensionsMap)=>{
    if (!autoConvertDefinitions || !macroAttributesMap || !autoConvertMatcherToExtensionsMap) return null;
    const matchedAutoConvertDefinition = $b6012fec42c82617$export$b83e318aa057e7ad(link, autoConvertDefinitions);
    if (matchedAutoConvertDefinition) {
        const { extensionKey: extensionKey } = matchedAutoConvertDefinition;
        const macroAttributes = macroAttributesMap[extensionKey];
        // Clone the object here to avoid mutating the original object
        const convertedMacroAttributes = structuredClone(macroAttributes);
        convertedMacroAttributes.attrs.parameters.autoConvertLink = link;
        convertedMacroAttributes.attrs.parameters.hasBeenAutoConverted = true;
        analyticsClient.sendEvent((0, $91ea3b98b23f5ddc$export$30c16f5c43437fd7).FORGE_MACRO_AUTO_CONVERT_SUCCESS, {
            extensionId: convertedMacroAttributes.attrs.parameters.extensionId,
            macroTitle: convertedMacroAttributes.attrs.parameters.extensionTitle,
            forgeEnvironment: convertedMacroAttributes.attrs.parameters.forgeEnvironment,
            render: convertedMacroAttributes.attrs.parameters.render,
            link: link
        });
        return convertedMacroAttributes;
    } else return null;
};






const $a9a0f392f6cf3804$var$getExtensionTypeFromADFNodeLayout = (layout)=>{
    switch(layout){
        case 'bodied':
            return 'bodiedExtension';
        case 'inline':
            return 'inlineExtension';
        default:
            return 'extension';
    }
};
const $a9a0f392f6cf3804$var$getNodeByLayout = (extension, currentNodeType, pastedLink)=>{
    const localId = (0, $7366316c4ffedfad$export$a8391a3395b499ed)();
    const extensionType = $a9a0f392f6cf3804$var$getExtensionTypeFromADFNodeLayout(extension.macroADFNode?.attrs.parameters.layout);
    const extensionNode = {
        type: extensionType,
        attrs: {
            extensionKey: extension.extensionKey,
            extensionType: (0, $31HPn.EXTENSION_NAMESPACE),
            localId: localId,
            parameters: {
                extensionId: extension.macroADFNode?.attrs.parameters.extensionId,
                extensionTitle: extension.macroADFNode?.attrs.parameters.extensionTitle,
                forgeEnvironment: extension.macroADFNode?.attrs.parameters.forgeEnvironment,
                render: extension.macroADFNode?.attrs.parameters.render,
                layout: extension.macroADFNode?.attrs.parameters.layout,
                autoConvertLink: pastedLink,
                hasBeenAutoConverted: true
            },
            text: extension.macroADFNode?.attrs.text
        },
        ...extensionType === 'bodiedExtension' ? {
            // include empty content so bodiedExtension doesn't throw error
            content: [
                {
                    type: 'paragraph',
                    content: []
                }
            ]
        } : {}
    };
    //Changing from a block/bodied to inline extension requires establishing a paragraph wrapping node
    if ($a9a0f392f6cf3804$var$getExtensionTypeFromADFNodeLayout(extension.macroADFNode?.attrs.parameters.layout) === 'inlineExtension' && (currentNodeType === 'extension' || currentNodeType === 'bodiedExtension')) return {
        type: 'paragraph',
        content: [
            extensionNode
        ]
    };
    return extensionNode;
};
const $a9a0f392f6cf3804$export$423a31d6ceadaac3 = (autoConvertDefinitions, autoConvertMatcherToExtensionsMap, editorActions, link)=>{
    if (!autoConvertDefinitions || !autoConvertMatcherToExtensionsMap) return [];
    let pastedLink = link;
    if (!link) {
        const node = editorActions?.getSelectedNode();
        pastedLink = node?.attrs.parameters.autoConvertLink;
    }
    const matchedAutoConvertDefinition = pastedLink ? (0, $b6012fec42c82617$export$b83e318aa057e7ad)(pastedLink, autoConvertDefinitions) : undefined;
    if (matchedAutoConvertDefinition && autoConvertMatcherToExtensionsMap) {
        const extensionsWithTheSameMatcher = autoConvertMatcherToExtensionsMap[matchedAutoConvertDefinition.matcher];
        const node = editorActions?.getSelectedNode();
        const currentNodeType = node?.type.name;
        const options = extensionsWithTheSameMatcher.map((extension)=>{
            return {
                id: `${extension.extensionKey}-dropdown-option`,
                title: extension.macroName,
                selected: extension.extensionKey === node?.attrs.extensionKey,
                onClick: async (state, dispatch, view)=>{
                    if (view) {
                        const { selection: selection } = view?.state;
                        const insertPosition = selection.$from.pos;
                        // If the current node is an inlineExtension, replaceSelection is unable to delete the current inline node
                        if (currentNodeType === 'inlineExtension') {
                            const transaction = state.tr.deleteSelection().scrollIntoView();
                            view?.dispatch(transaction);
                        }
                        editorActions?.replaceSelection($a9a0f392f6cf3804$var$getNodeByLayout(extension, currentNodeType, pastedLink), true, insertPosition);
                    }
                    return true;
                }
            };
        });
        return options;
    }
    return [];
};











const $9834bfcdf88177f5$export$dc6604afff08e361 = {
    '16': ()=>Promise.resolve((parcelRequire("jcPzc"))),
    '24': ()=>Promise.resolve((parcelRequire("jcPzc"))),
    '48': ()=>Promise.resolve((parcelRequire("jcPzc")))
};
const $9834bfcdf88177f5$export$1fe770db7b01f9fc = (actions, localId, payload)=>{
    try {
        actions.doc.update(localId, (currentValue)=>$9834bfcdf88177f5$export$227008f8867b6b1a(currentValue?.attrs || {}, payload));
    } catch (error) {
        (0, $4460d49fe1c967ee$export$4537e246a5edda0a)(error);
    }
};
const $9834bfcdf88177f5$export$227008f8867b6b1a = (attrs, { config: config, body: body })=>{
    // HOTFIX for HOT-115700
    // https://ecosystem-platform.atlassian.net/browse/EXT-2877
    // Remove "forgeEnvironment" and "render" from the node attributes, as they would break validation
    // and therefore prevent the user from submitting a macro configuration.
    const { forgeEnvironment: _forgeEnvironment, render: _render, ...cleanedAttrs } = attrs;
    return {
        attrs: {
            ...cleanedAttrs,
            parameters: {
                ...cleanedAttrs.parameters || {},
                ...(0, $e2cd313e500316d2$export$33006db0d9b837ff)(config)
            }
        },
        ...body ? {
            content: body.content
        } : {}
    };
};
const $9834bfcdf88177f5$export$4bf92a336c844766 = (actions, localId, payload)=>{
    try {
        const { node: node } = actions.getNodeWithPosByLocalId(localId);
        const nodeEl = document.querySelector(`[extensionkey="${node?.attrs.extensionKey}"]`);
        if (nodeEl) setTimeout(()=>{
            const rectHeight = nodeEl?.getBoundingClientRect().height;
            actions.doc.update(localId, (currentValue)=>{
                const result = $9834bfcdf88177f5$export$227008f8867b6b1a(currentValue.attrs || {}, payload);
                const newNode = {
                    attrs: {
                        ...result.attrs,
                        parameters: {
                            ...result.attrs.parameters,
                            measuredHeight: rectHeight
                        }
                    }
                };
                return newNode;
            });
        }, 3000);
        else actions.doc.update(localId, (currentValue)=>$9834bfcdf88177f5$export$227008f8867b6b1a(currentValue?.attrs || {}, payload));
    } catch (error) {
        (0, $4460d49fe1c967ee$export$4537e246a5edda0a)(error);
    }
};

const $9834bfcdf88177f5$export$205fc211839e6c8b = ({ analyticsClient: analyticsClient, editorActions: editorActions, eventSource: eventSource, fieldsModules: fieldsModules, renderConfigHelper: renderConfigHelper, createRenderFunction: createRenderFunction, connectToForgeBlockedExtensions: connectToForgeBlockedExtensions, getFieldsDefinitionFunction: getFieldsDefinitionFunction, updateFunction: updateFunction, autoConvertDefinitions: autoConvertDefinitions, autoConvertMatcherToExtensionsMap: autoConvertMatcherToExtensionsMap, embeddedMacroContext: embeddedMacroContext })=>(extension)=>{
        const { sendEvent: sendEvent } = analyticsClient;
        const { id: id, properties: properties, environmentType: environmentType, migrationKey: migrationKey, environmentKey: environmentKey } = extension;
        const title = (0, $aab0628593b7d8ff$export$553719da8802da2d)(properties.title || 'Forge UI Macro', environmentKey, environmentType);
        const extensionIdWithoutPrefix = (0, $7MEO5.parse)(id).resourceId;
        const isCustomUI = (0, $iqcSr.isCustomUI)(extension);
        const isUiKitTwo = extension.properties.render === 'native';
        const hasUiKitOneConfig = !!properties.config && !!properties.config.function;
        const hasConfig = isUiKitTwo || isCustomUI ? !!properties.config : hasUiKitOneConfig;
        const hasCustomConfig = (isUiKitTwo || isCustomUI) && !!properties.config?.resource;
        const hasAutoConvertLinks = !!properties.autoConvert;
        const isInline = properties.layout === 'inline';
        const isBodiedExtension = properties.layout === 'bodied'; // For UI Kit and custom UI apps with side context panel config only
        // Custom config openOnInsert is a different parameter in the manifest config object, and is rendered by renderConfigHelper()
        const openConfigOnInsert = (isUiKitTwo || isCustomUI) && hasConfig && !hasCustomConfig && !!properties.config?.openOnInsert;
        const connectModuleKey = (0, $2437e4eca8e1f4e6$export$c47b515b4275a492)(extensionIdWithoutPrefix); // Extension properties to be stored in `parameters` to be passed to the renderer for rendering embedded macros
        const embeddedMacrosProps = {
            extension: extension,
            extensionData: embeddedMacroContext.extensionData,
            accountId: embeddedMacroContext.accountId,
            cloudId: embeddedMacroContext.cloudId,
            contextIds: embeddedMacroContext.contextIds
        };
        const createExtensionProps = (macroId)=>{
            const localId = macroId || (0, $7366316c4ffedfad$export$a8391a3395b499ed)();
            const extensionId = id;
            const type = (0, $jc2GP.getExtensionType)(extension);
            return {
                // Do not add any additional props in this object or in attrs without changing the adf schema
                type: type,
                attrs: {
                    extensionKey: extensionIdWithoutPrefix,
                    extensionType: (0, $31HPn.EXTENSION_NAMESPACE),
                    // Only parameters can change without changing the adf schema
                    // Be careful as connect and editor reference node.attrs.parameters.X in multiple places
                    parameters: {
                        localId: localId,
                        extensionId: extensionId,
                        extensionTitle: title,
                        layout: type,
                        forgeEnvironment: environmentType,
                        render: properties.render,
                        ...(0, $dh538.fg)('platform_forge_clean_up_embed_ext_properties') ? {
                            embeddedMacroContext: embeddedMacroContext
                        } : {
                            extensionProperties: embeddedMacrosProps
                        }
                    },
                    text: title,
                    localId: localId
                },
                ...type === 'bodiedExtension' ? {
                    // include empty content so bodiedExtension doesn't throw error
                    content: [
                        {
                            type: 'paragraph',
                            content: []
                        }
                    ]
                } : {}
            };
        };
        const icon = /*#__PURE__*/ $42omo.createElement((0, $jcPzc.default), {
            label: properties?.title ?? '',
            imgUrl: properties.icon
        });
        const macroIcons = properties.icon && properties.icon.length > 0 ? {
            '16': ()=>Promise.resolve(()=>icon),
            '24': ()=>Promise.resolve(()=>icon),
            '48': ()=>Promise.resolve(()=>icon)
        } : $9834bfcdf88177f5$export$dc6604afff08e361;
        const getFieldsDefinition = (0, $9e4c06087ba25b96$export$55efa0cfd3b99204)({
            analyticsClient: analyticsClient,
            connectToForgeBlockedExtensions: connectToForgeBlockedExtensions,
            eventSource: eventSource,
            extension: extension,
            hasCustomConfig: hasCustomConfig,
            hasUiKitOneConfig: hasUiKitOneConfig,
            isCustomUI: isCustomUI,
            isUiKitTwo: isUiKitTwo,
            uiKitOneGetFieldsDefinitionFunction: getFieldsDefinitionFunction
        });
        const makeAutoConvertDropdownOptionsInManifest = ()=>{
            const node = editorActions?.getSelectedNode();
            const link = node?.attrs.parameters.autoConvertLink;
            return (0, $a9a0f392f6cf3804$export$423a31d6ceadaac3)(autoConvertDefinitions, autoConvertMatcherToExtensionsMap, editorActions, link);
        };
        const getQuickInsertNode = async (actions)=>{
            let extensionProps = createExtensionProps();
            const { localId: localId } = extensionProps.attrs.parameters;
            const { type: extensionType } = extensionProps;
            const isBodiedExtension = extensionType === 'bodiedExtension';
            if (hasCustomConfig) {
                // Skips merging node with payload that renders the config on insert
                if (extension.properties.config?.openOnInsert === false) {
                    sendEvent((0, $91ea3b98b23f5ddc$export$30c16f5c43437fd7).FORGE_EXTENSION_INSERTED, {
                        extension: extension,
                        localId: localId
                    });
                    return extensionProps;
                }
                const forgeExtensionNode = {
                    ...extensionProps.attrs,
                    type: extensionType
                };
                const payload = await new Promise((resolve)=>{
                    let isInitialInsertion = true;
                    renderConfigHelper({
                        extension: extension,
                        forgeExtensionNode: forgeExtensionNode,
                        hasCustomConfig: hasCustomConfig,
                        isInitialInsertion: true,
                        createRenderFunction: // We don't use the variable here because this is only executed once
                        createRenderFunction,
                        onSubmit: (payload)=>{
                            if (isInitialInsertion) {
                                isInitialInsertion = false;
                                resolve(payload);
                            } else if (actions) // Update existing node
                            $9834bfcdf88177f5$export$1fe770db7b01f9fc(actions, localId, payload);
                        },
                        onValidate: (data)=>(0, $4460d49fe1c967ee$export$d6710954d38d35b9)(data, {
                                isBodiedExtension: isBodiedExtension,
                                isInitialInsertion: isInitialInsertion,
                                schema: editorActions?._privateGetEditorView?.()?.state.schema
                            })
                    });
                });
                extensionProps = {
                    ...extensionProps,
                    ...$9834bfcdf88177f5$export$227008f8867b6b1a(extensionProps.attrs, payload)
                };
            }
            sendEvent((0, $91ea3b98b23f5ddc$export$30c16f5c43437fd7).FORGE_EXTENSION_INSERTED, {
                extension: extension,
                localId: localId
            });
            return extensionProps;
        };
        const isExtensionHidden = ()=>{
            return (0, $c6GJD.default).getExperimentValue('platform_forge_macro_hidden_filtering', 'isEnabled', false) && extension.type === 'xen:macro' && 'hidden' in properties && properties.hidden === true;
        };
        const shouldBlockExtension = ()=>{
            return (0, $32d592094b83de00$export$61f675db88ce9814)(extension) || isExtensionHidden();
        };
        return {
            title: title,
            description: properties.description,
            type: (0, $31HPn.EXTENSION_NAMESPACE),
            key: extensionIdWithoutPrefix,
            icons: macroIcons,
            categories: properties.categories,
            connectModuleKey: connectModuleKey,
            migrationKey: migrationKey,
            createExtensionProps: createExtensionProps,
            autoConvert: properties.autoConvert,
            modules: {
                ...shouldBlockExtension() ? {} : {
                    quickInsert: [
                        {
                            key: 'forge-macro',
                            action: async (actions)=>{
                                const node = await getQuickInsertNode(actions);
                                if (openConfigOnInsert && editorActions?._privateGetEditorView()) {
                                    if (isBodiedExtension) (0, $fbPMY.renderBodiedExtensionIframe)({
                                        extension: extension,
                                        forgeExtensionNode: node.attrs,
                                        createRenderFunction: createRenderFunction
                                    });
                                    editorActions?.replaceSelection(node); // Workaround as the dispatch call within editorActions.replaceSelection() is async,
                                    // and we need to ensure that editInContextPanel is called after.
                                    setTimeout(()=>actions.editInContextPanel((0, $e2cd313e500316d2$export$c995c5854d98b6ef), async (params)=>(0, $e2cd313e500316d2$export$33006db0d9b837ff)(params)), 0); // We return undefined here to skip the additional replaceSelection() in editor-core
                                    // platform/packages/editor/editor-core/src/utils/extensions.tsx getItems()
                                    return;
                                }
                                return node;
                            }
                        }
                    ]
                },
                nodes: {
                    default: {
                        type: 'extension',
                        render: ()=>createRenderFunction(extension),
                        update: hasConfig ? (params, actions)=>updateFunction(params, actions, extension, hasCustomConfig) : undefined,
                        getFieldsDefinition: getFieldsDefinition
                    }
                },
                fields: fieldsModules,
                contextualToolbars: hasAutoConvertLinks ? [
                    {
                        context: {
                            nodeType: (0, $jc2GP.getExtensionType)(extension),
                            extensionKey: extensionIdWithoutPrefix,
                            type: 'extension',
                            extensionType: 'com.atlassian.ecosystem',
                            shouldExclude: (node)=>{
                                return !node.attrs?.parameters.hasBeenAutoConverted;
                            }
                        },
                        toolbarItems: [
                            {
                                key: `${extension.key}-convert-to-smartlink-toolbarItem`,
                                // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
                                label: 'Convert to link',
                                display: 'icon',
                                icon: ()=>Promise.resolve((parcelRequire("duwSm"))).then((mod)=>mod.default),
                                action: async ()=>{
                                    /*We need the editorView object to determine the position of the node.
            By default, the safeInsert method inside replaceSelection inserts nodes in pos + 1 if the selected
            node is an extension. */ const editorView = editorActions?._privateGetEditorView();
                                    const node = editorActions?.getSelectedNode();
                                    const originalLink = node?.attrs.parameters.autoConvertLink;
                                    if (editorView) {
                                        const { selection: selection } = editorView.state;
                                        const insertPosition = selection.$from.pos;
                                        editorActions?.replaceSelection(isInline ? {
                                            type: 'inlineCard',
                                            attrs: {
                                                url: originalLink
                                            }
                                        } : {
                                            type: 'paragraph',
                                            content: [
                                                {
                                                    type: 'inlineCard',
                                                    attrs: {
                                                        url: originalLink
                                                    }
                                                }
                                            ]
                                        }, true, insertPosition);
                                        sendEvent((0, $91ea3b98b23f5ddc$export$30c16f5c43437fd7).FORGE_MACRO_AUTO_CONVERT_TO_SMARTLINK, {
                                            extensionId: extension.key,
                                            forgeEnvironment: extension.environmentType,
                                            render: extension.properties.render,
                                            link: originalLink
                                        });
                                    }
                                },
                                tooltip: 'Convert to link',
                                ariaLabel: 'Convert to link'
                            },
                            {
                                id: `${extension.key}-display-options-toolbarItem`,
                                title: 'Display options',
                                type: 'dropdown',
                                options: ()=>makeAutoConvertDropdownOptionsInManifest(),
                                tooltip: 'Display options'
                            }
                        ]
                    }
                ] : []
            }
        };
    };



var $bre0g = parcelRequire("bre0g");








class $c9f729d4895fa4b3$export$6add1decf4f736cc extends (0, $bre0g.default) {
    async getExtension(type, key) {
        try {
            return await super.getExtension(type, key);
        } catch (forgeError) {
            // There is no Forge app to match the full ARI extensionKey
            // If the extensionType is Connect, we fall back to trying to resolve it by harmonised connect module key
            if (type === (0, $31HPn.P2_OR_CONNECT_CONFLUENCE_MACRO_EXTENSION_TYPE)) {
                const { sendEvent: sendEvent } = this.analyticsClient || {};
                if (!this.connectExtensionProvider) {
                    if (sendEvent) sendEvent((0, $91ea3b98b23f5ddc$export$30c16f5c43437fd7).H11N_RESOLVE_FAILED, {
                        extensionKey: key,
                        error: 'No connect extension provider'
                    });
                    else this.sendAnalytics?.(key, 'No connect extension provider');
                } else try {
                    // We first check that no Connect app still exists that can handle this extensionKey
                    await (await this.connectExtensionProvider).getExtension(type, key);
                } catch (connectError) {
                    // We know that there is no corresponding Connect app, so we can look up the Forge app by Connect key
                    const extension = await this.getConnectToForgeExtension(key);
                    if (extension) return extension;
                    if ((0, $dh538.fg)('platform_upgrade_p2_to_forge_macro')) {
                        const getP2ToForgeExtension = await this.getP2ToForgeExtension(key);
                        if (getP2ToForgeExtension) {
                            if (sendEvent) sendEvent((0, $91ea3b98b23f5ddc$export$30c16f5c43437fd7).APP_MIGRATION_P2_MACRO_RESOLVED, {
                                extensionKey: key,
                                extensionType: (0, $31HPn.P2_OR_CONNECT_CONFLUENCE_MACRO_EXTENSION_TYPE)
                            });
                            return getP2ToForgeExtension;
                        }
                    }
                    // Report failure to find a Forge extension for this Connect key
                    if (sendEvent) sendEvent((0, $91ea3b98b23f5ddc$export$30c16f5c43437fd7).H11N_RESOLVE_FAILED, {
                        extensionKey: key,
                        error: forgeError
                    });
                    else this.sendAnalytics?.(key, forgeError instanceof Error ? forgeError.message : String(forgeError));
                }
            }
            throw forgeError;
        }
    }
    async getExtensions() {
        return super.getExtensions();
    }
    async getP2ToForgeExtension(key) {
        try {
            return await super.getExtension((0, $31HPn.EXTENSION_NAMESPACE), key);
        } catch (_) {
            // Means no extension was found
            return;
        }
    }
    async getConnectToForgeExtension(key) {
        const extensions = await this.getExtensions();
        return extensions.find((manifest)=>'connectModuleKey' in manifest && Boolean(manifest.migrationKey) && manifest.connectModuleKey === key);
    }
    constructor(manifests, connectExtensionProvider, sendAnalytics, autoConvertHandlers, analyticsClient){
        super(manifests);
        this.connectExtensionProvider = void 0;
        this.sendAnalytics = void 0;
        this.analyticsClient = void 0;
        this.connectExtensionProvider = connectExtensionProvider;
        this.sendAnalytics = sendAnalytics;
        this.manifestsPromise = Promise.resolve(manifests);
        this.autoConvertHandlers = autoConvertHandlers;
        this.analyticsClient = analyticsClient;
    }
}











const $68ff445db2b43490$export$6daa7566596cd68 = (pattern)=>{
    // Escape special regex characters, excluding `*`
    const escapePattern = (str)=>{
        return str.replace(/[\-\[\]\/\(\)\+\?\.\\\^\$\|]/g, '\\$&');
    };
    // Consolidate any double wildcards (** -> *)
    pattern = pattern.replace(/\*\*/g, '*');
    // Escape special characters (but leave `*` as-is for now)
    pattern = escapePattern(pattern);
    // Replace wildcards (*) with regex equivalent
    pattern = pattern.replace(/\*/g, '[^/]*?'); // Replace escaped `*`
    // Add start (^) and end ($) anchors
    pattern = '^' + pattern + '$';
    return pattern;
};


/**
 * Validates auto convert url patterns. The regex is matching:
 * - a required protocol (http:// or https:// or a custom protocol like myapp: or myapp:\\)
 * - allows wildcard (*) in any part of the url
 * - no whitespaces
 * - 1024 character limit
 * For more information: https://hello.atlassian.net/wiki/spaces/ECO/pages/4856894219/Manifest+Schema+Changes+Documentation
 */ const $baef684beab2aaab$export$3ecb154bc09ddd37 = (pattern)=>{
    const urlRegex = /^(?=.{1,1024}$)[a-zA-Z]+:(\/\/)?(\\\\)?(?:[a-zA-Z0-9-\*]+[\.:])*[a-zA-Z0-9-\*]+(?:\.:[a-zA-Z\*]{1,})?(?:\/.*)?$/;
    return urlRegex.test(pattern);
};





const $ada83bc359a64db0$export$96c30bce9b9743b7 = (extensions, embeddedMacroContext)=>{
    if (!extensions) return {
        autoConvertDefinitions: undefined,
        macroADFNodeMap: undefined
    };
    const autoConvertDefinitions = [];
    // a map of macro key to ADF node
    const macroADFNodeMap = {};
    extensions.forEach((extension)=>{
        if (!(0, $7MEO5.parse)(extension.id).resourceId || !extension.properties.autoConvert) return;
        const extensionIdWithoutPrefix = (0, $7MEO5.parse)(extension.id).resourceId;
        const embeddedMacroExtensionProperties = {
            extension: extension,
            extensionData: embeddedMacroContext.extensionData,
            accountId: embeddedMacroContext.accountId,
            cloudId: embeddedMacroContext.cloudId,
            contextIds: embeddedMacroContext.contextIds
        };
        const platform_add_bridge_message_forwarding_from_faus = (0, $dh538.fg)('platform_add_bridge_message_forwarding_from_faus');
        const platform_add_embedded_macro_support_to_ui_kit = (0, $dh538.fg)('platform_add_embedded_macro_support_to_ui_kit');
        // only macro with autoconvertData can be converted
        extension.properties.autoConvert.matchers.forEach(({ pattern: pattern })=>{
            // Invalid patterns will silently fail. We are relying on the CLI linter to warn developers for invalid pattern
            if ((0, $baef684beab2aaab$export$3ecb154bc09ddd37)(pattern)) {
                const type = (0, $jc2GP.getExtensionType)(extension);
                macroADFNodeMap[extensionIdWithoutPrefix] = {
                    type: type,
                    attrs: {
                        extensionKey: extensionIdWithoutPrefix,
                        extensionType: (0, $31HPn.EXTENSION_NAMESPACE),
                        parameters: {
                            extensionId: extension.id,
                            extensionTitle: extension.properties.title,
                            layout: extension.properties.layout || 'block',
                            forgeEnvironment: extension.environmentType,
                            render: extension.properties.render || 'default',
                            ...platform_add_bridge_message_forwarding_from_faus || platform_add_embedded_macro_support_to_ui_kit ? (0, $dh538.fg)('platform_forge_clean_up_embed_ext_properties') ? {
                                embeddedMacroContext: embeddedMacroContext
                            } : {
                                extensionProperties: embeddedMacroExtensionProperties
                            } : {}
                        },
                        layout: 'default',
                        text: extension.properties.title
                    }
                };
                const autoConvertDefinition = {
                    macroName: extension.properties.title || '',
                    matcher: (0, $68ff445db2b43490$export$6daa7566596cd68)(pattern),
                    extensionKey: extensionIdWithoutPrefix
                };
                autoConvertDefinitions.push(autoConvertDefinition);
            }
        });
    });
    return {
        autoConvertDefinitions: autoConvertDefinitions,
        macroADFNodeMap: macroADFNodeMap
    };
};



const $2226d21eed80f2d5$export$83421df3e56a4930 = (analyticsClient, autoConvertDefinitions, macroADFNodeMap, autoConvertMatcherToExtensionsMap)=>{
    return (link)=>(0, $b6012fec42c82617$export$ba0026a66deb9f75)(link, analyticsClient, autoConvertDefinitions, macroADFNodeMap, autoConvertMatcherToExtensionsMap);
};


const $eb95a8e4ea635d0f$export$d2b6953e93cee5f0 = (autoConvertDefinitions, macroADFNodeMap)=>{
    if (!autoConvertDefinitions || !macroADFNodeMap) return {};
    return autoConvertDefinitions.reduce((acc, def)=>{
        if (!acc[def.matcher]) acc[def.matcher] = [];
        acc[def.matcher].push({
            macroName: def.macroName,
            macroADFNode: macroADFNodeMap[def.extensionKey],
            extensionKey: def.extensionKey
        });
        return acc;
    }, {});
};


const $aab0628593b7d8ff$var$humanReadableEnvironmentType = {
    DEVELOPMENT: 'Development',
    STAGING: 'Staging',
    PRODUCTION: 'Production'
};
const $aab0628593b7d8ff$export$553719da8802da2d = (title, environmentKey, environmentType = (0, $1c598.ExtensionEnvironment).PRODUCTION)=>{
    if (environmentType === (0, $1c598.ExtensionEnvironment).PRODUCTION) return title;
    if (environmentKey === undefined) return `${title} (${$aab0628593b7d8ff$var$humanReadableEnvironmentType[environmentType]})`;
    if (environmentType === (0, $1c598.ExtensionEnvironment).DEVELOPMENT && environmentKey !== 'default') return `${title} - ${environmentKey} (Dev)`;
    return `${title} (${$aab0628593b7d8ff$var$humanReadableEnvironmentType[environmentType]})`;
};
/*
	This exists to provide a default value for the flag functions that Confluence
	is meant to inject with the FlagProvider param. The param must be optional in
	getForgeExtensionProvider because breaking changes are disallowed without a
	deprecation period (which we want to avoid) - see go/releasing-changes-safely.
	The renderExtension function expects FlagProvider to be defined, so this default is provided.
*/ const $aab0628593b7d8ff$var$noopFlags = {
    showFlag: async ()=>{
        return {};
    },
    hideFlag: async ()=>{}
};
const $aab0628593b7d8ff$var$noopFlagProvider = ({ children: children })=>children($aab0628593b7d8ff$var$noopFlags);
// We keep track of the reason that an extension failed to upgrade, for analytics purposes
const $aab0628593b7d8ff$var$connectToForgeBlockedExtensions = new Set();
const $aab0628593b7d8ff$export$5f25f73e1231045e = async ({ accountId: accountId, cloudId: cloudId, apolloClient: apolloClient, contextIds: contextIds, dataProviders: dataProviders, environment: environment, product: product, page: page, isEditing: isEditing, analyticsWebClient: analyticsWebClient, forgeUIAnalyticsContext: forgeUIAnalyticsContext = {}, extensionData: extensionData, extensionHandlerWithReference: extensionHandlerWithReference, connectExtensionProvider: connectExtensionProvider, editorActions: editorActions, editorAPI: editorAPI, FlagProvider: FlagProvider = $aab0628593b7d8ff$var$noopFlagProvider, extensionsFilter: extensionsFilter, dataClassificationTagIds: dataClassificationTagIds, hideGlassPane: hideGlassPane, locale: locale, useGetContextToken: useGetContextToken, useRouteActions: useRouteActions })=>{
    let extensionProvider;
    const createRenderFunction = async (extension, customEditContext)=>extension && (0, $32d592094b83de00$export$61f675db88ce9814)(extension) ? (0, $32d592094b83de00$export$17b6162b15b3194c)({
            extension: extension
        }) : (0, $e804e4ac91f66148$export$b7482bdc8aff85e4)({
            accountId: accountId,
            analyticsWebClient: analyticsWebClient,
            cloudId: cloudId,
            extension: extension,
            extensionData: extensionData,
            extensionHandlerWithReference: extensionHandlerWithReference,
            forgeUIAnalyticsContext: forgeUIAnalyticsContext,
            apolloClient: apolloClient,
            contextIds: contextIds,
            isEditing: Boolean(isEditing),
            dataProviders: dataProviders,
            environment: environment,
            product: product,
            page: page,
            FlagProvider: FlagProvider,
            hideGlassPane: hideGlassPane,
            customEditContext: customEditContext,
            editorAPI: editorAPI,
            useGetContextToken: useGetContextToken,
            useRouteActions: useRouteActions
        });
    const getFieldsDefinitionFunction = (0, $9e4c06087ba25b96$export$b76d6fd67df268aa)({
        analyticsWebClient: analyticsWebClient,
        apolloClient: apolloClient,
        contextIds: contextIds,
        cloudId: cloudId,
        extensionData: extensionData
    });
    const { extensions: extensions } = await (0, $fYGGr.getForgeUIExtensionsAsync)({
        client: apolloClient,
        contextIds: contextIds,
        moduleType: (0, $31HPn.MODULE_NAME),
        expandAppOwner: true,
        extensionsFilter: extensionsFilter,
        dataClassificationTagIds: dataClassificationTagIds,
        locale: locale,
        cloudId: cloudId,
        context: {
            spaceKey: extensionData?.space?.key,
            contentId: extensionData?.content?.id
        },
        includeHidden: true
    });
    const eventSource = editorActions ? 'editPageScreen' : 'viewPageScreen';
    const analyticsClient = (0, $91ea3b98b23f5ddc$export$3d970ca206012d6b)({
        analyticsWebClient: analyticsWebClient,
        forgeUIAnalyticsContext: forgeUIAnalyticsContext,
        source: eventSource
    });
    const { sendEvent: sendEvent } = analyticsClient;
    const updateFunction = async (parameters, actions, extension, hasCustomConfig)=>{
        // Remember the localId of the selected node. If it's upgraded to Forge, it becomes unselected, so localId
        // is needed to find it again.
        const localId = editorActions?.getSelectedNode()?.attrs.localId;
        await (0, $89d33f8c6eeca662$export$142e3c584022ba7e)({
            actions: actions,
            analyticsClient: analyticsClient,
            connectToForgeBlockedExtensions: $aab0628593b7d8ff$var$connectToForgeBlockedExtensions,
            editorActions: editorActions,
            extensionProvider: extensionProvider
        });
        const node = (0, $dh538.fg)('platform_reread_node_after_upgrade_to_forge') ? actions.getNodeWithPosByLocalId(localId)?.node : editorActions?.getSelectedNode();
        const isBodiedExtension = node?.type.name === 'bodiedExtension';
        if (node && extension && actions && (hasCustomConfig || isBodiedExtension)) {
            /**
			 * Converts a ProseMirror Node (received by EditorActions API) to a ForgeExtension (provided to render function)
			 * This includes:
			 * - Extracting the node's attributes
			 * - Extracting the node's type
			 * - Transforming the node's content from ProseMirror to ADF JSON (and handling any errors)
			 */ const forgeExtensionNode = (()=>{
                const forgeExtension = {
                    ...node.attrs,
                    type: node.type.name
                };
                try {
                    const { content: content } = new (0, $h9yJL.JSONTransformer)().encode(node);
                    return {
                        ...forgeExtension,
                        content: content
                    };
                } catch (error) {
                    // failed to encode node to JSON
                    // continue rendering custom config without content and emit analytics error event
                    const { localId: localId } = node.attrs;
                    sendEvent((0, $91ea3b98b23f5ddc$export$30c16f5c43437fd7).FORGE_EXTENSION_FAILED, {
                        extension: extension,
                        error: error,
                        localId: localId
                    });
                    return forgeExtension;
                }
            })();
            // No need to wait for config to render to start showing the panel (for non-custom config)
            // noinspection ES6MissingAwait
            (0, $fbPMY.renderConfigHelper)({
                extension: extension,
                forgeExtensionNode: forgeExtensionNode,
                hasCustomConfig: Boolean(hasCustomConfig),
                isInitialInsertion: false,
                createRenderFunction: createRenderFunction,
                onSubmit: (payload)=>(0, $dh538.fg)('platform_measure_macro_height') ? (0, $9834bfcdf88177f5$export$4bf92a336c844766)(actions, node.attrs.localId, payload) : (0, $9834bfcdf88177f5$export$1fe770db7b01f9fc)(actions, node.attrs.localId, payload),
                onValidate: (data)=>(0, $4460d49fe1c967ee$export$d6710954d38d35b9)(data, {
                        isBodiedExtension: isBodiedExtension,
                        isInitialInsertion: false,
                        schema: editorActions?._privateGetEditorView?.()?.state.schema
                    })
            });
        }
        if (!hasCustomConfig) return actions.editInContextPanel((0, $e2cd313e500316d2$export$c995c5854d98b6ef), async (params)=>{
            if ((0, $dh538.fg)('platform_measure_macro_height')) {
                const currentNode = actions.getNodeWithPosByLocalId(node?.attrs.localId);
                const existingParameters = currentNode?.node.attrs.parameters;
                if (existingParameters.measuredHeight) {
                    const tr = (0, $e2cd313e500316d2$export$33006db0d9b837ff)(params);
                    return {
                        ...tr,
                        measuredHeight: existingParameters.measuredHeight
                    };
                }
            }
            return (0, $e2cd313e500316d2$export$33006db0d9b837ff)(params);
        });
    };
    const fieldsModules = {
        user: {
            [(0, $c8c0ee2f628d6095$export$5e2bcfbdd2ce465e)]: {
                provider: async ()=>({
                        siteId: cloudId,
                        // If principalId === 'Context', upstream attempts to use other context to discover the principal ID
                        principalId: accountId || 'Context',
                        fieldId: 'forgeConfigUserPicker',
                        productKey: product
                    })
            }
        }
    };
    const embeddedMacroContext = {
        extensionData: extensionData,
        contextIds: contextIds,
        accountId: accountId || '',
        cloudId: cloudId
    };
    const { autoConvertDefinitions: autoConvertDefinitions, macroADFNodeMap: macroADFNodeMap } = (0, $ada83bc359a64db0$export$96c30bce9b9743b7)(extensions, embeddedMacroContext);
    const autoConvertMatcherToExtensionsMap = (0, $eb95a8e4ea635d0f$export$d2b6953e93cee5f0)(autoConvertDefinitions, macroADFNodeMap);
    const convertLinkToADFNode = (0, $2226d21eed80f2d5$export$83421df3e56a4930)(analyticsClient, autoConvertDefinitions, macroADFNodeMap, autoConvertMatcherToExtensionsMap);
    const convertToExtensionManifest = (0, $9834bfcdf88177f5$export$205fc211839e6c8b)({
        analyticsClient: analyticsClient,
        editorActions: editorActions,
        eventSource: eventSource,
        fieldsModules: fieldsModules,
        renderConfigHelper: $fbPMY.renderConfigHelper,
        createRenderFunction: createRenderFunction,
        connectToForgeBlockedExtensions: $aab0628593b7d8ff$var$connectToForgeBlockedExtensions,
        getFieldsDefinitionFunction: getFieldsDefinitionFunction,
        updateFunction: updateFunction,
        autoConvertDefinitions: autoConvertDefinitions,
        autoConvertMatcherToExtensionsMap: autoConvertMatcherToExtensionsMap,
        embeddedMacroContext: embeddedMacroContext
    });
    const extensionManifests = (extensions || []).filter(({ id: id })=>(0, $7MEO5.parse)(id).resourceId !== undefined).map(convertToExtensionManifest);
    const legacyMacroManifest = {
        /**
		 * title, description and icons are required but will not be used anywhere,
		 * since this manifest is used solely for rendering legacy nodes
		 **/ title: 'Forge UI Macro',
        description: 'Supports existing Forge UI Macro nodes',
        type: (0, $31HPn.EXTENSION_NAMESPACE),
        key: 'xen:macro',
        icons: (0, $9834bfcdf88177f5$export$dc6604afff08e361),
        modules: {
            nodes: {
                default: {
                    type: 'extension',
                    render: createRenderFunction,
                    update: updateFunction,
                    getFieldsDefinition: getFieldsDefinitionFunction
                }
            },
            fields: fieldsModules
        }
    };
    const manifests = [
        legacyMacroManifest,
        ...extensionManifests
    ];
    extensionProvider = new (0, $c9f729d4895fa4b3$export$6add1decf4f736cc)(manifests, connectExtensionProvider, undefined, [
        (link)=>{
            const result = convertLinkToADFNode(link);
            if (result) return result;
            return undefined;
        }
    ], analyticsClient);
    return extensionProvider;
};



var $aF5bm = parcelRequire("aF5bm");


var $grQpA = parcelRequire("grQpA");


var $8z3oB = parcelRequire("8z3oB");


var $ge2sX = parcelRequire("ge2sX");


var $5bak6 = parcelRequire("5bak6");


var $04e9M = parcelRequire("04e9M");


var $5SzHz = parcelRequire("5SzHz");


var $gKr8t = parcelRequire("gKr8t");


var $dPJCf = parcelRequire("dPJCf");

const $011c3ef08c0f8175$export$31bd098138fa620d = async ({ spaceKey: spaceKey, spaceId: spaceId, contentId: contentId, contentType: contentType, mentionProvider: mentionProvider, isEditing: isEditing, contentMode: contentMode, connectExtensionProvider: connectExtensionProvider, editorActions: editorActions, hideGlassPaneForForge: hideGlassPaneForForge, locale: locale, isLivePage: isLivePage = false, editorAPI: editorAPI, useGetContextToken: useGetContextToken, templateId: templateId })=>{
    const { cloudId: cloudId, userId: userId, environment: environment, activationId: activationId } = await (0, $ge2sX.getSessionData)();
    const accountId = userId ?? '';
    const apolloClient = (0, $gKr8t.getAGGClient)();
    const contextIds = [
        (0, $aF5bm.getWorkspaceARI)({
            cloudId: cloudId,
            activationId: activationId
        })
    ];
    const providerFactory = (0, $4FxUL.default).create(mentionProvider);
    const getProviderOptions = ({ spaceKey: spaceKeyArg, spaceId: spaceIdArg })=>({
            accountId: accountId,
            cloudId: cloudId,
            apolloClient: apolloClient,
            contextIds: contextIds,
            dataProviders: providerFactory,
            environment: (0, $5bak6.environmentToForgeProductEnvironment)(environment),
            product: 'confluence',
            page: 'confluence:macroEditor',
            isEditing: isEditing,
            contentMode: contentMode,
            analyticsWebClient: (0, $04e9M.getAnalyticsWebClient)(),
            forgeUIAnalyticsContext: (0, $5bak6.createForgeUIAnalyticsContext)({
                objectId: contentId,
                objectType: contentType,
                containerId: spaceKeyArg,
                containerType: 'space'
            }),
            extensionData: (0, $5bak6.createForgeMacroExtensionData)({
                spaceKey: spaceKeyArg,
                spaceId: spaceIdArg ?? spaceId,
                contentId: contentId,
                contentType: contentType,
                isLivePage: isLivePage,
                templateId: templateId
            }),
            connectExtensionProvider: connectExtensionProvider,
            editorActions: editorActions,
            FlagProvider: $8z3oB.FlagProvider,
            extensionsFilter: undefined,
            hideGlassPane: hideGlassPaneForForge,
            locale: locale,
            editorAPI: editorAPI,
            useGetContextToken: useGetContextToken,
            useRouteActions: $dPJCf.useRouteActions
        });
    const forgeExtensionProvider = $011c3ef08c0f8175$export$c165817f58cf8b({
        getProviderOptions: getProviderOptions,
        spaceKey: spaceKey
    });
    return forgeExtensionProvider;
};
const $011c3ef08c0f8175$export$c165817f58cf8b = async ({ getProviderOptions: getProviderOptions, spaceKey: spaceKey })=>{
    return (0, $5SzHz.fetchSpaceDetail)(spaceKey).then(({ data: data, loading: loading, error: error })=>{
        if (!loading) {
            const dataClassificationTags = data?.space?.dataClassificationTags;
            const spaceKeyFromQuery = data?.space?.key;
            const spaceIdFromQuery = data?.space?.id;
            return {
                dataClassificationTags: dataClassificationTags,
                spaceKeyFromQuery: spaceKeyFromQuery,
                spaceIdFromQuery: spaceIdFromQuery,
                error: error
            };
        }
    }).then((data)=>{
        if (data?.error) return Promise.reject(data.error);
        const providerOptions = getProviderOptions({
            spaceKey: data?.spaceKeyFromQuery,
            spaceId: data?.spaceIdFromQuery
        });
        // TODO: Should always use new extensions query regardless of whether there's dataClassificationTags
        // Remove as part of https://product-fabric.atlassian.net/browse/CCECO-3476
        const shouldUseNewExtensionsQuery = !!(data?.dataClassificationTags && data?.dataClassificationTags.length > 0);
        if (shouldUseNewExtensionsQuery) {
            providerOptions.extensionsFilter = [
                {
                    type: (0, $grQpA.GQLExtensionContextsFilterType).ExtensionType,
                    value: [
                        'xen:macro'
                    ]
                }
            ];
            providerOptions.dataClassificationTagIds = data?.dataClassificationTags;
        }
        return (0, $aab0628593b7d8ff$export$5f25f73e1231045e)(providerOptions);
    });
};
module.exports["getForgeExtensionHandler"] = $011c3ef08c0f8175$export$31bd098138fa620d;
module.exports["fetchForgeExtensionProvider"] = $011c3ef08c0f8175$export$c165817f58cf8b;

});

parcelRegister("5SNLA", function(module, exports) {
"use strict";
var __extends = this && this.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $iwB6M = parcelRequire("iwB6M");


var $dZ9AU = parcelRequire("dZ9AU");

/**
 * Buffers the source Observable values until `closingNotifier` emits.
 *
 * <span class="informal">Collects values from the past as an array, and emits
 * that array only when another Observable emits.</span>
 *
 * <img src="./img/buffer.png" width="100%">
 *
 * Buffers the incoming Observable values until the given `closingNotifier`
 * Observable emits a value, at which point it emits the buffer on the output
 * Observable and starts a new buffer internally, awaiting the next time
 * `closingNotifier` emits.
 *
 * @example <caption>On every click, emit array of most recent interval events</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var interval = Rx.Observable.interval(1000);
 * var buffered = interval.buffer(clicks);
 * buffered.subscribe(x => console.log(x));
 *
 * @see {@link bufferCount}
 * @see {@link bufferTime}
 * @see {@link bufferToggle}
 * @see {@link bufferWhen}
 * @see {@link window}
 *
 * @param {Observable<any>} closingNotifier An Observable that signals the
 * buffer to be emitted on the output Observable.
 * @return {Observable<T[]>} An Observable of buffers, which are arrays of
 * values.
 * @method buffer
 * @owner Observable
 */ function buffer(closingNotifier) {
    return function bufferOperatorFunction(source) {
        return source.lift(new BufferOperator(closingNotifier));
    };
}
exports.buffer = buffer;
var BufferOperator = function() {
    function BufferOperator(closingNotifier) {
        this.closingNotifier = closingNotifier;
    }
    BufferOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new BufferSubscriber(subscriber, this.closingNotifier));
    };
    return BufferOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var BufferSubscriber = function(_super) {
    __extends(BufferSubscriber, _super);
    function BufferSubscriber(destination, closingNotifier) {
        _super.call(this, destination);
        this.buffer = [];
        this.add($dZ9AU.subscribeToResult(this, closingNotifier));
    }
    BufferSubscriber.prototype._next = function(value) {
        this.buffer.push(value);
    };
    BufferSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        var buffer = this.buffer;
        this.buffer = [];
        this.destination.next(buffer);
    };
    return BufferSubscriber;
}($iwB6M.OuterSubscriber);

});

parcelRegister("j2Sfh", function(module, exports) {
"use strict";
var __extends = this && this.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $axeml = parcelRequire("axeml");

/**
 * Counts the number of emissions on the source and emits that number when the
 * source completes.
 *
 * <span class="informal">Tells how many values were emitted, when the source
 * completes.</span>
 *
 * <img src="./img/count.png" width="100%">
 *
 * `count` transforms an Observable that emits values into an Observable that
 * emits a single value that represents the number of values emitted by the
 * source Observable. If the source Observable terminates with an error, `count`
 * will pass this error notification along without emitting a value first. If
 * the source Observable does not terminate at all, `count` will neither emit
 * a value nor terminate. This operator takes an optional `predicate` function
 * as argument, in which case the output emission will represent the number of
 * source values that matched `true` with the `predicate`.
 *
 * @example <caption>Counts how many seconds have passed before the first click happened</caption>
 * var seconds = Rx.Observable.interval(1000);
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var secondsBeforeClick = seconds.takeUntil(clicks);
 * var result = secondsBeforeClick.count();
 * result.subscribe(x => console.log(x));
 *
 * @example <caption>Counts how many odd numbers are there between 1 and 7</caption>
 * var numbers = Rx.Observable.range(1, 7);
 * var result = numbers.count(i => i % 2 === 1);
 * result.subscribe(x => console.log(x));
 *
 * // Results in:
 * // 4
 *
 * @see {@link max}
 * @see {@link min}
 * @see {@link reduce}
 *
 * @param {function(value: T, i: number, source: Observable<T>): boolean} [predicate] A
 * boolean function to select what values are to be counted. It is provided with
 * arguments of:
 * - `value`: the value from the source Observable.
 * - `index`: the (zero-based) "index" of the value from the source Observable.
 * - `source`: the source Observable instance itself.
 * @return {Observable} An Observable of one number that represents the count as
 * described above.
 * @method count
 * @owner Observable
 */ function count(predicate) {
    return function(source) {
        return source.lift(new CountOperator(predicate, source));
    };
}
exports.count = count;
var CountOperator = function() {
    function CountOperator(predicate, source) {
        this.predicate = predicate;
        this.source = source;
    }
    CountOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new CountSubscriber(subscriber, this.predicate, this.source));
    };
    return CountOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var CountSubscriber = function(_super) {
    __extends(CountSubscriber, _super);
    function CountSubscriber(destination, predicate, source) {
        _super.call(this, destination);
        this.predicate = predicate;
        this.source = source;
        this.count = 0;
        this.index = 0;
    }
    CountSubscriber.prototype._next = function(value) {
        if (this.predicate) this._tryPredicate(value);
        else this.count++;
    };
    CountSubscriber.prototype._tryPredicate = function(value) {
        var result;
        try {
            result = this.predicate(value, this.index++, this.source);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        if (result) this.count++;
    };
    CountSubscriber.prototype._complete = function() {
        this.destination.next(this.count);
        this.destination.complete();
    };
    return CountSubscriber;
}($axeml.Subscriber);

});

parcelRegister("2eCs8", function(module, exports) {
"use strict";

var $3u6GG = parcelRequire("3u6GG");


var $2QGAA = parcelRequire("2QGAA");

/**
 * @param scheduler
 * @return {Observable<Timestamp<any>>|WebSocketSubject<T>|Observable<T>}
 * @method timestamp
 * @owner Observable
 */ function timestamp(scheduler) {
    if (scheduler === void 0) scheduler = $3u6GG.async;
    return $2QGAA.map(function(value) {
        return new Timestamp(value, scheduler.now());
    });
// return (source: Observable<T>) => source.lift(new TimestampOperator(scheduler));
}
exports.timestamp = timestamp;
var Timestamp = function() {
    function Timestamp(value, timestamp) {
        this.value = value;
        this.timestamp = timestamp;
    }
    return Timestamp;
}();
exports.Timestamp = Timestamp;

});

parcelRegister("7fTeW", function(module, exports) {
"use strict";
var __extends = this && this.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $augeV = parcelRequire("augeV");


var $iwB6M = parcelRequire("iwB6M");


var $dZ9AU = parcelRequire("dZ9AU");

/**
 * Branch out the source Observable values as a nested Observable whenever
 * `windowBoundaries` emits.
 *
 * <span class="informal">It's like {@link buffer}, but emits a nested Observable
 * instead of an array.</span>
 *
 * <img src="./img/window.png" width="100%">
 *
 * Returns an Observable that emits windows of items it collects from the source
 * Observable. The output Observable emits connected, non-overlapping
 * windows. It emits the current window and opens a new one whenever the
 * Observable `windowBoundaries` emits an item. Because each window is an
 * Observable, the output is a higher-order Observable.
 *
 * @example <caption>In every window of 1 second each, emit at most 2 click events</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var interval = Rx.Observable.interval(1000);
 * var result = clicks.window(interval)
 *   .map(win => win.take(2)) // each window has at most 2 emissions
 *   .mergeAll(); // flatten the Observable-of-Observables
 * result.subscribe(x => console.log(x));
 *
 * @see {@link windowCount}
 * @see {@link windowTime}
 * @see {@link windowToggle}
 * @see {@link windowWhen}
 * @see {@link buffer}
 *
 * @param {Observable<any>} windowBoundaries An Observable that completes the
 * previous window and starts a new window.
 * @return {Observable<Observable<T>>} An Observable of windows, which are
 * Observables emitting values of the source Observable.
 * @method window
 * @owner Observable
 */ function window(windowBoundaries) {
    return function windowOperatorFunction(source) {
        return source.lift(new WindowOperator(windowBoundaries));
    };
}
exports.window = window;
var WindowOperator = function() {
    function WindowOperator(windowBoundaries) {
        this.windowBoundaries = windowBoundaries;
    }
    WindowOperator.prototype.call = function(subscriber, source) {
        var windowSubscriber = new WindowSubscriber(subscriber);
        var sourceSubscription = source.subscribe(windowSubscriber);
        if (!sourceSubscription.closed) windowSubscriber.add($dZ9AU.subscribeToResult(windowSubscriber, this.windowBoundaries));
        return sourceSubscription;
    };
    return WindowOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var WindowSubscriber = function(_super) {
    __extends(WindowSubscriber, _super);
    function WindowSubscriber(destination) {
        _super.call(this, destination);
        this.window = new $augeV.Subject();
        destination.next(this.window);
    }
    WindowSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.openWindow();
    };
    WindowSubscriber.prototype.notifyError = function(error, innerSub) {
        this._error(error);
    };
    WindowSubscriber.prototype.notifyComplete = function(innerSub) {
        this._complete();
    };
    WindowSubscriber.prototype._next = function(value) {
        this.window.next(value);
    };
    WindowSubscriber.prototype._error = function(err) {
        this.window.error(err);
        this.destination.error(err);
    };
    WindowSubscriber.prototype._complete = function() {
        this.window.complete();
        this.destination.complete();
    };
    /** @deprecated internal use only */ WindowSubscriber.prototype._unsubscribe = function() {
        this.window = null;
    };
    WindowSubscriber.prototype.openWindow = function() {
        var prevWindow = this.window;
        if (prevWindow) prevWindow.complete();
        var destination = this.destination;
        var newWindow = this.window = new $augeV.Subject();
        destination.next(newWindow);
    };
    return WindowSubscriber;
}($iwB6M.OuterSubscriber);

});

parcelRegister("iCyab", function(module, exports) {
"use strict";
var $d8e646b8a45c637e$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $HHFyQ = parcelRequire("HHFyQ");


var $fvPwd = parcelRequire("fvPwd");


var $axeml = parcelRequire("axeml");


var $iwB6M = parcelRequire("iwB6M");


var $dZ9AU = parcelRequire("dZ9AU");


var $kNaF1 = parcelRequire("kNaF1");

/* tslint:enable:max-line-length */ /**
 * @param observables
 * @return {Observable<R>}
 * @method zip
 * @owner Observable
 */ function $d8e646b8a45c637e$var$zip() {
    var observables = [];
    for(var _i = 0; _i < arguments.length; _i++)observables[_i - 0] = arguments[_i];
    return function zipOperatorFunction(source) {
        return source.lift.call($d8e646b8a45c637e$var$zipStatic.apply(void 0, [
            source
        ].concat(observables)));
    };
}
module.exports.zip = $d8e646b8a45c637e$var$zip;
/* tslint:enable:max-line-length */ /**
 * Combines multiple Observables to create an Observable whose values are calculated from the values, in order, of each
 * of its input Observables.
 *
 * If the latest parameter is a function, this function is used to compute the created value from the input values.
 * Otherwise, an array of the input values is returned.
 *
 * @example <caption>Combine age and name from different sources</caption>
 *
 * let age$ = Observable.of<number>(27, 25, 29);
 * let name$ = Observable.of<string>('Foo', 'Bar', 'Beer');
 * let isDev$ = Observable.of<boolean>(true, true, false);
 *
 * Observable
 *     .zip(age$,
 *          name$,
 *          isDev$,
 *          (age: number, name: string, isDev: boolean) => ({ age, name, isDev }))
 *     .subscribe(x => console.log(x));
 *
 * // outputs
 * // { age: 27, name: 'Foo', isDev: true }
 * // { age: 25, name: 'Bar', isDev: true }
 * // { age: 29, name: 'Beer', isDev: false }
 *
 * @param observables
 * @return {Observable<R>}
 * @static true
 * @name zip
 * @owner Observable
 */ function $d8e646b8a45c637e$var$zipStatic() {
    var observables = [];
    for(var _i = 0; _i < arguments.length; _i++)observables[_i - 0] = arguments[_i];
    var project = observables[observables.length - 1];
    if (typeof project === 'function') observables.pop();
    return new $HHFyQ.ArrayObservable(observables).lift(new $d8e646b8a45c637e$var$ZipOperator(project));
}
module.exports.zipStatic = $d8e646b8a45c637e$var$zipStatic;
var $d8e646b8a45c637e$var$ZipOperator = function() {
    function ZipOperator(project) {
        this.project = project;
    }
    ZipOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $d8e646b8a45c637e$var$ZipSubscriber(subscriber, this.project));
    };
    return ZipOperator;
}();
module.exports.ZipOperator = $d8e646b8a45c637e$var$ZipOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $d8e646b8a45c637e$var$ZipSubscriber = function(_super) {
    $d8e646b8a45c637e$var$__extends(ZipSubscriber, _super);
    function ZipSubscriber(destination, project, values) {
        if (values === void 0) values = Object.create(null);
        _super.call(this, destination);
        this.iterators = [];
        this.active = 0;
        this.project = typeof project === 'function' ? project : null;
        this.values = values;
    }
    ZipSubscriber.prototype._next = function(value) {
        var iterators = this.iterators;
        if ($fvPwd.isArray(value)) iterators.push(new $d8e646b8a45c637e$var$StaticArrayIterator(value));
        else if (typeof value[$kNaF1.iterator] === 'function') iterators.push(new $d8e646b8a45c637e$var$StaticIterator(value[$kNaF1.iterator]()));
        else iterators.push(new $d8e646b8a45c637e$var$ZipBufferIterator(this.destination, this, value));
    };
    ZipSubscriber.prototype._complete = function() {
        var iterators = this.iterators;
        var len = iterators.length;
        if (len === 0) {
            this.destination.complete();
            return;
        }
        this.active = len;
        for(var i = 0; i < len; i++){
            var iterator = iterators[i];
            if (iterator.stillUnsubscribed) this.add(iterator.subscribe(iterator, i));
            else this.active--; // not an observable
        }
    };
    ZipSubscriber.prototype.notifyInactive = function() {
        this.active--;
        if (this.active === 0) this.destination.complete();
    };
    ZipSubscriber.prototype.checkIterators = function() {
        var iterators = this.iterators;
        var len = iterators.length;
        var destination = this.destination;
        // abort if not all of them have values
        for(var i = 0; i < len; i++){
            var iterator = iterators[i];
            if (typeof iterator.hasValue === 'function' && !iterator.hasValue()) return;
        }
        var shouldComplete = false;
        var args = [];
        for(var i = 0; i < len; i++){
            var iterator = iterators[i];
            var result = iterator.next();
            // check to see if it's completed now that you've gotten
            // the next value.
            if (iterator.hasCompleted()) shouldComplete = true;
            if (result.done) {
                destination.complete();
                return;
            }
            args.push(result.value);
        }
        if (this.project) this._tryProject(args);
        else destination.next(args);
        if (shouldComplete) destination.complete();
    };
    ZipSubscriber.prototype._tryProject = function(args) {
        var result;
        try {
            result = this.project.apply(this, args);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(result);
    };
    return ZipSubscriber;
}($axeml.Subscriber);
module.exports.ZipSubscriber = $d8e646b8a45c637e$var$ZipSubscriber;
var $d8e646b8a45c637e$var$StaticIterator = function() {
    function StaticIterator(iterator) {
        this.iterator = iterator;
        this.nextResult = iterator.next();
    }
    StaticIterator.prototype.hasValue = function() {
        return true;
    };
    StaticIterator.prototype.next = function() {
        var result = this.nextResult;
        this.nextResult = this.iterator.next();
        return result;
    };
    StaticIterator.prototype.hasCompleted = function() {
        var nextResult = this.nextResult;
        return nextResult && nextResult.done;
    };
    return StaticIterator;
}();
var $d8e646b8a45c637e$var$StaticArrayIterator = function() {
    function StaticArrayIterator(array) {
        this.array = array;
        this.index = 0;
        this.length = 0;
        this.length = array.length;
    }
    StaticArrayIterator.prototype[$kNaF1.iterator] = function() {
        return this;
    };
    StaticArrayIterator.prototype.next = function(value) {
        var i = this.index++;
        var array = this.array;
        return i < this.length ? {
            value: array[i],
            done: false
        } : {
            value: null,
            done: true
        };
    };
    StaticArrayIterator.prototype.hasValue = function() {
        return this.array.length > this.index;
    };
    StaticArrayIterator.prototype.hasCompleted = function() {
        return this.array.length === this.index;
    };
    return StaticArrayIterator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $d8e646b8a45c637e$var$ZipBufferIterator = function(_super) {
    $d8e646b8a45c637e$var$__extends(ZipBufferIterator, _super);
    function ZipBufferIterator(destination, parent, observable) {
        _super.call(this, destination);
        this.parent = parent;
        this.observable = observable;
        this.stillUnsubscribed = true;
        this.buffer = [];
        this.isComplete = false;
    }
    ZipBufferIterator.prototype[$kNaF1.iterator] = function() {
        return this;
    };
    // NOTE: there is actually a name collision here with Subscriber.next and Iterator.next
    //    this is legit because `next()` will never be called by a subscription in this case.
    ZipBufferIterator.prototype.next = function() {
        var buffer = this.buffer;
        if (buffer.length === 0 && this.isComplete) return {
            value: null,
            done: true
        };
        else return {
            value: buffer.shift(),
            done: false
        };
    };
    ZipBufferIterator.prototype.hasValue = function() {
        return this.buffer.length > 0;
    };
    ZipBufferIterator.prototype.hasCompleted = function() {
        return this.buffer.length === 0 && this.isComplete;
    };
    ZipBufferIterator.prototype.notifyComplete = function() {
        if (this.buffer.length > 0) {
            this.isComplete = true;
            this.parent.notifyInactive();
        } else this.destination.complete();
    };
    ZipBufferIterator.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.buffer.push(innerValue);
        this.parent.checkIterators();
    };
    ZipBufferIterator.prototype.subscribe = function(value, index) {
        return $dZ9AU.subscribeToResult(this, this.observable, this, index);
    };
    return ZipBufferIterator;
}($iwB6M.OuterSubscriber);

});

parcelRegister("jcPzc", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $42omo = parcelRequire("42omo");


var $jdPfT = parcelRequire("jdPfT");


var $6fnsQ = parcelRequire("6fnsQ");

const $4d5dcf1f78afd27c$var$Icon = ({ label: label = '', imgUrl: imgUrl })=>{
    return imgUrl ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("img", {
        "data-testid": "macro-custom-icon-img",
        alt: label,
        src: imgUrl,
        width: "100%"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jdPfT))), {
        spacing: "spacious",
        label: label,
        color: `var(--ds-icon-accent-gray, ${(0, $6fnsQ.N60)})`
    });
};
var $4d5dcf1f78afd27c$export$2e2bcd8739ae039 = $4d5dcf1f78afd27c$var$Icon;
module.exports["default"] = $4d5dcf1f78afd27c$export$2e2bcd8739ae039;

});

parcelRegister("gxXVf", function(module, exports) {
$parcel$export(module.exports, "openMacroBrowserForInitialConfiguration", () => $e47b9ace59ffb2ab$export$2fcab9f40bb3cea4);
$parcel$export(module.exports, "openMacroBrowserToEditExistingMacro", () => $e47b9ace59ffb2ab$export$bb0b49ebec872281);

var $6g1oe = parcelRequire("6g1oe");


var $foRF9 = parcelRequire("foRF9");


var $6OgRG = parcelRequire("6OgRG");

var $6mEZ3 = parcelRequire("6mEZ3");

var $3IXUB = parcelRequire("3IXUB");


var $8pcS0 = parcelRequire("8pcS0");


var $fgbpl = parcelRequire("fgbpl");


var $9Cbhx = parcelRequire("9Cbhx");


var $7W8i8 = parcelRequire("7W8i8");


var $6Ywr0 = parcelRequire("6Ywr0");


var $7bL1M = parcelRequire("7bL1M");


var $bx6Tx = parcelRequire("bx6Tx");

parcelRequire("5KKq4");

// An empty adf node to fallback to if no selected macro is provided
const $e47b9ace59ffb2ab$var$fallbackADNode = {
    type: 'extension',
    content: (0, $8pcS0.EMPTY_ADF_CONTENT)
};
const $e47b9ace59ffb2ab$export$a40defd79158e045 = {
    showLabels: {
        value: 'true'
    },
    max: {
        value: '15'
    },
    sort: {
        value: null
    },
    showSpace: {
        value: 'true'
    },
    reverse: {
        value: 'false'
    },
    excerptType: {
        value: 'none'
    }
};
function $e47b9ace59ffb2ab$export$4793f1f3f9872794() {
    return (0, $3IXUB.getMacroMetaData)().then((macros)=>macros.filter((item)=>(0, $8pcS0.allowedMacrosForInsertMenu).includes(item.macroName)));
}
function $e47b9ace59ffb2ab$export$ace579897112f22(macroDefinition) {
    return {
        type: 'embedCard',
        attrs: {
            url: macroDefinition.params && macroDefinition.params.url,
            layout: 'wide'
        }
    };
}
const $e47b9ace59ffb2ab$var$fireAnchorAnalyticsEvent = (createAnalyticsEvent, action, contentId, nameStatus)=>{
    createAnalyticsEvent({
        type: 'sendUIEvent',
        data: {
            action: action,
            actionSubject: `${action}Anchor`,
            source: 'extensions-editor',
            attributes: {
                contentId: contentId,
                nameStatus: nameStatus
            }
        }
    }).fire();
};
const $e47b9ace59ffb2ab$var$fireJIMAnalyticsEvent = (contentId, prevNodeType, newNodeType, createAnalyticsEvent)=>{
    const tableToIssueCount = prevNodeType === 'extension' && newNodeType === 'inlineExtension';
    const issueCountToTable = prevNodeType === 'inlineExtension' && newNodeType === 'extension';
    if (tableToIssueCount || issueCountToTable) createAnalyticsEvent({
        type: 'sendUIEvent',
        data: {
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'changedJiraIssueMacroExtensionView',
            source: 'JiraIssueMacro',
            objectId: contentId,
            attributes: {
                tableToIssueCount: tableToIssueCount,
                issueCountToTable: issueCountToTable
            }
        }
    }).fire();
};
const $e47b9ace59ffb2ab$var$fireContentByLabelAnalyticsEvent = (contentId, parameters, createAnalyticsEvent)=>{
    const getUGCFreeParameters = ()=>{
        const { cql: cql, title: title, ...rest } = parameters;
        return {
            ...$e47b9ace59ffb2ab$export$a40defd79158e045,
            ...rest
        };
    };
    if (parameters) createAnalyticsEvent({
        type: 'sendUIEvent',
        data: {
            action: 'closed',
            actionSubject: 'modal',
            actionSubjectId: 'macroBrowser',
            source: 'ContentByLabel',
            objectId: contentId,
            attributes: {
                extensionKey: 'contentbylabel',
                parameters: {
                    ...getUGCFreeParameters()
                }
            }
        }
    }).fire();
};
const $e47b9ace59ffb2ab$var$fireErrorAnalytics = (contentId, actionSubject, createAnalyticsEvent, error, extensionKey)=>{
    createAnalyticsEvent({
        type: 'sendOperationalEvent',
        data: {
            action: 'error',
            actionSubject: actionSubject,
            source: 'editor-extensions',
            objectId: contentId,
            attributes: {
                error: error?.message ?? error,
                stack: error?.stack,
                extensionKey: extensionKey
            }
        }
    }).fire();
};
async function $e47b9ace59ffb2ab$export$ff9b124c4a74b7b1(macroDefinition, isEditingMacro, extensionAnalyticsInfo) {
    if (macroDefinition.name === 'anchor') {
        const anchorNameProvidedByUser = macroDefinition.params[''];
        // Strip spaces off the beginning and end of the name
        let anchorNameWithoutSpaces = anchorNameProvidedByUser.replace(/^\s+/g, '');
        anchorNameWithoutSpaces = anchorNameWithoutSpaces.replace(/\s+$/g, '');
        // Changing any remaining spaces to '-' to match header logic
        anchorNameWithoutSpaces = anchorNameWithoutSpaces.replace(/\s+/g, '-');
        // Stripping out any single or double quotes for security (VULN-539679)
        anchorNameWithoutSpaces = anchorNameWithoutSpaces.replace(/[\"\']+/g, '');
        if (extensionAnalyticsInfo && extensionAnalyticsInfo.createAnalyticsEvent) {
            let nameStatus;
            if (anchorNameWithoutSpaces === '') nameStatus = 'missing';
            else {
                anchorNameWithoutSpaces = anchorNameWithoutSpaces.substring(0, (0, $bx6Tx.MAX_ATLASSIAN_ALLOWED_FRAGMENT_LENGTH));
                try {
                    decodeURIComponent(anchorNameWithoutSpaces);
                    nameStatus = 'valid';
                } catch  {
                    nameStatus = 'invalid';
                }
            }
            $e47b9ace59ffb2ab$var$fireAnchorAnalyticsEvent(extensionAnalyticsInfo.createAnalyticsEvent, extensionAnalyticsInfo.action, extensionAnalyticsInfo?.contentId, nameStatus);
        }
        return {
            type: 'inlineExtension',
            attrs: {
                extensionType: 'com.atlassian.confluence.macro.core',
                extensionKey: 'anchor',
                parameters: {
                    macroParams: {
                        '': {
                            value: anchorNameWithoutSpaces
                        }
                    },
                    macroMetadata: {
                        title: 'Anchor'
                    }
                }
            }
        };
    } else if (macroDefinition.name === 'jiraroadmap') {
        /** jiraroadmap is always in confluence/next/packages/editor-features/src/utils/smartCardOptions.ts */ if (!isEditingMacro) return $e47b9ace59ffb2ab$export$ace579897112f22(macroDefinition);
    /*
        in order to render a single issue as a smart link the following conditions must be true or we default to inlineExtension
          - issue must be from a cloud server (params.key is defined and domain must be of a cloud instance)
          - required module from monolith (applinks-bridge-for-spa) must be loaded
          - the browser origin and issue link must be in the same environment (e.g. prod and prod, staging and staging) - only an issue for devs
      */ } else if (macroDefinition.name === 'jira' && !!macroDefinition.params.key) {
        if ((0, $6Ywr0.isRequiredModuleLoaded)('confluence/jim/jira/applinks-bridge-for-spa')) try {
            const ApplinksBridge = (0, (/*@__PURE__*/$parcel$interopDefault($6g1oe))).require('confluence/jim/jira/applinks-bridge-for-spa');
            const issueUrl = await ApplinksBridge.getUrlForKey(macroDefinition.params.key, macroDefinition.params.serverId);
            if (await ApplinksBridge.isCloudAppLinkFromServerId(macroDefinition.params.serverId) && issueUrl) {
                const isIssueSameEnv = issueUrl.indexOf('atlassian.net') !== -1 === ((0, (/*@__PURE__*/$parcel$interopDefault($6g1oe))).location.origin.indexOf('atlassian.net') !== -1);
                // allow smart link insertion from localhost
                if (isIssueSameEnv || false) return {
                    type: 'inlineCard',
                    attrs: {
                        url: issueUrl
                    }
                };
            }
        } catch (e) {}
    }
    return null;
}
function $e47b9ace59ffb2ab$export$e33e56a93f919d6f(macro, config, extensionAnalyticsInfo) {
    const name = macro.macroName;
    // CFE-2344: despite not having a required parameter, the children macro should open the macro browser
    // so that the user can select a parent page. Without this, on a brand new page, the children display
    // macro renders a loading state, then completely disappears and looks broken.
    // CONFDEV-62041: tasks report macro also doesn't have a required parameter, but without any parameters
    // it tries to search the entirety of Confluence for tasks and usually times out, so let's ask for parameters anyway.
    if (macro.anyParameterRequired || name === 'children' || name === 'tasks-report-macro') return $e47b9ace59ffb2ab$export$2fcab9f40bb3cea4(macro, config, undefined, extensionAnalyticsInfo);
    return (0, $foRF9.fetchMacroAttributes)({
        macroDefinition: {
            name: name,
            body: '',
            params: {}
        },
        contentId: config.contentId
    });
}
function $e47b9ace59ffb2ab$export$5f89c55fbaf728a5(selectedMacroDefinition) {
    const { name: name, body: body, params: params, defaultParameterValue: defaultParameterValue, schemaVersion: schemaVersion } = selectedMacroDefinition;
    return {
        name: name || '',
        body: body || '',
        params: params,
        defaultParameterValue: defaultParameterValue || '',
        schemaVersion: schemaVersion
    };
}
async function $e47b9ace59ffb2ab$export$367af34aacb259a2(macroDefinition, contentId, selectedMacro) {
    const newMacroNode = await (0, $foRF9.fetchMacroAttributes)({
        macroDefinition: macroDefinition,
        contentId: contentId,
        selectedMacro: null
    });
    if ((0, $fgbpl.isBodiedExtension)(newMacroNode.type)) {
        // Updating the content of the macro if it was changed with saveMacro
        // If saveMacro does not include the body, macroDefinition.body will
        // be substituted with some function
        if (typeof macroDefinition.body === 'string') {
            let convertedBody;
            try {
                convertedBody = await (0, $6mEZ3.convertBody)('storage', 'atlas_doc_format', macroDefinition.body, contentId) || '';
                newMacroNode.content = JSON.parse(convertedBody).content;
            } catch (error) {
                const logger = (0, $7W8i8.getLogger)('getMacroBrowserSettings.onComplete');
                logger.error`Can't convert provided body from storage format to ADF: ${convertedBody}`;
                // if provided body can't be converted to ADF return the previous content
                if (selectedMacro?.content) newMacroNode.content = selectedMacro?.content;
            }
        } else if (selectedMacro?.content) newMacroNode.content = selectedMacro?.content;
    }
    return newMacroNode;
}
async function $e47b9ace59ffb2ab$export$9477d47ee97b1087(macroBrowser, config, selectedMacro, macroBrowserResolve, macroBrowserReject, extensionAnalyticsInfo, onCompleteCallback, updateMacro, macroId) {
    const blocklistRestore = await (0, $6OgRG.applyBlocklist)(macroBrowser);
    let isInserting;
    let insertUpdatedMacroFailureCount = 0;
    return {
        autoClose: false,
        onComplete: async (rowMacroDefinition)=>{
            isInserting = true;
            macroBrowser.UI.showBrowserSpinner(true);
            const macroDefinition = $e47b9ace59ffb2ab$export$5f89c55fbaf728a5(rowMacroDefinition);
            try {
                let newMacroNode = await $e47b9ace59ffb2ab$export$ff9b124c4a74b7b1(macroDefinition, selectedMacro?.attrs?.extensionKey === 'jiraroadmap', extensionAnalyticsInfo);
                // If no transformation happen process as general macro
                if (!newMacroNode) {
                    newMacroNode = await $e47b9ace59ffb2ab$export$367af34aacb259a2(macroDefinition, config.contentId, selectedMacro);
                    if (selectedMacro?.attrs?.extensionKey === 'jira' && extensionAnalyticsInfo && extensionAnalyticsInfo.createAnalyticsEvent) $e47b9ace59ffb2ab$var$fireJIMAnalyticsEvent(config.contentId, selectedMacro?.type, newMacroNode?.type, extensionAnalyticsInfo?.createAnalyticsEvent);
                    if (macroDefinition?.name === 'contentbylabel' && extensionAnalyticsInfo && extensionAnalyticsInfo.createAnalyticsEvent) $e47b9ace59ffb2ab$var$fireContentByLabelAnalyticsEvent(config.contentId, newMacroNode?.attrs?.parameters?.macroParams, extensionAnalyticsInfo?.createAnalyticsEvent);
                }
                if (macroId && !newMacroNode?.attrs?.parameters?.macroMetadata?.macroId) {
                    newMacroNode.attrs.parameters = newMacroNode?.attrs?.parameters || {};
                    newMacroNode.attrs.parameters.macroMetadata = newMacroNode?.attrs?.parameters?.macroMetadata || {};
                    newMacroNode.attrs.parameters.macroMetadata.macroId = {
                        value: macroId
                    };
                }
                macroBrowserResolve(newMacroNode);
                macroBrowser.close();
                blocklistRestore();
                onCompleteCallback?.({
                    macro: macroDefinition?.name,
                    isBodiedExtension: (0, $fgbpl.isBodiedExtension)(newMacroNode?.type)
                });
            } catch (err) {
                if ((0, $8pcS0.MODERENIZED_MACRO_KEYS).includes(selectedMacro?.attrs?.extensionKey)) $e47b9ace59ffb2ab$var$fireErrorAnalytics(config.contentId, 'onComplete', extensionAnalyticsInfo?.createAnalyticsEvent, err, selectedMacro?.attrs?.extensionKey);
                macroBrowserReject(err);
            }
        },
        onCancel: ()=>{
            blocklistRestore();
            // Macro browser can call cancel on insert, so we need to keep state
            // and only reject when someone isn't trying to insert
            if (!isInserting) macroBrowserReject({
                reason: 'cancel'
            });
        },
        insertUpdatedMacro: async (rowMacroDefinition)=>{
            const macroDefinition = $e47b9ace59ffb2ab$export$5f89c55fbaf728a5(rowMacroDefinition);
            try {
                const newMacroNode = await $e47b9ace59ffb2ab$export$367af34aacb259a2(macroDefinition, config.contentId, selectedMacro);
                updateMacro?.(newMacroNode);
                insertUpdatedMacroFailureCount = 0;
            } catch (error) {
                insertUpdatedMacroFailureCount++;
                if (insertUpdatedMacroFailureCount > 5) {
                    insertUpdatedMacroFailureCount = 0;
                    $e47b9ace59ffb2ab$var$fireErrorAnalytics(config.contentId, 'insertUpdatedMacro', extensionAnalyticsInfo?.createAnalyticsEvent, error, selectedMacro?.attrs?.extensionKey);
                }
            }
        }
    };
}
function $e47b9ace59ffb2ab$export$bb0b49ebec872281(selectedMacro, config, macroFilter, extensionAnalyticsInfo, updateMacro, intl, isLivePagesFeatureEnabled) {
    return new Promise(async (resolve, reject)=>{
        const selectedMacroFormattedAsLegacyMacro = await (0, $6mEZ3.formatAsLegacyMacroWithOverrides)(selectedMacro || $e47b9ace59ffb2ab$var$fallbackADNode, intl, isLivePagesFeatureEnabled);
        const macroBrowser = await (0, $7bL1M.loadMacroBrowserResources)();
        // filter based on dynamic data such as feature flags
        if (macroFilter) macroBrowser.metadataList = macroBrowser.metadataList.filter(macroFilter);
        if (extensionAnalyticsInfo) extensionAnalyticsInfo.action = 'update';
        const macroBrowserSettings = await $e47b9ace59ffb2ab$export$9477d47ee97b1087(macroBrowser, config, selectedMacro, resolve, reject, extensionAnalyticsInfo, undefined, updateMacro, null);
        try {
            macroBrowser.open({
                ...macroBrowserSettings,
                selectedMacro: {
                    ...selectedMacroFormattedAsLegacyMacro,
                    productContext: {
                        // product context is used by connect macros, when they call /wiki/plugins/servlet/ac/{app-key}/{macro-key}
                        // this endpoint enriches the response's structuredContext field, which is used by AP.context.getContext
                        // ideally would be good to check that this is a connect macro, however, it seems
                        // that there's no information available to check that
                        'content.id': config.contentId,
                        'macro.id': selectedMacro?.attrs?.parameters?.macroMetadata?.macroId?.value,
                        'enrich-content-context-parameters': true
                    }
                }
            });
        } catch (err) {
            $e47b9ace59ffb2ab$var$fireErrorAnalytics(config.contentId, 'openMacroBrowserToEditExistingMacro', extensionAnalyticsInfo?.createAnalyticsEvent, err, selectedMacro?.attrs?.extensionKey);
            reject(err);
        }
    });
}
function $e47b9ace59ffb2ab$export$2fcab9f40bb3cea4(selectedMacro, config, macroFilter, extensionAnalyticsInfo, onCompleteCallback, updateMacro) {
    return new Promise(async (resolve, reject)=>{
        // Generate macroId on insertion for macros since if they don't have one so BE will continuously regenrate since
        // it's not in FE ADF. This is a problem for 3P macros where vendors rely on a stable macroId to fetch their macros.
        const macroId = (0, $9Cbhx.getMacroId)(null);
        const macroBrowser = await (0, $7bL1M.loadMacroBrowserResources)();
        // filter based on dynamic data such as feature flags
        if (macroFilter) macroBrowser.metadataList = macroBrowser.metadataList.filter(macroFilter);
        if (extensionAnalyticsInfo) extensionAnalyticsInfo.action = 'insert';
        const macroBrowserSettings = await $e47b9ace59ffb2ab$export$9477d47ee97b1087(macroBrowser, config, selectedMacro, resolve, reject, extensionAnalyticsInfo, onCompleteCallback, updateMacro, macroId);
        try {
            macroBrowser.open({
                ...macroBrowserSettings,
                presetMacroMetadata: {
                    ...selectedMacro,
                    productContext: {
                        'macro.id': macroId,
                        'content.id': config.contentId,
                        'enrich-content-context-parameters': true
                    }
                }
            });
        } catch (err) {
            $e47b9ace59ffb2ab$var$fireErrorAnalytics(config.contentId, 'openMacroBrowserForInitialConfiguration', extensionAnalyticsInfo?.createAnalyticsEvent, err, selectedMacro?.attrs?.extensionKey);
            reject(err);
        }
    });
}

});

parcelRegister("7bL1M", function(module, exports) {

var $6g1oe = parcelRequire("6g1oe");


var $dmKyV = parcelRequire("dmKyV");

const $eb991ea0881203b1$export$1a7a5965be14ecdf = ()=>[
        'wr!com.atlassian.confluence.plugins.confluence-create-content-plugin:editor-resources',
        'wr!com.atlassian.confluence.plugins.confluence-create-content-plugin:create-from-template-macro-browser-resources',
        'wr!com.atlassian.confluence.plugins.confluence-create-content-plugin:create-from-template-resources'
    ];

function $eb991ea0881203b1$export$db2ef8ac15563eb4() {
    return new Promise((resolve)=>{
        const resources = [
            // plugins contributing to macro browser will be loaded through this context.
            // `fabric-editor-macro-browser` context is found in core in case we want to add resources of other macro in future.
            'wrc!fabric-editor-macro-browser',
            // The inline task report plugin implements its own (legacy) way of loading JS overrides, hence we have to require
            // these overrides here.
            'wr!com.atlassian.confluence.plugins.confluence-inline-tasks:inline-tasks-macro-browser',
            // Jira gadgets
            'wr!com.atlassian.confluence.plugins.gadgets:macro-browser-for-gadgetsplugin',
            // these resources are necessary for create-from-template-macro to initialize and populate the template dropdown
            // copy from packages/confluence-editor/src/editor-plugins/create-from-template-macro/plugin.js
            // tinymce also did similar macro loading via packages/confluence-editor/src/editor-plugins/index.js
            ...$eb991ea0881203b1$export$1a7a5965be14ecdf()
        ];
        (0, $dmKyV.WRM).require(resources, ()=>{
            const macroBrowser = (0, (/*@__PURE__*/$parcel$interopDefault($6g1oe))).require('confluence-macro-browser/macro-browser');
            (parcelRequire("01OTV")).then((macroBrowserOverridesModule)=>{
                macroBrowserOverridesModule.default();
            }).then(()=>{
                /**
         * this is required for atlassian connect plugin to work correctly
         * e.g open custom dialog for DrawIO, Gliffy macro
         * check this repo for more info:
         * https://stash.atlassian.com/projects/AC/repos/atlassian-connect/browse
         */ // @ts-ignore TODO FIXME we really don't need typings for "window-or-global", we need to get rid of it instead
                (0, (/*@__PURE__*/$parcel$interopDefault($6g1oe))).AJS.trigger('reset.rte');
                resolve(macroBrowser);
            });
        });
    });
}
module.exports["loadMacroBrowserResources"] = $eb991ea0881203b1$export$db2ef8ac15563eb4;

});

parcelRegister("01OTV", function(module, exports) {

let $005794005c5bfad1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $005794005c5bfad1$var$load("2wLue").then(()=>parcelRequire('74DtK'));

});

parcelRegister("iol5P", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $jmjWc = parcelRequire("jmjWc");


var $lOkIA = parcelRequire("lOkIA");


const $2957f690f8f5a888$export$4072164b6bd9337 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "FUMAJ",
    name: "TemplateVariableDialogLoader",
    loader: async ()=>(await (parcelRequire("iC8Gs"))).TemplateVariableDialogComponent,
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lOkIA.CenteredSpinner), {
            size: "medium"
        })
});
module.exports["TemplateVariableDialogLoader"] = $2957f690f8f5a888$export$4072164b6bd9337;

});

parcelRegister("iC8Gs", function(module, exports) {

let $d8d2830765e7291c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d8d2830765e7291c$var$load("6IjKj").then(()=>parcelRequire('5KoaE'));

});

parcelRegister("ajgiQ", function(module, exports) {
$parcel$export(module.exports, "filterADNodesByType", () => (parcelRequire("j2dS3")).filterADNodesByType);
$parcel$export(module.exports, "updateParams", () => (parcelRequire("j2dS3")).updateParams);
parcelRequire("j2dS3");


});

parcelRegister("3JqyB", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $kwjRd = parcelRequire("kwjRd");

const $f366aa2b03faa65b$export$3e35a8e6e9fd352d = ({ parameters: parameters })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kwjRd.TemplateVariableNameWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kwjRd.TemplateVariableName), {
        "data-testid": "variable-name"
    }, parameters?.name)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kwjRd.TemplateVariableType), {
        "data-testid": "variable-type"
    }, `| ${parameters?.type}`));
};
module.exports["TemplateVariableComponent"] = $f366aa2b03faa65b$export$3e35a8e6e9fd352d;

});

parcelRegister("5ho0B", function(module, exports) {
const $8e4a96485e98e7e7$export$92339ebd679037fc = ()=>(extension)=>{
        if (!extension) return null;
        // Add template migration extension handlers logic here
        return null;
    };
module.exports["getTemplateMigrationExtHandler"] = $8e4a96485e98e7e7$export$92339ebd679037fc;

});

parcelRegister("k77lQ", function(module, exports) {
$parcel$export(module.exports, "getExtensionHandlers", () => (parcelRequire("7okiz")).getExtensionHandlers);
parcelRequire("7okiz");


});

parcelRegister("4YwC8", function(module, exports) {

let $39f610853f37e12d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $39f610853f37e12d$var$load("h3ABO"),
    $39f610853f37e12d$var$load("2YffH"),
    $39f610853f37e12d$var$load("cv53Q"),
    $39f610853f37e12d$var$load("3I8KJ"),
    $39f610853f37e12d$var$load("dfzwa"),
    $39f610853f37e12d$var$load("hJpvQ"),
    $39f610853f37e12d$var$load("2F69B"),
    $39f610853f37e12d$var$load("edaDG"),
    $39f610853f37e12d$var$load("lCOAy"),
    $39f610853f37e12d$var$load("1x778"),
    $39f610853f37e12d$var$load("fJtJG"),
    $39f610853f37e12d$var$load("70l64"),
    $39f610853f37e12d$var$load("7czq2"),
    $39f610853f37e12d$var$load("53pgU"),
    $39f610853f37e12d$var$load("lkOIY"),
    $39f610853f37e12d$var$load("1yMtA"),
    $39f610853f37e12d$var$load("jbxHq"),
    $39f610853f37e12d$var$load("8YSo7"),
    $39f610853f37e12d$var$load("hz0as"),
    $39f610853f37e12d$var$load("8Oa5b"),
    $39f610853f37e12d$var$load("8j9XC"),
    $39f610853f37e12d$var$load("9ijrN"),
    $39f610853f37e12d$var$load("3w411"),
    $39f610853f37e12d$var$load("fSobj"),
    $39f610853f37e12d$var$load("74u2y"),
    $39f610853f37e12d$var$load("hv4mn"),
    $39f610853f37e12d$var$load("6wr18"),
    $39f610853f37e12d$var$load("kjZZD"),
    $39f610853f37e12d$var$load("Wowvf"),
    $39f610853f37e12d$var$load("cyGuT"),
    $39f610853f37e12d$var$load("dRpV3"),
    $39f610853f37e12d$var$load("ffEVr"),
    $39f610853f37e12d$var$load("32ouE"),
    $39f610853f37e12d$var$load("gkK2W"),
    $39f610853f37e12d$var$load("8gQdh"),
    $39f610853f37e12d$var$load("8x9cy"),
    $39f610853f37e12d$var$load("9O9hx"),
    $39f610853f37e12d$var$load("bGR8z"),
    $39f610853f37e12d$var$load("fZt2F"),
    $39f610853f37e12d$var$load("dpE2f"),
    $39f610853f37e12d$var$load("6u1hm"),
    $39f610853f37e12d$var$load("hogcU"),
    $39f610853f37e12d$var$load("GuKfo"),
    $39f610853f37e12d$var$load("5ZwKh"),
    $39f610853f37e12d$var$load("iqKwT"),
    $39f610853f37e12d$var$load("l5llo"),
    $39f610853f37e12d$var$load("9Oy8P"),
    $39f610853f37e12d$var$load("jeGXT"),
    $39f610853f37e12d$var$load("bITOY"),
    $39f610853f37e12d$var$load("h305A"),
    $39f610853f37e12d$var$load("3amkb"),
    $39f610853f37e12d$var$load("5gMuq"),
    $39f610853f37e12d$var$load("7aOpi"),
    $39f610853f37e12d$var$load("beE2d"),
    $39f610853f37e12d$var$load("kjaQZ"),
    $39f610853f37e12d$var$load("4amFq"),
    $39f610853f37e12d$var$load("hhss7"),
    $39f610853f37e12d$var$load("1kMwS"),
    $39f610853f37e12d$var$load("7S1t7"),
    $39f610853f37e12d$var$load("7EorR"),
    $39f610853f37e12d$var$load("lsb09")
]).then(()=>parcelRequire('gnN3I'));

});

parcelRegister("hFueH", function(module, exports) {
parcelRequire("42omo");


var $jmjWc = parcelRequire("jmjWc");


const $cdcdb83d150ac905$var$EditorLoaderLoader = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "uC_t0",
    name: "EditorLoaderLoader",
    loader: ()=>(parcelRequire("dIGEa"))
});
var $cdcdb83d150ac905$export$2e2bcd8739ae039 = $cdcdb83d150ac905$var$EditorLoaderLoader;
module.exports["default"] = $cdcdb83d150ac905$export$2e2bcd8739ae039;

});

parcelRegister("dIGEa", function(module, exports) {

let $9fd0772f3f1fd3d7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $9fd0772f3f1fd3d7$var$load("43hsF"),
    $9fd0772f3f1fd3d7$var$load("kHDuB")
]).then(()=>parcelRequire('Il8QU'));

});

parcelRegister("cjG4e", function(module, exports) {

let $8f77e40fe2fffacf$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8f77e40fe2fffacf$var$load("dQy5b").then(()=>parcelRequire('fcgkZ'));

});

parcelRegister("69aHU", function(module, exports) {

var $eEmxu = parcelRequire("eEmxu");

var $bre0g = parcelRequire("bre0g");


var $5bak6 = parcelRequire("5bak6");


var $gKr8t = parcelRequire("gKr8t");


var $bfil7 = parcelRequire("bfil7");


var $8pcS0 = parcelRequire("8pcS0");


var $04e9M = parcelRequire("04e9M");


var $aIqlA = parcelRequire("aIqlA");


var $aF5bm = parcelRequire("aF5bm");


var $8z3oB = parcelRequire("8z3oB");


var $gxXVf = parcelRequire("gxXVf");


var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");


var $eIlE7 = parcelRequire("eIlE7");


var $3JqyB = parcelRequire("3JqyB");


var $2igSQ = parcelRequire("2igSQ");





var $2oer2 = parcelRequire("2oer2");

var $399836d35d211a20$export$f73f87f0b8cabb66 = /*#__PURE__*/ function(TemplateVariableMode) {
    TemplateVariableMode[TemplateVariableMode["CONFIG"] = 0] = "CONFIG";
    TemplateVariableMode[TemplateVariableMode["INPUT"] = 1] = "INPUT";
    return TemplateVariableMode;
}({});
const $399836d35d211a20$var$i18n = (0, $cgtv4.defineMessages)({
    templateVariablesAdd: {
        id: "confluence-fabric-editor.template.variables.add",
        defaultMessage: "New variable"
    },
    templateVariablesAddTooltip: {
        id: "confluence-fabric-editor.template.variables.add.tooltip",
        defaultMessage: "Add a new field into the page for the template user to fill out."
    }
});
function $399836d35d211a20$export$de09af8432d39de0(intl, mode = 0, config, editorActions) {
    const type = 'inlineExtension';
    const title = intl.formatMessage($399836d35d211a20$var$i18n.templateVariablesAdd);
    const Component = mode === 1 ? (0, $2igSQ.TemplateVariableInput) : (0, $3JqyB.TemplateVariableComponent);
    return {
        key: (0, $8pcS0.EXTENSION_KEY).TEMPLATE,
        type: (0, $8pcS0.EXTENSION_TYPE).TEMPLATE,
        title: title,
        description: intl.formatMessage($399836d35d211a20$var$i18n.templateVariablesAddTooltip),
        icons: {
            '48': async ()=>()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eIlE7))), {
                        color: "currentColor",
                        label: title,
                        spacing: "spacious"
                    })
        },
        modules: {
            quickInsert: editorActions && [
                {
                    key: (0, $8pcS0.EXTENSION_KEY).TEMPLATE,
                    featured: true,
                    action: {
                        type: 'node',
                        key: 'default',
                        parameters: {
                            type: (0, $2oer2.TEXT_TYPE),
                            name: (0, $2oer2.defaultVariableName)
                        }
                    }
                }
            ],
            nodes: {
                default: {
                    type: type,
                    render: async ()=>({ node: node })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Component, {
                                parameters: node.parameters
                            }),
                    update: config && (async (parameters)=>{
                        try {
                            const { attrs: attrs } = await (0, $2oer2.openTemplateVariableDialog)({
                                type: type,
                                attrs: {
                                    parameters: parameters
                                }
                            }, config);
                            return attrs.parameters || parameters;
                        } catch  {
                            // On error keep the existing value
                            return parameters;
                        }
                    })
                }
            }
        }
    };
}



var $bgcaM = parcelRequire("bgcaM");


var $1JyKZ = parcelRequire("1JyKZ");


var $dPJCf = parcelRequire("dPJCf");


const $2d9ea9a54c5e94d8$var$createLCMRendererExtensionProvider = async ()=>{
    const { rendererManifest: rendererManifest } = await (parcelRequire("aMZF9"));
    return new (0, $bre0g.default)([
        rendererManifest
    ]);
};
const $2d9ea9a54c5e94d8$export$c0ba9eb7d0e2ed47 = (providerFactory, { intl: intl, containerId: containerId, accountId: accountId, cloudId: cloudId, spaceKey: spaceKey, spaceId: spaceId, contentId: contentId, contentType: contentType, contentVersion: contentVersion, contentStatus: contentStatus, contentMode: contentMode, environment: environment, extensionHandlers: extensionHandlers, showTemplateInputInPreview: showTemplateInputInPreview, showTemplateVariablesInPreview: showTemplateVariablesInPreview, setManifestReadyState: setManifestReadyState, createAnalyticsEvent: createAnalyticsEvent, activationId: activationId, isLivePage: isLivePage = false, isLivePagesFeatureEnabled: isLivePagesFeatureEnabled = false })=>{
    const extensionProvidersList = [];
    const extensionProvider = (0, $bfil7.getConfluenceMacrosExtensionProviderForRenderer)({
        contentId: contentId,
        spaceKey: spaceKey,
        spaceId: spaceId,
        features: {}
    }, extensionHandlers, (0, $bgcaM.getMigrationExtensionManifest), (0, $gxXVf.openMacroBrowserToEditExistingMacro), (0, $gxXVf.openMacroBrowserForInitialConfiguration), intl, createAnalyticsEvent, providerFactory, isLivePagesFeatureEnabled);
    extensionProvidersList.push(extensionProvider);
    const lcmExtension = $2d9ea9a54c5e94d8$var$createLCMRendererExtensionProvider();
    extensionProvidersList.push(lcmExtension);
    if (showTemplateInputInPreview || showTemplateVariablesInPreview) extensionProvidersList.push(new (0, $bre0g.default)([
        (0, $399836d35d211a20$export$de09af8432d39de0)(intl, showTemplateInputInPreview ? (0, $399836d35d211a20$export$f73f87f0b8cabb66).INPUT : (0, $399836d35d211a20$export$f73f87f0b8cabb66).CONFIG)
    ]));
    const apolloClient = (0, $gKr8t.getAGGClient)();
    const contextIds = [
        (0, $aF5bm.getWorkspaceARI)({
            cloudId: cloudId,
            activationId: activationId
        })
    ];
    const forgeExtensionProvider = async ()=>{
        const getProviderOptions = ({ spaceKey: spaceKeyArg, spaceId: spaceIdArg })=>({
                accountId: accountId ?? undefined,
                cloudId: cloudId,
                apolloClient: apolloClient,
                contextIds: contextIds,
                dataProviders: providerFactory,
                environment: (0, $5bak6.environmentToForgeProductEnvironment)(environment),
                product: 'confluence',
                page: 'confluence:macroRenderer',
                isEditing: false,
                contentMode: contentMode,
                analyticsWebClient: (0, $04e9M.getAnalyticsWebClient)(),
                forgeUIAnalyticsContext: (0, $5bak6.createForgeUIAnalyticsContext)({
                    objectId: contentId,
                    // @ts-ignore
                    objectType: contentType,
                    containerId: containerId,
                    containerType: 'space'
                }),
                extensionData: (0, $5bak6.createForgeMacroExtensionData)({
                    spaceKey: spaceKeyArg ?? '',
                    isLivePage: isLivePage,
                    spaceId: spaceIdArg ?? spaceId ?? '',
                    contentId: contentId,
                    contentType: contentType,
                    contentVersion: contentVersion ?? undefined,
                    contentStatus: contentStatus ?? undefined
                }),
                extensionHandlerWithReference: extensionHandlers[(0, $8pcS0.EXTENSION_TYPE).MACRO_WITH_REFERENCES],
                connectExtensionProvider: extensionProvider,
                FlagProvider: $8z3oB.FlagProvider,
                extensionsFilter: undefined,
                locale: intl.locale,
                useGetContextToken: $1JyKZ.useGetContextToken,
                useRouteActions: $dPJCf.useRouteActions
            });
        return (0, $aIqlA.fetchForgeExtensionProvider)({
            getProviderOptions: getProviderOptions,
            spaceKey: spaceKey
        });
    };
    extensionProvidersList.push(forgeExtensionProvider());
    const combinedProvider = (0, $eEmxu.default)(extensionProvidersList);
    providerFactory.setProvider('extensionProvider', Promise.resolve(combinedProvider));
    // Call preload on all provider that later we can use it synchronously in packages/editor/editor-common/src/extensions/extension-handlers.tsx
    combinedProvider?.preload?.().then(()=>{
        setManifestReadyState?.(true);
    });
};
module.exports["populateExtensionProviders"] = $2d9ea9a54c5e94d8$export$c0ba9eb7d0e2ed47;

});

parcelRegister("bgcaM", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");


var $jdPfT = parcelRequire("jdPfT");


var $8pcS0 = parcelRequire("8pcS0");


var $5h7sn = parcelRequire("5h7sn");

var $bQCqI = parcelRequire("bQCqI");






var $gtD4K = parcelRequire("gtD4K");


var $2Nwuj = parcelRequire("2Nwuj");


var $8am3c = parcelRequire("8am3c");


var $9wGTI = parcelRequire("9wGTI");

const $3d419e1dae817d20$var$i18n = (0, $cgtv4.defineMessages)({
    unmodifiableMacroDialogTitle: {
        id: "fabric-extension-handlers.unmodifiable.macro.dialog.title",
        defaultMessage: "This macro can\u2019t be edited"
    },
    unmodifiableMacroDialogBody: {
        id: "fabric-extension-handlers.unmodifiable.macro.dialog.body",
        defaultMessage: "This macro was added to a page that was converted from the legacy editor. It can\u2019t be edited because it is now incompatible with the <alink>current editor</alink>."
    }
});
const $3d419e1dae817d20$export$752d3018048f7d27 = (selectedNode, flags, createAnalyticsEvent)=>new Promise((resolve, reject)=>{
        if (!selectedNode || !selectedNode.attrs || !flags) {
            reject(new Error('Cannot show unmodifiable macro error flag'));
            return;
        }
        const fireLinkClickAnalytics = ()=>{
            if (createAnalyticsEvent) createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'link',
                    actionSubjectId: 'unmodifiableMacroDialogComponentLearnMoreLink',
                    source: 'showUnmodifiableMacroFlag'
                }
            }).fire();
        };
        flags.showFlag({
            type: 'error',
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $3d419e1dae817d20$var$i18n.unmodifiableMacroDialogTitle),
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
                ...$3d419e1dae817d20$var$i18n.unmodifiableMacroDialogBody,
                values: {
                    alink: (...chunks)=>(0, $9wGTI.fg)('dst-a11y__replace-anchor-with-link__page-experienc') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
                            href: (0, $8am3c.LEARN_MORE_URL),
                            target: "_blank",
                            onClick: fireLinkClickAnalytics
                        }, chunks) : // eslint-disable-next-line @atlaskit/design-system/no-html-anchor
                        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("a", {
                            href: (0, $8am3c.LEARN_MORE_URL),
                            target: "_blank",
                            onClick: fireLinkClickAnalytics
                        }, chunks)
                }
            }),
            close: 'auto'
        });
        resolve();
    });



var $6mKj3 = parcelRequire("6mKj3");


var $fUN4A = parcelRequire("fUN4A");

const $bc16cbc3cc94b402$var$i18n = (0, $cgtv4.defineMessages)({
    widthLabel: {
        id: "confluence-fabric-editor.migration-extension.manifest.width.label",
        defaultMessage: "Width"
    },
    widthDescription: {
        id: "confluence-fabric-editor.migration-extension.manifest.width.description",
        defaultMessage: "Width of image"
    },
    heightLabel: {
        id: "confluence-fabric-editor.migration-extension.manifest.height.label",
        defaultMessage: "Height"
    },
    heightDescription: {
        id: "confluence-fabric-editor.migration-extension.manifest.height.description",
        defaultMessage: "Height of image"
    },
    configPlaceholder: {
        id: "confluence-fabric-editor.migration-extension.manifest.config.placeholder",
        defaultMessage: "auto"
    }
});
function $bc16cbc3cc94b402$export$fb67662ebef720ab(contentId, isEditor, intl, flags, createAnalyticsEvent) {
    if ((0, $6mKj3.expValEquals)('enable_edit_of_inline_image_extensions', 'cohort', 'test')) return $bc16cbc3cc94b402$var$getMigrationExtensionManifestV2(contentId, isEditor, intl, flags, createAnalyticsEvent);
    const type = 'inlineExtension';
    const getExtensionHandler = isEditor ? (0, $5h7sn.getMigrationExtHandlerForEditor) : (0, $bQCqI.getMigrationExtHandlerForRenderer);
    return [
        (0, $8pcS0.EXTENSION_KEY).INVALID,
        (0, $8pcS0.EXTENSION_KEY).INLINE_MEDIA_IMAGE,
        (0, $8pcS0.EXTENSION_KEY).INLINE_EXTERNAL_IMAGE
    ].map((key)=>{
        const node = {
            type: type,
            async preloadRender () {
            // Intentionally left empty. But the function needs to be defined
            },
            renderSync () {
                return ({ node: node })=>getExtensionHandler({
                        contentId: contentId,
                        contextProviders: {
                            ClassicEditorContextProvider: (0, $fUN4A.ClassicEditorContextProviderLazyLoader)
                        }
                    })(node, {});
            },
            async render () {
                return this.renderSync();
            },
            update: isEditor ? (parameters)=>(0, $3d419e1dae817d20$export$752d3018048f7d27)({
                    type: type,
                    attrs: {
                        parameters: parameters
                    }
                }, flags, createAnalyticsEvent) : undefined
        };
        return {
            title: 'Migration Extension',
            key: key,
            type: (0, $8pcS0.EXTENSION_TYPE).MIGRATION,
            icons: {
                '48': async ()=>()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jdPfT))), {
                            label: "Migration Extension"
                        })
            },
            modules: {
                nodes: {
                    default: node
                }
            }
        };
    });
}
const $bc16cbc3cc94b402$var$getMigrationExtensionManifestV2 = (contentId, isEditor, intl, flags, createAnalyticsEvent)=>{
    const getExtensionHandler = isEditor ? (0, $5h7sn.getMigrationExtHandlerForEditor) : (0, $bQCqI.getMigrationExtHandlerForRenderer);
    const invalidExtensionManifest = $bc16cbc3cc94b402$var$createInvalidMigrationExtensionManifest(contentId, getExtensionHandler, isEditor, flags, createAnalyticsEvent);
    const inlineImagesExtensionManifests = [
        (0, $8pcS0.EXTENSION_KEY).INLINE_MEDIA_IMAGE,
        (0, $8pcS0.EXTENSION_KEY).INLINE_EXTERNAL_IMAGE
    ].map((key)=>$bc16cbc3cc94b402$var$createInlineImagesMigrationExtensionManifest(key, contentId, getExtensionHandler, isEditor, intl));
    return [
        invalidExtensionManifest,
        ...inlineImagesExtensionManifests
    ];
};
const $bc16cbc3cc94b402$var$createInlineImagesMigrationExtensionManifest = (key, contentId, getExtensionHandler, isEditor, intl)=>{
    const node = {
        type: 'inlineExtension',
        async preloadRender () {
        // Intentionally left empty. But the function needs to be defined
        },
        renderSync () {
            return ({ node: node })=>getExtensionHandler({
                    contentId: contentId,
                    contextProviders: {
                        ClassicEditorContextProvider: (0, $fUN4A.ClassicEditorContextProviderLazyLoader)
                    }
                })(node, {});
        },
        async render () {
            return this.renderSync();
        },
        async getFieldsDefinition () {
            return [
                {
                    name: 'width',
                    label: intl.formatMessage($bc16cbc3cc94b402$var$i18n.widthLabel),
                    isRequired: false,
                    description: intl.formatMessage($bc16cbc3cc94b402$var$i18n.widthDescription),
                    placeholder: intl.formatMessage($bc16cbc3cc94b402$var$i18n.configPlaceholder),
                    type: 'number'
                },
                {
                    name: 'height',
                    label: intl.formatMessage($bc16cbc3cc94b402$var$i18n.heightLabel),
                    isRequired: false,
                    description: intl.formatMessage($bc16cbc3cc94b402$var$i18n.heightDescription),
                    placeholder: intl.formatMessage($bc16cbc3cc94b402$var$i18n.configPlaceholder),
                    type: 'number'
                }
            ];
        },
        update: isEditor ? async (_, actions)=>actions.editInContextPanel((parameters)=>{
                return {
                    ...parameters,
                    width: Number(parameters.width) || undefined,
                    height: Number(parameters.height) || undefined
                };
            }, (parameters)=>{
                return {
                    ...parameters,
                    width: $bc16cbc3cc94b402$var$transformImageSize(parameters.width, 16),
                    height: $bc16cbc3cc94b402$var$transformImageSize(parameters.height, 8)
                };
            }) : undefined
    };
    return $bc16cbc3cc94b402$var$createMigrationExtenionManifest(key, node);
};
const $bc16cbc3cc94b402$var$createInvalidMigrationExtensionManifest = (contentId, getExtensionHandler, isEditor, flags, createAnalyticsEvent)=>{
    const node = {
        type: 'inlineExtension',
        async preloadRender () {
        // Intentionally left empty. But the function needs to be defined
        },
        renderSync () {
            return ({ node: node })=>getExtensionHandler({
                    contentId: contentId,
                    contextProviders: {
                        ClassicEditorContextProvider: (0, $fUN4A.ClassicEditorContextProviderLazyLoader)
                    }
                })(node, {});
        },
        async render () {
            return this.renderSync();
        },
        update: isEditor ? (parameters)=>(0, $3d419e1dae817d20$export$752d3018048f7d27)({
                type: 'inlineExtension',
                attrs: {
                    parameters: parameters
                }
            }, flags, createAnalyticsEvent) : undefined
    };
    return $bc16cbc3cc94b402$var$createMigrationExtenionManifest((0, $8pcS0.EXTENSION_KEY).INVALID, node);
};
const $bc16cbc3cc94b402$var$transformImageSize = (size, minSize)=>{
    if (size === undefined) return '';
    if (size <= minSize) return String(minSize);
    return String(size);
};
const $bc16cbc3cc94b402$var$createMigrationExtenionManifest = (key, node)=>{
    return {
        title: 'Migration Extension',
        key: key,
        type: (0, $8pcS0.EXTENSION_TYPE).MIGRATION,
        icons: {
            '48': async ()=>()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jdPfT))), {
                        label: "Migration Extension"
                    })
        },
        modules: {
            nodes: {
                default: node
            }
        }
    };
};
module.exports["getMigrationExtensionManifest"] = $bc16cbc3cc94b402$export$fb67662ebef720ab;

});

parcelRegister("8am3c", function(module, exports) {
const $5f205cb1fe7d8e74$export$2dd355223baa0569 = 'com.atlassian.confluence.plugins.confluence-frontend-support';
const $5f205cb1fe7d8e74$export$73d3e00099fbbdb2 = 'confluence.fabric.page.migration.banner';
const $5f205cb1fe7d8e74$export$af6d68522cb370b8 = 'https://confluence.atlassian.com/confcloud/converting-pages-to-the-new-editor-993930226.html';
module.exports["PLUGIN_KEY"] = $5f205cb1fe7d8e74$export$2dd355223baa0569;
module.exports["PAGE_MIGRATION_FEATURE_KEY"] = $5f205cb1fe7d8e74$export$73d3e00099fbbdb2;
module.exports["LEARN_MORE_URL"] = $5f205cb1fe7d8e74$export$af6d68522cb370b8;

});

parcelRegister("aMZF9", function(module, exports) {

let $7dae3800350c9739$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $7dae3800350c9739$var$load("juBmA"),
    $7dae3800350c9739$var$load("5S8LV"),
    $7dae3800350c9739$var$load("dpE2f"),
    $7dae3800350c9739$var$load("bu7LS"),
    $7dae3800350c9739$var$load("kgxfY"),
    $7dae3800350c9739$var$load("8iZfW"),
    $7dae3800350c9739$var$load("6uX9q"),
    $7dae3800350c9739$var$load("hOaAV"),
    $7dae3800350c9739$var$load("kKvGf"),
    $7dae3800350c9739$var$load("9f5Sw"),
    $7dae3800350c9739$var$load("1okAQ"),
    $7dae3800350c9739$var$load("g5HUX"),
    $7dae3800350c9739$var$load("5BEZW"),
    $7dae3800350c9739$var$load("11lCS"),
    $7dae3800350c9739$var$load("2GhbU"),
    $7dae3800350c9739$var$load("4BnVn"),
    $7dae3800350c9739$var$load("4f5Vx"),
    $7dae3800350c9739$var$load("Wowvf"),
    $7dae3800350c9739$var$load("1kEXt"),
    $7dae3800350c9739$var$load("8A3nE"),
    $7dae3800350c9739$var$load("3j1kT"),
    $7dae3800350c9739$var$load("kEwWf"),
    $7dae3800350c9739$var$load("2nlDO"),
    $7dae3800350c9739$var$load("57DtC"),
    $7dae3800350c9739$var$load("cEqm7"),
    $7dae3800350c9739$var$load("hhss7"),
    $7dae3800350c9739$var$load("jplsw"),
    $7dae3800350c9739$var$load("6XCf4"),
    $7dae3800350c9739$var$load("9S9Mz"),
    $7dae3800350c9739$var$load("g5leU"),
    $7dae3800350c9739$var$load("7EorR"),
    $7dae3800350c9739$var$load("aJ9z1"),
    $7dae3800350c9739$var$load("glvWr"),
    $7dae3800350c9739$var$load("e4wOQ"),
    $7dae3800350c9739$var$load("5pvpJ"),
    $7dae3800350c9739$var$load("e1qbZ"),
    $7dae3800350c9739$var$load("87xQF"),
    $7dae3800350c9739$var$load("2euij"),
    $7dae3800350c9739$var$load("kZMnh"),
    $7dae3800350c9739$var$load("855o0"),
    $7dae3800350c9739$var$load("8MfZE"),
    $7dae3800350c9739$var$load("dek7I"),
    $7dae3800350c9739$var$load("lm9Lt"),
    $7dae3800350c9739$var$load("9wPDc"),
    $7dae3800350c9739$var$load("1MWOL"),
    $7dae3800350c9739$var$load("dYtBN"),
    $7dae3800350c9739$var$load("kNV5Y"),
    $7dae3800350c9739$var$load("6wr18"),
    $7dae3800350c9739$var$load("kjZZD"),
    $7dae3800350c9739$var$load("e6ams"),
    $7dae3800350c9739$var$load("iVgrO"),
    $7dae3800350c9739$var$load("ffEVr"),
    $7dae3800350c9739$var$load("1qlDN"),
    $7dae3800350c9739$var$load("1yVM6"),
    $7dae3800350c9739$var$load("dTsOE"),
    $7dae3800350c9739$var$load("lE7kL"),
    $7dae3800350c9739$var$load("gbKmf"),
    $7dae3800350c9739$var$load("iq6Zv")
]).then(()=>parcelRequire('8pP5E'));

});

parcelRegister("bqQGV", function(module, exports) {
/* QuestionItem.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");


var $6nXDf = parcelRequire("6nXDf");


var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $cO1el = parcelRequire("cO1el");


var $6f0Oj = parcelRequire("6f0Oj");

var $dcJ7R = parcelRequire("dcJ7R");

var $1GzhS = parcelRequire("1GzhS");

var $5dK2X = parcelRequire("5dK2X");

var $ecnYn = parcelRequire("ecnYn");


var $imt6g = parcelRequire("imt6g");


var $8lYIw = parcelRequire("8lYIw");


var $kTuMi = parcelRequire("kTuMi");


var $izEQ8 = parcelRequire("izEQ8");

const $fa5ea10c7ff356d4$var$i18n = (0, $cgtv4.defineMessages)({
    answerCount: {
        id: "questions.question-item.answer-count",
        defaultMessage: "{count, plural, one {{count} answer} other {{count} answers}}"
    },
    voteCount: {
        id: "questions.question-item.vote-count",
        defaultMessage: "{count, plural, one {vote} other {votes}}"
    }
});
const $fa5ea10c7ff356d4$var$outerStyles = (0, $ecnYn.xcss)({
    marginBlock: 'space.100'
});
const $fa5ea10c7ff356d4$var$linkStyles = null;
const $fa5ea10c7ff356d4$var$voteCountStyles = (0, $ecnYn.xcss)({
    textAlign: 'center',
    minWidth: '32px'
});
const $fa5ea10c7ff356d4$export$2f31fc0a7a44451 = ({ questionTitle: questionTitle, questionId: questionId, topics: topics, routerName: routerName, numberOfAnswers: numberOfAnswers, createdBy: createdBy, numberOfVotes: numberOfVotes, createdDate: createdDate, spaceKey: spaceKey, spaceName: spaceName, hasAcceptedAnswer: hasAcceptedAnswer })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $fa5ea10c7ff356d4$var$outerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
        alignInline: "center",
        xcss: $fa5ea10c7ff356d4$var$voteCountStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cO1el.default), {
        size: "medium"
    }, numberOfVotes), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
        size: "small"
    }, formatMessage($fa5ea10c7ff356d4$var$i18n.voteCount, {
        count: numberOfVotes
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
        alignBlock: "start",
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cO1el.default), {
        size: "small"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        alignBlock: "center",
        space: "space.100"
    }, hasAcceptedAnswer && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($imt6g))), {
        color: "var(--ds-icon-accent-green)",
        label: "Accepted answer"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8lYIw.Link), {
        name: routerName,
        params: {
            questionId: questionId,
            spaceKey: spaceKey
        },
        className: (0, $gMc0m.default)([
            "_4bfu1r31 _1hmsglyw _ajmmnqa1"
        ])
    }, questionTitle))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        alignBlock: "center",
        shouldWrap: true,
        space: "space.100",
        separator: "\xb7"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
        size: "small"
    }, formatMessage($fa5ea10c7ff356d4$var$i18n.answerCount, {
        count: numberOfAnswers
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
        size: "small"
    }, createdBy), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
        size: "small"
    }, (0, $6nXDf.default)(createdDate, {
        addSuffix: true
    })), spaceKey && spaceName && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kTuMi.SpaceLink), {
        spaceKey: spaceKey,
        spaceName: spaceName
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $izEQ8.QuestionTopics), {
        topics: topics
    }))));
};
module.exports["QuestionItem"] = $fa5ea10c7ff356d4$export$2f31fc0a7a44451;

});

parcelRegister("bfgJH", function(module, exports) {
"use strict";
var $82fe13dc7fbc2778$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $3FcLR = parcelRequire("3FcLR");


var $6LPWz = parcelRequire("6LPWz");


var $iwB6M = parcelRequire("iwB6M");


var $dZ9AU = parcelRequire("dZ9AU");

/**
 * Ignores source values for a duration determined by another Observable, then
 * emits the most recent value from the source Observable, then repeats this
 * process.
 *
 * <span class="informal">It's like {@link auditTime}, but the silencing
 * duration is determined by a second Observable.</span>
 *
 * <img src="./img/audit.png" width="100%">
 *
 * `audit` is similar to `throttle`, but emits the last value from the silenced
 * time window, instead of the first value. `audit` emits the most recent value
 * from the source Observable on the output Observable as soon as its internal
 * timer becomes disabled, and ignores source values while the timer is enabled.
 * Initially, the timer is disabled. As soon as the first source value arrives,
 * the timer is enabled by calling the `durationSelector` function with the
 * source value, which returns the "duration" Observable. When the duration
 * Observable emits a value or completes, the timer is disabled, then the most
 * recent source value is emitted on the output Observable, and this process
 * repeats for the next source value.
 *
 * @example <caption>Emit clicks at a rate of at most one click per second</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.audit(ev => Rx.Observable.interval(1000));
 * result.subscribe(x => console.log(x));
 *
 * @see {@link auditTime}
 * @see {@link debounce}
 * @see {@link delayWhen}
 * @see {@link sample}
 * @see {@link throttle}
 *
 * @param {function(value: T): SubscribableOrPromise} durationSelector A function
 * that receives a value from the source Observable, for computing the silencing
 * duration, returned as an Observable or a Promise.
 * @return {Observable<T>} An Observable that performs rate-limiting of
 * emissions from the source Observable.
 * @method audit
 * @owner Observable
 */ function $82fe13dc7fbc2778$var$audit(durationSelector) {
    return function auditOperatorFunction(source) {
        return source.lift(new $82fe13dc7fbc2778$var$AuditOperator(durationSelector));
    };
}
module.exports.audit = $82fe13dc7fbc2778$var$audit;
var $82fe13dc7fbc2778$var$AuditOperator = function() {
    function AuditOperator(durationSelector) {
        this.durationSelector = durationSelector;
    }
    AuditOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $82fe13dc7fbc2778$var$AuditSubscriber(subscriber, this.durationSelector));
    };
    return AuditOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $82fe13dc7fbc2778$var$AuditSubscriber = function(_super) {
    $82fe13dc7fbc2778$var$__extends(AuditSubscriber, _super);
    function AuditSubscriber(destination, durationSelector) {
        _super.call(this, destination);
        this.durationSelector = durationSelector;
        this.hasValue = false;
    }
    AuditSubscriber.prototype._next = function(value) {
        this.value = value;
        this.hasValue = true;
        if (!this.throttled) {
            var duration = $3FcLR.tryCatch(this.durationSelector)(value);
            if (duration === $6LPWz.errorObject) this.destination.error($6LPWz.errorObject.e);
            else {
                var innerSubscription = $dZ9AU.subscribeToResult(this, duration);
                if (innerSubscription.closed) this.clearThrottle();
                else this.add(this.throttled = innerSubscription);
            }
        }
    };
    AuditSubscriber.prototype.clearThrottle = function() {
        var _a = this, value = _a.value, hasValue = _a.hasValue, throttled = _a.throttled;
        if (throttled) {
            this.remove(throttled);
            this.throttled = null;
            throttled.unsubscribe();
        }
        if (hasValue) {
            this.value = null;
            this.hasValue = false;
            this.destination.next(value);
        }
    };
    AuditSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex) {
        this.clearThrottle();
    };
    AuditSubscriber.prototype.notifyComplete = function() {
        this.clearThrottle();
    };
    return AuditSubscriber;
}($iwB6M.OuterSubscriber);

});

parcelRegister("3POu8", function(module, exports) {
"use strict";
var $2cad4bcff446834c$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $8biLX = parcelRequire("8biLX");


var $YgydF = parcelRequire("YgydF");


var $3u6GG = parcelRequire("3u6GG");


var $5Dgek = parcelRequire("5Dgek");


var $kVeeY = parcelRequire("kVeeY");

/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $2cad4bcff446834c$var$TimerObservable = function(_super) {
    $2cad4bcff446834c$var$__extends(TimerObservable, _super);
    function TimerObservable(dueTime, period, scheduler) {
        if (dueTime === void 0) dueTime = 0;
        _super.call(this);
        this.period = -1;
        this.dueTime = 0;
        if ($8biLX.isNumeric(period)) this.period = Number(period) < 1 && 1 || Number(period);
        else if ($5Dgek.isScheduler(period)) scheduler = period;
        if (!$5Dgek.isScheduler(scheduler)) scheduler = $3u6GG.async;
        this.scheduler = scheduler;
        this.dueTime = $kVeeY.isDate(dueTime) ? +dueTime - this.scheduler.now() : dueTime;
    }
    /**
     * Creates an Observable that starts emitting after an `initialDelay` and
     * emits ever increasing numbers after each `period` of time thereafter.
     *
     * <span class="informal">Its like {@link interval}, but you can specify when
     * should the emissions start.</span>
     *
     * <img src="./img/timer.png" width="100%">
     *
     * `timer` returns an Observable that emits an infinite sequence of ascending
     * integers, with a constant interval of time, `period` of your choosing
     * between those emissions. The first emission happens after the specified
     * `initialDelay`. The initial delay may be a {@link Date}. By default, this
     * operator uses the `async` IScheduler to provide a notion of time, but you
     * may pass any IScheduler to it. If `period` is not specified, the output
     * Observable emits only one value, `0`. Otherwise, it emits an infinite
     * sequence.
     *
     * @example <caption>Emits ascending numbers, one every second (1000ms), starting after 3 seconds</caption>
     * var numbers = Rx.Observable.timer(3000, 1000);
     * numbers.subscribe(x => console.log(x));
     *
     * @example <caption>Emits one number after five seconds</caption>
     * var numbers = Rx.Observable.timer(5000);
     * numbers.subscribe(x => console.log(x));
     *
     * @see {@link interval}
     * @see {@link delay}
     *
     * @param {number|Date} initialDelay The initial delay time to wait before
     * emitting the first value of `0`.
     * @param {number} [period] The period of time between emissions of the
     * subsequent numbers.
     * @param {Scheduler} [scheduler=async] The IScheduler to use for scheduling
     * the emission of values, and providing a notion of "time".
     * @return {Observable} An Observable that emits a `0` after the
     * `initialDelay` and ever increasing numbers after each `period` of time
     * thereafter.
     * @static true
     * @name timer
     * @owner Observable
     */ TimerObservable.create = function(initialDelay, period, scheduler) {
        if (initialDelay === void 0) initialDelay = 0;
        return new TimerObservable(initialDelay, period, scheduler);
    };
    TimerObservable.dispatch = function(state) {
        var index = state.index, period = state.period, subscriber = state.subscriber;
        var action = this;
        subscriber.next(index);
        if (subscriber.closed) return;
        else if (period === -1) return subscriber.complete();
        state.index = index + 1;
        action.schedule(state, period);
    };
    /** @deprecated internal use only */ TimerObservable.prototype._subscribe = function(subscriber) {
        var index = 0;
        var _a = this, period = _a.period, dueTime = _a.dueTime, scheduler = _a.scheduler;
        return scheduler.schedule(TimerObservable.dispatch, dueTime, {
            index: index,
            period: period,
            subscriber: subscriber
        });
    };
    return TimerObservable;
}($YgydF.Observable);
module.exports.TimerObservable = $2cad4bcff446834c$var$TimerObservable;

});

parcelRegister("ha2Ff", function(module, exports) {
"use strict";
var $c7e56fe83d655d12$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $3u6GG = parcelRequire("3u6GG");


var $axeml = parcelRequire("axeml");


var $5Dgek = parcelRequire("5Dgek");

/* tslint:enable:max-line-length */ /**
 * Buffers the source Observable values for a specific time period.
 *
 * <span class="informal">Collects values from the past as an array, and emits
 * those arrays periodically in time.</span>
 *
 * <img src="./img/bufferTime.png" width="100%">
 *
 * Buffers values from the source for a specific time duration `bufferTimeSpan`.
 * Unless the optional argument `bufferCreationInterval` is given, it emits and
 * resets the buffer every `bufferTimeSpan` milliseconds. If
 * `bufferCreationInterval` is given, this operator opens the buffer every
 * `bufferCreationInterval` milliseconds and closes (emits and resets) the
 * buffer every `bufferTimeSpan` milliseconds. When the optional argument
 * `maxBufferSize` is specified, the buffer will be closed either after
 * `bufferTimeSpan` milliseconds or when it contains `maxBufferSize` elements.
 *
 * @example <caption>Every second, emit an array of the recent click events</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var buffered = clicks.bufferTime(1000);
 * buffered.subscribe(x => console.log(x));
 *
 * @example <caption>Every 5 seconds, emit the click events from the next 2 seconds</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var buffered = clicks.bufferTime(2000, 5000);
 * buffered.subscribe(x => console.log(x));
 *
 * @see {@link buffer}
 * @see {@link bufferCount}
 * @see {@link bufferToggle}
 * @see {@link bufferWhen}
 * @see {@link windowTime}
 *
 * @param {number} bufferTimeSpan The amount of time to fill each buffer array.
 * @param {number} [bufferCreationInterval] The interval at which to start new
 * buffers.
 * @param {number} [maxBufferSize] The maximum buffer size.
 * @param {Scheduler} [scheduler=async] The scheduler on which to schedule the
 * intervals that determine buffer boundaries.
 * @return {Observable<T[]>} An observable of arrays of buffered values.
 * @method bufferTime
 * @owner Observable
 */ function $c7e56fe83d655d12$var$bufferTime(bufferTimeSpan) {
    var length = arguments.length;
    var scheduler = $3u6GG.async;
    if ($5Dgek.isScheduler(arguments[arguments.length - 1])) {
        scheduler = arguments[arguments.length - 1];
        length--;
    }
    var bufferCreationInterval = null;
    if (length >= 2) bufferCreationInterval = arguments[1];
    var maxBufferSize = Number.POSITIVE_INFINITY;
    if (length >= 3) maxBufferSize = arguments[2];
    return function bufferTimeOperatorFunction(source) {
        return source.lift(new $c7e56fe83d655d12$var$BufferTimeOperator(bufferTimeSpan, bufferCreationInterval, maxBufferSize, scheduler));
    };
}
module.exports.bufferTime = $c7e56fe83d655d12$var$bufferTime;
var $c7e56fe83d655d12$var$BufferTimeOperator = function() {
    function BufferTimeOperator(bufferTimeSpan, bufferCreationInterval, maxBufferSize, scheduler) {
        this.bufferTimeSpan = bufferTimeSpan;
        this.bufferCreationInterval = bufferCreationInterval;
        this.maxBufferSize = maxBufferSize;
        this.scheduler = scheduler;
    }
    BufferTimeOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $c7e56fe83d655d12$var$BufferTimeSubscriber(subscriber, this.bufferTimeSpan, this.bufferCreationInterval, this.maxBufferSize, this.scheduler));
    };
    return BufferTimeOperator;
}();
var $c7e56fe83d655d12$var$Context = function() {
    function Context() {
        this.buffer = [];
    }
    return Context;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $c7e56fe83d655d12$var$BufferTimeSubscriber = function(_super) {
    $c7e56fe83d655d12$var$__extends(BufferTimeSubscriber, _super);
    function BufferTimeSubscriber(destination, bufferTimeSpan, bufferCreationInterval, maxBufferSize, scheduler) {
        _super.call(this, destination);
        this.bufferTimeSpan = bufferTimeSpan;
        this.bufferCreationInterval = bufferCreationInterval;
        this.maxBufferSize = maxBufferSize;
        this.scheduler = scheduler;
        this.contexts = [];
        var context = this.openContext();
        this.timespanOnly = bufferCreationInterval == null || bufferCreationInterval < 0;
        if (this.timespanOnly) {
            var timeSpanOnlyState = {
                subscriber: this,
                context: context,
                bufferTimeSpan: bufferTimeSpan
            };
            this.add(context.closeAction = scheduler.schedule($c7e56fe83d655d12$var$dispatchBufferTimeSpanOnly, bufferTimeSpan, timeSpanOnlyState));
        } else {
            var closeState = {
                subscriber: this,
                context: context
            };
            var creationState = {
                bufferTimeSpan: bufferTimeSpan,
                bufferCreationInterval: bufferCreationInterval,
                subscriber: this,
                scheduler: scheduler
            };
            this.add(context.closeAction = scheduler.schedule($c7e56fe83d655d12$var$dispatchBufferClose, bufferTimeSpan, closeState));
            this.add(scheduler.schedule($c7e56fe83d655d12$var$dispatchBufferCreation, bufferCreationInterval, creationState));
        }
    }
    BufferTimeSubscriber.prototype._next = function(value) {
        var contexts = this.contexts;
        var len = contexts.length;
        var filledBufferContext;
        for(var i = 0; i < len; i++){
            var context = contexts[i];
            var buffer = context.buffer;
            buffer.push(value);
            if (buffer.length == this.maxBufferSize) filledBufferContext = context;
        }
        if (filledBufferContext) this.onBufferFull(filledBufferContext);
    };
    BufferTimeSubscriber.prototype._error = function(err) {
        this.contexts.length = 0;
        _super.prototype._error.call(this, err);
    };
    BufferTimeSubscriber.prototype._complete = function() {
        var _a = this, contexts = _a.contexts, destination = _a.destination;
        while(contexts.length > 0){
            var context = contexts.shift();
            destination.next(context.buffer);
        }
        _super.prototype._complete.call(this);
    };
    /** @deprecated internal use only */ BufferTimeSubscriber.prototype._unsubscribe = function() {
        this.contexts = null;
    };
    BufferTimeSubscriber.prototype.onBufferFull = function(context) {
        this.closeContext(context);
        var closeAction = context.closeAction;
        closeAction.unsubscribe();
        this.remove(closeAction);
        if (!this.closed && this.timespanOnly) {
            context = this.openContext();
            var bufferTimeSpan = this.bufferTimeSpan;
            var timeSpanOnlyState = {
                subscriber: this,
                context: context,
                bufferTimeSpan: bufferTimeSpan
            };
            this.add(context.closeAction = this.scheduler.schedule($c7e56fe83d655d12$var$dispatchBufferTimeSpanOnly, bufferTimeSpan, timeSpanOnlyState));
        }
    };
    BufferTimeSubscriber.prototype.openContext = function() {
        var context = new $c7e56fe83d655d12$var$Context();
        this.contexts.push(context);
        return context;
    };
    BufferTimeSubscriber.prototype.closeContext = function(context) {
        this.destination.next(context.buffer);
        var contexts = this.contexts;
        var spliceIndex = contexts ? contexts.indexOf(context) : -1;
        if (spliceIndex >= 0) contexts.splice(contexts.indexOf(context), 1);
    };
    return BufferTimeSubscriber;
}($axeml.Subscriber);
function $c7e56fe83d655d12$var$dispatchBufferTimeSpanOnly(state) {
    var subscriber = state.subscriber;
    var prevContext = state.context;
    if (prevContext) subscriber.closeContext(prevContext);
    if (!subscriber.closed) {
        state.context = subscriber.openContext();
        state.context.closeAction = this.schedule(state, state.bufferTimeSpan);
    }
}
function $c7e56fe83d655d12$var$dispatchBufferCreation(state) {
    var bufferCreationInterval = state.bufferCreationInterval, bufferTimeSpan = state.bufferTimeSpan, subscriber = state.subscriber, scheduler = state.scheduler;
    var context = subscriber.openContext();
    var action = this;
    if (!subscriber.closed) {
        subscriber.add(context.closeAction = scheduler.schedule($c7e56fe83d655d12$var$dispatchBufferClose, bufferTimeSpan, {
            subscriber: subscriber,
            context: context
        }));
        action.schedule(state, bufferCreationInterval);
    }
}
function $c7e56fe83d655d12$var$dispatchBufferClose(arg) {
    var subscriber = arg.subscriber, context = arg.context;
    subscriber.closeContext(context);
}

});

parcelRegister("hvtnc", function(module, exports) {
"use strict";
var $cbec1dd232b2b9ed$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $8v4h5 = parcelRequire("8v4h5");


var $dZ9AU = parcelRequire("dZ9AU");


var $iwB6M = parcelRequire("iwB6M");

/**
 * Buffers the source Observable values starting from an emission from
 * `openings` and ending when the output of `closingSelector` emits.
 *
 * <span class="informal">Collects values from the past as an array. Starts
 * collecting only when `opening` emits, and calls the `closingSelector`
 * function to get an Observable that tells when to close the buffer.</span>
 *
 * <img src="./img/bufferToggle.png" width="100%">
 *
 * Buffers values from the source by opening the buffer via signals from an
 * Observable provided to `openings`, and closing and sending the buffers when
 * a Subscribable or Promise returned by the `closingSelector` function emits.
 *
 * @example <caption>Every other second, emit the click events from the next 500ms</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var openings = Rx.Observable.interval(1000);
 * var buffered = clicks.bufferToggle(openings, i =>
 *   i % 2 ? Rx.Observable.interval(500) : Rx.Observable.empty()
 * );
 * buffered.subscribe(x => console.log(x));
 *
 * @see {@link buffer}
 * @see {@link bufferCount}
 * @see {@link bufferTime}
 * @see {@link bufferWhen}
 * @see {@link windowToggle}
 *
 * @param {SubscribableOrPromise<O>} openings A Subscribable or Promise of notifications to start new
 * buffers.
 * @param {function(value: O): SubscribableOrPromise} closingSelector A function that takes
 * the value emitted by the `openings` observable and returns a Subscribable or Promise,
 * which, when it emits, signals that the associated buffer should be emitted
 * and cleared.
 * @return {Observable<T[]>} An observable of arrays of buffered values.
 * @method bufferToggle
 * @owner Observable
 */ function $cbec1dd232b2b9ed$var$bufferToggle(openings, closingSelector) {
    return function bufferToggleOperatorFunction(source) {
        return source.lift(new $cbec1dd232b2b9ed$var$BufferToggleOperator(openings, closingSelector));
    };
}
module.exports.bufferToggle = $cbec1dd232b2b9ed$var$bufferToggle;
var $cbec1dd232b2b9ed$var$BufferToggleOperator = function() {
    function BufferToggleOperator(openings, closingSelector) {
        this.openings = openings;
        this.closingSelector = closingSelector;
    }
    BufferToggleOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $cbec1dd232b2b9ed$var$BufferToggleSubscriber(subscriber, this.openings, this.closingSelector));
    };
    return BufferToggleOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $cbec1dd232b2b9ed$var$BufferToggleSubscriber = function(_super) {
    $cbec1dd232b2b9ed$var$__extends(BufferToggleSubscriber, _super);
    function BufferToggleSubscriber(destination, openings, closingSelector) {
        _super.call(this, destination);
        this.openings = openings;
        this.closingSelector = closingSelector;
        this.contexts = [];
        this.add($dZ9AU.subscribeToResult(this, openings));
    }
    BufferToggleSubscriber.prototype._next = function(value) {
        var contexts = this.contexts;
        var len = contexts.length;
        for(var i = 0; i < len; i++)contexts[i].buffer.push(value);
    };
    BufferToggleSubscriber.prototype._error = function(err) {
        var contexts = this.contexts;
        while(contexts.length > 0){
            var context = contexts.shift();
            context.subscription.unsubscribe();
            context.buffer = null;
            context.subscription = null;
        }
        this.contexts = null;
        _super.prototype._error.call(this, err);
    };
    BufferToggleSubscriber.prototype._complete = function() {
        var contexts = this.contexts;
        while(contexts.length > 0){
            var context = contexts.shift();
            this.destination.next(context.buffer);
            context.subscription.unsubscribe();
            context.buffer = null;
            context.subscription = null;
        }
        this.contexts = null;
        _super.prototype._complete.call(this);
    };
    BufferToggleSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        outerValue ? this.closeBuffer(outerValue) : this.openBuffer(innerValue);
    };
    BufferToggleSubscriber.prototype.notifyComplete = function(innerSub) {
        this.closeBuffer(innerSub.context);
    };
    BufferToggleSubscriber.prototype.openBuffer = function(value) {
        try {
            var closingSelector = this.closingSelector;
            var closingNotifier = closingSelector.call(this, value);
            if (closingNotifier) this.trySubscribe(closingNotifier);
        } catch (err) {
            this._error(err);
        }
    };
    BufferToggleSubscriber.prototype.closeBuffer = function(context) {
        var contexts = this.contexts;
        if (contexts && context) {
            var buffer = context.buffer, subscription = context.subscription;
            this.destination.next(buffer);
            contexts.splice(contexts.indexOf(context), 1);
            this.remove(subscription);
            subscription.unsubscribe();
        }
    };
    BufferToggleSubscriber.prototype.trySubscribe = function(closingNotifier) {
        var contexts = this.contexts;
        var buffer = [];
        var subscription = new $8v4h5.Subscription();
        var context = {
            buffer: buffer,
            subscription: subscription
        };
        contexts.push(context);
        var innerSubscription = $dZ9AU.subscribeToResult(this, closingNotifier, context);
        if (!innerSubscription || innerSubscription.closed) this.closeBuffer(context);
        else {
            innerSubscription.context = context;
            this.add(innerSubscription);
            subscription.add(innerSubscription);
        }
    };
    return BufferToggleSubscriber;
}($iwB6M.OuterSubscriber);

});

parcelRegister("7Jon0", function(module, exports) {
"use strict";
var $5a0fa3c0e6106d7a$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $8v4h5 = parcelRequire("8v4h5");


var $3FcLR = parcelRequire("3FcLR");


var $6LPWz = parcelRequire("6LPWz");


var $iwB6M = parcelRequire("iwB6M");


var $dZ9AU = parcelRequire("dZ9AU");

/**
 * Buffers the source Observable values, using a factory function of closing
 * Observables to determine when to close, emit, and reset the buffer.
 *
 * <span class="informal">Collects values from the past as an array. When it
 * starts collecting values, it calls a function that returns an Observable that
 * tells when to close the buffer and restart collecting.</span>
 *
 * <img src="./img/bufferWhen.png" width="100%">
 *
 * Opens a buffer immediately, then closes the buffer when the observable
 * returned by calling `closingSelector` function emits a value. When it closes
 * the buffer, it immediately opens a new buffer and repeats the process.
 *
 * @example <caption>Emit an array of the last clicks every [1-5] random seconds</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var buffered = clicks.bufferWhen(() =>
 *   Rx.Observable.interval(1000 + Math.random() * 4000)
 * );
 * buffered.subscribe(x => console.log(x));
 *
 * @see {@link buffer}
 * @see {@link bufferCount}
 * @see {@link bufferTime}
 * @see {@link bufferToggle}
 * @see {@link windowWhen}
 *
 * @param {function(): Observable} closingSelector A function that takes no
 * arguments and returns an Observable that signals buffer closure.
 * @return {Observable<T[]>} An observable of arrays of buffered values.
 * @method bufferWhen
 * @owner Observable
 */ function $5a0fa3c0e6106d7a$var$bufferWhen(closingSelector) {
    return function(source) {
        return source.lift(new $5a0fa3c0e6106d7a$var$BufferWhenOperator(closingSelector));
    };
}
module.exports.bufferWhen = $5a0fa3c0e6106d7a$var$bufferWhen;
var $5a0fa3c0e6106d7a$var$BufferWhenOperator = function() {
    function BufferWhenOperator(closingSelector) {
        this.closingSelector = closingSelector;
    }
    BufferWhenOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $5a0fa3c0e6106d7a$var$BufferWhenSubscriber(subscriber, this.closingSelector));
    };
    return BufferWhenOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $5a0fa3c0e6106d7a$var$BufferWhenSubscriber = function(_super) {
    $5a0fa3c0e6106d7a$var$__extends(BufferWhenSubscriber, _super);
    function BufferWhenSubscriber(destination, closingSelector) {
        _super.call(this, destination);
        this.closingSelector = closingSelector;
        this.subscribing = false;
        this.openBuffer();
    }
    BufferWhenSubscriber.prototype._next = function(value) {
        this.buffer.push(value);
    };
    BufferWhenSubscriber.prototype._complete = function() {
        var buffer = this.buffer;
        if (buffer) this.destination.next(buffer);
        _super.prototype._complete.call(this);
    };
    /** @deprecated internal use only */ BufferWhenSubscriber.prototype._unsubscribe = function() {
        this.buffer = null;
        this.subscribing = false;
    };
    BufferWhenSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.openBuffer();
    };
    BufferWhenSubscriber.prototype.notifyComplete = function() {
        if (this.subscribing) this.complete();
        else this.openBuffer();
    };
    BufferWhenSubscriber.prototype.openBuffer = function() {
        var closingSubscription = this.closingSubscription;
        if (closingSubscription) {
            this.remove(closingSubscription);
            closingSubscription.unsubscribe();
        }
        var buffer = this.buffer;
        if (this.buffer) this.destination.next(buffer);
        this.buffer = [];
        var closingNotifier = $3FcLR.tryCatch(this.closingSelector)();
        if (closingNotifier === $6LPWz.errorObject) this.error($6LPWz.errorObject.e);
        else {
            closingSubscription = new $8v4h5.Subscription();
            this.closingSubscription = closingSubscription;
            this.add(closingSubscription);
            this.subscribing = true;
            closingSubscription.add($dZ9AU.subscribeToResult(this, closingNotifier));
            this.subscribing = false;
        }
    };
    return BufferWhenSubscriber;
}($iwB6M.OuterSubscriber);

});

parcelRegister("gonhO", function(module, exports) {
"use strict";
var $bef0f369511e8f7a$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $HHFyQ = parcelRequire("HHFyQ");


var $fvPwd = parcelRequire("fvPwd");


var $iwB6M = parcelRequire("iwB6M");


var $dZ9AU = parcelRequire("dZ9AU");

var $bef0f369511e8f7a$var$none = {};
/* tslint:enable:max-line-length */ /**
 * Combines multiple Observables to create an Observable whose values are
 * calculated from the latest values of each of its input Observables.
 *
 * <span class="informal">Whenever any input Observable emits a value, it
 * computes a formula using the latest values from all the inputs, then emits
 * the output of that formula.</span>
 *
 * <img src="./img/combineLatest.png" width="100%">
 *
 * `combineLatest` combines the values from this Observable with values from
 * Observables passed as arguments. This is done by subscribing to each
 * Observable, in order, and collecting an array of each of the most recent
 * values any time any of the input Observables emits, then either taking that
 * array and passing it as arguments to an optional `project` function and
 * emitting the return value of that, or just emitting the array of recent
 * values directly if there is no `project` function.
 *
 * @example <caption>Dynamically calculate the Body-Mass Index from an Observable of weight and one for height</caption>
 * var weight = Rx.Observable.of(70, 72, 76, 79, 75);
 * var height = Rx.Observable.of(1.76, 1.77, 1.78);
 * var bmi = weight.combineLatest(height, (w, h) => w / (h * h));
 * bmi.subscribe(x => console.log('BMI is ' + x));
 *
 * // With output to console:
 * // BMI is 24.212293388429753
 * // BMI is 23.93948099205209
 * // BMI is 23.671253629592222
 *
 * @see {@link combineAll}
 * @see {@link merge}
 * @see {@link withLatestFrom}
 *
 * @param {ObservableInput} other An input Observable to combine with the source
 * Observable. More than one input Observables may be given as argument.
 * @param {function} [project] An optional function to project the values from
 * the combined latest values into a new value on the output Observable.
 * @return {Observable} An Observable of projected values from the most recent
 * values from each input Observable, or an array of the most recent values from
 * each input Observable.
 * @method combineLatest
 * @owner Observable
 */ function $bef0f369511e8f7a$var$combineLatest() {
    var observables = [];
    for(var _i = 0; _i < arguments.length; _i++)observables[_i - 0] = arguments[_i];
    var project = null;
    if (typeof observables[observables.length - 1] === 'function') project = observables.pop();
    // if the first and only other argument besides the resultSelector is an array
    // assume it's been called with `combineLatest([obs1, obs2, obs3], project)`
    if (observables.length === 1 && $fvPwd.isArray(observables[0])) observables = observables[0].slice();
    return function(source) {
        return source.lift.call(new $HHFyQ.ArrayObservable([
            source
        ].concat(observables)), new $bef0f369511e8f7a$var$CombineLatestOperator(project));
    };
}
module.exports.combineLatest = $bef0f369511e8f7a$var$combineLatest;
var $bef0f369511e8f7a$var$CombineLatestOperator = function() {
    function CombineLatestOperator(project) {
        this.project = project;
    }
    CombineLatestOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $bef0f369511e8f7a$var$CombineLatestSubscriber(subscriber, this.project));
    };
    return CombineLatestOperator;
}();
module.exports.CombineLatestOperator = $bef0f369511e8f7a$var$CombineLatestOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $bef0f369511e8f7a$var$CombineLatestSubscriber = function(_super) {
    $bef0f369511e8f7a$var$__extends(CombineLatestSubscriber, _super);
    function CombineLatestSubscriber(destination, project) {
        _super.call(this, destination);
        this.project = project;
        this.active = 0;
        this.values = [];
        this.observables = [];
    }
    CombineLatestSubscriber.prototype._next = function(observable) {
        this.values.push($bef0f369511e8f7a$var$none);
        this.observables.push(observable);
    };
    CombineLatestSubscriber.prototype._complete = function() {
        var observables = this.observables;
        var len = observables.length;
        if (len === 0) this.destination.complete();
        else {
            this.active = len;
            this.toRespond = len;
            for(var i = 0; i < len; i++){
                var observable = observables[i];
                this.add($dZ9AU.subscribeToResult(this, observable, observable, i));
            }
        }
    };
    CombineLatestSubscriber.prototype.notifyComplete = function(unused) {
        if ((this.active -= 1) === 0) this.destination.complete();
    };
    CombineLatestSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        var values = this.values;
        var oldVal = values[outerIndex];
        var toRespond = !this.toRespond ? 0 : oldVal === $bef0f369511e8f7a$var$none ? --this.toRespond : this.toRespond;
        values[outerIndex] = innerValue;
        if (toRespond === 0) {
            if (this.project) this._tryProject(values);
            else this.destination.next(values.slice());
        }
    };
    CombineLatestSubscriber.prototype._tryProject = function(values) {
        var result;
        try {
            result = this.project.apply(this, values);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(result);
    };
    return CombineLatestSubscriber;
}($iwB6M.OuterSubscriber);
module.exports.CombineLatestSubscriber = $bef0f369511e8f7a$var$CombineLatestSubscriber;

});

parcelRegister("3EdwZ", function(module, exports) {
"use strict";
var $2a7f9a89907952dc$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $iwB6M = parcelRequire("iwB6M");


var $dZ9AU = parcelRequire("dZ9AU");

/**
 * Emits a value from the source Observable only after a particular time span
 * determined by another Observable has passed without another source emission.
 *
 * <span class="informal">It's like {@link debounceTime}, but the time span of
 * emission silence is determined by a second Observable.</span>
 *
 * <img src="./img/debounce.png" width="100%">
 *
 * `debounce` delays values emitted by the source Observable, but drops previous
 * pending delayed emissions if a new value arrives on the source Observable.
 * This operator keeps track of the most recent value from the source
 * Observable, and spawns a duration Observable by calling the
 * `durationSelector` function. The value is emitted only when the duration
 * Observable emits a value or completes, and if no other value was emitted on
 * the source Observable since the duration Observable was spawned. If a new
 * value appears before the duration Observable emits, the previous value will
 * be dropped and will not be emitted on the output Observable.
 *
 * Like {@link debounceTime}, this is a rate-limiting operator, and also a
 * delay-like operator since output emissions do not necessarily occur at the
 * same time as they did on the source Observable.
 *
 * @example <caption>Emit the most recent click after a burst of clicks</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.debounce(() => Rx.Observable.interval(1000));
 * result.subscribe(x => console.log(x));
 *
 * @see {@link audit}
 * @see {@link debounceTime}
 * @see {@link delayWhen}
 * @see {@link throttle}
 *
 * @param {function(value: T): SubscribableOrPromise} durationSelector A function
 * that receives a value from the source Observable, for computing the timeout
 * duration for each source value, returned as an Observable or a Promise.
 * @return {Observable} An Observable that delays the emissions of the source
 * Observable by the specified duration Observable returned by
 * `durationSelector`, and may drop some values if they occur too frequently.
 * @method debounce
 * @owner Observable
 */ function $2a7f9a89907952dc$var$debounce(durationSelector) {
    return function(source) {
        return source.lift(new $2a7f9a89907952dc$var$DebounceOperator(durationSelector));
    };
}
module.exports.debounce = $2a7f9a89907952dc$var$debounce;
var $2a7f9a89907952dc$var$DebounceOperator = function() {
    function DebounceOperator(durationSelector) {
        this.durationSelector = durationSelector;
    }
    DebounceOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $2a7f9a89907952dc$var$DebounceSubscriber(subscriber, this.durationSelector));
    };
    return DebounceOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $2a7f9a89907952dc$var$DebounceSubscriber = function(_super) {
    $2a7f9a89907952dc$var$__extends(DebounceSubscriber, _super);
    function DebounceSubscriber(destination, durationSelector) {
        _super.call(this, destination);
        this.durationSelector = durationSelector;
        this.hasValue = false;
        this.durationSubscription = null;
    }
    DebounceSubscriber.prototype._next = function(value) {
        try {
            var result = this.durationSelector.call(this, value);
            if (result) this._tryNext(value, result);
        } catch (err) {
            this.destination.error(err);
        }
    };
    DebounceSubscriber.prototype._complete = function() {
        this.emitValue();
        this.destination.complete();
    };
    DebounceSubscriber.prototype._tryNext = function(value, duration) {
        var subscription = this.durationSubscription;
        this.value = value;
        this.hasValue = true;
        if (subscription) {
            subscription.unsubscribe();
            this.remove(subscription);
        }
        subscription = $dZ9AU.subscribeToResult(this, duration);
        if (!subscription.closed) this.add(this.durationSubscription = subscription);
    };
    DebounceSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.emitValue();
    };
    DebounceSubscriber.prototype.notifyComplete = function() {
        this.emitValue();
    };
    DebounceSubscriber.prototype.emitValue = function() {
        if (this.hasValue) {
            var value = this.value;
            var subscription = this.durationSubscription;
            if (subscription) {
                this.durationSubscription = null;
                subscription.unsubscribe();
                this.remove(subscription);
            }
            this.value = null;
            this.hasValue = false;
            _super.prototype._next.call(this, value);
        }
    };
    return DebounceSubscriber;
}($iwB6M.OuterSubscriber);

});

parcelRegister("dGzwg", function(module, exports) {
"use strict";
var $9f6ac0077b20b014$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $axeml = parcelRequire("axeml");


var $3u6GG = parcelRequire("3u6GG");

/**
 * Emits a value from the source Observable only after a particular time span
 * has passed without another source emission.
 *
 * <span class="informal">It's like {@link delay}, but passes only the most
 * recent value from each burst of emissions.</span>
 *
 * <img src="./img/debounceTime.png" width="100%">
 *
 * `debounceTime` delays values emitted by the source Observable, but drops
 * previous pending delayed emissions if a new value arrives on the source
 * Observable. This operator keeps track of the most recent value from the
 * source Observable, and emits that only when `dueTime` enough time has passed
 * without any other value appearing on the source Observable. If a new value
 * appears before `dueTime` silence occurs, the previous value will be dropped
 * and will not be emitted on the output Observable.
 *
 * This is a rate-limiting operator, because it is impossible for more than one
 * value to be emitted in any time window of duration `dueTime`, but it is also
 * a delay-like operator since output emissions do not occur at the same time as
 * they did on the source Observable. Optionally takes a {@link IScheduler} for
 * managing timers.
 *
 * @example <caption>Emit the most recent click after a burst of clicks</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.debounceTime(1000);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link auditTime}
 * @see {@link debounce}
 * @see {@link delay}
 * @see {@link sampleTime}
 * @see {@link throttleTime}
 *
 * @param {number} dueTime The timeout duration in milliseconds (or the time
 * unit determined internally by the optional `scheduler`) for the window of
 * time required to wait for emission silence before emitting the most recent
 * source value.
 * @param {Scheduler} [scheduler=async] The {@link IScheduler} to use for
 * managing the timers that handle the timeout for each value.
 * @return {Observable} An Observable that delays the emissions of the source
 * Observable by the specified `dueTime`, and may drop some values if they occur
 * too frequently.
 * @method debounceTime
 * @owner Observable
 */ function $9f6ac0077b20b014$var$debounceTime(dueTime, scheduler) {
    if (scheduler === void 0) scheduler = $3u6GG.async;
    return function(source) {
        return source.lift(new $9f6ac0077b20b014$var$DebounceTimeOperator(dueTime, scheduler));
    };
}
module.exports.debounceTime = $9f6ac0077b20b014$var$debounceTime;
var $9f6ac0077b20b014$var$DebounceTimeOperator = function() {
    function DebounceTimeOperator(dueTime, scheduler) {
        this.dueTime = dueTime;
        this.scheduler = scheduler;
    }
    DebounceTimeOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $9f6ac0077b20b014$var$DebounceTimeSubscriber(subscriber, this.dueTime, this.scheduler));
    };
    return DebounceTimeOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $9f6ac0077b20b014$var$DebounceTimeSubscriber = function(_super) {
    $9f6ac0077b20b014$var$__extends(DebounceTimeSubscriber, _super);
    function DebounceTimeSubscriber(destination, dueTime, scheduler) {
        _super.call(this, destination);
        this.dueTime = dueTime;
        this.scheduler = scheduler;
        this.debouncedSubscription = null;
        this.lastValue = null;
        this.hasValue = false;
    }
    DebounceTimeSubscriber.prototype._next = function(value) {
        this.clearDebounce();
        this.lastValue = value;
        this.hasValue = true;
        this.add(this.debouncedSubscription = this.scheduler.schedule($9f6ac0077b20b014$var$dispatchNext, this.dueTime, this));
    };
    DebounceTimeSubscriber.prototype._complete = function() {
        this.debouncedNext();
        this.destination.complete();
    };
    DebounceTimeSubscriber.prototype.debouncedNext = function() {
        this.clearDebounce();
        if (this.hasValue) {
            this.destination.next(this.lastValue);
            this.lastValue = null;
            this.hasValue = false;
        }
    };
    DebounceTimeSubscriber.prototype.clearDebounce = function() {
        var debouncedSubscription = this.debouncedSubscription;
        if (debouncedSubscription !== null) {
            this.remove(debouncedSubscription);
            debouncedSubscription.unsubscribe();
            this.debouncedSubscription = null;
        }
    };
    return DebounceTimeSubscriber;
}($axeml.Subscriber);
function $9f6ac0077b20b014$var$dispatchNext(subscriber) {
    subscriber.debouncedNext();
}

});

parcelRegister("3YBdK", function(module, exports) {
"use strict";
var $2e53d8f87cbc215e$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $axeml = parcelRequire("axeml");


var $YgydF = parcelRequire("YgydF");


var $iwB6M = parcelRequire("iwB6M");


var $dZ9AU = parcelRequire("dZ9AU");

/**
 * Delays the emission of items from the source Observable by a given time span
 * determined by the emissions of another Observable.
 *
 * <span class="informal">It's like {@link delay}, but the time span of the
 * delay duration is determined by a second Observable.</span>
 *
 * <img src="./img/delayWhen.png" width="100%">
 *
 * `delayWhen` time shifts each emitted value from the source Observable by a
 * time span determined by another Observable. When the source emits a value,
 * the `delayDurationSelector` function is called with the source value as
 * argument, and should return an Observable, called the "duration" Observable.
 * The source value is emitted on the output Observable only when the duration
 * Observable emits a value or completes.
 *
 * Optionally, `delayWhen` takes a second argument, `subscriptionDelay`, which
 * is an Observable. When `subscriptionDelay` emits its first value or
 * completes, the source Observable is subscribed to and starts behaving like
 * described in the previous paragraph. If `subscriptionDelay` is not provided,
 * `delayWhen` will subscribe to the source Observable as soon as the output
 * Observable is subscribed.
 *
 * @example <caption>Delay each click by a random amount of time, between 0 and 5 seconds</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var delayedClicks = clicks.delayWhen(event =>
 *   Rx.Observable.interval(Math.random() * 5000)
 * );
 * delayedClicks.subscribe(x => console.log(x));
 *
 * @see {@link debounce}
 * @see {@link delay}
 *
 * @param {function(value: T): Observable} delayDurationSelector A function that
 * returns an Observable for each value emitted by the source Observable, which
 * is then used to delay the emission of that item on the output Observable
 * until the Observable returned from this function emits a value.
 * @param {Observable} subscriptionDelay An Observable that triggers the
 * subscription to the source Observable once it emits any value.
 * @return {Observable} An Observable that delays the emissions of the source
 * Observable by an amount of time specified by the Observable returned by
 * `delayDurationSelector`.
 * @method delayWhen
 * @owner Observable
 */ function $2e53d8f87cbc215e$var$delayWhen(delayDurationSelector, subscriptionDelay) {
    if (subscriptionDelay) return function(source) {
        return new $2e53d8f87cbc215e$var$SubscriptionDelayObservable(source, subscriptionDelay).lift(new $2e53d8f87cbc215e$var$DelayWhenOperator(delayDurationSelector));
    };
    return function(source) {
        return source.lift(new $2e53d8f87cbc215e$var$DelayWhenOperator(delayDurationSelector));
    };
}
module.exports.delayWhen = $2e53d8f87cbc215e$var$delayWhen;
var $2e53d8f87cbc215e$var$DelayWhenOperator = function() {
    function DelayWhenOperator(delayDurationSelector) {
        this.delayDurationSelector = delayDurationSelector;
    }
    DelayWhenOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $2e53d8f87cbc215e$var$DelayWhenSubscriber(subscriber, this.delayDurationSelector));
    };
    return DelayWhenOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $2e53d8f87cbc215e$var$DelayWhenSubscriber = function(_super) {
    $2e53d8f87cbc215e$var$__extends(DelayWhenSubscriber, _super);
    function DelayWhenSubscriber(destination, delayDurationSelector) {
        _super.call(this, destination);
        this.delayDurationSelector = delayDurationSelector;
        this.completed = false;
        this.delayNotifierSubscriptions = [];
        this.values = [];
    }
    DelayWhenSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.destination.next(outerValue);
        this.removeSubscription(innerSub);
        this.tryComplete();
    };
    DelayWhenSubscriber.prototype.notifyError = function(error, innerSub) {
        this._error(error);
    };
    DelayWhenSubscriber.prototype.notifyComplete = function(innerSub) {
        var value = this.removeSubscription(innerSub);
        if (value) this.destination.next(value);
        this.tryComplete();
    };
    DelayWhenSubscriber.prototype._next = function(value) {
        try {
            var delayNotifier = this.delayDurationSelector(value);
            if (delayNotifier) this.tryDelay(delayNotifier, value);
        } catch (err) {
            this.destination.error(err);
        }
    };
    DelayWhenSubscriber.prototype._complete = function() {
        this.completed = true;
        this.tryComplete();
    };
    DelayWhenSubscriber.prototype.removeSubscription = function(subscription) {
        subscription.unsubscribe();
        var subscriptionIdx = this.delayNotifierSubscriptions.indexOf(subscription);
        var value = null;
        if (subscriptionIdx !== -1) {
            value = this.values[subscriptionIdx];
            this.delayNotifierSubscriptions.splice(subscriptionIdx, 1);
            this.values.splice(subscriptionIdx, 1);
        }
        return value;
    };
    DelayWhenSubscriber.prototype.tryDelay = function(delayNotifier, value) {
        var notifierSubscription = $dZ9AU.subscribeToResult(this, delayNotifier, value);
        if (notifierSubscription && !notifierSubscription.closed) {
            this.add(notifierSubscription);
            this.delayNotifierSubscriptions.push(notifierSubscription);
        }
        this.values.push(value);
    };
    DelayWhenSubscriber.prototype.tryComplete = function() {
        if (this.completed && this.delayNotifierSubscriptions.length === 0) this.destination.complete();
    };
    return DelayWhenSubscriber;
}($iwB6M.OuterSubscriber);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $2e53d8f87cbc215e$var$SubscriptionDelayObservable = function(_super) {
    $2e53d8f87cbc215e$var$__extends(SubscriptionDelayObservable, _super);
    function SubscriptionDelayObservable(/** @deprecated internal use only */ source, subscriptionDelay) {
        _super.call(this);
        this.source = source;
        this.subscriptionDelay = subscriptionDelay;
    }
    /** @deprecated internal use only */ SubscriptionDelayObservable.prototype._subscribe = function(subscriber) {
        this.subscriptionDelay.subscribe(new $2e53d8f87cbc215e$var$SubscriptionDelaySubscriber(subscriber, this.source));
    };
    return SubscriptionDelayObservable;
}($YgydF.Observable);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $2e53d8f87cbc215e$var$SubscriptionDelaySubscriber = function(_super) {
    $2e53d8f87cbc215e$var$__extends(SubscriptionDelaySubscriber, _super);
    function SubscriptionDelaySubscriber(parent, source) {
        _super.call(this);
        this.parent = parent;
        this.source = source;
        this.sourceSubscribed = false;
    }
    SubscriptionDelaySubscriber.prototype._next = function(unused) {
        this.subscribeToSource();
    };
    SubscriptionDelaySubscriber.prototype._error = function(err) {
        this.unsubscribe();
        this.parent.error(err);
    };
    SubscriptionDelaySubscriber.prototype._complete = function() {
        this.subscribeToSource();
    };
    SubscriptionDelaySubscriber.prototype.subscribeToSource = function() {
        if (!this.sourceSubscribed) {
            this.sourceSubscribed = true;
            this.unsubscribe();
            this.source.subscribe(this.parent);
        }
    };
    return SubscriptionDelaySubscriber;
}($axeml.Subscriber);

});

parcelRegister("5vrRW", function(module, exports) {
"use strict";
var $40257735fb6101a1$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $axeml = parcelRequire("axeml");

/**
 * Converts an Observable of {@link Notification} objects into the emissions
 * that they represent.
 *
 * <span class="informal">Unwraps {@link Notification} objects as actual `next`,
 * `error` and `complete` emissions. The opposite of {@link materialize}.</span>
 *
 * <img src="./img/dematerialize.png" width="100%">
 *
 * `dematerialize` is assumed to operate an Observable that only emits
 * {@link Notification} objects as `next` emissions, and does not emit any
 * `error`. Such Observable is the output of a `materialize` operation. Those
 * notifications are then unwrapped using the metadata they contain, and emitted
 * as `next`, `error`, and `complete` on the output Observable.
 *
 * Use this operator in conjunction with {@link materialize}.
 *
 * @example <caption>Convert an Observable of Notifications to an actual Observable</caption>
 * var notifA = new Rx.Notification('N', 'A');
 * var notifB = new Rx.Notification('N', 'B');
 * var notifE = new Rx.Notification('E', void 0,
 *   new TypeError('x.toUpperCase is not a function')
 * );
 * var materialized = Rx.Observable.of(notifA, notifB, notifE);
 * var upperCase = materialized.dematerialize();
 * upperCase.subscribe(x => console.log(x), e => console.error(e));
 *
 * // Results in:
 * // A
 * // B
 * // TypeError: x.toUpperCase is not a function
 *
 * @see {@link Notification}
 * @see {@link materialize}
 *
 * @return {Observable} An Observable that emits items and notifications
 * embedded in Notification objects emitted by the source Observable.
 * @method dematerialize
 * @owner Observable
 */ function $40257735fb6101a1$var$dematerialize() {
    return function dematerializeOperatorFunction(source) {
        return source.lift(new $40257735fb6101a1$var$DeMaterializeOperator());
    };
}
module.exports.dematerialize = $40257735fb6101a1$var$dematerialize;
var $40257735fb6101a1$var$DeMaterializeOperator = function() {
    function DeMaterializeOperator() {}
    DeMaterializeOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $40257735fb6101a1$var$DeMaterializeSubscriber(subscriber));
    };
    return DeMaterializeOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $40257735fb6101a1$var$DeMaterializeSubscriber = function(_super) {
    $40257735fb6101a1$var$__extends(DeMaterializeSubscriber, _super);
    function DeMaterializeSubscriber(destination) {
        _super.call(this, destination);
    }
    DeMaterializeSubscriber.prototype._next = function(value) {
        value.observe(this.destination);
    };
    return DeMaterializeSubscriber;
}($axeml.Subscriber);

});

parcelRegister("jKOLV", function(module, exports) {
"use strict";
var $e619b26f9423c809$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $iwB6M = parcelRequire("iwB6M");


var $dZ9AU = parcelRequire("dZ9AU");

var $5b4bf236188716d8$export$ac57f2e66ff143c0;
var $5b4bf236188716d8$export$bdf4ff5a442cbbc5;
"use strict";

var $4iRIL = parcelRequire("4iRIL");

function $5b4bf236188716d8$var$minimalSetImpl() {
    // THIS IS NOT a full impl of Set, this is just the minimum
    // bits of functionality we need for this library.
    return function() {
        function MinimalSet() {
            this._values = [];
        }
        MinimalSet.prototype.add = function(value) {
            if (!this.has(value)) this._values.push(value);
        };
        MinimalSet.prototype.has = function(value) {
            return this._values.indexOf(value) !== -1;
        };
        Object.defineProperty(MinimalSet.prototype, "size", {
            get: function() {
                return this._values.length;
            },
            enumerable: true,
            configurable: true
        });
        MinimalSet.prototype.clear = function() {
            this._values.length = 0;
        };
        return MinimalSet;
    }();
}
$5b4bf236188716d8$export$ac57f2e66ff143c0 = $5b4bf236188716d8$var$minimalSetImpl;
$5b4bf236188716d8$export$bdf4ff5a442cbbc5 = $4iRIL.root.Set || $5b4bf236188716d8$var$minimalSetImpl();


/**
 * Returns an Observable that emits all items emitted by the source Observable that are distinct by comparison from previous items.
 *
 * If a keySelector function is provided, then it will project each value from the source observable into a new value that it will
 * check for equality with previously projected values. If a keySelector function is not provided, it will use each value from the
 * source observable directly with an equality check against previous values.
 *
 * In JavaScript runtimes that support `Set`, this operator will use a `Set` to improve performance of the distinct value checking.
 *
 * In other runtimes, this operator will use a minimal implementation of `Set` that relies on an `Array` and `indexOf` under the
 * hood, so performance will degrade as more values are checked for distinction. Even in newer browsers, a long-running `distinct`
 * use might result in memory leaks. To help alleviate this in some scenarios, an optional `flushes` parameter is also provided so
 * that the internal `Set` can be "flushed", basically clearing it of values.
 *
 * @example <caption>A simple example with numbers</caption>
 * Observable.of(1, 1, 2, 2, 2, 1, 2, 3, 4, 3, 2, 1)
 *   .distinct()
 *   .subscribe(x => console.log(x)); // 1, 2, 3, 4
 *
 * @example <caption>An example using a keySelector function</caption>
 * interface Person {
 *    age: number,
 *    name: string
 * }
 *
 * Observable.of<Person>(
 *     { age: 4, name: 'Foo'},
 *     { age: 7, name: 'Bar'},
 *     { age: 5, name: 'Foo'})
 *     .distinct((p: Person) => p.name)
 *     .subscribe(x => console.log(x));
 *
 * // displays:
 * // { age: 4, name: 'Foo' }
 * // { age: 7, name: 'Bar' }
 *
 * @see {@link distinctUntilChanged}
 * @see {@link distinctUntilKeyChanged}
 *
 * @param {function} [keySelector] Optional function to select which value you want to check as distinct.
 * @param {Observable} [flushes] Optional Observable for flushing the internal HashSet of the operator.
 * @return {Observable} An Observable that emits items from the source Observable with distinct values.
 * @method distinct
 * @owner Observable
 */ function $e619b26f9423c809$var$distinct(keySelector, flushes) {
    return function(source) {
        return source.lift(new $e619b26f9423c809$var$DistinctOperator(keySelector, flushes));
    };
}
module.exports.distinct = $e619b26f9423c809$var$distinct;
var $e619b26f9423c809$var$DistinctOperator = function() {
    function DistinctOperator(keySelector, flushes) {
        this.keySelector = keySelector;
        this.flushes = flushes;
    }
    DistinctOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $e619b26f9423c809$var$DistinctSubscriber(subscriber, this.keySelector, this.flushes));
    };
    return DistinctOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $e619b26f9423c809$var$DistinctSubscriber = function(_super) {
    $e619b26f9423c809$var$__extends(DistinctSubscriber, _super);
    function DistinctSubscriber(destination, keySelector, flushes) {
        _super.call(this, destination);
        this.keySelector = keySelector;
        this.values = new $5b4bf236188716d8$export$bdf4ff5a442cbbc5();
        if (flushes) this.add($dZ9AU.subscribeToResult(this, flushes));
    }
    DistinctSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.values.clear();
    };
    DistinctSubscriber.prototype.notifyError = function(error, innerSub) {
        this._error(error);
    };
    DistinctSubscriber.prototype._next = function(value) {
        if (this.keySelector) this._useKeySelector(value);
        else this._finalizeNext(value, value);
    };
    DistinctSubscriber.prototype._useKeySelector = function(value) {
        var key;
        var destination = this.destination;
        try {
            key = this.keySelector(value);
        } catch (err) {
            destination.error(err);
            return;
        }
        this._finalizeNext(key, value);
    };
    DistinctSubscriber.prototype._finalizeNext = function(key, value) {
        var values = this.values;
        if (!values.has(key)) {
            values.add(key);
            this.destination.next(value);
        }
    };
    return DistinctSubscriber;
}($iwB6M.OuterSubscriber);
module.exports.DistinctSubscriber = $e619b26f9423c809$var$DistinctSubscriber;

});

parcelRegister("j5i71", function(module, exports) {
"use strict";
var $de4c88a7f81bf6d9$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $axeml = parcelRequire("axeml");


var $2g0GA = parcelRequire("2g0GA");

/**
 * Emits the single value at the specified `index` in a sequence of emissions
 * from the source Observable.
 *
 * <span class="informal">Emits only the i-th value, then completes.</span>
 *
 * <img src="./img/elementAt.png" width="100%">
 *
 * `elementAt` returns an Observable that emits the item at the specified
 * `index` in the source Observable, or a default value if that `index` is out
 * of range and the `default` argument is provided. If the `default` argument is
 * not given and the `index` is out of range, the output Observable will emit an
 * `ArgumentOutOfRangeError` error.
 *
 * @example <caption>Emit only the third click event</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.elementAt(2);
 * result.subscribe(x => console.log(x));
 *
 * // Results in:
 * // click 1 = nothing
 * // click 2 = nothing
 * // click 3 = MouseEvent object logged to console
 *
 * @see {@link first}
 * @see {@link last}
 * @see {@link skip}
 * @see {@link single}
 * @see {@link take}
 *
 * @throws {ArgumentOutOfRangeError} When using `elementAt(i)`, it delivers an
 * ArgumentOutOrRangeError to the Observer's `error` callback if `i < 0` or the
 * Observable has completed before emitting the i-th `next` notification.
 *
 * @param {number} index Is the number `i` for the i-th source emission that has
 * happened since the subscription, starting from the number `0`.
 * @param {T} [defaultValue] The default value returned for missing indices.
 * @return {Observable} An Observable that emits a single item, if it is found.
 * Otherwise, will emit the default value if given. If not, then emits an error.
 * @method elementAt
 * @owner Observable
 */ function $de4c88a7f81bf6d9$var$elementAt(index, defaultValue) {
    return function(source) {
        return source.lift(new $de4c88a7f81bf6d9$var$ElementAtOperator(index, defaultValue));
    };
}
module.exports.elementAt = $de4c88a7f81bf6d9$var$elementAt;
var $de4c88a7f81bf6d9$var$ElementAtOperator = function() {
    function ElementAtOperator(index, defaultValue) {
        this.index = index;
        this.defaultValue = defaultValue;
        if (index < 0) throw new $2g0GA.ArgumentOutOfRangeError;
    }
    ElementAtOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $de4c88a7f81bf6d9$var$ElementAtSubscriber(subscriber, this.index, this.defaultValue));
    };
    return ElementAtOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $de4c88a7f81bf6d9$var$ElementAtSubscriber = function(_super) {
    $de4c88a7f81bf6d9$var$__extends(ElementAtSubscriber, _super);
    function ElementAtSubscriber(destination, index, defaultValue) {
        _super.call(this, destination);
        this.index = index;
        this.defaultValue = defaultValue;
    }
    ElementAtSubscriber.prototype._next = function(x) {
        if (this.index-- === 0) {
            this.destination.next(x);
            this.destination.complete();
        }
    };
    ElementAtSubscriber.prototype._complete = function() {
        var destination = this.destination;
        if (this.index >= 0) {
            if (typeof this.defaultValue !== 'undefined') destination.next(this.defaultValue);
            else destination.error(new $2g0GA.ArgumentOutOfRangeError);
        }
        destination.complete();
    };
    return ElementAtSubscriber;
}($axeml.Subscriber);

});

parcelRegister("8eQTU", function(module, exports) {
"use strict";
var $5ff8aa8b810adc26$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $axeml = parcelRequire("axeml");

/**
 * Returns an Observable that emits whether or not every item of the source satisfies the condition specified.
 *
 * @example <caption>A simple example emitting true if all elements are less than 5, false otherwise</caption>
 *  Observable.of(1, 2, 3, 4, 5, 6)
 *     .every(x => x < 5)
 *     .subscribe(x => console.log(x)); // -> false
 *
 * @param {function} predicate A function for determining if an item meets a specified condition.
 * @param {any} [thisArg] Optional object to use for `this` in the callback.
 * @return {Observable} An Observable of booleans that determines if all items of the source Observable meet the condition specified.
 * @method every
 * @owner Observable
 */ function $5ff8aa8b810adc26$var$every(predicate, thisArg) {
    return function(source) {
        return source.lift(new $5ff8aa8b810adc26$var$EveryOperator(predicate, thisArg, source));
    };
}
module.exports.every = $5ff8aa8b810adc26$var$every;
var $5ff8aa8b810adc26$var$EveryOperator = function() {
    function EveryOperator(predicate, thisArg, source) {
        this.predicate = predicate;
        this.thisArg = thisArg;
        this.source = source;
    }
    EveryOperator.prototype.call = function(observer, source) {
        return source.subscribe(new $5ff8aa8b810adc26$var$EverySubscriber(observer, this.predicate, this.thisArg, this.source));
    };
    return EveryOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $5ff8aa8b810adc26$var$EverySubscriber = function(_super) {
    $5ff8aa8b810adc26$var$__extends(EverySubscriber, _super);
    function EverySubscriber(destination, predicate, thisArg, source) {
        _super.call(this, destination);
        this.predicate = predicate;
        this.thisArg = thisArg;
        this.source = source;
        this.index = 0;
        this.thisArg = thisArg || this;
    }
    EverySubscriber.prototype.notifyComplete = function(everyValueMatch) {
        this.destination.next(everyValueMatch);
        this.destination.complete();
    };
    EverySubscriber.prototype._next = function(value) {
        var result = false;
        try {
            result = this.predicate.call(this.thisArg, value, this.index++, this.source);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        if (!result) this.notifyComplete(false);
    };
    EverySubscriber.prototype._complete = function() {
        this.notifyComplete(true);
    };
    return EverySubscriber;
}($axeml.Subscriber);

});

parcelRegister("d2JY2", function(module, exports) {
"use strict";
var $97ef1e6c23a2f872$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $iwB6M = parcelRequire("iwB6M");


var $dZ9AU = parcelRequire("dZ9AU");

/**
 * Converts a higher-order Observable into a first-order Observable by dropping
 * inner Observables while the previous inner Observable has not yet completed.
 *
 * <span class="informal">Flattens an Observable-of-Observables by dropping the
 * next inner Observables while the current inner is still executing.</span>
 *
 * <img src="./img/exhaust.png" width="100%">
 *
 * `exhaust` subscribes to an Observable that emits Observables, also known as a
 * higher-order Observable. Each time it observes one of these emitted inner
 * Observables, the output Observable begins emitting the items emitted by that
 * inner Observable. So far, it behaves like {@link mergeAll}. However,
 * `exhaust` ignores every new inner Observable if the previous Observable has
 * not yet completed. Once that one completes, it will accept and flatten the
 * next inner Observable and repeat this process.
 *
 * @example <caption>Run a finite timer for each click, only if there is no currently active timer</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var higherOrder = clicks.map((ev) => Rx.Observable.interval(1000).take(5));
 * var result = higherOrder.exhaust();
 * result.subscribe(x => console.log(x));
 *
 * @see {@link combineAll}
 * @see {@link concatAll}
 * @see {@link switch}
 * @see {@link mergeAll}
 * @see {@link exhaustMap}
 * @see {@link zipAll}
 *
 * @return {Observable} An Observable that takes a source of Observables and propagates the first observable
 * exclusively until it completes before subscribing to the next.
 * @method exhaust
 * @owner Observable
 */ function $97ef1e6c23a2f872$var$exhaust() {
    return function(source) {
        return source.lift(new $97ef1e6c23a2f872$var$SwitchFirstOperator());
    };
}
module.exports.exhaust = $97ef1e6c23a2f872$var$exhaust;
var $97ef1e6c23a2f872$var$SwitchFirstOperator = function() {
    function SwitchFirstOperator() {}
    SwitchFirstOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $97ef1e6c23a2f872$var$SwitchFirstSubscriber(subscriber));
    };
    return SwitchFirstOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $97ef1e6c23a2f872$var$SwitchFirstSubscriber = function(_super) {
    $97ef1e6c23a2f872$var$__extends(SwitchFirstSubscriber, _super);
    function SwitchFirstSubscriber(destination) {
        _super.call(this, destination);
        this.hasCompleted = false;
        this.hasSubscription = false;
    }
    SwitchFirstSubscriber.prototype._next = function(value) {
        if (!this.hasSubscription) {
            this.hasSubscription = true;
            this.add($dZ9AU.subscribeToResult(this, value));
        }
    };
    SwitchFirstSubscriber.prototype._complete = function() {
        this.hasCompleted = true;
        if (!this.hasSubscription) this.destination.complete();
    };
    SwitchFirstSubscriber.prototype.notifyComplete = function(innerSub) {
        this.remove(innerSub);
        this.hasSubscription = false;
        if (this.hasCompleted) this.destination.complete();
    };
    return SwitchFirstSubscriber;
}($iwB6M.OuterSubscriber);

});

parcelRegister("kjCE7", function(module, exports) {
"use strict";
var $eca38f4ecee3e3bf$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $iwB6M = parcelRequire("iwB6M");


var $dZ9AU = parcelRequire("dZ9AU");

/* tslint:enable:max-line-length */ /**
 * Projects each source value to an Observable which is merged in the output
 * Observable only if the previous projected Observable has completed.
 *
 * <span class="informal">Maps each value to an Observable, then flattens all of
 * these inner Observables using {@link exhaust}.</span>
 *
 * <img src="./img/exhaustMap.png" width="100%">
 *
 * Returns an Observable that emits items based on applying a function that you
 * supply to each item emitted by the source Observable, where that function
 * returns an (so-called "inner") Observable. When it projects a source value to
 * an Observable, the output Observable begins emitting the items emitted by
 * that projected Observable. However, `exhaustMap` ignores every new projected
 * Observable if the previous projected Observable has not yet completed. Once
 * that one completes, it will accept and flatten the next projected Observable
 * and repeat this process.
 *
 * @example <caption>Run a finite timer for each click, only if there is no currently active timer</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.exhaustMap((ev) => Rx.Observable.interval(1000).take(5));
 * result.subscribe(x => console.log(x));
 *
 * @see {@link concatMap}
 * @see {@link exhaust}
 * @see {@link mergeMap}
 * @see {@link switchMap}
 *
 * @param {function(value: T, ?index: number): ObservableInput} project A function
 * that, when applied to an item emitted by the source Observable, returns an
 * Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @return {Observable} An Observable containing projected Observables
 * of each item of the source, ignoring projected Observables that start before
 * their preceding Observable has completed.
 * @method exhaustMap
 * @owner Observable
 */ function $eca38f4ecee3e3bf$var$exhaustMap(project, resultSelector) {
    return function(source) {
        return source.lift(new $eca38f4ecee3e3bf$var$SwitchFirstMapOperator(project, resultSelector));
    };
}
module.exports.exhaustMap = $eca38f4ecee3e3bf$var$exhaustMap;
var $eca38f4ecee3e3bf$var$SwitchFirstMapOperator = function() {
    function SwitchFirstMapOperator(project, resultSelector) {
        this.project = project;
        this.resultSelector = resultSelector;
    }
    SwitchFirstMapOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $eca38f4ecee3e3bf$var$SwitchFirstMapSubscriber(subscriber, this.project, this.resultSelector));
    };
    return SwitchFirstMapOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $eca38f4ecee3e3bf$var$SwitchFirstMapSubscriber = function(_super) {
    $eca38f4ecee3e3bf$var$__extends(SwitchFirstMapSubscriber, _super);
    function SwitchFirstMapSubscriber(destination, project, resultSelector) {
        _super.call(this, destination);
        this.project = project;
        this.resultSelector = resultSelector;
        this.hasSubscription = false;
        this.hasCompleted = false;
        this.index = 0;
    }
    SwitchFirstMapSubscriber.prototype._next = function(value) {
        if (!this.hasSubscription) this.tryNext(value);
    };
    SwitchFirstMapSubscriber.prototype.tryNext = function(value) {
        var index = this.index++;
        var destination = this.destination;
        try {
            var result = this.project(value, index);
            this.hasSubscription = true;
            this.add($dZ9AU.subscribeToResult(this, result, value, index));
        } catch (err) {
            destination.error(err);
        }
    };
    SwitchFirstMapSubscriber.prototype._complete = function() {
        this.hasCompleted = true;
        if (!this.hasSubscription) this.destination.complete();
    };
    SwitchFirstMapSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        var _a = this, resultSelector = _a.resultSelector, destination = _a.destination;
        if (resultSelector) this.trySelectResult(outerValue, innerValue, outerIndex, innerIndex);
        else destination.next(innerValue);
    };
    SwitchFirstMapSubscriber.prototype.trySelectResult = function(outerValue, innerValue, outerIndex, innerIndex) {
        var _a = this, resultSelector = _a.resultSelector, destination = _a.destination;
        try {
            var result = resultSelector(outerValue, innerValue, outerIndex, innerIndex);
            destination.next(result);
        } catch (err) {
            destination.error(err);
        }
    };
    SwitchFirstMapSubscriber.prototype.notifyError = function(err) {
        this.destination.error(err);
    };
    SwitchFirstMapSubscriber.prototype.notifyComplete = function(innerSub) {
        this.remove(innerSub);
        this.hasSubscription = false;
        if (this.hasCompleted) this.destination.complete();
    };
    return SwitchFirstMapSubscriber;
}($iwB6M.OuterSubscriber);

});

parcelRegister("dbHcj", function(module, exports) {
"use strict";
var $999dcf9799c33e67$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $3FcLR = parcelRequire("3FcLR");


var $6LPWz = parcelRequire("6LPWz");


var $iwB6M = parcelRequire("iwB6M");


var $dZ9AU = parcelRequire("dZ9AU");

/* tslint:enable:max-line-length */ /**
 * Recursively projects each source value to an Observable which is merged in
 * the output Observable.
 *
 * <span class="informal">It's similar to {@link mergeMap}, but applies the
 * projection function to every source value as well as every output value.
 * It's recursive.</span>
 *
 * <img src="./img/expand.png" width="100%">
 *
 * Returns an Observable that emits items based on applying a function that you
 * supply to each item emitted by the source Observable, where that function
 * returns an Observable, and then merging those resulting Observables and
 * emitting the results of this merger. *Expand* will re-emit on the output
 * Observable every source value. Then, each output value is given to the
 * `project` function which returns an inner Observable to be merged on the
 * output Observable. Those output values resulting from the projection are also
 * given to the `project` function to produce new output values. This is how
 * *expand* behaves recursively.
 *
 * @example <caption>Start emitting the powers of two on every click, at most 10 of them</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var powersOfTwo = clicks
 *   .mapTo(1)
 *   .expand(x => Rx.Observable.of(2 * x).delay(1000))
 *   .take(10);
 * powersOfTwo.subscribe(x => console.log(x));
 *
 * @see {@link mergeMap}
 * @see {@link mergeScan}
 *
 * @param {function(value: T, index: number) => Observable} project A function
 * that, when applied to an item emitted by the source or the output Observable,
 * returns an Observable.
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
 * Observables being subscribed to concurrently.
 * @param {Scheduler} [scheduler=null] The IScheduler to use for subscribing to
 * each projected inner Observable.
 * @return {Observable} An Observable that emits the source values and also
 * result of applying the projection function to each value emitted on the
 * output Observable and and merging the results of the Observables obtained
 * from this transformation.
 * @method expand
 * @owner Observable
 */ function $999dcf9799c33e67$var$expand(project, concurrent, scheduler) {
    if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
    if (scheduler === void 0) scheduler = undefined;
    concurrent = (concurrent || 0) < 1 ? Number.POSITIVE_INFINITY : concurrent;
    return function(source) {
        return source.lift(new $999dcf9799c33e67$var$ExpandOperator(project, concurrent, scheduler));
    };
}
module.exports.expand = $999dcf9799c33e67$var$expand;
var $999dcf9799c33e67$var$ExpandOperator = function() {
    function ExpandOperator(project, concurrent, scheduler) {
        this.project = project;
        this.concurrent = concurrent;
        this.scheduler = scheduler;
    }
    ExpandOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $999dcf9799c33e67$var$ExpandSubscriber(subscriber, this.project, this.concurrent, this.scheduler));
    };
    return ExpandOperator;
}();
module.exports.ExpandOperator = $999dcf9799c33e67$var$ExpandOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $999dcf9799c33e67$var$ExpandSubscriber = function(_super) {
    $999dcf9799c33e67$var$__extends(ExpandSubscriber, _super);
    function ExpandSubscriber(destination, project, concurrent, scheduler) {
        _super.call(this, destination);
        this.project = project;
        this.concurrent = concurrent;
        this.scheduler = scheduler;
        this.index = 0;
        this.active = 0;
        this.hasCompleted = false;
        if (concurrent < Number.POSITIVE_INFINITY) this.buffer = [];
    }
    ExpandSubscriber.dispatch = function(arg) {
        var subscriber = arg.subscriber, result = arg.result, value = arg.value, index = arg.index;
        subscriber.subscribeToProjection(result, value, index);
    };
    ExpandSubscriber.prototype._next = function(value) {
        var destination = this.destination;
        if (destination.closed) {
            this._complete();
            return;
        }
        var index = this.index++;
        if (this.active < this.concurrent) {
            destination.next(value);
            var result = $3FcLR.tryCatch(this.project)(value, index);
            if (result === $6LPWz.errorObject) destination.error($6LPWz.errorObject.e);
            else if (!this.scheduler) this.subscribeToProjection(result, value, index);
            else {
                var state = {
                    subscriber: this,
                    result: result,
                    value: value,
                    index: index
                };
                this.add(this.scheduler.schedule(ExpandSubscriber.dispatch, 0, state));
            }
        } else this.buffer.push(value);
    };
    ExpandSubscriber.prototype.subscribeToProjection = function(result, value, index) {
        this.active++;
        this.add($dZ9AU.subscribeToResult(this, result, value, index));
    };
    ExpandSubscriber.prototype._complete = function() {
        this.hasCompleted = true;
        if (this.hasCompleted && this.active === 0) this.destination.complete();
    };
    ExpandSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this._next(innerValue);
    };
    ExpandSubscriber.prototype.notifyComplete = function(innerSub) {
        var buffer = this.buffer;
        this.remove(innerSub);
        this.active--;
        if (buffer && buffer.length > 0) this._next(buffer.shift());
        if (this.hasCompleted && this.active === 0) this.destination.complete();
    };
    return ExpandSubscriber;
}($iwB6M.OuterSubscriber);
module.exports.ExpandSubscriber = $999dcf9799c33e67$var$ExpandSubscriber;

});

parcelRegister("5JBQy", function(module, exports) {
"use strict";
var $42ce8344bc48e304$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $axeml = parcelRequire("axeml");


var $8v4h5 = parcelRequire("8v4h5");

/**
 * Returns an Observable that mirrors the source Observable, but will call a specified function when
 * the source terminates on complete or error.
 * @param {function} callback Function to be called when source terminates.
 * @return {Observable} An Observable that mirrors the source, but will call the specified function on termination.
 * @method finally
 * @owner Observable
 */ function $42ce8344bc48e304$var$finalize(callback) {
    return function(source) {
        return source.lift(new $42ce8344bc48e304$var$FinallyOperator(callback));
    };
}
module.exports.finalize = $42ce8344bc48e304$var$finalize;
var $42ce8344bc48e304$var$FinallyOperator = function() {
    function FinallyOperator(callback) {
        this.callback = callback;
    }
    FinallyOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $42ce8344bc48e304$var$FinallySubscriber(subscriber, this.callback));
    };
    return FinallyOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $42ce8344bc48e304$var$FinallySubscriber = function(_super) {
    $42ce8344bc48e304$var$__extends(FinallySubscriber, _super);
    function FinallySubscriber(destination, callback) {
        _super.call(this, destination);
        this.add(new $8v4h5.Subscription(callback));
    }
    return FinallySubscriber;
}($axeml.Subscriber);

});

parcelRegister("dUt6W", function(module, exports) {
"use strict";
var $a207162d322edc88$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $axeml = parcelRequire("axeml");

/**
 * Emits only the first value emitted by the source Observable that meets some
 * condition.
 *
 * <span class="informal">Finds the first value that passes some test and emits
 * that.</span>
 *
 * <img src="./img/find.png" width="100%">
 *
 * `find` searches for the first item in the source Observable that matches the
 * specified condition embodied by the `predicate`, and returns the first
 * occurrence in the source. Unlike {@link first}, the `predicate` is required
 * in `find`, and does not emit an error if a valid value is not found.
 *
 * @example <caption>Find and emit the first click that happens on a DIV element</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.find(ev => ev.target.tagName === 'DIV');
 * result.subscribe(x => console.log(x));
 *
 * @see {@link filter}
 * @see {@link first}
 * @see {@link findIndex}
 * @see {@link take}
 *
 * @param {function(value: T, index: number, source: Observable<T>): boolean} predicate
 * A function called with each item to test for condition matching.
 * @param {any} [thisArg] An optional argument to determine the value of `this`
 * in the `predicate` function.
 * @return {Observable<T>} An Observable of the first item that matches the
 * condition.
 * @method find
 * @owner Observable
 */ function $a207162d322edc88$var$find(predicate, thisArg) {
    if (typeof predicate !== 'function') throw new TypeError('predicate is not a function');
    return function(source) {
        return source.lift(new $a207162d322edc88$var$FindValueOperator(predicate, source, false, thisArg));
    };
}
module.exports.find = $a207162d322edc88$var$find;
var $a207162d322edc88$var$FindValueOperator = function() {
    function FindValueOperator(predicate, source, yieldIndex, thisArg) {
        this.predicate = predicate;
        this.source = source;
        this.yieldIndex = yieldIndex;
        this.thisArg = thisArg;
    }
    FindValueOperator.prototype.call = function(observer, source) {
        return source.subscribe(new $a207162d322edc88$var$FindValueSubscriber(observer, this.predicate, this.source, this.yieldIndex, this.thisArg));
    };
    return FindValueOperator;
}();
module.exports.FindValueOperator = $a207162d322edc88$var$FindValueOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $a207162d322edc88$var$FindValueSubscriber = function(_super) {
    $a207162d322edc88$var$__extends(FindValueSubscriber, _super);
    function FindValueSubscriber(destination, predicate, source, yieldIndex, thisArg) {
        _super.call(this, destination);
        this.predicate = predicate;
        this.source = source;
        this.yieldIndex = yieldIndex;
        this.thisArg = thisArg;
        this.index = 0;
    }
    FindValueSubscriber.prototype.notifyComplete = function(value) {
        var destination = this.destination;
        destination.next(value);
        destination.complete();
    };
    FindValueSubscriber.prototype._next = function(value) {
        var _a = this, predicate = _a.predicate, thisArg = _a.thisArg;
        var index = this.index++;
        try {
            var result = predicate.call(thisArg || this, value, index, this.source);
            if (result) this.notifyComplete(this.yieldIndex ? index : value);
        } catch (err) {
            this.destination.error(err);
        }
    };
    FindValueSubscriber.prototype._complete = function() {
        this.notifyComplete(this.yieldIndex ? -1 : undefined);
    };
    return FindValueSubscriber;
}($axeml.Subscriber);
module.exports.FindValueSubscriber = $a207162d322edc88$var$FindValueSubscriber;

});

parcelRegister("iVKw6", function(module, exports) {
"use strict";
var $dc81a225d9d64229$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $axeml = parcelRequire("axeml");


var $3X9I5 = parcelRequire("3X9I5");

/**
 * Emits only the first value (or the first value that meets some condition)
 * emitted by the source Observable.
 *
 * <span class="informal">Emits only the first value. Or emits only the first
 * value that passes some test.</span>
 *
 * <img src="./img/first.png" width="100%">
 *
 * If called with no arguments, `first` emits the first value of the source
 * Observable, then completes. If called with a `predicate` function, `first`
 * emits the first value of the source that matches the specified condition. It
 * may also take a `resultSelector` function to produce the output value from
 * the input value, and a `defaultValue` to emit in case the source completes
 * before it is able to emit a valid value. Throws an error if `defaultValue`
 * was not provided and a matching element is not found.
 *
 * @example <caption>Emit only the first click that happens on the DOM</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.first();
 * result.subscribe(x => console.log(x));
 *
 * @example <caption>Emits the first click that happens on a DIV</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.first(ev => ev.target.tagName === 'DIV');
 * result.subscribe(x => console.log(x));
 *
 * @see {@link filter}
 * @see {@link find}
 * @see {@link take}
 *
 * @throws {EmptyError} Delivers an EmptyError to the Observer's `error`
 * callback if the Observable completes before any `next` notification was sent.
 *
 * @param {function(value: T, index: number, source: Observable<T>): boolean} [predicate]
 * An optional function called with each item to test for condition matching.
 * @param {function(value: T, index: number): R} [resultSelector] A function to
 * produce the value on the output Observable based on the values
 * and the indices of the source Observable. The arguments passed to this
 * function are:
 * - `value`: the value that was emitted on the source.
 * - `index`: the "index" of the value from the source.
 * @param {R} [defaultValue] The default value emitted in case no valid value
 * was found on the source.
 * @return {Observable<T|R>} An Observable of the first item that matches the
 * condition.
 * @method first
 * @owner Observable
 */ function $dc81a225d9d64229$var$first(predicate, resultSelector, defaultValue) {
    return function(source) {
        return source.lift(new $dc81a225d9d64229$var$FirstOperator(predicate, resultSelector, defaultValue, source));
    };
}
module.exports.first = $dc81a225d9d64229$var$first;
var $dc81a225d9d64229$var$FirstOperator = function() {
    function FirstOperator(predicate, resultSelector, defaultValue, source) {
        this.predicate = predicate;
        this.resultSelector = resultSelector;
        this.defaultValue = defaultValue;
        this.source = source;
    }
    FirstOperator.prototype.call = function(observer, source) {
        return source.subscribe(new $dc81a225d9d64229$var$FirstSubscriber(observer, this.predicate, this.resultSelector, this.defaultValue, this.source));
    };
    return FirstOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $dc81a225d9d64229$var$FirstSubscriber = function(_super) {
    $dc81a225d9d64229$var$__extends(FirstSubscriber, _super);
    function FirstSubscriber(destination, predicate, resultSelector, defaultValue, source) {
        _super.call(this, destination);
        this.predicate = predicate;
        this.resultSelector = resultSelector;
        this.defaultValue = defaultValue;
        this.source = source;
        this.index = 0;
        this.hasCompleted = false;
        this._emitted = false;
    }
    FirstSubscriber.prototype._next = function(value) {
        var index = this.index++;
        if (this.predicate) this._tryPredicate(value, index);
        else this._emit(value, index);
    };
    FirstSubscriber.prototype._tryPredicate = function(value, index) {
        var result;
        try {
            result = this.predicate(value, index, this.source);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        if (result) this._emit(value, index);
    };
    FirstSubscriber.prototype._emit = function(value, index) {
        if (this.resultSelector) {
            this._tryResultSelector(value, index);
            return;
        }
        this._emitFinal(value);
    };
    FirstSubscriber.prototype._tryResultSelector = function(value, index) {
        var result;
        try {
            result = this.resultSelector(value, index);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        this._emitFinal(result);
    };
    FirstSubscriber.prototype._emitFinal = function(value) {
        var destination = this.destination;
        if (!this._emitted) {
            this._emitted = true;
            destination.next(value);
            destination.complete();
            this.hasCompleted = true;
        }
    };
    FirstSubscriber.prototype._complete = function() {
        var destination = this.destination;
        if (!this.hasCompleted && typeof this.defaultValue !== 'undefined') {
            destination.next(this.defaultValue);
            destination.complete();
        } else if (!this.hasCompleted) destination.error(new $3X9I5.EmptyError);
    };
    return FirstSubscriber;
}($axeml.Subscriber);

});

parcelRegister("6sXAX", function(module, exports) {
"use strict";
var $4b5395ed11b5c8d6$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $axeml = parcelRequire("axeml");


var $8v4h5 = parcelRequire("8v4h5");


var $YgydF = parcelRequire("YgydF");


var $augeV = parcelRequire("augeV");

var $5fc1e10afd4e32d7$export$a5c7b93649eaf8f8;
"use strict";

var $4iRIL = parcelRequire("4iRIL");

var $eebf2f0ff6469564$export$dd450425f6b4a07;
"use strict";
var $eebf2f0ff6469564$var$MapPolyfill = function() {
    function MapPolyfill() {
        this.size = 0;
        this._values = [];
        this._keys = [];
    }
    MapPolyfill.prototype.get = function(key) {
        var i = this._keys.indexOf(key);
        return i === -1 ? undefined : this._values[i];
    };
    MapPolyfill.prototype.set = function(key, value) {
        var i = this._keys.indexOf(key);
        if (i === -1) {
            this._keys.push(key);
            this._values.push(value);
            this.size++;
        } else this._values[i] = value;
        return this;
    };
    MapPolyfill.prototype.delete = function(key) {
        var i = this._keys.indexOf(key);
        if (i === -1) return false;
        this._values.splice(i, 1);
        this._keys.splice(i, 1);
        this.size--;
        return true;
    };
    MapPolyfill.prototype.clear = function() {
        this._keys.length = 0;
        this._values.length = 0;
        this.size = 0;
    };
    MapPolyfill.prototype.forEach = function(cb, thisArg) {
        for(var i = 0; i < this.size; i++)cb.call(thisArg, this._values[i], this._keys[i]);
    };
    return MapPolyfill;
}();
$eebf2f0ff6469564$export$dd450425f6b4a07 = $eebf2f0ff6469564$var$MapPolyfill;


$5fc1e10afd4e32d7$export$a5c7b93649eaf8f8 = $4iRIL.root.Map || function() {
    return $eebf2f0ff6469564$export$dd450425f6b4a07;
}();


var $cf48927dd2f0e858$export$d3f0a24774bb4055;
"use strict";
var $cf48927dd2f0e858$var$FastMap = function() {
    function FastMap() {
        this.values = {};
    }
    FastMap.prototype.delete = function(key) {
        this.values[key] = null;
        return true;
    };
    FastMap.prototype.set = function(key, value) {
        this.values[key] = value;
        return this;
    };
    FastMap.prototype.get = function(key) {
        return this.values[key];
    };
    FastMap.prototype.forEach = function(cb, thisArg) {
        var values = this.values;
        for(var key in values)if (values.hasOwnProperty(key) && values[key] !== null) cb.call(thisArg, values[key], key);
    };
    FastMap.prototype.clear = function() {
        this.values = {};
    };
    return FastMap;
}();
$cf48927dd2f0e858$export$d3f0a24774bb4055 = $cf48927dd2f0e858$var$FastMap;


/* tslint:enable:max-line-length */ /**
 * Groups the items emitted by an Observable according to a specified criterion,
 * and emits these grouped items as `GroupedObservables`, one
 * {@link GroupedObservable} per group.
 *
 * <img src="./img/groupBy.png" width="100%">
 *
 * @example <caption>Group objects by id and return as array</caption>
 * Observable.of<Obj>({id: 1, name: 'aze1'},
 *                    {id: 2, name: 'sf2'},
 *                    {id: 2, name: 'dg2'},
 *                    {id: 1, name: 'erg1'},
 *                    {id: 1, name: 'df1'},
 *                    {id: 2, name: 'sfqfb2'},
 *                    {id: 3, name: 'qfs3'},
 *                    {id: 2, name: 'qsgqsfg2'}
 *     )
 *     .groupBy(p => p.id)
 *     .flatMap( (group$) => group$.reduce((acc, cur) => [...acc, cur], []))
 *     .subscribe(p => console.log(p));
 *
 * // displays:
 * // [ { id: 1, name: 'aze1' },
 * //   { id: 1, name: 'erg1' },
 * //   { id: 1, name: 'df1' } ]
 * //
 * // [ { id: 2, name: 'sf2' },
 * //   { id: 2, name: 'dg2' },
 * //   { id: 2, name: 'sfqfb2' },
 * //   { id: 2, name: 'qsgqsfg2' } ]
 * //
 * // [ { id: 3, name: 'qfs3' } ]
 *
 * @example <caption>Pivot data on the id field</caption>
 * Observable.of<Obj>({id: 1, name: 'aze1'},
 *                    {id: 2, name: 'sf2'},
 *                    {id: 2, name: 'dg2'},
 *                    {id: 1, name: 'erg1'},
 *                    {id: 1, name: 'df1'},
 *                    {id: 2, name: 'sfqfb2'},
 *                    {id: 3, name: 'qfs1'},
 *                    {id: 2, name: 'qsgqsfg2'}
 *                   )
 *     .groupBy(p => p.id, p => p.name)
 *     .flatMap( (group$) => group$.reduce((acc, cur) => [...acc, cur], ["" + group$.key]))
 *     .map(arr => ({'id': parseInt(arr[0]), 'values': arr.slice(1)}))
 *     .subscribe(p => console.log(p));
 *
 * // displays:
 * // { id: 1, values: [ 'aze1', 'erg1', 'df1' ] }
 * // { id: 2, values: [ 'sf2', 'dg2', 'sfqfb2', 'qsgqsfg2' ] }
 * // { id: 3, values: [ 'qfs1' ] }
 *
 * @param {function(value: T): K} keySelector A function that extracts the key
 * for each item.
 * @param {function(value: T): R} [elementSelector] A function that extracts the
 * return element for each item.
 * @param {function(grouped: GroupedObservable<K,R>): Observable<any>} [durationSelector]
 * A function that returns an Observable to determine how long each group should
 * exist.
 * @return {Observable<GroupedObservable<K,R>>} An Observable that emits
 * GroupedObservables, each of which corresponds to a unique key value and each
 * of which emits those items from the source Observable that share that key
 * value.
 * @method groupBy
 * @owner Observable
 */ function $4b5395ed11b5c8d6$var$groupBy(keySelector, elementSelector, durationSelector, subjectSelector) {
    return function(source) {
        return source.lift(new $4b5395ed11b5c8d6$var$GroupByOperator(keySelector, elementSelector, durationSelector, subjectSelector));
    };
}
module.exports.groupBy = $4b5395ed11b5c8d6$var$groupBy;
var $4b5395ed11b5c8d6$var$GroupByOperator = function() {
    function GroupByOperator(keySelector, elementSelector, durationSelector, subjectSelector) {
        this.keySelector = keySelector;
        this.elementSelector = elementSelector;
        this.durationSelector = durationSelector;
        this.subjectSelector = subjectSelector;
    }
    GroupByOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $4b5395ed11b5c8d6$var$GroupBySubscriber(subscriber, this.keySelector, this.elementSelector, this.durationSelector, this.subjectSelector));
    };
    return GroupByOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $4b5395ed11b5c8d6$var$GroupBySubscriber = function(_super) {
    $4b5395ed11b5c8d6$var$__extends(GroupBySubscriber, _super);
    function GroupBySubscriber(destination, keySelector, elementSelector, durationSelector, subjectSelector) {
        _super.call(this, destination);
        this.keySelector = keySelector;
        this.elementSelector = elementSelector;
        this.durationSelector = durationSelector;
        this.subjectSelector = subjectSelector;
        this.groups = null;
        this.attemptedToUnsubscribe = false;
        this.count = 0;
    }
    GroupBySubscriber.prototype._next = function(value) {
        var key;
        try {
            key = this.keySelector(value);
        } catch (err) {
            this.error(err);
            return;
        }
        this._group(value, key);
    };
    GroupBySubscriber.prototype._group = function(value, key) {
        var groups = this.groups;
        if (!groups) groups = this.groups = typeof key === 'string' ? new $cf48927dd2f0e858$export$d3f0a24774bb4055() : new $5fc1e10afd4e32d7$export$a5c7b93649eaf8f8();
        var group = groups.get(key);
        var element;
        if (this.elementSelector) try {
            element = this.elementSelector(value);
        } catch (err) {
            this.error(err);
        }
        else element = value;
        if (!group) {
            group = this.subjectSelector ? this.subjectSelector() : new $augeV.Subject();
            groups.set(key, group);
            var groupedObservable = new $4b5395ed11b5c8d6$var$GroupedObservable(key, group, this);
            this.destination.next(groupedObservable);
            if (this.durationSelector) {
                var duration = void 0;
                try {
                    duration = this.durationSelector(new $4b5395ed11b5c8d6$var$GroupedObservable(key, group));
                } catch (err) {
                    this.error(err);
                    return;
                }
                this.add(duration.subscribe(new $4b5395ed11b5c8d6$var$GroupDurationSubscriber(key, group, this)));
            }
        }
        if (!group.closed) group.next(element);
    };
    GroupBySubscriber.prototype._error = function(err) {
        var groups = this.groups;
        if (groups) {
            groups.forEach(function(group, key) {
                group.error(err);
            });
            groups.clear();
        }
        this.destination.error(err);
    };
    GroupBySubscriber.prototype._complete = function() {
        var groups = this.groups;
        if (groups) {
            groups.forEach(function(group, key) {
                group.complete();
            });
            groups.clear();
        }
        this.destination.complete();
    };
    GroupBySubscriber.prototype.removeGroup = function(key) {
        this.groups.delete(key);
    };
    GroupBySubscriber.prototype.unsubscribe = function() {
        if (!this.closed) {
            this.attemptedToUnsubscribe = true;
            if (this.count === 0) _super.prototype.unsubscribe.call(this);
        }
    };
    return GroupBySubscriber;
}($axeml.Subscriber);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $4b5395ed11b5c8d6$var$GroupDurationSubscriber = function(_super) {
    $4b5395ed11b5c8d6$var$__extends(GroupDurationSubscriber, _super);
    function GroupDurationSubscriber(key, group, parent) {
        _super.call(this, group);
        this.key = key;
        this.group = group;
        this.parent = parent;
    }
    GroupDurationSubscriber.prototype._next = function(value) {
        this.complete();
    };
    /** @deprecated internal use only */ GroupDurationSubscriber.prototype._unsubscribe = function() {
        var _a = this, parent = _a.parent, key = _a.key;
        this.key = this.parent = null;
        if (parent) parent.removeGroup(key);
    };
    return GroupDurationSubscriber;
}($axeml.Subscriber);
/**
 * An Observable representing values belonging to the same group represented by
 * a common key. The values emitted by a GroupedObservable come from the source
 * Observable. The common key is available as the field `key` on a
 * GroupedObservable instance.
 *
 * @class GroupedObservable<K, T>
 */ var $4b5395ed11b5c8d6$var$GroupedObservable = function(_super) {
    $4b5395ed11b5c8d6$var$__extends(GroupedObservable, _super);
    function GroupedObservable(key, groupSubject, refCountSubscription) {
        _super.call(this);
        this.key = key;
        this.groupSubject = groupSubject;
        this.refCountSubscription = refCountSubscription;
    }
    /** @deprecated internal use only */ GroupedObservable.prototype._subscribe = function(subscriber) {
        var subscription = new $8v4h5.Subscription();
        var _a = this, refCountSubscription = _a.refCountSubscription, groupSubject = _a.groupSubject;
        if (refCountSubscription && !refCountSubscription.closed) subscription.add(new $4b5395ed11b5c8d6$var$InnerRefCountSubscription(refCountSubscription));
        subscription.add(groupSubject.subscribe(subscriber));
        return subscription;
    };
    return GroupedObservable;
}($YgydF.Observable);
module.exports.GroupedObservable = $4b5395ed11b5c8d6$var$GroupedObservable;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $4b5395ed11b5c8d6$var$InnerRefCountSubscription = function(_super) {
    $4b5395ed11b5c8d6$var$__extends(InnerRefCountSubscription, _super);
    function InnerRefCountSubscription(parent) {
        _super.call(this);
        this.parent = parent;
        parent.count++;
    }
    InnerRefCountSubscription.prototype.unsubscribe = function() {
        var parent = this.parent;
        if (!parent.closed && !this.closed) {
            _super.prototype.unsubscribe.call(this);
            parent.count -= 1;
            if (parent.count === 0 && parent.attemptedToUnsubscribe) parent.unsubscribe();
        }
    };
    return InnerRefCountSubscription;
}($8v4h5.Subscription);

});

parcelRegister("3WLBy", function(module, exports) {
"use strict";
var $2dfbb72c0d57d5e2$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $axeml = parcelRequire("axeml");


var $6qxzH = parcelRequire("6qxzH");

/**
 * Ignores all items emitted by the source Observable and only passes calls of `complete` or `error`.
 *
 * <img src="./img/ignoreElements.png" width="100%">
 *
 * @return {Observable} An empty Observable that only calls `complete`
 * or `error`, based on which one is called by the source Observable.
 * @method ignoreElements
 * @owner Observable
 */ function $2dfbb72c0d57d5e2$var$ignoreElements() {
    return function ignoreElementsOperatorFunction(source) {
        return source.lift(new $2dfbb72c0d57d5e2$var$IgnoreElementsOperator());
    };
}
module.exports.ignoreElements = $2dfbb72c0d57d5e2$var$ignoreElements;
var $2dfbb72c0d57d5e2$var$IgnoreElementsOperator = function() {
    function IgnoreElementsOperator() {}
    IgnoreElementsOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $2dfbb72c0d57d5e2$var$IgnoreElementsSubscriber(subscriber));
    };
    return IgnoreElementsOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $2dfbb72c0d57d5e2$var$IgnoreElementsSubscriber = function(_super) {
    $2dfbb72c0d57d5e2$var$__extends(IgnoreElementsSubscriber, _super);
    function IgnoreElementsSubscriber() {
        _super.apply(this, arguments);
    }
    IgnoreElementsSubscriber.prototype._next = function(unused) {
        $6qxzH.noop();
    };
    return IgnoreElementsSubscriber;
}($axeml.Subscriber);

});

parcelRegister("6FTyv", function(module, exports) {
"use strict";
var $4dc1aa942df3ab91$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $axeml = parcelRequire("axeml");

function $4dc1aa942df3ab91$var$isEmpty() {
    return function(source) {
        return source.lift(new $4dc1aa942df3ab91$var$IsEmptyOperator());
    };
}
module.exports.isEmpty = $4dc1aa942df3ab91$var$isEmpty;
var $4dc1aa942df3ab91$var$IsEmptyOperator = function() {
    function IsEmptyOperator() {}
    IsEmptyOperator.prototype.call = function(observer, source) {
        return source.subscribe(new $4dc1aa942df3ab91$var$IsEmptySubscriber(observer));
    };
    return IsEmptyOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $4dc1aa942df3ab91$var$IsEmptySubscriber = function(_super) {
    $4dc1aa942df3ab91$var$__extends(IsEmptySubscriber, _super);
    function IsEmptySubscriber(destination) {
        _super.call(this, destination);
    }
    IsEmptySubscriber.prototype.notifyComplete = function(isEmpty) {
        var destination = this.destination;
        destination.next(isEmpty);
        destination.complete();
    };
    IsEmptySubscriber.prototype._next = function(value) {
        this.notifyComplete(false);
    };
    IsEmptySubscriber.prototype._complete = function() {
        this.notifyComplete(true);
    };
    return IsEmptySubscriber;
}($axeml.Subscriber);

});

parcelRegister("bOaaj", function(module, exports) {
"use strict";
var $898c3fda25491493$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $axeml = parcelRequire("axeml");


var $3X9I5 = parcelRequire("3X9I5");

/* tslint:enable:max-line-length */ /**
 * Returns an Observable that emits only the last item emitted by the source Observable.
 * It optionally takes a predicate function as a parameter, in which case, rather than emitting
 * the last item from the source Observable, the resulting Observable will emit the last item
 * from the source Observable that satisfies the predicate.
 *
 * <img src="./img/last.png" width="100%">
 *
 * @throws {EmptyError} Delivers an EmptyError to the Observer's `error`
 * callback if the Observable completes before any `next` notification was sent.
 * @param {function} predicate - The condition any source emitted item has to satisfy.
 * @return {Observable} An Observable that emits only the last item satisfying the given condition
 * from the source, or an NoSuchElementException if no such items are emitted.
 * @throws - Throws if no items that match the predicate are emitted by the source Observable.
 * @method last
 * @owner Observable
 */ function $898c3fda25491493$var$last(predicate, resultSelector, defaultValue) {
    return function(source) {
        return source.lift(new $898c3fda25491493$var$LastOperator(predicate, resultSelector, defaultValue, source));
    };
}
module.exports.last = $898c3fda25491493$var$last;
var $898c3fda25491493$var$LastOperator = function() {
    function LastOperator(predicate, resultSelector, defaultValue, source) {
        this.predicate = predicate;
        this.resultSelector = resultSelector;
        this.defaultValue = defaultValue;
        this.source = source;
    }
    LastOperator.prototype.call = function(observer, source) {
        return source.subscribe(new $898c3fda25491493$var$LastSubscriber(observer, this.predicate, this.resultSelector, this.defaultValue, this.source));
    };
    return LastOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $898c3fda25491493$var$LastSubscriber = function(_super) {
    $898c3fda25491493$var$__extends(LastSubscriber, _super);
    function LastSubscriber(destination, predicate, resultSelector, defaultValue, source) {
        _super.call(this, destination);
        this.predicate = predicate;
        this.resultSelector = resultSelector;
        this.defaultValue = defaultValue;
        this.source = source;
        this.hasValue = false;
        this.index = 0;
        if (typeof defaultValue !== 'undefined') {
            this.lastValue = defaultValue;
            this.hasValue = true;
        }
    }
    LastSubscriber.prototype._next = function(value) {
        var index = this.index++;
        if (this.predicate) this._tryPredicate(value, index);
        else {
            if (this.resultSelector) {
                this._tryResultSelector(value, index);
                return;
            }
            this.lastValue = value;
            this.hasValue = true;
        }
    };
    LastSubscriber.prototype._tryPredicate = function(value, index) {
        var result;
        try {
            result = this.predicate(value, index, this.source);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        if (result) {
            if (this.resultSelector) {
                this._tryResultSelector(value, index);
                return;
            }
            this.lastValue = value;
            this.hasValue = true;
        }
    };
    LastSubscriber.prototype._tryResultSelector = function(value, index) {
        var result;
        try {
            result = this.resultSelector(value, index);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        this.lastValue = result;
        this.hasValue = true;
    };
    LastSubscriber.prototype._complete = function() {
        var destination = this.destination;
        if (this.hasValue) {
            destination.next(this.lastValue);
            destination.complete();
        } else destination.error(new $3X9I5.EmptyError);
    };
    return LastSubscriber;
}($axeml.Subscriber);

});

parcelRegister("dsb2s", function(module, exports) {
"use strict";
var $9cb673eb697ddfca$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $axeml = parcelRequire("axeml");

/**
 * Emits the given constant value on the output Observable every time the source
 * Observable emits a value.
 *
 * <span class="informal">Like {@link map}, but it maps every source value to
 * the same output value every time.</span>
 *
 * <img src="./img/mapTo.png" width="100%">
 *
 * Takes a constant `value` as argument, and emits that whenever the source
 * Observable emits a value. In other words, ignores the actual source value,
 * and simply uses the emission moment to know when to emit the given `value`.
 *
 * @example <caption>Map every click to the string 'Hi'</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var greetings = clicks.mapTo('Hi');
 * greetings.subscribe(x => console.log(x));
 *
 * @see {@link map}
 *
 * @param {any} value The value to map each source value to.
 * @return {Observable} An Observable that emits the given `value` every time
 * the source Observable emits something.
 * @method mapTo
 * @owner Observable
 */ function $9cb673eb697ddfca$var$mapTo(value) {
    return function(source) {
        return source.lift(new $9cb673eb697ddfca$var$MapToOperator(value));
    };
}
module.exports.mapTo = $9cb673eb697ddfca$var$mapTo;
var $9cb673eb697ddfca$var$MapToOperator = function() {
    function MapToOperator(value) {
        this.value = value;
    }
    MapToOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $9cb673eb697ddfca$var$MapToSubscriber(subscriber, this.value));
    };
    return MapToOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $9cb673eb697ddfca$var$MapToSubscriber = function(_super) {
    $9cb673eb697ddfca$var$__extends(MapToSubscriber, _super);
    function MapToSubscriber(destination, value) {
        _super.call(this, destination);
        this.value = value;
    }
    MapToSubscriber.prototype._next = function(x) {
        this.destination.next(this.value);
    };
    return MapToSubscriber;
}($axeml.Subscriber);

});

parcelRegister("b5JJ1", function(module, exports) {
"use strict";
var $8133a16758384b80$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $axeml = parcelRequire("axeml");


var $6j5QO = parcelRequire("6j5QO");

/**
 * Represents all of the notifications from the source Observable as `next`
 * emissions marked with their original types within {@link Notification}
 * objects.
 *
 * <span class="informal">Wraps `next`, `error` and `complete` emissions in
 * {@link Notification} objects, emitted as `next` on the output Observable.
 * </span>
 *
 * <img src="./img/materialize.png" width="100%">
 *
 * `materialize` returns an Observable that emits a `next` notification for each
 * `next`, `error`, or `complete` emission of the source Observable. When the
 * source Observable emits `complete`, the output Observable will emit `next` as
 * a Notification of type "complete", and then it will emit `complete` as well.
 * When the source Observable emits `error`, the output will emit `next` as a
 * Notification of type "error", and then `complete`.
 *
 * This operator is useful for producing metadata of the source Observable, to
 * be consumed as `next` emissions. Use it in conjunction with
 * {@link dematerialize}.
 *
 * @example <caption>Convert a faulty Observable to an Observable of Notifications</caption>
 * var letters = Rx.Observable.of('a', 'b', 13, 'd');
 * var upperCase = letters.map(x => x.toUpperCase());
 * var materialized = upperCase.materialize();
 * materialized.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // - Notification {kind: "N", value: "A", error: undefined, hasValue: true}
 * // - Notification {kind: "N", value: "B", error: undefined, hasValue: true}
 * // - Notification {kind: "E", value: undefined, error: TypeError:
 * //   x.toUpperCase is not a function at MapSubscriber.letters.map.x
 * //   [as project] (http://1…, hasValue: false}
 *
 * @see {@link Notification}
 * @see {@link dematerialize}
 *
 * @return {Observable<Notification<T>>} An Observable that emits
 * {@link Notification} objects that wrap the original emissions from the source
 * Observable with metadata.
 * @method materialize
 * @owner Observable
 */ function $8133a16758384b80$var$materialize() {
    return function materializeOperatorFunction(source) {
        return source.lift(new $8133a16758384b80$var$MaterializeOperator());
    };
}
module.exports.materialize = $8133a16758384b80$var$materialize;
var $8133a16758384b80$var$MaterializeOperator = function() {
    function MaterializeOperator() {}
    MaterializeOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $8133a16758384b80$var$MaterializeSubscriber(subscriber));
    };
    return MaterializeOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $8133a16758384b80$var$MaterializeSubscriber = function(_super) {
    $8133a16758384b80$var$__extends(MaterializeSubscriber, _super);
    function MaterializeSubscriber(destination) {
        _super.call(this, destination);
    }
    MaterializeSubscriber.prototype._next = function(value) {
        this.destination.next($6j5QO.Notification.createNext(value));
    };
    MaterializeSubscriber.prototype._error = function(err) {
        var destination = this.destination;
        destination.next($6j5QO.Notification.createError(err));
        destination.complete();
    };
    MaterializeSubscriber.prototype._complete = function() {
        var destination = this.destination;
        destination.next($6j5QO.Notification.createComplete());
        destination.complete();
    };
    return MaterializeSubscriber;
}($axeml.Subscriber);

});

parcelRegister("btvNM", function(module, exports) {
"use strict";
var $85ab125358105968$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $iwB6M = parcelRequire("iwB6M");


var $dZ9AU = parcelRequire("dZ9AU");

/* tslint:enable:max-line-length */ /**
 * Projects each source value to the same Observable which is merged multiple
 * times in the output Observable.
 *
 * <span class="informal">It's like {@link mergeMap}, but maps each value always
 * to the same inner Observable.</span>
 *
 * <img src="./img/mergeMapTo.png" width="100%">
 *
 * Maps each source value to the given Observable `innerObservable` regardless
 * of the source value, and then merges those resulting Observables into one
 * single Observable, which is the output Observable.
 *
 * @example <caption>For each click event, start an interval Observable ticking every 1 second</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.mergeMapTo(Rx.Observable.interval(1000));
 * result.subscribe(x => console.log(x));
 *
 * @see {@link concatMapTo}
 * @see {@link merge}
 * @see {@link mergeAll}
 * @see {@link mergeMap}
 * @see {@link mergeScan}
 * @see {@link switchMapTo}
 *
 * @param {ObservableInput} innerObservable An Observable to replace each value from
 * the source Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
 * Observables being subscribed to concurrently.
 * @return {Observable} An Observable that emits items from the given
 * `innerObservable` (and optionally transformed through `resultSelector`) every
 * time a value is emitted on the source Observable.
 * @method mergeMapTo
 * @owner Observable
 */ function $85ab125358105968$var$mergeMapTo(innerObservable, resultSelector, concurrent) {
    if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
    if (typeof resultSelector === 'number') {
        concurrent = resultSelector;
        resultSelector = null;
    }
    return function(source) {
        return source.lift(new $85ab125358105968$var$MergeMapToOperator(innerObservable, resultSelector, concurrent));
    };
}
module.exports.mergeMapTo = $85ab125358105968$var$mergeMapTo;
// TODO: Figure out correct signature here: an Operator<Observable<T>, R>
//       needs to implement call(observer: Subscriber<R>): Subscriber<Observable<T>>
var $85ab125358105968$var$MergeMapToOperator = function() {
    function MergeMapToOperator(ish, resultSelector, concurrent) {
        if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
        this.ish = ish;
        this.resultSelector = resultSelector;
        this.concurrent = concurrent;
    }
    MergeMapToOperator.prototype.call = function(observer, source) {
        return source.subscribe(new $85ab125358105968$var$MergeMapToSubscriber(observer, this.ish, this.resultSelector, this.concurrent));
    };
    return MergeMapToOperator;
}();
module.exports.MergeMapToOperator = $85ab125358105968$var$MergeMapToOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $85ab125358105968$var$MergeMapToSubscriber = function(_super) {
    $85ab125358105968$var$__extends(MergeMapToSubscriber, _super);
    function MergeMapToSubscriber(destination, ish, resultSelector, concurrent) {
        if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
        _super.call(this, destination);
        this.ish = ish;
        this.resultSelector = resultSelector;
        this.concurrent = concurrent;
        this.hasCompleted = false;
        this.buffer = [];
        this.active = 0;
        this.index = 0;
    }
    MergeMapToSubscriber.prototype._next = function(value) {
        if (this.active < this.concurrent) {
            var resultSelector = this.resultSelector;
            var index = this.index++;
            var ish = this.ish;
            var destination = this.destination;
            this.active++;
            this._innerSub(ish, destination, resultSelector, value, index);
        } else this.buffer.push(value);
    };
    MergeMapToSubscriber.prototype._innerSub = function(ish, destination, resultSelector, value, index) {
        this.add($dZ9AU.subscribeToResult(this, ish, value, index));
    };
    MergeMapToSubscriber.prototype._complete = function() {
        this.hasCompleted = true;
        if (this.active === 0 && this.buffer.length === 0) this.destination.complete();
    };
    MergeMapToSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        var _a = this, resultSelector = _a.resultSelector, destination = _a.destination;
        if (resultSelector) this.trySelectResult(outerValue, innerValue, outerIndex, innerIndex);
        else destination.next(innerValue);
    };
    MergeMapToSubscriber.prototype.trySelectResult = function(outerValue, innerValue, outerIndex, innerIndex) {
        var _a = this, resultSelector = _a.resultSelector, destination = _a.destination;
        var result;
        try {
            result = resultSelector(outerValue, innerValue, outerIndex, innerIndex);
        } catch (err) {
            destination.error(err);
            return;
        }
        destination.next(result);
    };
    MergeMapToSubscriber.prototype.notifyError = function(err) {
        this.destination.error(err);
    };
    MergeMapToSubscriber.prototype.notifyComplete = function(innerSub) {
        var buffer = this.buffer;
        this.remove(innerSub);
        this.active--;
        if (buffer.length > 0) this._next(buffer.shift());
        else if (this.active === 0 && this.hasCompleted) this.destination.complete();
    };
    return MergeMapToSubscriber;
}($iwB6M.OuterSubscriber);
module.exports.MergeMapToSubscriber = $85ab125358105968$var$MergeMapToSubscriber;

});

parcelRegister("8fVz5", function(module, exports) {
"use strict";
var $602c60a2f550ced8$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $3FcLR = parcelRequire("3FcLR");


var $6LPWz = parcelRequire("6LPWz");


var $dZ9AU = parcelRequire("dZ9AU");


var $iwB6M = parcelRequire("iwB6M");

/**
 * Applies an accumulator function over the source Observable where the
 * accumulator function itself returns an Observable, then each intermediate
 * Observable returned is merged into the output Observable.
 *
 * <span class="informal">It's like {@link scan}, but the Observables returned
 * by the accumulator are merged into the outer Observable.</span>
 *
 * @example <caption>Count the number of click events</caption>
 * const click$ = Rx.Observable.fromEvent(document, 'click');
 * const one$ = click$.mapTo(1);
 * const seed = 0;
 * const count$ = one$.mergeScan((acc, one) => Rx.Observable.of(acc + one), seed);
 * count$.subscribe(x => console.log(x));
 *
 * // Results:
 * 1
 * 2
 * 3
 * 4
 * // ...and so on for each click
 *
 * @param {function(acc: R, value: T): Observable<R>} accumulator
 * The accumulator function called on each source value.
 * @param seed The initial accumulation value.
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of
 * input Observables being subscribed to concurrently.
 * @return {Observable<R>} An observable of the accumulated values.
 * @method mergeScan
 * @owner Observable
 */ function $602c60a2f550ced8$var$mergeScan(accumulator, seed, concurrent) {
    if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
    return function(source) {
        return source.lift(new $602c60a2f550ced8$var$MergeScanOperator(accumulator, seed, concurrent));
    };
}
module.exports.mergeScan = $602c60a2f550ced8$var$mergeScan;
var $602c60a2f550ced8$var$MergeScanOperator = function() {
    function MergeScanOperator(accumulator, seed, concurrent) {
        this.accumulator = accumulator;
        this.seed = seed;
        this.concurrent = concurrent;
    }
    MergeScanOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $602c60a2f550ced8$var$MergeScanSubscriber(subscriber, this.accumulator, this.seed, this.concurrent));
    };
    return MergeScanOperator;
}();
module.exports.MergeScanOperator = $602c60a2f550ced8$var$MergeScanOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $602c60a2f550ced8$var$MergeScanSubscriber = function(_super) {
    $602c60a2f550ced8$var$__extends(MergeScanSubscriber, _super);
    function MergeScanSubscriber(destination, accumulator, acc, concurrent) {
        _super.call(this, destination);
        this.accumulator = accumulator;
        this.acc = acc;
        this.concurrent = concurrent;
        this.hasValue = false;
        this.hasCompleted = false;
        this.buffer = [];
        this.active = 0;
        this.index = 0;
    }
    MergeScanSubscriber.prototype._next = function(value) {
        if (this.active < this.concurrent) {
            var index = this.index++;
            var ish = $3FcLR.tryCatch(this.accumulator)(this.acc, value);
            var destination = this.destination;
            if (ish === $6LPWz.errorObject) destination.error($6LPWz.errorObject.e);
            else {
                this.active++;
                this._innerSub(ish, value, index);
            }
        } else this.buffer.push(value);
    };
    MergeScanSubscriber.prototype._innerSub = function(ish, value, index) {
        this.add($dZ9AU.subscribeToResult(this, ish, value, index));
    };
    MergeScanSubscriber.prototype._complete = function() {
        this.hasCompleted = true;
        if (this.active === 0 && this.buffer.length === 0) {
            if (this.hasValue === false) this.destination.next(this.acc);
            this.destination.complete();
        }
    };
    MergeScanSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        var destination = this.destination;
        this.acc = innerValue;
        this.hasValue = true;
        destination.next(innerValue);
    };
    MergeScanSubscriber.prototype.notifyComplete = function(innerSub) {
        var buffer = this.buffer;
        this.remove(innerSub);
        this.active--;
        if (buffer.length > 0) this._next(buffer.shift());
        else if (this.active === 0 && this.hasCompleted) {
            if (this.hasValue === false) this.destination.next(this.acc);
            this.destination.complete();
        }
    };
    return MergeScanSubscriber;
}($iwB6M.OuterSubscriber);
module.exports.MergeScanSubscriber = $602c60a2f550ced8$var$MergeScanSubscriber;

});

parcelRegister("f5yaK", function(module, exports) {
"use strict";
var $afc1d48f4f3eb15c$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $augeV = parcelRequire("augeV");


var $YgydF = parcelRequire("YgydF");


var $axeml = parcelRequire("axeml");


var $8v4h5 = parcelRequire("8v4h5");


var $iY7u4 = parcelRequire("iY7u4");

/**
 * @class ConnectableObservable<T>
 */ var $afc1d48f4f3eb15c$var$ConnectableObservable = function(_super) {
    $afc1d48f4f3eb15c$var$__extends(ConnectableObservable, _super);
    function ConnectableObservable(/** @deprecated internal use only */ source, /** @deprecated internal use only */ subjectFactory) {
        _super.call(this);
        this.source = source;
        this.subjectFactory = subjectFactory;
        /** @deprecated internal use only */ this._refCount = 0;
        this._isComplete = false;
    }
    /** @deprecated internal use only */ ConnectableObservable.prototype._subscribe = function(subscriber) {
        return this.getSubject().subscribe(subscriber);
    };
    /** @deprecated internal use only */ ConnectableObservable.prototype.getSubject = function() {
        var subject = this._subject;
        if (!subject || subject.isStopped) this._subject = this.subjectFactory();
        return this._subject;
    };
    ConnectableObservable.prototype.connect = function() {
        var connection = this._connection;
        if (!connection) {
            this._isComplete = false;
            connection = this._connection = new $8v4h5.Subscription();
            connection.add(this.source.subscribe(new $afc1d48f4f3eb15c$var$ConnectableSubscriber(this.getSubject(), this)));
            if (connection.closed) {
                this._connection = null;
                connection = $8v4h5.Subscription.EMPTY;
            } else this._connection = connection;
        }
        return connection;
    };
    ConnectableObservable.prototype.refCount = function() {
        return $iY7u4.refCount()(this);
    };
    return ConnectableObservable;
}($YgydF.Observable);
module.exports.ConnectableObservable = $afc1d48f4f3eb15c$var$ConnectableObservable;
var $afc1d48f4f3eb15c$var$connectableProto = $afc1d48f4f3eb15c$var$ConnectableObservable.prototype;
module.exports.connectableObservableDescriptor = {
    operator: {
        value: null
    },
    _refCount: {
        value: 0,
        writable: true
    },
    _subject: {
        value: null,
        writable: true
    },
    _connection: {
        value: null,
        writable: true
    },
    _subscribe: {
        value: $afc1d48f4f3eb15c$var$connectableProto._subscribe
    },
    _isComplete: {
        value: $afc1d48f4f3eb15c$var$connectableProto._isComplete,
        writable: true
    },
    getSubject: {
        value: $afc1d48f4f3eb15c$var$connectableProto.getSubject
    },
    connect: {
        value: $afc1d48f4f3eb15c$var$connectableProto.connect
    },
    refCount: {
        value: $afc1d48f4f3eb15c$var$connectableProto.refCount
    }
};
var $afc1d48f4f3eb15c$var$ConnectableSubscriber = function(_super) {
    $afc1d48f4f3eb15c$var$__extends(ConnectableSubscriber, _super);
    function ConnectableSubscriber(destination, connectable) {
        _super.call(this, destination);
        this.connectable = connectable;
    }
    ConnectableSubscriber.prototype._error = function(err) {
        this._unsubscribe();
        _super.prototype._error.call(this, err);
    };
    ConnectableSubscriber.prototype._complete = function() {
        this.connectable._isComplete = true;
        this._unsubscribe();
        _super.prototype._complete.call(this);
    };
    /** @deprecated internal use only */ ConnectableSubscriber.prototype._unsubscribe = function() {
        var connectable = this.connectable;
        if (connectable) {
            this.connectable = null;
            var connection = connectable._connection;
            connectable._refCount = 0;
            connectable._subject = null;
            connectable._connection = null;
            if (connection) connection.unsubscribe();
        }
    };
    return ConnectableSubscriber;
}($augeV.SubjectSubscriber);
var $afc1d48f4f3eb15c$var$RefCountOperator = function() {
    function RefCountOperator(connectable) {
        this.connectable = connectable;
    }
    RefCountOperator.prototype.call = function(subscriber, source) {
        var connectable = this.connectable;
        connectable._refCount++;
        var refCounter = new $afc1d48f4f3eb15c$var$RefCountSubscriber(subscriber, connectable);
        var subscription = source.subscribe(refCounter);
        if (!refCounter.closed) refCounter.connection = connectable.connect();
        return subscription;
    };
    return RefCountOperator;
}();
var $afc1d48f4f3eb15c$var$RefCountSubscriber = function(_super) {
    $afc1d48f4f3eb15c$var$__extends(RefCountSubscriber, _super);
    function RefCountSubscriber(destination, connectable) {
        _super.call(this, destination);
        this.connectable = connectable;
    }
    /** @deprecated internal use only */ RefCountSubscriber.prototype._unsubscribe = function() {
        var connectable = this.connectable;
        if (!connectable) {
            this.connection = null;
            return;
        }
        this.connectable = null;
        var refCount = connectable._refCount;
        if (refCount <= 0) {
            this.connection = null;
            return;
        }
        connectable._refCount = refCount - 1;
        if (refCount > 1) {
            this.connection = null;
            return;
        }
        ///
        // Compare the local RefCountSubscriber's connection Subscription to the
        // connection Subscription on the shared ConnectableObservable. In cases
        // where the ConnectableObservable source synchronously emits values, and
        // the RefCountSubscriber's downstream Observers synchronously unsubscribe,
        // execution continues to here before the RefCountOperator has a chance to
        // supply the RefCountSubscriber with the shared connection Subscription.
        // For example:
        // ```
        // Observable.range(0, 10)
        //   .publish()
        //   .refCount()
        //   .take(5)
        //   .subscribe();
        // ```
        // In order to account for this case, RefCountSubscriber should only dispose
        // the ConnectableObservable's shared connection Subscription if the
        // connection Subscription exists, *and* either:
        //   a. RefCountSubscriber doesn't have a reference to the shared connection
        //      Subscription yet, or,
        //   b. RefCountSubscriber's connection Subscription reference is identical
        //      to the shared connection Subscription
        ///
        var connection = this.connection;
        var sharedConnection = connectable._connection;
        this.connection = null;
        if (sharedConnection && (!connection || sharedConnection === connection)) sharedConnection.unsubscribe();
    };
    return RefCountSubscriber;
}($axeml.Subscriber);

});

parcelRegister("c17EK", function(module, exports) {
"use strict";
var $8bfb8468338672f7$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $e3P0W = parcelRequire("e3P0W");


var $fvPwd = parcelRequire("fvPwd");


var $iwB6M = parcelRequire("iwB6M");


var $dZ9AU = parcelRequire("dZ9AU");

/* tslint:enable:max-line-length */ /**
 * When any of the provided Observable emits an complete or error notification, it immediately subscribes to the next one
 * that was passed.
 *
 * <span class="informal">Execute series of Observables no matter what, even if it means swallowing errors.</span>
 *
 * <img src="./img/onErrorResumeNext.png" width="100%">
 *
 * `onErrorResumeNext` is an operator that accepts a series of Observables, provided either directly as
 * arguments or as an array. If no single Observable is provided, returned Observable will simply behave the same
 * as the source.
 *
 * `onErrorResumeNext` returns an Observable that starts by subscribing and re-emitting values from the source Observable.
 * When its stream of values ends - no matter if Observable completed or emitted an error - `onErrorResumeNext`
 * will subscribe to the first Observable that was passed as an argument to the method. It will start re-emitting
 * its values as well and - again - when that stream ends, `onErrorResumeNext` will proceed to subscribing yet another
 * Observable in provided series, no matter if previous Observable completed or ended with an error. This will
 * be happening until there is no more Observables left in the series, at which point returned Observable will
 * complete - even if the last subscribed stream ended with an error.
 *
 * `onErrorResumeNext` can be therefore thought of as version of {@link concat} operator, which is more permissive
 * when it comes to the errors emitted by its input Observables. While `concat` subscribes to the next Observable
 * in series only if previous one successfully completed, `onErrorResumeNext` subscribes even if it ended with
 * an error.
 *
 * Note that you do not get any access to errors emitted by the Observables. In particular do not
 * expect these errors to appear in error callback passed to {@link subscribe}. If you want to take
 * specific actions based on what error was emitted by an Observable, you should try out {@link catch} instead.
 *
 *
 * @example <caption>Subscribe to the next Observable after map fails</caption>
 * Rx.Observable.of(1, 2, 3, 0)
 *   .map(x => {
 *       if (x === 0) { throw Error(); }
         return 10 / x;
 *   })
 *   .onErrorResumeNext(Rx.Observable.of(1, 2, 3))
 *   .subscribe(
 *     val => console.log(val),
 *     err => console.log(err),          // Will never be called.
 *     () => console.log('that\'s it!')
 *   );
 *
 * // Logs:
 * // 10
 * // 5
 * // 3.3333333333333335
 * // 1
 * // 2
 * // 3
 * // "that's it!"
 *
 * @see {@link concat}
 * @see {@link catch}
 *
 * @param {...ObservableInput} observables Observables passed either directly or as an array.
 * @return {Observable} An Observable that emits values from source Observable, but - if it errors - subscribes
 * to the next passed Observable and so on, until it completes or runs out of Observables.
 * @method onErrorResumeNext
 * @owner Observable
 */ function $8bfb8468338672f7$var$onErrorResumeNext() {
    var nextSources = [];
    for(var _i = 0; _i < arguments.length; _i++)nextSources[_i - 0] = arguments[_i];
    if (nextSources.length === 1 && $fvPwd.isArray(nextSources[0])) nextSources = nextSources[0];
    return function(source) {
        return source.lift(new $8bfb8468338672f7$var$OnErrorResumeNextOperator(nextSources));
    };
}
module.exports.onErrorResumeNext = $8bfb8468338672f7$var$onErrorResumeNext;
/* tslint:enable:max-line-length */ function $8bfb8468338672f7$var$onErrorResumeNextStatic() {
    var nextSources = [];
    for(var _i = 0; _i < arguments.length; _i++)nextSources[_i - 0] = arguments[_i];
    var source = null;
    if (nextSources.length === 1 && $fvPwd.isArray(nextSources[0])) nextSources = nextSources[0];
    source = nextSources.shift();
    return new $e3P0W.FromObservable(source, null).lift(new $8bfb8468338672f7$var$OnErrorResumeNextOperator(nextSources));
}
module.exports.onErrorResumeNextStatic = $8bfb8468338672f7$var$onErrorResumeNextStatic;
var $8bfb8468338672f7$var$OnErrorResumeNextOperator = function() {
    function OnErrorResumeNextOperator(nextSources) {
        this.nextSources = nextSources;
    }
    OnErrorResumeNextOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $8bfb8468338672f7$var$OnErrorResumeNextSubscriber(subscriber, this.nextSources));
    };
    return OnErrorResumeNextOperator;
}();
var $8bfb8468338672f7$var$OnErrorResumeNextSubscriber = function(_super) {
    $8bfb8468338672f7$var$__extends(OnErrorResumeNextSubscriber, _super);
    function OnErrorResumeNextSubscriber(destination, nextSources) {
        _super.call(this, destination);
        this.destination = destination;
        this.nextSources = nextSources;
    }
    OnErrorResumeNextSubscriber.prototype.notifyError = function(error, innerSub) {
        this.subscribeToNextSource();
    };
    OnErrorResumeNextSubscriber.prototype.notifyComplete = function(innerSub) {
        this.subscribeToNextSource();
    };
    OnErrorResumeNextSubscriber.prototype._error = function(err) {
        this.subscribeToNextSource();
    };
    OnErrorResumeNextSubscriber.prototype._complete = function() {
        this.subscribeToNextSource();
    };
    OnErrorResumeNextSubscriber.prototype.subscribeToNextSource = function() {
        var next = this.nextSources.shift();
        if (next) this.add($dZ9AU.subscribeToResult(this, next));
        else this.destination.complete();
    };
    return OnErrorResumeNextSubscriber;
}($iwB6M.OuterSubscriber);

});

parcelRegister("5hER9", function(module, exports) {
"use strict";
var $3d8e3b81ce32029d$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $axeml = parcelRequire("axeml");

/**
 * Groups pairs of consecutive emissions together and emits them as an array of
 * two values.
 *
 * <span class="informal">Puts the current value and previous value together as
 * an array, and emits that.</span>
 *
 * <img src="./img/pairwise.png" width="100%">
 *
 * The Nth emission from the source Observable will cause the output Observable
 * to emit an array [(N-1)th, Nth] of the previous and the current value, as a
 * pair. For this reason, `pairwise` emits on the second and subsequent
 * emissions from the source Observable, but not on the first emission, because
 * there is no previous value in that case.
 *
 * @example <caption>On every click (starting from the second), emit the relative distance to the previous click</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var pairs = clicks.pairwise();
 * var distance = pairs.map(pair => {
 *   var x0 = pair[0].clientX;
 *   var y0 = pair[0].clientY;
 *   var x1 = pair[1].clientX;
 *   var y1 = pair[1].clientY;
 *   return Math.sqrt(Math.pow(x0 - x1, 2) + Math.pow(y0 - y1, 2));
 * });
 * distance.subscribe(x => console.log(x));
 *
 * @see {@link buffer}
 * @see {@link bufferCount}
 *
 * @return {Observable<Array<T>>} An Observable of pairs (as arrays) of
 * consecutive values from the source Observable.
 * @method pairwise
 * @owner Observable
 */ function $3d8e3b81ce32029d$var$pairwise() {
    return function(source) {
        return source.lift(new $3d8e3b81ce32029d$var$PairwiseOperator());
    };
}
module.exports.pairwise = $3d8e3b81ce32029d$var$pairwise;
var $3d8e3b81ce32029d$var$PairwiseOperator = function() {
    function PairwiseOperator() {}
    PairwiseOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $3d8e3b81ce32029d$var$PairwiseSubscriber(subscriber));
    };
    return PairwiseOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $3d8e3b81ce32029d$var$PairwiseSubscriber = function(_super) {
    $3d8e3b81ce32029d$var$__extends(PairwiseSubscriber, _super);
    function PairwiseSubscriber(destination) {
        _super.call(this, destination);
        this.hasPrev = false;
    }
    PairwiseSubscriber.prototype._next = function(value) {
        if (this.hasPrev) this.destination.next([
            this.prev,
            value
        ]);
        else this.hasPrev = true;
        this.prev = value;
    };
    return PairwiseSubscriber;
}($axeml.Subscriber);

});

parcelRegister("5JYSv", function(module, exports) {
"use strict";
var $42e060df17a9a962$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $augeV = parcelRequire("augeV");


var $8v4h5 = parcelRequire("8v4h5");

/**
 * @class AsyncSubject<T>
 */ var $42e060df17a9a962$var$AsyncSubject = function(_super) {
    $42e060df17a9a962$var$__extends(AsyncSubject, _super);
    function AsyncSubject() {
        _super.apply(this, arguments);
        this.value = null;
        this.hasNext = false;
        this.hasCompleted = false;
    }
    /** @deprecated internal use only */ AsyncSubject.prototype._subscribe = function(subscriber) {
        if (this.hasError) {
            subscriber.error(this.thrownError);
            return $8v4h5.Subscription.EMPTY;
        } else if (this.hasCompleted && this.hasNext) {
            subscriber.next(this.value);
            subscriber.complete();
            return $8v4h5.Subscription.EMPTY;
        }
        return _super.prototype._subscribe.call(this, subscriber);
    };
    AsyncSubject.prototype.next = function(value) {
        if (!this.hasCompleted) {
            this.value = value;
            this.hasNext = true;
        }
    };
    AsyncSubject.prototype.error = function(error) {
        if (!this.hasCompleted) _super.prototype.error.call(this, error);
    };
    AsyncSubject.prototype.complete = function() {
        this.hasCompleted = true;
        if (this.hasNext) _super.prototype.next.call(this, this.value);
        _super.prototype.complete.call(this);
    };
    return AsyncSubject;
}($augeV.Subject);
module.exports.AsyncSubject = $42e060df17a9a962$var$AsyncSubject;

});

parcelRegister("iiAcs", function(module, exports) {
"use strict";
var $d525fcf695f9e47c$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $fvPwd = parcelRequire("fvPwd");


var $HHFyQ = parcelRequire("HHFyQ");


var $iwB6M = parcelRequire("iwB6M");


var $dZ9AU = parcelRequire("dZ9AU");

function $d525fcf695f9e47c$var$race() {
    var observables = [];
    for(var _i = 0; _i < arguments.length; _i++)observables[_i - 0] = arguments[_i];
    // if the only argument is an array, it was most likely called with
    // `race([obs1, obs2, ...])`
    if (observables.length === 1) {
        if ($fvPwd.isArray(observables[0])) observables = observables[0];
        else return observables[0];
    }
    return new $HHFyQ.ArrayObservable(observables).lift(new $d525fcf695f9e47c$var$RaceOperator());
}
module.exports.race = $d525fcf695f9e47c$var$race;
var $d525fcf695f9e47c$var$RaceOperator = function() {
    function RaceOperator() {}
    RaceOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $d525fcf695f9e47c$var$RaceSubscriber(subscriber));
    };
    return RaceOperator;
}();
module.exports.RaceOperator = $d525fcf695f9e47c$var$RaceOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $d525fcf695f9e47c$var$RaceSubscriber = function(_super) {
    $d525fcf695f9e47c$var$__extends(RaceSubscriber, _super);
    function RaceSubscriber(destination) {
        _super.call(this, destination);
        this.hasFirst = false;
        this.observables = [];
        this.subscriptions = [];
    }
    RaceSubscriber.prototype._next = function(observable) {
        this.observables.push(observable);
    };
    RaceSubscriber.prototype._complete = function() {
        var observables = this.observables;
        var len = observables.length;
        if (len === 0) this.destination.complete();
        else {
            for(var i = 0; i < len && !this.hasFirst; i++){
                var observable = observables[i];
                var subscription = $dZ9AU.subscribeToResult(this, observable, observable, i);
                if (this.subscriptions) this.subscriptions.push(subscription);
                this.add(subscription);
            }
            this.observables = null;
        }
    };
    RaceSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        if (!this.hasFirst) {
            this.hasFirst = true;
            for(var i = 0; i < this.subscriptions.length; i++)if (i !== outerIndex) {
                var subscription = this.subscriptions[i];
                subscription.unsubscribe();
                this.remove(subscription);
            }
            this.subscriptions = null;
        }
        this.destination.next(innerValue);
    };
    return RaceSubscriber;
}($iwB6M.OuterSubscriber);
module.exports.RaceSubscriber = $d525fcf695f9e47c$var$RaceSubscriber;

});

parcelRegister("5AGP5", function(module, exports) {
"use strict";
var $41218848cc38d59b$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $axeml = parcelRequire("axeml");


var $b5CQv = parcelRequire("b5CQv");

/**
 * Returns an Observable that repeats the stream of items emitted by the source Observable at most count times.
 *
 * <img src="./img/repeat.png" width="100%">
 *
 * @param {number} [count] The number of times the source Observable items are repeated, a count of 0 will yield
 * an empty Observable.
 * @return {Observable} An Observable that repeats the stream of items emitted by the source Observable at most
 * count times.
 * @method repeat
 * @owner Observable
 */ function $41218848cc38d59b$var$repeat(count) {
    if (count === void 0) count = -1;
    return function(source) {
        if (count === 0) return new $b5CQv.EmptyObservable();
        else if (count < 0) return source.lift(new $41218848cc38d59b$var$RepeatOperator(-1, source));
        else return source.lift(new $41218848cc38d59b$var$RepeatOperator(count - 1, source));
    };
}
module.exports.repeat = $41218848cc38d59b$var$repeat;
var $41218848cc38d59b$var$RepeatOperator = function() {
    function RepeatOperator(count, source) {
        this.count = count;
        this.source = source;
    }
    RepeatOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $41218848cc38d59b$var$RepeatSubscriber(subscriber, this.count, this.source));
    };
    return RepeatOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $41218848cc38d59b$var$RepeatSubscriber = function(_super) {
    $41218848cc38d59b$var$__extends(RepeatSubscriber, _super);
    function RepeatSubscriber(destination, count, source) {
        _super.call(this, destination);
        this.count = count;
        this.source = source;
    }
    RepeatSubscriber.prototype.complete = function() {
        if (!this.isStopped) {
            var _a = this, source = _a.source, count = _a.count;
            if (count === 0) return _super.prototype.complete.call(this);
            else if (count > -1) this.count = count - 1;
            source.subscribe(this._unsubscribeAndRecycle());
        }
    };
    return RepeatSubscriber;
}($axeml.Subscriber);

});

parcelRegister("6GFHk", function(module, exports) {
"use strict";
var $4de702a12ff3c7e8$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $augeV = parcelRequire("augeV");


var $3FcLR = parcelRequire("3FcLR");


var $6LPWz = parcelRequire("6LPWz");


var $iwB6M = parcelRequire("iwB6M");


var $dZ9AU = parcelRequire("dZ9AU");

/**
 * Returns an Observable that mirrors the source Observable with the exception of a `complete`. If the source
 * Observable calls `complete`, this method will emit to the Observable returned from `notifier`. If that Observable
 * calls `complete` or `error`, then this method will call `complete` or `error` on the child subscription. Otherwise
 * this method will resubscribe to the source Observable.
 *
 * <img src="./img/repeatWhen.png" width="100%">
 *
 * @param {function(notifications: Observable): Observable} notifier - Receives an Observable of notifications with
 * which a user can `complete` or `error`, aborting the repetition.
 * @return {Observable} The source Observable modified with repeat logic.
 * @method repeatWhen
 * @owner Observable
 */ function $4de702a12ff3c7e8$var$repeatWhen(notifier) {
    return function(source) {
        return source.lift(new $4de702a12ff3c7e8$var$RepeatWhenOperator(notifier));
    };
}
module.exports.repeatWhen = $4de702a12ff3c7e8$var$repeatWhen;
var $4de702a12ff3c7e8$var$RepeatWhenOperator = function() {
    function RepeatWhenOperator(notifier) {
        this.notifier = notifier;
    }
    RepeatWhenOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $4de702a12ff3c7e8$var$RepeatWhenSubscriber(subscriber, this.notifier, source));
    };
    return RepeatWhenOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $4de702a12ff3c7e8$var$RepeatWhenSubscriber = function(_super) {
    $4de702a12ff3c7e8$var$__extends(RepeatWhenSubscriber, _super);
    function RepeatWhenSubscriber(destination, notifier, source) {
        _super.call(this, destination);
        this.notifier = notifier;
        this.source = source;
        this.sourceIsBeingSubscribedTo = true;
    }
    RepeatWhenSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.sourceIsBeingSubscribedTo = true;
        this.source.subscribe(this);
    };
    RepeatWhenSubscriber.prototype.notifyComplete = function(innerSub) {
        if (this.sourceIsBeingSubscribedTo === false) return _super.prototype.complete.call(this);
    };
    RepeatWhenSubscriber.prototype.complete = function() {
        this.sourceIsBeingSubscribedTo = false;
        if (!this.isStopped) {
            if (!this.retries) this.subscribeToRetries();
            if (!this.retriesSubscription || this.retriesSubscription.closed) return _super.prototype.complete.call(this);
            this._unsubscribeAndRecycle();
            this.notifications.next();
        }
    };
    /** @deprecated internal use only */ RepeatWhenSubscriber.prototype._unsubscribe = function() {
        var _a = this, notifications = _a.notifications, retriesSubscription = _a.retriesSubscription;
        if (notifications) {
            notifications.unsubscribe();
            this.notifications = null;
        }
        if (retriesSubscription) {
            retriesSubscription.unsubscribe();
            this.retriesSubscription = null;
        }
        this.retries = null;
    };
    /** @deprecated internal use only */ RepeatWhenSubscriber.prototype._unsubscribeAndRecycle = function() {
        var _a = this, notifications = _a.notifications, retries = _a.retries, retriesSubscription = _a.retriesSubscription;
        this.notifications = null;
        this.retries = null;
        this.retriesSubscription = null;
        _super.prototype._unsubscribeAndRecycle.call(this);
        this.notifications = notifications;
        this.retries = retries;
        this.retriesSubscription = retriesSubscription;
        return this;
    };
    RepeatWhenSubscriber.prototype.subscribeToRetries = function() {
        this.notifications = new $augeV.Subject();
        var retries = $3FcLR.tryCatch(this.notifier)(this.notifications);
        if (retries === $6LPWz.errorObject) return _super.prototype.complete.call(this);
        this.retries = retries;
        this.retriesSubscription = $dZ9AU.subscribeToResult(this, retries);
    };
    return RepeatWhenSubscriber;
}($iwB6M.OuterSubscriber);

});

parcelRegister("e6s15", function(module, exports) {
"use strict";
var $a4475bb3d801fc16$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $axeml = parcelRequire("axeml");

/**
 * Returns an Observable that mirrors the source Observable with the exception of an `error`. If the source Observable
 * calls `error`, this method will resubscribe to the source Observable for a maximum of `count` resubscriptions (given
 * as a number parameter) rather than propagating the `error` call.
 *
 * <img src="./img/retry.png" width="100%">
 *
 * Any and all items emitted by the source Observable will be emitted by the resulting Observable, even those emitted
 * during failed subscriptions. For example, if an Observable fails at first but emits [1, 2] then succeeds the second
 * time and emits: [1, 2, 3, 4, 5] then the complete stream of emissions and notifications
 * would be: [1, 2, 1, 2, 3, 4, 5, `complete`].
 * @param {number} count - Number of retry attempts before failing.
 * @return {Observable} The source Observable modified with the retry logic.
 * @method retry
 * @owner Observable
 */ function $a4475bb3d801fc16$var$retry(count) {
    if (count === void 0) count = -1;
    return function(source) {
        return source.lift(new $a4475bb3d801fc16$var$RetryOperator(count, source));
    };
}
module.exports.retry = $a4475bb3d801fc16$var$retry;
var $a4475bb3d801fc16$var$RetryOperator = function() {
    function RetryOperator(count, source) {
        this.count = count;
        this.source = source;
    }
    RetryOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $a4475bb3d801fc16$var$RetrySubscriber(subscriber, this.count, this.source));
    };
    return RetryOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $a4475bb3d801fc16$var$RetrySubscriber = function(_super) {
    $a4475bb3d801fc16$var$__extends(RetrySubscriber, _super);
    function RetrySubscriber(destination, count, source) {
        _super.call(this, destination);
        this.count = count;
        this.source = source;
    }
    RetrySubscriber.prototype.error = function(err) {
        if (!this.isStopped) {
            var _a = this, source = _a.source, count = _a.count;
            if (count === 0) return _super.prototype.error.call(this, err);
            else if (count > -1) this.count = count - 1;
            source.subscribe(this._unsubscribeAndRecycle());
        }
    };
    return RetrySubscriber;
}($axeml.Subscriber);

});

parcelRegister("igrC3", function(module, exports) {
"use strict";
var $d4bf23f5ba143f06$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $augeV = parcelRequire("augeV");


var $3FcLR = parcelRequire("3FcLR");


var $6LPWz = parcelRequire("6LPWz");


var $iwB6M = parcelRequire("iwB6M");


var $dZ9AU = parcelRequire("dZ9AU");

/**
 * Returns an Observable that mirrors the source Observable with the exception of an `error`. If the source Observable
 * calls `error`, this method will emit the Throwable that caused the error to the Observable returned from `notifier`.
 * If that Observable calls `complete` or `error` then this method will call `complete` or `error` on the child
 * subscription. Otherwise this method will resubscribe to the source Observable.
 *
 * <img src="./img/retryWhen.png" width="100%">
 *
 * @param {function(errors: Observable): Observable} notifier - Receives an Observable of notifications with which a
 * user can `complete` or `error`, aborting the retry.
 * @return {Observable} The source Observable modified with retry logic.
 * @method retryWhen
 * @owner Observable
 */ function $d4bf23f5ba143f06$var$retryWhen(notifier) {
    return function(source) {
        return source.lift(new $d4bf23f5ba143f06$var$RetryWhenOperator(notifier, source));
    };
}
module.exports.retryWhen = $d4bf23f5ba143f06$var$retryWhen;
var $d4bf23f5ba143f06$var$RetryWhenOperator = function() {
    function RetryWhenOperator(notifier, source) {
        this.notifier = notifier;
        this.source = source;
    }
    RetryWhenOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $d4bf23f5ba143f06$var$RetryWhenSubscriber(subscriber, this.notifier, this.source));
    };
    return RetryWhenOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $d4bf23f5ba143f06$var$RetryWhenSubscriber = function(_super) {
    $d4bf23f5ba143f06$var$__extends(RetryWhenSubscriber, _super);
    function RetryWhenSubscriber(destination, notifier, source) {
        _super.call(this, destination);
        this.notifier = notifier;
        this.source = source;
    }
    RetryWhenSubscriber.prototype.error = function(err) {
        if (!this.isStopped) {
            var errors = this.errors;
            var retries = this.retries;
            var retriesSubscription = this.retriesSubscription;
            if (!retries) {
                errors = new $augeV.Subject();
                retries = $3FcLR.tryCatch(this.notifier)(errors);
                if (retries === $6LPWz.errorObject) return _super.prototype.error.call(this, $6LPWz.errorObject.e);
                retriesSubscription = $dZ9AU.subscribeToResult(this, retries);
            } else {
                this.errors = null;
                this.retriesSubscription = null;
            }
            this._unsubscribeAndRecycle();
            this.errors = errors;
            this.retries = retries;
            this.retriesSubscription = retriesSubscription;
            errors.next(err);
        }
    };
    /** @deprecated internal use only */ RetryWhenSubscriber.prototype._unsubscribe = function() {
        var _a = this, errors = _a.errors, retriesSubscription = _a.retriesSubscription;
        if (errors) {
            errors.unsubscribe();
            this.errors = null;
        }
        if (retriesSubscription) {
            retriesSubscription.unsubscribe();
            this.retriesSubscription = null;
        }
        this.retries = null;
    };
    RetryWhenSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        var _a = this, errors = _a.errors, retries = _a.retries, retriesSubscription = _a.retriesSubscription;
        this.errors = null;
        this.retries = null;
        this.retriesSubscription = null;
        this._unsubscribeAndRecycle();
        this.errors = errors;
        this.retries = retries;
        this.retriesSubscription = retriesSubscription;
        this.source.subscribe(this);
    };
    return RetryWhenSubscriber;
}($iwB6M.OuterSubscriber);

});

parcelRegister("iY7u4", function(module, exports) {
"use strict";
var $dcf3a2c4cbc9dcbc$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $axeml = parcelRequire("axeml");

function $dcf3a2c4cbc9dcbc$var$refCount() {
    return function refCountOperatorFunction(source) {
        return source.lift(new $dcf3a2c4cbc9dcbc$var$RefCountOperator(source));
    };
}
module.exports.refCount = $dcf3a2c4cbc9dcbc$var$refCount;
var $dcf3a2c4cbc9dcbc$var$RefCountOperator = function() {
    function RefCountOperator(connectable) {
        this.connectable = connectable;
    }
    RefCountOperator.prototype.call = function(subscriber, source) {
        var connectable = this.connectable;
        connectable._refCount++;
        var refCounter = new $dcf3a2c4cbc9dcbc$var$RefCountSubscriber(subscriber, connectable);
        var subscription = source.subscribe(refCounter);
        if (!refCounter.closed) refCounter.connection = connectable.connect();
        return subscription;
    };
    return RefCountOperator;
}();
var $dcf3a2c4cbc9dcbc$var$RefCountSubscriber = function(_super) {
    $dcf3a2c4cbc9dcbc$var$__extends(RefCountSubscriber, _super);
    function RefCountSubscriber(destination, connectable) {
        _super.call(this, destination);
        this.connectable = connectable;
    }
    /** @deprecated internal use only */ RefCountSubscriber.prototype._unsubscribe = function() {
        var connectable = this.connectable;
        if (!connectable) {
            this.connection = null;
            return;
        }
        this.connectable = null;
        var refCount = connectable._refCount;
        if (refCount <= 0) {
            this.connection = null;
            return;
        }
        connectable._refCount = refCount - 1;
        if (refCount > 1) {
            this.connection = null;
            return;
        }
        ///
        // Compare the local RefCountSubscriber's connection Subscription to the
        // connection Subscription on the shared ConnectableObservable. In cases
        // where the ConnectableObservable source synchronously emits values, and
        // the RefCountSubscriber's downstream Observers synchronously unsubscribe,
        // execution continues to here before the RefCountOperator has a chance to
        // supply the RefCountSubscriber with the shared connection Subscription.
        // For example:
        // ```
        // Observable.range(0, 10)
        //   .publish()
        //   .refCount()
        //   .take(5)
        //   .subscribe();
        // ```
        // In order to account for this case, RefCountSubscriber should only dispose
        // the ConnectableObservable's shared connection Subscription if the
        // connection Subscription exists, *and* either:
        //   a. RefCountSubscriber doesn't have a reference to the shared connection
        //      Subscription yet, or,
        //   b. RefCountSubscriber's connection Subscription reference is identical
        //      to the shared connection Subscription
        ///
        var connection = this.connection;
        var sharedConnection = connectable._connection;
        this.connection = null;
        if (sharedConnection && (!connection || sharedConnection === connection)) sharedConnection.unsubscribe();
    };
    return RefCountSubscriber;
}($axeml.Subscriber);

});

parcelRegister("4LrJQ", function(module, exports) {
"use strict";
var $3781117ca12633b5$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $iwB6M = parcelRequire("iwB6M");


var $dZ9AU = parcelRequire("dZ9AU");

/**
 * Emits the most recently emitted value from the source Observable whenever
 * another Observable, the `notifier`, emits.
 *
 * <span class="informal">It's like {@link sampleTime}, but samples whenever
 * the `notifier` Observable emits something.</span>
 *
 * <img src="./img/sample.png" width="100%">
 *
 * Whenever the `notifier` Observable emits a value or completes, `sample`
 * looks at the source Observable and emits whichever value it has most recently
 * emitted since the previous sampling, unless the source has not emitted
 * anything since the previous sampling. The `notifier` is subscribed to as soon
 * as the output Observable is subscribed.
 *
 * @example <caption>On every click, sample the most recent "seconds" timer</caption>
 * var seconds = Rx.Observable.interval(1000);
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = seconds.sample(clicks);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link audit}
 * @see {@link debounce}
 * @see {@link sampleTime}
 * @see {@link throttle}
 *
 * @param {Observable<any>} notifier The Observable to use for sampling the
 * source Observable.
 * @return {Observable<T>} An Observable that emits the results of sampling the
 * values emitted by the source Observable whenever the notifier Observable
 * emits value or completes.
 * @method sample
 * @owner Observable
 */ function $3781117ca12633b5$var$sample(notifier) {
    return function(source) {
        return source.lift(new $3781117ca12633b5$var$SampleOperator(notifier));
    };
}
module.exports.sample = $3781117ca12633b5$var$sample;
var $3781117ca12633b5$var$SampleOperator = function() {
    function SampleOperator(notifier) {
        this.notifier = notifier;
    }
    SampleOperator.prototype.call = function(subscriber, source) {
        var sampleSubscriber = new $3781117ca12633b5$var$SampleSubscriber(subscriber);
        var subscription = source.subscribe(sampleSubscriber);
        subscription.add($dZ9AU.subscribeToResult(sampleSubscriber, this.notifier));
        return subscription;
    };
    return SampleOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $3781117ca12633b5$var$SampleSubscriber = function(_super) {
    $3781117ca12633b5$var$__extends(SampleSubscriber, _super);
    function SampleSubscriber() {
        _super.apply(this, arguments);
        this.hasValue = false;
    }
    SampleSubscriber.prototype._next = function(value) {
        this.value = value;
        this.hasValue = true;
    };
    SampleSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.emitValue();
    };
    SampleSubscriber.prototype.notifyComplete = function() {
        this.emitValue();
    };
    SampleSubscriber.prototype.emitValue = function() {
        if (this.hasValue) {
            this.hasValue = false;
            this.destination.next(this.value);
        }
    };
    return SampleSubscriber;
}($iwB6M.OuterSubscriber);

});

parcelRegister("jAcJW", function(module, exports) {
"use strict";
var $e41b43010c369ea1$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $axeml = parcelRequire("axeml");


var $3u6GG = parcelRequire("3u6GG");

/**
 * Emits the most recently emitted value from the source Observable within
 * periodic time intervals.
 *
 * <span class="informal">Samples the source Observable at periodic time
 * intervals, emitting what it samples.</span>
 *
 * <img src="./img/sampleTime.png" width="100%">
 *
 * `sampleTime` periodically looks at the source Observable and emits whichever
 * value it has most recently emitted since the previous sampling, unless the
 * source has not emitted anything since the previous sampling. The sampling
 * happens periodically in time every `period` milliseconds (or the time unit
 * defined by the optional `scheduler` argument). The sampling starts as soon as
 * the output Observable is subscribed.
 *
 * @example <caption>Every second, emit the most recent click at most once</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.sampleTime(1000);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link auditTime}
 * @see {@link debounceTime}
 * @see {@link delay}
 * @see {@link sample}
 * @see {@link throttleTime}
 *
 * @param {number} period The sampling period expressed in milliseconds or the
 * time unit determined internally by the optional `scheduler`.
 * @param {Scheduler} [scheduler=async] The {@link IScheduler} to use for
 * managing the timers that handle the sampling.
 * @return {Observable<T>} An Observable that emits the results of sampling the
 * values emitted by the source Observable at the specified time interval.
 * @method sampleTime
 * @owner Observable
 */ function $e41b43010c369ea1$var$sampleTime(period, scheduler) {
    if (scheduler === void 0) scheduler = $3u6GG.async;
    return function(source) {
        return source.lift(new $e41b43010c369ea1$var$SampleTimeOperator(period, scheduler));
    };
}
module.exports.sampleTime = $e41b43010c369ea1$var$sampleTime;
var $e41b43010c369ea1$var$SampleTimeOperator = function() {
    function SampleTimeOperator(period, scheduler) {
        this.period = period;
        this.scheduler = scheduler;
    }
    SampleTimeOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $e41b43010c369ea1$var$SampleTimeSubscriber(subscriber, this.period, this.scheduler));
    };
    return SampleTimeOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $e41b43010c369ea1$var$SampleTimeSubscriber = function(_super) {
    $e41b43010c369ea1$var$__extends(SampleTimeSubscriber, _super);
    function SampleTimeSubscriber(destination, period, scheduler) {
        _super.call(this, destination);
        this.period = period;
        this.scheduler = scheduler;
        this.hasValue = false;
        this.add(scheduler.schedule($e41b43010c369ea1$var$dispatchNotification, period, {
            subscriber: this,
            period: period
        }));
    }
    SampleTimeSubscriber.prototype._next = function(value) {
        this.lastValue = value;
        this.hasValue = true;
    };
    SampleTimeSubscriber.prototype.notifyNext = function() {
        if (this.hasValue) {
            this.hasValue = false;
            this.destination.next(this.lastValue);
        }
    };
    return SampleTimeSubscriber;
}($axeml.Subscriber);
function $e41b43010c369ea1$var$dispatchNotification(state) {
    var subscriber = state.subscriber, period = state.period;
    subscriber.notifyNext();
    this.schedule(state, period);
}

});

parcelRegister("4Lrrt", function(module, exports) {
"use strict";
var $3780d69f2dbd28c3$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $axeml = parcelRequire("axeml");


var $3FcLR = parcelRequire("3FcLR");


var $6LPWz = parcelRequire("6LPWz");

/**
 * Compares all values of two observables in sequence using an optional comparor function
 * and returns an observable of a single boolean value representing whether or not the two sequences
 * are equal.
 *
 * <span class="informal">Checks to see of all values emitted by both observables are equal, in order.</span>
 *
 * <img src="./img/sequenceEqual.png" width="100%">
 *
 * `sequenceEqual` subscribes to two observables and buffers incoming values from each observable. Whenever either
 * observable emits a value, the value is buffered and the buffers are shifted and compared from the bottom
 * up; If any value pair doesn't match, the returned observable will emit `false` and complete. If one of the
 * observables completes, the operator will wait for the other observable to complete; If the other
 * observable emits before completing, the returned observable will emit `false` and complete. If one observable never
 * completes or emits after the other complets, the returned observable will never complete.
 *
 * @example <caption>figure out if the Konami code matches</caption>
 * var code = Rx.Observable.from([
 *  "ArrowUp",
 *  "ArrowUp",
 *  "ArrowDown",
 *  "ArrowDown",
 *  "ArrowLeft",
 *  "ArrowRight",
 *  "ArrowLeft",
 *  "ArrowRight",
 *  "KeyB",
 *  "KeyA",
 *  "Enter" // no start key, clearly.
 * ]);
 *
 * var keys = Rx.Observable.fromEvent(document, 'keyup')
 *  .map(e => e.code);
 * var matches = keys.bufferCount(11, 1)
 *  .mergeMap(
 *    last11 =>
 *      Rx.Observable.from(last11)
 *        .sequenceEqual(code)
 *   );
 * matches.subscribe(matched => console.log('Successful cheat at Contra? ', matched));
 *
 * @see {@link combineLatest}
 * @see {@link zip}
 * @see {@link withLatestFrom}
 *
 * @param {Observable} compareTo The observable sequence to compare the source sequence to.
 * @param {function} [comparor] An optional function to compare each value pair
 * @return {Observable} An Observable of a single boolean value representing whether or not
 * the values emitted by both observables were equal in sequence.
 * @method sequenceEqual
 * @owner Observable
 */ function $3780d69f2dbd28c3$var$sequenceEqual(compareTo, comparor) {
    return function(source) {
        return source.lift(new $3780d69f2dbd28c3$var$SequenceEqualOperator(compareTo, comparor));
    };
}
module.exports.sequenceEqual = $3780d69f2dbd28c3$var$sequenceEqual;
var $3780d69f2dbd28c3$var$SequenceEqualOperator = function() {
    function SequenceEqualOperator(compareTo, comparor) {
        this.compareTo = compareTo;
        this.comparor = comparor;
    }
    SequenceEqualOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $3780d69f2dbd28c3$var$SequenceEqualSubscriber(subscriber, this.compareTo, this.comparor));
    };
    return SequenceEqualOperator;
}();
module.exports.SequenceEqualOperator = $3780d69f2dbd28c3$var$SequenceEqualOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $3780d69f2dbd28c3$var$SequenceEqualSubscriber = function(_super) {
    $3780d69f2dbd28c3$var$__extends(SequenceEqualSubscriber, _super);
    function SequenceEqualSubscriber(destination, compareTo, comparor) {
        _super.call(this, destination);
        this.compareTo = compareTo;
        this.comparor = comparor;
        this._a = [];
        this._b = [];
        this._oneComplete = false;
        this.add(compareTo.subscribe(new $3780d69f2dbd28c3$var$SequenceEqualCompareToSubscriber(destination, this)));
    }
    SequenceEqualSubscriber.prototype._next = function(value) {
        if (this._oneComplete && this._b.length === 0) this.emit(false);
        else {
            this._a.push(value);
            this.checkValues();
        }
    };
    SequenceEqualSubscriber.prototype._complete = function() {
        if (this._oneComplete) this.emit(this._a.length === 0 && this._b.length === 0);
        else this._oneComplete = true;
    };
    SequenceEqualSubscriber.prototype.checkValues = function() {
        var _c = this, _a = _c._a, _b = _c._b, comparor = _c.comparor;
        while(_a.length > 0 && _b.length > 0){
            var a = _a.shift();
            var b = _b.shift();
            var areEqual = false;
            if (comparor) {
                areEqual = $3FcLR.tryCatch(comparor)(a, b);
                if (areEqual === $6LPWz.errorObject) this.destination.error($6LPWz.errorObject.e);
            } else areEqual = a === b;
            if (!areEqual) this.emit(false);
        }
    };
    SequenceEqualSubscriber.prototype.emit = function(value) {
        var destination = this.destination;
        destination.next(value);
        destination.complete();
    };
    SequenceEqualSubscriber.prototype.nextB = function(value) {
        if (this._oneComplete && this._a.length === 0) this.emit(false);
        else {
            this._b.push(value);
            this.checkValues();
        }
    };
    return SequenceEqualSubscriber;
}($axeml.Subscriber);
module.exports.SequenceEqualSubscriber = $3780d69f2dbd28c3$var$SequenceEqualSubscriber;
var $3780d69f2dbd28c3$var$SequenceEqualCompareToSubscriber = function(_super) {
    $3780d69f2dbd28c3$var$__extends(SequenceEqualCompareToSubscriber, _super);
    function SequenceEqualCompareToSubscriber(destination, parent) {
        _super.call(this, destination);
        this.parent = parent;
    }
    SequenceEqualCompareToSubscriber.prototype._next = function(value) {
        this.parent.nextB(value);
    };
    SequenceEqualCompareToSubscriber.prototype._error = function(err) {
        this.parent.error(err);
    };
    SequenceEqualCompareToSubscriber.prototype._complete = function() {
        this.parent._complete();
    };
    return SequenceEqualCompareToSubscriber;
}($axeml.Subscriber);

});

parcelRegister("gVc40", function(module, exports) {
"use strict";
var $c51b53cd79ffd8c7$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $axeml = parcelRequire("axeml");


var $3X9I5 = parcelRequire("3X9I5");

/**
 * Returns an Observable that emits the single item emitted by the source Observable that matches a specified
 * predicate, if that Observable emits one such item. If the source Observable emits more than one such item or no
 * such items, notify of an IllegalArgumentException or NoSuchElementException respectively.
 *
 * <img src="./img/single.png" width="100%">
 *
 * @throws {EmptyError} Delivers an EmptyError to the Observer's `error`
 * callback if the Observable completes before any `next` notification was sent.
 * @param {Function} predicate - A predicate function to evaluate items emitted by the source Observable.
 * @return {Observable<T>} An Observable that emits the single item emitted by the source Observable that matches
 * the predicate.
 .
 * @method single
 * @owner Observable
 */ function $c51b53cd79ffd8c7$var$single(predicate) {
    return function(source) {
        return source.lift(new $c51b53cd79ffd8c7$var$SingleOperator(predicate, source));
    };
}
module.exports.single = $c51b53cd79ffd8c7$var$single;
var $c51b53cd79ffd8c7$var$SingleOperator = function() {
    function SingleOperator(predicate, source) {
        this.predicate = predicate;
        this.source = source;
    }
    SingleOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $c51b53cd79ffd8c7$var$SingleSubscriber(subscriber, this.predicate, this.source));
    };
    return SingleOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $c51b53cd79ffd8c7$var$SingleSubscriber = function(_super) {
    $c51b53cd79ffd8c7$var$__extends(SingleSubscriber, _super);
    function SingleSubscriber(destination, predicate, source) {
        _super.call(this, destination);
        this.predicate = predicate;
        this.source = source;
        this.seenValue = false;
        this.index = 0;
    }
    SingleSubscriber.prototype.applySingleValue = function(value) {
        if (this.seenValue) this.destination.error('Sequence contains more than one element');
        else {
            this.seenValue = true;
            this.singleValue = value;
        }
    };
    SingleSubscriber.prototype._next = function(value) {
        var index = this.index++;
        if (this.predicate) this.tryNext(value, index);
        else this.applySingleValue(value);
    };
    SingleSubscriber.prototype.tryNext = function(value, index) {
        try {
            if (this.predicate(value, index, this.source)) this.applySingleValue(value);
        } catch (err) {
            this.destination.error(err);
        }
    };
    SingleSubscriber.prototype._complete = function() {
        var destination = this.destination;
        if (this.index > 0) {
            destination.next(this.seenValue ? this.singleValue : undefined);
            destination.complete();
        } else destination.error(new $3X9I5.EmptyError);
    };
    return SingleSubscriber;
}($axeml.Subscriber);

});

parcelRegister("bFxBy", function(module, exports) {
"use strict";
var $87ed973a594f176c$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $axeml = parcelRequire("axeml");

/**
 * Returns an Observable that skips the first `count` items emitted by the source Observable.
 *
 * <img src="./img/skip.png" width="100%">
 *
 * @param {Number} count - The number of times, items emitted by source Observable should be skipped.
 * @return {Observable} An Observable that skips values emitted by the source Observable.
 *
 * @method skip
 * @owner Observable
 */ function $87ed973a594f176c$var$skip(count) {
    return function(source) {
        return source.lift(new $87ed973a594f176c$var$SkipOperator(count));
    };
}
module.exports.skip = $87ed973a594f176c$var$skip;
var $87ed973a594f176c$var$SkipOperator = function() {
    function SkipOperator(total) {
        this.total = total;
    }
    SkipOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $87ed973a594f176c$var$SkipSubscriber(subscriber, this.total));
    };
    return SkipOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $87ed973a594f176c$var$SkipSubscriber = function(_super) {
    $87ed973a594f176c$var$__extends(SkipSubscriber, _super);
    function SkipSubscriber(destination, total) {
        _super.call(this, destination);
        this.total = total;
        this.count = 0;
    }
    SkipSubscriber.prototype._next = function(x) {
        if (++this.count > this.total) this.destination.next(x);
    };
    return SkipSubscriber;
}($axeml.Subscriber);

});

parcelRegister("3nfDH", function(module, exports) {
"use strict";
var $274fa6ba1c4b147d$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $axeml = parcelRequire("axeml");


var $2g0GA = parcelRequire("2g0GA");

/**
 * Skip the last `count` values emitted by the source Observable.
 *
 * <img src="./img/skipLast.png" width="100%">
 *
 * `skipLast` returns an Observable that accumulates a queue with a length
 * enough to store the first `count` values. As more values are received,
 * values are taken from the front of the queue and produced on the result
 * sequence. This causes values to be delayed.
 *
 * @example <caption>Skip the last 2 values of an Observable with many values</caption>
 * var many = Rx.Observable.range(1, 5);
 * var skipLastTwo = many.skipLast(2);
 * skipLastTwo.subscribe(x => console.log(x));
 *
 * // Results in:
 * // 1 2 3
 *
 * @see {@link skip}
 * @see {@link skipUntil}
 * @see {@link skipWhile}
 * @see {@link take}
 *
 * @throws {ArgumentOutOfRangeError} When using `skipLast(i)`, it throws
 * ArgumentOutOrRangeError if `i < 0`.
 *
 * @param {number} count Number of elements to skip from the end of the source Observable.
 * @returns {Observable<T>} An Observable that skips the last count values
 * emitted by the source Observable.
 * @method skipLast
 * @owner Observable
 */ function $274fa6ba1c4b147d$var$skipLast(count) {
    return function(source) {
        return source.lift(new $274fa6ba1c4b147d$var$SkipLastOperator(count));
    };
}
module.exports.skipLast = $274fa6ba1c4b147d$var$skipLast;
var $274fa6ba1c4b147d$var$SkipLastOperator = function() {
    function SkipLastOperator(_skipCount) {
        this._skipCount = _skipCount;
        if (this._skipCount < 0) throw new $2g0GA.ArgumentOutOfRangeError;
    }
    SkipLastOperator.prototype.call = function(subscriber, source) {
        if (this._skipCount === 0) // If we don't want to skip any values then just subscribe
        // to Subscriber without any further logic.
        return source.subscribe(new $axeml.Subscriber(subscriber));
        else return source.subscribe(new $274fa6ba1c4b147d$var$SkipLastSubscriber(subscriber, this._skipCount));
    };
    return SkipLastOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $274fa6ba1c4b147d$var$SkipLastSubscriber = function(_super) {
    $274fa6ba1c4b147d$var$__extends(SkipLastSubscriber, _super);
    function SkipLastSubscriber(destination, _skipCount) {
        _super.call(this, destination);
        this._skipCount = _skipCount;
        this._count = 0;
        this._ring = new Array(_skipCount);
    }
    SkipLastSubscriber.prototype._next = function(value) {
        var skipCount = this._skipCount;
        var count = this._count++;
        if (count < skipCount) this._ring[count] = value;
        else {
            var currentIndex = count % skipCount;
            var ring = this._ring;
            var oldValue = ring[currentIndex];
            ring[currentIndex] = value;
            this.destination.next(oldValue);
        }
    };
    return SkipLastSubscriber;
}($axeml.Subscriber);

});

parcelRegister("lDurq", function(module, exports) {
"use strict";
var $fc04da8297a68360$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $iwB6M = parcelRequire("iwB6M");


var $dZ9AU = parcelRequire("dZ9AU");

/**
 * Returns an Observable that skips items emitted by the source Observable until a second Observable emits an item.
 *
 * <img src="./img/skipUntil.png" width="100%">
 *
 * @param {Observable} notifier - The second Observable that has to emit an item before the source Observable's elements begin to
 * be mirrored by the resulting Observable.
 * @return {Observable<T>} An Observable that skips items from the source Observable until the second Observable emits
 * an item, then emits the remaining items.
 * @method skipUntil
 * @owner Observable
 */ function $fc04da8297a68360$var$skipUntil(notifier) {
    return function(source) {
        return source.lift(new $fc04da8297a68360$var$SkipUntilOperator(notifier));
    };
}
module.exports.skipUntil = $fc04da8297a68360$var$skipUntil;
var $fc04da8297a68360$var$SkipUntilOperator = function() {
    function SkipUntilOperator(notifier) {
        this.notifier = notifier;
    }
    SkipUntilOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $fc04da8297a68360$var$SkipUntilSubscriber(subscriber, this.notifier));
    };
    return SkipUntilOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $fc04da8297a68360$var$SkipUntilSubscriber = function(_super) {
    $fc04da8297a68360$var$__extends(SkipUntilSubscriber, _super);
    function SkipUntilSubscriber(destination, notifier) {
        _super.call(this, destination);
        this.hasValue = false;
        this.isInnerStopped = false;
        this.add($dZ9AU.subscribeToResult(this, notifier));
    }
    SkipUntilSubscriber.prototype._next = function(value) {
        if (this.hasValue) _super.prototype._next.call(this, value);
    };
    SkipUntilSubscriber.prototype._complete = function() {
        if (this.isInnerStopped) _super.prototype._complete.call(this);
        else this.unsubscribe();
    };
    SkipUntilSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.hasValue = true;
    };
    SkipUntilSubscriber.prototype.notifyComplete = function() {
        this.isInnerStopped = true;
        if (this.isStopped) _super.prototype._complete.call(this);
    };
    return SkipUntilSubscriber;
}($iwB6M.OuterSubscriber);

});

parcelRegister("a1Ene", function(module, exports) {
"use strict";
var $74c950c73157567d$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $iwB6M = parcelRequire("iwB6M");


var $dZ9AU = parcelRequire("dZ9AU");

/* tslint:enable:max-line-length */ /**
 * Projects each source value to the same Observable which is flattened multiple
 * times with {@link switch} in the output Observable.
 *
 * <span class="informal">It's like {@link switchMap}, but maps each value
 * always to the same inner Observable.</span>
 *
 * <img src="./img/switchMapTo.png" width="100%">
 *
 * Maps each source value to the given Observable `innerObservable` regardless
 * of the source value, and then flattens those resulting Observables into one
 * single Observable, which is the output Observable. The output Observables
 * emits values only from the most recently emitted instance of
 * `innerObservable`.
 *
 * @example <caption>Rerun an interval Observable on every click event</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.switchMapTo(Rx.Observable.interval(1000));
 * result.subscribe(x => console.log(x));
 *
 * @see {@link concatMapTo}
 * @see {@link switch}
 * @see {@link switchMap}
 * @see {@link mergeMapTo}
 *
 * @param {ObservableInput} innerObservable An Observable to replace each value from
 * the source Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @return {Observable} An Observable that emits items from the given
 * `innerObservable` (and optionally transformed through `resultSelector`) every
 * time a value is emitted on the source Observable, and taking only the values
 * from the most recently projected inner Observable.
 * @method switchMapTo
 * @owner Observable
 */ function $74c950c73157567d$var$switchMapTo(innerObservable, resultSelector) {
    return function(source) {
        return source.lift(new $74c950c73157567d$var$SwitchMapToOperator(innerObservable, resultSelector));
    };
}
module.exports.switchMapTo = $74c950c73157567d$var$switchMapTo;
var $74c950c73157567d$var$SwitchMapToOperator = function() {
    function SwitchMapToOperator(observable, resultSelector) {
        this.observable = observable;
        this.resultSelector = resultSelector;
    }
    SwitchMapToOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $74c950c73157567d$var$SwitchMapToSubscriber(subscriber, this.observable, this.resultSelector));
    };
    return SwitchMapToOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $74c950c73157567d$var$SwitchMapToSubscriber = function(_super) {
    $74c950c73157567d$var$__extends(SwitchMapToSubscriber, _super);
    function SwitchMapToSubscriber(destination, inner, resultSelector) {
        _super.call(this, destination);
        this.inner = inner;
        this.resultSelector = resultSelector;
        this.index = 0;
    }
    SwitchMapToSubscriber.prototype._next = function(value) {
        var innerSubscription = this.innerSubscription;
        if (innerSubscription) innerSubscription.unsubscribe();
        this.add(this.innerSubscription = $dZ9AU.subscribeToResult(this, this.inner, value, this.index++));
    };
    SwitchMapToSubscriber.prototype._complete = function() {
        var innerSubscription = this.innerSubscription;
        if (!innerSubscription || innerSubscription.closed) _super.prototype._complete.call(this);
    };
    /** @deprecated internal use only */ SwitchMapToSubscriber.prototype._unsubscribe = function() {
        this.innerSubscription = null;
    };
    SwitchMapToSubscriber.prototype.notifyComplete = function(innerSub) {
        this.remove(innerSub);
        this.innerSubscription = null;
        if (this.isStopped) _super.prototype._complete.call(this);
    };
    SwitchMapToSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        var _a = this, resultSelector = _a.resultSelector, destination = _a.destination;
        if (resultSelector) this.tryResultSelector(outerValue, innerValue, outerIndex, innerIndex);
        else destination.next(innerValue);
    };
    SwitchMapToSubscriber.prototype.tryResultSelector = function(outerValue, innerValue, outerIndex, innerIndex) {
        var _a = this, resultSelector = _a.resultSelector, destination = _a.destination;
        var result;
        try {
            result = resultSelector(outerValue, innerValue, outerIndex, innerIndex);
        } catch (err) {
            destination.error(err);
            return;
        }
        destination.next(result);
    };
    return SwitchMapToSubscriber;
}($iwB6M.OuterSubscriber);

});

parcelRegister("ghTt7", function(module, exports) {
"use strict";
var $bdb942c9e90a22f4$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $iwB6M = parcelRequire("iwB6M");


var $dZ9AU = parcelRequire("dZ9AU");

/**
 * Emits the values emitted by the source Observable until a `notifier`
 * Observable emits a value.
 *
 * <span class="informal">Lets values pass until a second Observable,
 * `notifier`, emits something. Then, it completes.</span>
 *
 * <img src="./img/takeUntil.png" width="100%">
 *
 * `takeUntil` subscribes and begins mirroring the source Observable. It also
 * monitors a second Observable, `notifier` that you provide. If the `notifier`
 * emits a value or a complete notification, the output Observable stops
 * mirroring the source Observable and completes.
 *
 * @example <caption>Tick every second until the first click happens</caption>
 * var interval = Rx.Observable.interval(1000);
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = interval.takeUntil(clicks);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link take}
 * @see {@link takeLast}
 * @see {@link takeWhile}
 * @see {@link skip}
 *
 * @param {Observable} notifier The Observable whose first emitted value will
 * cause the output Observable of `takeUntil` to stop emitting values from the
 * source Observable.
 * @return {Observable<T>} An Observable that emits the values from the source
 * Observable until such time as `notifier` emits its first value.
 * @method takeUntil
 * @owner Observable
 */ function $bdb942c9e90a22f4$var$takeUntil(notifier) {
    return function(source) {
        return source.lift(new $bdb942c9e90a22f4$var$TakeUntilOperator(notifier));
    };
}
module.exports.takeUntil = $bdb942c9e90a22f4$var$takeUntil;
var $bdb942c9e90a22f4$var$TakeUntilOperator = function() {
    function TakeUntilOperator(notifier) {
        this.notifier = notifier;
    }
    TakeUntilOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $bdb942c9e90a22f4$var$TakeUntilSubscriber(subscriber, this.notifier));
    };
    return TakeUntilOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $bdb942c9e90a22f4$var$TakeUntilSubscriber = function(_super) {
    $bdb942c9e90a22f4$var$__extends(TakeUntilSubscriber, _super);
    function TakeUntilSubscriber(destination, notifier) {
        _super.call(this, destination);
        this.notifier = notifier;
        this.add($dZ9AU.subscribeToResult(this, notifier));
    }
    TakeUntilSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.complete();
    };
    TakeUntilSubscriber.prototype.notifyComplete = function() {
    // noop
    };
    return TakeUntilSubscriber;
}($iwB6M.OuterSubscriber);

});

parcelRegister("6ssFC", function(module, exports) {
"use strict";
var $4b3b98f13c19830b$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $axeml = parcelRequire("axeml");

/**
 * Emits values emitted by the source Observable so long as each value satisfies
 * the given `predicate`, and then completes as soon as this `predicate` is not
 * satisfied.
 *
 * <span class="informal">Takes values from the source only while they pass the
 * condition given. When the first value does not satisfy, it completes.</span>
 *
 * <img src="./img/takeWhile.png" width="100%">
 *
 * `takeWhile` subscribes and begins mirroring the source Observable. Each value
 * emitted on the source is given to the `predicate` function which returns a
 * boolean, representing a condition to be satisfied by the source values. The
 * output Observable emits the source values until such time as the `predicate`
 * returns false, at which point `takeWhile` stops mirroring the source
 * Observable and completes the output Observable.
 *
 * @example <caption>Emit click events only while the clientX property is greater than 200</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.takeWhile(ev => ev.clientX > 200);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link take}
 * @see {@link takeLast}
 * @see {@link takeUntil}
 * @see {@link skip}
 *
 * @param {function(value: T, index: number): boolean} predicate A function that
 * evaluates a value emitted by the source Observable and returns a boolean.
 * Also takes the (zero-based) index as the second argument.
 * @return {Observable<T>} An Observable that emits the values from the source
 * Observable so long as each value satisfies the condition defined by the
 * `predicate`, then completes.
 * @method takeWhile
 * @owner Observable
 */ function $4b3b98f13c19830b$var$takeWhile(predicate) {
    return function(source) {
        return source.lift(new $4b3b98f13c19830b$var$TakeWhileOperator(predicate));
    };
}
module.exports.takeWhile = $4b3b98f13c19830b$var$takeWhile;
var $4b3b98f13c19830b$var$TakeWhileOperator = function() {
    function TakeWhileOperator(predicate) {
        this.predicate = predicate;
    }
    TakeWhileOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $4b3b98f13c19830b$var$TakeWhileSubscriber(subscriber, this.predicate));
    };
    return TakeWhileOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $4b3b98f13c19830b$var$TakeWhileSubscriber = function(_super) {
    $4b3b98f13c19830b$var$__extends(TakeWhileSubscriber, _super);
    function TakeWhileSubscriber(destination, predicate) {
        _super.call(this, destination);
        this.predicate = predicate;
        this.index = 0;
    }
    TakeWhileSubscriber.prototype._next = function(value) {
        var destination = this.destination;
        var result;
        try {
            result = this.predicate(value, this.index++);
        } catch (err) {
            destination.error(err);
            return;
        }
        this.nextOrComplete(value, result);
    };
    TakeWhileSubscriber.prototype.nextOrComplete = function(value, predicateResult) {
        var destination = this.destination;
        if (Boolean(predicateResult)) destination.next(value);
        else destination.complete();
    };
    return TakeWhileSubscriber;
}($axeml.Subscriber);

});

parcelRegister("jb2dN", function(module, exports) {
"use strict";
var $df60c49313124e01$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $iwB6M = parcelRequire("iwB6M");


var $dZ9AU = parcelRequire("dZ9AU");

module.exports.defaultThrottleConfig = {
    leading: true,
    trailing: false
};
/**
 * Emits a value from the source Observable, then ignores subsequent source
 * values for a duration determined by another Observable, then repeats this
 * process.
 *
 * <span class="informal">It's like {@link throttleTime}, but the silencing
 * duration is determined by a second Observable.</span>
 *
 * <img src="./img/throttle.png" width="100%">
 *
 * `throttle` emits the source Observable values on the output Observable
 * when its internal timer is disabled, and ignores source values when the timer
 * is enabled. Initially, the timer is disabled. As soon as the first source
 * value arrives, it is forwarded to the output Observable, and then the timer
 * is enabled by calling the `durationSelector` function with the source value,
 * which returns the "duration" Observable. When the duration Observable emits a
 * value or completes, the timer is disabled, and this process repeats for the
 * next source value.
 *
 * @example <caption>Emit clicks at a rate of at most one click per second</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.throttle(ev => Rx.Observable.interval(1000));
 * result.subscribe(x => console.log(x));
 *
 * @see {@link audit}
 * @see {@link debounce}
 * @see {@link delayWhen}
 * @see {@link sample}
 * @see {@link throttleTime}
 *
 * @param {function(value: T): SubscribableOrPromise} durationSelector A function
 * that receives a value from the source Observable, for computing the silencing
 * duration for each source value, returned as an Observable or a Promise.
 * @param {Object} config a configuration object to define `leading` and `trailing` behavior. Defaults
 * to `{ leading: true, trailing: false }`.
 * @return {Observable<T>} An Observable that performs the throttle operation to
 * limit the rate of emissions from the source.
 * @method throttle
 * @owner Observable
 */ function $df60c49313124e01$var$throttle(durationSelector, config) {
    if (config === void 0) config = module.exports.defaultThrottleConfig;
    return function(source) {
        return source.lift(new $df60c49313124e01$var$ThrottleOperator(durationSelector, config.leading, config.trailing));
    };
}
module.exports.throttle = $df60c49313124e01$var$throttle;
var $df60c49313124e01$var$ThrottleOperator = function() {
    function ThrottleOperator(durationSelector, leading, trailing) {
        this.durationSelector = durationSelector;
        this.leading = leading;
        this.trailing = trailing;
    }
    ThrottleOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $df60c49313124e01$var$ThrottleSubscriber(subscriber, this.durationSelector, this.leading, this.trailing));
    };
    return ThrottleOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc
 * @ignore
 * @extends {Ignored}
 */ var $df60c49313124e01$var$ThrottleSubscriber = function(_super) {
    $df60c49313124e01$var$__extends(ThrottleSubscriber, _super);
    function ThrottleSubscriber(destination, durationSelector, _leading, _trailing) {
        _super.call(this, destination);
        this.destination = destination;
        this.durationSelector = durationSelector;
        this._leading = _leading;
        this._trailing = _trailing;
        this._hasTrailingValue = false;
    }
    ThrottleSubscriber.prototype._next = function(value) {
        if (this.throttled) {
            if (this._trailing) {
                this._hasTrailingValue = true;
                this._trailingValue = value;
            }
        } else {
            var duration = this.tryDurationSelector(value);
            if (duration) this.add(this.throttled = $dZ9AU.subscribeToResult(this, duration));
            if (this._leading) {
                this.destination.next(value);
                if (this._trailing) {
                    this._hasTrailingValue = true;
                    this._trailingValue = value;
                }
            }
        }
    };
    ThrottleSubscriber.prototype.tryDurationSelector = function(value) {
        try {
            return this.durationSelector(value);
        } catch (err) {
            this.destination.error(err);
            return null;
        }
    };
    /** @deprecated internal use only */ ThrottleSubscriber.prototype._unsubscribe = function() {
        var _a = this, throttled = _a.throttled, _trailingValue = _a._trailingValue, _hasTrailingValue = _a._hasTrailingValue, _trailing = _a._trailing;
        this._trailingValue = null;
        this._hasTrailingValue = false;
        if (throttled) {
            this.remove(throttled);
            this.throttled = null;
            throttled.unsubscribe();
        }
    };
    ThrottleSubscriber.prototype._sendTrailing = function() {
        var _a = this, destination = _a.destination, throttled = _a.throttled, _trailing = _a._trailing, _trailingValue = _a._trailingValue, _hasTrailingValue = _a._hasTrailingValue;
        if (throttled && _trailing && _hasTrailingValue) {
            destination.next(_trailingValue);
            this._trailingValue = null;
            this._hasTrailingValue = false;
        }
    };
    ThrottleSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this._sendTrailing();
        this._unsubscribe();
    };
    ThrottleSubscriber.prototype.notifyComplete = function() {
        this._sendTrailing();
        this._unsubscribe();
    };
    return ThrottleSubscriber;
}($iwB6M.OuterSubscriber);

});

parcelRegister("9Kcfz", function(module, exports) {
"use strict";
var $7181e9893e83a606$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $axeml = parcelRequire("axeml");


var $3u6GG = parcelRequire("3u6GG");


var $jb2dN = parcelRequire("jb2dN");

/**
 * Emits a value from the source Observable, then ignores subsequent source
 * values for `duration` milliseconds, then repeats this process.
 *
 * <span class="informal">Lets a value pass, then ignores source values for the
 * next `duration` milliseconds.</span>
 *
 * <img src="./img/throttleTime.png" width="100%">
 *
 * `throttleTime` emits the source Observable values on the output Observable
 * when its internal timer is disabled, and ignores source values when the timer
 * is enabled. Initially, the timer is disabled. As soon as the first source
 * value arrives, it is forwarded to the output Observable, and then the timer
 * is enabled. After `duration` milliseconds (or the time unit determined
 * internally by the optional `scheduler`) has passed, the timer is disabled,
 * and this process repeats for the next source value. Optionally takes a
 * {@link IScheduler} for managing timers.
 *
 * @example <caption>Emit clicks at a rate of at most one click per second</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.throttleTime(1000);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link auditTime}
 * @see {@link debounceTime}
 * @see {@link delay}
 * @see {@link sampleTime}
 * @see {@link throttle}
 *
 * @param {number} duration Time to wait before emitting another value after
 * emitting the last value, measured in milliseconds or the time unit determined
 * internally by the optional `scheduler`.
 * @param {Scheduler} [scheduler=async] The {@link IScheduler} to use for
 * managing the timers that handle the throttling.
 * @return {Observable<T>} An Observable that performs the throttle operation to
 * limit the rate of emissions from the source.
 * @method throttleTime
 * @owner Observable
 */ function $7181e9893e83a606$var$throttleTime(duration, scheduler, config) {
    if (scheduler === void 0) scheduler = $3u6GG.async;
    if (config === void 0) config = $jb2dN.defaultThrottleConfig;
    return function(source) {
        return source.lift(new $7181e9893e83a606$var$ThrottleTimeOperator(duration, scheduler, config.leading, config.trailing));
    };
}
module.exports.throttleTime = $7181e9893e83a606$var$throttleTime;
var $7181e9893e83a606$var$ThrottleTimeOperator = function() {
    function ThrottleTimeOperator(duration, scheduler, leading, trailing) {
        this.duration = duration;
        this.scheduler = scheduler;
        this.leading = leading;
        this.trailing = trailing;
    }
    ThrottleTimeOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $7181e9893e83a606$var$ThrottleTimeSubscriber(subscriber, this.duration, this.scheduler, this.leading, this.trailing));
    };
    return ThrottleTimeOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $7181e9893e83a606$var$ThrottleTimeSubscriber = function(_super) {
    $7181e9893e83a606$var$__extends(ThrottleTimeSubscriber, _super);
    function ThrottleTimeSubscriber(destination, duration, scheduler, leading, trailing) {
        _super.call(this, destination);
        this.duration = duration;
        this.scheduler = scheduler;
        this.leading = leading;
        this.trailing = trailing;
        this._hasTrailingValue = false;
        this._trailingValue = null;
    }
    ThrottleTimeSubscriber.prototype._next = function(value) {
        if (this.throttled) {
            if (this.trailing) {
                this._trailingValue = value;
                this._hasTrailingValue = true;
            }
        } else {
            this.add(this.throttled = this.scheduler.schedule($7181e9893e83a606$var$dispatchNext, this.duration, {
                subscriber: this
            }));
            if (this.leading) this.destination.next(value);
        }
    };
    ThrottleTimeSubscriber.prototype.clearThrottle = function() {
        var throttled = this.throttled;
        if (throttled) {
            if (this.trailing && this._hasTrailingValue) {
                this.destination.next(this._trailingValue);
                this._trailingValue = null;
                this._hasTrailingValue = false;
            }
            throttled.unsubscribe();
            this.remove(throttled);
            this.throttled = null;
        }
    };
    return ThrottleTimeSubscriber;
}($axeml.Subscriber);
function $7181e9893e83a606$var$dispatchNext(arg) {
    var subscriber = arg.subscriber;
    subscriber.clearThrottle();
}

});

parcelRegister("hkdng", function(module, exports) {
"use strict";
var $c9ceadc4ca861d09$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $3u6GG = parcelRequire("3u6GG");


var $kVeeY = parcelRequire("kVeeY");


var $iwB6M = parcelRequire("iwB6M");


var $dZ9AU = parcelRequire("dZ9AU");

/* tslint:enable:max-line-length */ /**
 *
 * Errors if Observable does not emit a value in given time span, in case of which
 * subscribes to the second Observable.
 *
 * <span class="informal">It's a version of `timeout` operator that let's you specify fallback Observable.</span>
 *
 * <img src="./img/timeoutWith.png" width="100%">
 *
 * `timeoutWith` is a variation of `timeout` operator. It behaves exactly the same,
 * still accepting as a first argument either a number or a Date, which control - respectively -
 * when values of source Observable should be emitted or when it should complete.
 *
 * The only difference is that it accepts a second, required parameter. This parameter
 * should be an Observable which will be subscribed when source Observable fails any timeout check.
 * So whenever regular `timeout` would emit an error, `timeoutWith` will instead start re-emitting
 * values from second Observable. Note that this fallback Observable is not checked for timeouts
 * itself, so it can emit values and complete at arbitrary points in time. From the moment of a second
 * subscription, Observable returned from `timeoutWith` simply mirrors fallback stream. When that
 * stream completes, it completes as well.
 *
 * Scheduler, which in case of `timeout` is provided as as second argument, can be still provided
 * here - as a third, optional parameter. It still is used to schedule timeout checks and -
 * as a consequence - when second Observable will be subscribed, since subscription happens
 * immediately after failing check.
 *
 * @example <caption>Add fallback observable</caption>
 * const seconds = Rx.Observable.interval(1000);
 * const minutes = Rx.Observable.interval(60 * 1000);
 *
 * seconds.timeoutWith(900, minutes)
 *     .subscribe(
 *         value => console.log(value), // After 900ms, will start emitting `minutes`,
 *                                      // since first value of `seconds` will not arrive fast enough.
 *         err => console.log(err) // Would be called after 900ms in case of `timeout`,
 *                                 // but here will never be called.
 *     );
 *
 * @param {number|Date} due Number specifying period within which Observable must emit values
 *                          or Date specifying before when Observable should complete
 * @param {Observable<T>} withObservable Observable which will be subscribed if source fails timeout check.
 * @param {Scheduler} [scheduler] Scheduler controlling when timeout checks occur.
 * @return {Observable<T>} Observable that mirrors behaviour of source or, when timeout check fails, of an Observable
 *                          passed as a second parameter.
 * @method timeoutWith
 * @owner Observable
 */ function $c9ceadc4ca861d09$var$timeoutWith(due, withObservable, scheduler) {
    if (scheduler === void 0) scheduler = $3u6GG.async;
    return function(source) {
        var absoluteTimeout = $kVeeY.isDate(due);
        var waitFor = absoluteTimeout ? +due - scheduler.now() : Math.abs(due);
        return source.lift(new $c9ceadc4ca861d09$var$TimeoutWithOperator(waitFor, absoluteTimeout, withObservable, scheduler));
    };
}
module.exports.timeoutWith = $c9ceadc4ca861d09$var$timeoutWith;
var $c9ceadc4ca861d09$var$TimeoutWithOperator = function() {
    function TimeoutWithOperator(waitFor, absoluteTimeout, withObservable, scheduler) {
        this.waitFor = waitFor;
        this.absoluteTimeout = absoluteTimeout;
        this.withObservable = withObservable;
        this.scheduler = scheduler;
    }
    TimeoutWithOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $c9ceadc4ca861d09$var$TimeoutWithSubscriber(subscriber, this.absoluteTimeout, this.waitFor, this.withObservable, this.scheduler));
    };
    return TimeoutWithOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $c9ceadc4ca861d09$var$TimeoutWithSubscriber = function(_super) {
    $c9ceadc4ca861d09$var$__extends(TimeoutWithSubscriber, _super);
    function TimeoutWithSubscriber(destination, absoluteTimeout, waitFor, withObservable, scheduler) {
        _super.call(this, destination);
        this.absoluteTimeout = absoluteTimeout;
        this.waitFor = waitFor;
        this.withObservable = withObservable;
        this.scheduler = scheduler;
        this.action = null;
        this.scheduleTimeout();
    }
    TimeoutWithSubscriber.dispatchTimeout = function(subscriber) {
        var withObservable = subscriber.withObservable;
        subscriber._unsubscribeAndRecycle();
        subscriber.add($dZ9AU.subscribeToResult(subscriber, withObservable));
    };
    TimeoutWithSubscriber.prototype.scheduleTimeout = function() {
        var action = this.action;
        if (action) // Recycle the action if we've already scheduled one. All the production
        // Scheduler Actions mutate their state/delay time and return themeselves.
        // VirtualActions are immutable, so they create and return a clone. In this
        // case, we need to set the action reference to the most recent VirtualAction,
        // to ensure that's the one we clone from next time.
        this.action = action.schedule(this, this.waitFor);
        else this.add(this.action = this.scheduler.schedule(TimeoutWithSubscriber.dispatchTimeout, this.waitFor, this));
    };
    TimeoutWithSubscriber.prototype._next = function(value) {
        if (!this.absoluteTimeout) this.scheduleTimeout();
        _super.prototype._next.call(this, value);
    };
    /** @deprecated internal use only */ TimeoutWithSubscriber.prototype._unsubscribe = function() {
        this.action = null;
        this.scheduler = null;
        this.withObservable = null;
    };
    return TimeoutWithSubscriber;
}($iwB6M.OuterSubscriber);

});

parcelRegister("4MF2G", function(module, exports) {
"use strict";
var $37bb7b3c605f6934$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $axeml = parcelRequire("axeml");


var $augeV = parcelRequire("augeV");

/**
 * Branch out the source Observable values as a nested Observable with each
 * nested Observable emitting at most `windowSize` values.
 *
 * <span class="informal">It's like {@link bufferCount}, but emits a nested
 * Observable instead of an array.</span>
 *
 * <img src="./img/windowCount.png" width="100%">
 *
 * Returns an Observable that emits windows of items it collects from the source
 * Observable. The output Observable emits windows every `startWindowEvery`
 * items, each containing no more than `windowSize` items. When the source
 * Observable completes or encounters an error, the output Observable emits
 * the current window and propagates the notification from the source
 * Observable. If `startWindowEvery` is not provided, then new windows are
 * started immediately at the start of the source and when each window completes
 * with size `windowSize`.
 *
 * @example <caption>Ignore every 3rd click event, starting from the first one</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.windowCount(3)
 *   .map(win => win.skip(1)) // skip first of every 3 clicks
 *   .mergeAll(); // flatten the Observable-of-Observables
 * result.subscribe(x => console.log(x));
 *
 * @example <caption>Ignore every 3rd click event, starting from the third one</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.windowCount(2, 3)
 *   .mergeAll(); // flatten the Observable-of-Observables
 * result.subscribe(x => console.log(x));
 *
 * @see {@link window}
 * @see {@link windowTime}
 * @see {@link windowToggle}
 * @see {@link windowWhen}
 * @see {@link bufferCount}
 *
 * @param {number} windowSize The maximum number of values emitted by each
 * window.
 * @param {number} [startWindowEvery] Interval at which to start a new window.
 * For example if `startWindowEvery` is `2`, then a new window will be started
 * on every other value from the source. A new window is started at the
 * beginning of the source by default.
 * @return {Observable<Observable<T>>} An Observable of windows, which in turn
 * are Observable of values.
 * @method windowCount
 * @owner Observable
 */ function $37bb7b3c605f6934$var$windowCount(windowSize, startWindowEvery) {
    if (startWindowEvery === void 0) startWindowEvery = 0;
    return function windowCountOperatorFunction(source) {
        return source.lift(new $37bb7b3c605f6934$var$WindowCountOperator(windowSize, startWindowEvery));
    };
}
module.exports.windowCount = $37bb7b3c605f6934$var$windowCount;
var $37bb7b3c605f6934$var$WindowCountOperator = function() {
    function WindowCountOperator(windowSize, startWindowEvery) {
        this.windowSize = windowSize;
        this.startWindowEvery = startWindowEvery;
    }
    WindowCountOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $37bb7b3c605f6934$var$WindowCountSubscriber(subscriber, this.windowSize, this.startWindowEvery));
    };
    return WindowCountOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $37bb7b3c605f6934$var$WindowCountSubscriber = function(_super) {
    $37bb7b3c605f6934$var$__extends(WindowCountSubscriber, _super);
    function WindowCountSubscriber(destination, windowSize, startWindowEvery) {
        _super.call(this, destination);
        this.destination = destination;
        this.windowSize = windowSize;
        this.startWindowEvery = startWindowEvery;
        this.windows = [
            new $augeV.Subject()
        ];
        this.count = 0;
        destination.next(this.windows[0]);
    }
    WindowCountSubscriber.prototype._next = function(value) {
        var startWindowEvery = this.startWindowEvery > 0 ? this.startWindowEvery : this.windowSize;
        var destination = this.destination;
        var windowSize = this.windowSize;
        var windows = this.windows;
        var len = windows.length;
        for(var i = 0; i < len && !this.closed; i++)windows[i].next(value);
        var c = this.count - windowSize + 1;
        if (c >= 0 && c % startWindowEvery === 0 && !this.closed) windows.shift().complete();
        if (++this.count % startWindowEvery === 0 && !this.closed) {
            var window_1 = new $augeV.Subject();
            windows.push(window_1);
            destination.next(window_1);
        }
    };
    WindowCountSubscriber.prototype._error = function(err) {
        var windows = this.windows;
        if (windows) while(windows.length > 0 && !this.closed)windows.shift().error(err);
        this.destination.error(err);
    };
    WindowCountSubscriber.prototype._complete = function() {
        var windows = this.windows;
        if (windows) while(windows.length > 0 && !this.closed)windows.shift().complete();
        this.destination.complete();
    };
    /** @deprecated internal use only */ WindowCountSubscriber.prototype._unsubscribe = function() {
        this.count = 0;
        this.windows = null;
    };
    return WindowCountSubscriber;
}($axeml.Subscriber);

});

parcelRegister("7ssQI", function(module, exports) {
"use strict";
var $56e186d014032beb$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $augeV = parcelRequire("augeV");


var $3u6GG = parcelRequire("3u6GG");


var $axeml = parcelRequire("axeml");


var $8biLX = parcelRequire("8biLX");


var $5Dgek = parcelRequire("5Dgek");

function $56e186d014032beb$var$windowTime(windowTimeSpan) {
    var scheduler = $3u6GG.async;
    var windowCreationInterval = null;
    var maxWindowSize = Number.POSITIVE_INFINITY;
    if ($5Dgek.isScheduler(arguments[3])) scheduler = arguments[3];
    if ($5Dgek.isScheduler(arguments[2])) scheduler = arguments[2];
    else if ($8biLX.isNumeric(arguments[2])) maxWindowSize = arguments[2];
    if ($5Dgek.isScheduler(arguments[1])) scheduler = arguments[1];
    else if ($8biLX.isNumeric(arguments[1])) windowCreationInterval = arguments[1];
    return function windowTimeOperatorFunction(source) {
        return source.lift(new $56e186d014032beb$var$WindowTimeOperator(windowTimeSpan, windowCreationInterval, maxWindowSize, scheduler));
    };
}
module.exports.windowTime = $56e186d014032beb$var$windowTime;
var $56e186d014032beb$var$WindowTimeOperator = function() {
    function WindowTimeOperator(windowTimeSpan, windowCreationInterval, maxWindowSize, scheduler) {
        this.windowTimeSpan = windowTimeSpan;
        this.windowCreationInterval = windowCreationInterval;
        this.maxWindowSize = maxWindowSize;
        this.scheduler = scheduler;
    }
    WindowTimeOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $56e186d014032beb$var$WindowTimeSubscriber(subscriber, this.windowTimeSpan, this.windowCreationInterval, this.maxWindowSize, this.scheduler));
    };
    return WindowTimeOperator;
}();
var $56e186d014032beb$var$CountedSubject = function(_super) {
    $56e186d014032beb$var$__extends(CountedSubject, _super);
    function CountedSubject() {
        _super.apply(this, arguments);
        this._numberOfNextedValues = 0;
    }
    CountedSubject.prototype.next = function(value) {
        this._numberOfNextedValues++;
        _super.prototype.next.call(this, value);
    };
    Object.defineProperty(CountedSubject.prototype, "numberOfNextedValues", {
        get: function() {
            return this._numberOfNextedValues;
        },
        enumerable: true,
        configurable: true
    });
    return CountedSubject;
}($augeV.Subject);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $56e186d014032beb$var$WindowTimeSubscriber = function(_super) {
    $56e186d014032beb$var$__extends(WindowTimeSubscriber, _super);
    function WindowTimeSubscriber(destination, windowTimeSpan, windowCreationInterval, maxWindowSize, scheduler) {
        _super.call(this, destination);
        this.destination = destination;
        this.windowTimeSpan = windowTimeSpan;
        this.windowCreationInterval = windowCreationInterval;
        this.maxWindowSize = maxWindowSize;
        this.scheduler = scheduler;
        this.windows = [];
        var window = this.openWindow();
        if (windowCreationInterval !== null && windowCreationInterval >= 0) {
            var closeState = {
                subscriber: this,
                window: window,
                context: null
            };
            var creationState = {
                windowTimeSpan: windowTimeSpan,
                windowCreationInterval: windowCreationInterval,
                subscriber: this,
                scheduler: scheduler
            };
            this.add(scheduler.schedule($56e186d014032beb$var$dispatchWindowClose, windowTimeSpan, closeState));
            this.add(scheduler.schedule($56e186d014032beb$var$dispatchWindowCreation, windowCreationInterval, creationState));
        } else {
            var timeSpanOnlyState = {
                subscriber: this,
                window: window,
                windowTimeSpan: windowTimeSpan
            };
            this.add(scheduler.schedule($56e186d014032beb$var$dispatchWindowTimeSpanOnly, windowTimeSpan, timeSpanOnlyState));
        }
    }
    WindowTimeSubscriber.prototype._next = function(value) {
        var windows = this.windows;
        var len = windows.length;
        for(var i = 0; i < len; i++){
            var window_1 = windows[i];
            if (!window_1.closed) {
                window_1.next(value);
                if (window_1.numberOfNextedValues >= this.maxWindowSize) this.closeWindow(window_1);
            }
        }
    };
    WindowTimeSubscriber.prototype._error = function(err) {
        var windows = this.windows;
        while(windows.length > 0)windows.shift().error(err);
        this.destination.error(err);
    };
    WindowTimeSubscriber.prototype._complete = function() {
        var windows = this.windows;
        while(windows.length > 0){
            var window_2 = windows.shift();
            if (!window_2.closed) window_2.complete();
        }
        this.destination.complete();
    };
    WindowTimeSubscriber.prototype.openWindow = function() {
        var window = new $56e186d014032beb$var$CountedSubject();
        this.windows.push(window);
        var destination = this.destination;
        destination.next(window);
        return window;
    };
    WindowTimeSubscriber.prototype.closeWindow = function(window) {
        window.complete();
        var windows = this.windows;
        windows.splice(windows.indexOf(window), 1);
    };
    return WindowTimeSubscriber;
}($axeml.Subscriber);
function $56e186d014032beb$var$dispatchWindowTimeSpanOnly(state) {
    var subscriber = state.subscriber, windowTimeSpan = state.windowTimeSpan, window = state.window;
    if (window) subscriber.closeWindow(window);
    state.window = subscriber.openWindow();
    this.schedule(state, windowTimeSpan);
}
function $56e186d014032beb$var$dispatchWindowCreation(state) {
    var windowTimeSpan = state.windowTimeSpan, subscriber = state.subscriber, scheduler = state.scheduler, windowCreationInterval = state.windowCreationInterval;
    var window = subscriber.openWindow();
    var action = this;
    var context = {
        action: action,
        subscription: null
    };
    var timeSpanState = {
        subscriber: subscriber,
        window: window,
        context: context
    };
    context.subscription = scheduler.schedule($56e186d014032beb$var$dispatchWindowClose, windowTimeSpan, timeSpanState);
    action.add(context.subscription);
    action.schedule(state, windowCreationInterval);
}
function $56e186d014032beb$var$dispatchWindowClose(state) {
    var subscriber = state.subscriber, window = state.window, context = state.context;
    if (context && context.action && context.subscription) context.action.remove(context.subscription);
    subscriber.closeWindow(window);
}

});

parcelRegister("Cr5z9", function(module, exports) {
"use strict";
var $07388ffd9ec7ec3d$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $augeV = parcelRequire("augeV");


var $8v4h5 = parcelRequire("8v4h5");


var $3FcLR = parcelRequire("3FcLR");


var $6LPWz = parcelRequire("6LPWz");


var $iwB6M = parcelRequire("iwB6M");


var $dZ9AU = parcelRequire("dZ9AU");

/**
 * Branch out the source Observable values as a nested Observable starting from
 * an emission from `openings` and ending when the output of `closingSelector`
 * emits.
 *
 * <span class="informal">It's like {@link bufferToggle}, but emits a nested
 * Observable instead of an array.</span>
 *
 * <img src="./img/windowToggle.png" width="100%">
 *
 * Returns an Observable that emits windows of items it collects from the source
 * Observable. The output Observable emits windows that contain those items
 * emitted by the source Observable between the time when the `openings`
 * Observable emits an item and when the Observable returned by
 * `closingSelector` emits an item.
 *
 * @example <caption>Every other second, emit the click events from the next 500ms</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var openings = Rx.Observable.interval(1000);
 * var result = clicks.windowToggle(openings, i =>
 *   i % 2 ? Rx.Observable.interval(500) : Rx.Observable.empty()
 * ).mergeAll();
 * result.subscribe(x => console.log(x));
 *
 * @see {@link window}
 * @see {@link windowCount}
 * @see {@link windowTime}
 * @see {@link windowWhen}
 * @see {@link bufferToggle}
 *
 * @param {Observable<O>} openings An observable of notifications to start new
 * windows.
 * @param {function(value: O): Observable} closingSelector A function that takes
 * the value emitted by the `openings` observable and returns an Observable,
 * which, when it emits (either `next` or `complete`), signals that the
 * associated window should complete.
 * @return {Observable<Observable<T>>} An observable of windows, which in turn
 * are Observables.
 * @method windowToggle
 * @owner Observable
 */ function $07388ffd9ec7ec3d$var$windowToggle(openings, closingSelector) {
    return function(source) {
        return source.lift(new $07388ffd9ec7ec3d$var$WindowToggleOperator(openings, closingSelector));
    };
}
module.exports.windowToggle = $07388ffd9ec7ec3d$var$windowToggle;
var $07388ffd9ec7ec3d$var$WindowToggleOperator = function() {
    function WindowToggleOperator(openings, closingSelector) {
        this.openings = openings;
        this.closingSelector = closingSelector;
    }
    WindowToggleOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $07388ffd9ec7ec3d$var$WindowToggleSubscriber(subscriber, this.openings, this.closingSelector));
    };
    return WindowToggleOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $07388ffd9ec7ec3d$var$WindowToggleSubscriber = function(_super) {
    $07388ffd9ec7ec3d$var$__extends(WindowToggleSubscriber, _super);
    function WindowToggleSubscriber(destination, openings, closingSelector) {
        _super.call(this, destination);
        this.openings = openings;
        this.closingSelector = closingSelector;
        this.contexts = [];
        this.add(this.openSubscription = $dZ9AU.subscribeToResult(this, openings, openings));
    }
    WindowToggleSubscriber.prototype._next = function(value) {
        var contexts = this.contexts;
        if (contexts) {
            var len = contexts.length;
            for(var i = 0; i < len; i++)contexts[i].window.next(value);
        }
    };
    WindowToggleSubscriber.prototype._error = function(err) {
        var contexts = this.contexts;
        this.contexts = null;
        if (contexts) {
            var len = contexts.length;
            var index = -1;
            while(++index < len){
                var context = contexts[index];
                context.window.error(err);
                context.subscription.unsubscribe();
            }
        }
        _super.prototype._error.call(this, err);
    };
    WindowToggleSubscriber.prototype._complete = function() {
        var contexts = this.contexts;
        this.contexts = null;
        if (contexts) {
            var len = contexts.length;
            var index = -1;
            while(++index < len){
                var context = contexts[index];
                context.window.complete();
                context.subscription.unsubscribe();
            }
        }
        _super.prototype._complete.call(this);
    };
    /** @deprecated internal use only */ WindowToggleSubscriber.prototype._unsubscribe = function() {
        var contexts = this.contexts;
        this.contexts = null;
        if (contexts) {
            var len = contexts.length;
            var index = -1;
            while(++index < len){
                var context = contexts[index];
                context.window.unsubscribe();
                context.subscription.unsubscribe();
            }
        }
    };
    WindowToggleSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        if (outerValue === this.openings) {
            var closingSelector = this.closingSelector;
            var closingNotifier = $3FcLR.tryCatch(closingSelector)(innerValue);
            if (closingNotifier === $6LPWz.errorObject) return this.error($6LPWz.errorObject.e);
            else {
                var window_1 = new $augeV.Subject();
                var subscription = new $8v4h5.Subscription();
                var context = {
                    window: window_1,
                    subscription: subscription
                };
                this.contexts.push(context);
                var innerSubscription = $dZ9AU.subscribeToResult(this, closingNotifier, context);
                if (innerSubscription.closed) this.closeWindow(this.contexts.length - 1);
                else {
                    innerSubscription.context = context;
                    subscription.add(innerSubscription);
                }
                this.destination.next(window_1);
            }
        } else this.closeWindow(this.contexts.indexOf(outerValue));
    };
    WindowToggleSubscriber.prototype.notifyError = function(err) {
        this.error(err);
    };
    WindowToggleSubscriber.prototype.notifyComplete = function(inner) {
        if (inner !== this.openSubscription) this.closeWindow(this.contexts.indexOf(inner.context));
    };
    WindowToggleSubscriber.prototype.closeWindow = function(index) {
        if (index === -1) return;
        var contexts = this.contexts;
        var context = contexts[index];
        var window = context.window, subscription = context.subscription;
        contexts.splice(index, 1);
        window.complete();
        subscription.unsubscribe();
    };
    return WindowToggleSubscriber;
}($iwB6M.OuterSubscriber);

});

parcelRegister("5A6fs", function(module, exports) {
"use strict";
var $41052950c60e0d40$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $augeV = parcelRequire("augeV");


var $3FcLR = parcelRequire("3FcLR");


var $6LPWz = parcelRequire("6LPWz");


var $iwB6M = parcelRequire("iwB6M");


var $dZ9AU = parcelRequire("dZ9AU");

/**
 * Branch out the source Observable values as a nested Observable using a
 * factory function of closing Observables to determine when to start a new
 * window.
 *
 * <span class="informal">It's like {@link bufferWhen}, but emits a nested
 * Observable instead of an array.</span>
 *
 * <img src="./img/windowWhen.png" width="100%">
 *
 * Returns an Observable that emits windows of items it collects from the source
 * Observable. The output Observable emits connected, non-overlapping windows.
 * It emits the current window and opens a new one whenever the Observable
 * produced by the specified `closingSelector` function emits an item. The first
 * window is opened immediately when subscribing to the output Observable.
 *
 * @example <caption>Emit only the first two clicks events in every window of [1-5] random seconds</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks
 *   .windowWhen(() => Rx.Observable.interval(1000 + Math.random() * 4000))
 *   .map(win => win.take(2)) // each window has at most 2 emissions
 *   .mergeAll(); // flatten the Observable-of-Observables
 * result.subscribe(x => console.log(x));
 *
 * @see {@link window}
 * @see {@link windowCount}
 * @see {@link windowTime}
 * @see {@link windowToggle}
 * @see {@link bufferWhen}
 *
 * @param {function(): Observable} closingSelector A function that takes no
 * arguments and returns an Observable that signals (on either `next` or
 * `complete`) when to close the previous window and start a new one.
 * @return {Observable<Observable<T>>} An observable of windows, which in turn
 * are Observables.
 * @method windowWhen
 * @owner Observable
 */ function $41052950c60e0d40$var$windowWhen(closingSelector) {
    return function windowWhenOperatorFunction(source) {
        return source.lift(new $41052950c60e0d40$var$WindowOperator(closingSelector));
    };
}
module.exports.windowWhen = $41052950c60e0d40$var$windowWhen;
var $41052950c60e0d40$var$WindowOperator = function() {
    function WindowOperator(closingSelector) {
        this.closingSelector = closingSelector;
    }
    WindowOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $41052950c60e0d40$var$WindowSubscriber(subscriber, this.closingSelector));
    };
    return WindowOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $41052950c60e0d40$var$WindowSubscriber = function(_super) {
    $41052950c60e0d40$var$__extends(WindowSubscriber, _super);
    function WindowSubscriber(destination, closingSelector) {
        _super.call(this, destination);
        this.destination = destination;
        this.closingSelector = closingSelector;
        this.openWindow();
    }
    WindowSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.openWindow(innerSub);
    };
    WindowSubscriber.prototype.notifyError = function(error, innerSub) {
        this._error(error);
    };
    WindowSubscriber.prototype.notifyComplete = function(innerSub) {
        this.openWindow(innerSub);
    };
    WindowSubscriber.prototype._next = function(value) {
        this.window.next(value);
    };
    WindowSubscriber.prototype._error = function(err) {
        this.window.error(err);
        this.destination.error(err);
        this.unsubscribeClosingNotification();
    };
    WindowSubscriber.prototype._complete = function() {
        this.window.complete();
        this.destination.complete();
        this.unsubscribeClosingNotification();
    };
    WindowSubscriber.prototype.unsubscribeClosingNotification = function() {
        if (this.closingNotification) this.closingNotification.unsubscribe();
    };
    WindowSubscriber.prototype.openWindow = function(innerSub) {
        if (innerSub === void 0) innerSub = null;
        if (innerSub) {
            this.remove(innerSub);
            innerSub.unsubscribe();
        }
        var prevWindow = this.window;
        if (prevWindow) prevWindow.complete();
        var window = this.window = new $augeV.Subject();
        this.destination.next(window);
        var closingNotifier = $3FcLR.tryCatch(this.closingSelector)();
        if (closingNotifier === $6LPWz.errorObject) {
            var err = $6LPWz.errorObject.e;
            this.destination.error(err);
            this.window.error(err);
        } else this.add(this.closingNotification = $dZ9AU.subscribeToResult(this, closingNotifier));
    };
    return WindowSubscriber;
}($iwB6M.OuterSubscriber);

});

parcelRegister("6zLY4", function(module, exports) {
"use strict";
var $4c9b385c1afeef89$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $iwB6M = parcelRequire("iwB6M");


var $dZ9AU = parcelRequire("dZ9AU");

/* tslint:enable:max-line-length */ /**
 * Combines the source Observable with other Observables to create an Observable
 * whose values are calculated from the latest values of each, only when the
 * source emits.
 *
 * <span class="informal">Whenever the source Observable emits a value, it
 * computes a formula using that value plus the latest values from other input
 * Observables, then emits the output of that formula.</span>
 *
 * <img src="./img/withLatestFrom.png" width="100%">
 *
 * `withLatestFrom` combines each value from the source Observable (the
 * instance) with the latest values from the other input Observables only when
 * the source emits a value, optionally using a `project` function to determine
 * the value to be emitted on the output Observable. All input Observables must
 * emit at least one value before the output Observable will emit a value.
 *
 * @example <caption>On every click event, emit an array with the latest timer event plus the click event</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var timer = Rx.Observable.interval(1000);
 * var result = clicks.withLatestFrom(timer);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link combineLatest}
 *
 * @param {ObservableInput} other An input Observable to combine with the source
 * Observable. More than one input Observables may be given as argument.
 * @param {Function} [project] Projection function for combining values
 * together. Receives all values in order of the Observables passed, where the
 * first parameter is a value from the source Observable. (e.g.
 * `a.withLatestFrom(b, c, (a1, b1, c1) => a1 + b1 + c1)`). If this is not
 * passed, arrays will be emitted on the output Observable.
 * @return {Observable} An Observable of projected values from the most recent
 * values from each input Observable, or an array of the most recent values from
 * each input Observable.
 * @method withLatestFrom
 * @owner Observable
 */ function $4c9b385c1afeef89$var$withLatestFrom() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i - 0] = arguments[_i];
    return function(source) {
        var project;
        if (typeof args[args.length - 1] === 'function') project = args.pop();
        var observables = args;
        return source.lift(new $4c9b385c1afeef89$var$WithLatestFromOperator(observables, project));
    };
}
module.exports.withLatestFrom = $4c9b385c1afeef89$var$withLatestFrom;
var $4c9b385c1afeef89$var$WithLatestFromOperator = function() {
    function WithLatestFromOperator(observables, project) {
        this.observables = observables;
        this.project = project;
    }
    WithLatestFromOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $4c9b385c1afeef89$var$WithLatestFromSubscriber(subscriber, this.observables, this.project));
    };
    return WithLatestFromOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $4c9b385c1afeef89$var$WithLatestFromSubscriber = function(_super) {
    $4c9b385c1afeef89$var$__extends(WithLatestFromSubscriber, _super);
    function WithLatestFromSubscriber(destination, observables, project) {
        _super.call(this, destination);
        this.observables = observables;
        this.project = project;
        this.toRespond = [];
        var len = observables.length;
        this.values = new Array(len);
        for(var i = 0; i < len; i++)this.toRespond.push(i);
        for(var i = 0; i < len; i++){
            var observable = observables[i];
            this.add($dZ9AU.subscribeToResult(this, observable, observable, i));
        }
    }
    WithLatestFromSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.values[outerIndex] = innerValue;
        var toRespond = this.toRespond;
        if (toRespond.length > 0) {
            var found = toRespond.indexOf(outerIndex);
            if (found !== -1) toRespond.splice(found, 1);
        }
    };
    WithLatestFromSubscriber.prototype.notifyComplete = function() {
    // noop
    };
    WithLatestFromSubscriber.prototype._next = function(value) {
        if (this.toRespond.length === 0) {
            var args = [
                value
            ].concat(this.values);
            if (this.project) this._tryProject(args);
            else this.destination.next(args);
        }
    };
    WithLatestFromSubscriber.prototype._tryProject = function(args) {
        var result;
        try {
            result = this.project.apply(this, args);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(result);
    };
    return WithLatestFromSubscriber;
}($iwB6M.OuterSubscriber);

});

parcelRegister("5KKq4", function(module, exports) {

var $42omo = parcelRequire("42omo");

parcelRequire("2oer2");
var $cbr0D = parcelRequire("cbr0D");


var $8pcS0 = parcelRequire("8pcS0");


var $eS4Za = parcelRequire("eS4Za");


var $5ho0B = parcelRequire("5ho0B");


var $c8uPc = parcelRequire("c8uPc");


var $fuLIO = parcelRequire("fuLIO");


var $5kjCz = parcelRequire("5kjCz");


var $4KFTW = parcelRequire("4KFTW");


var $aJPUt = parcelRequire("aJPUt");

const $851f0e008a3a2296$export$5620f4aefea0d093 = ()=>({
        [(0, $8pcS0.EXTENSION_TYPE).MACRO_CORE]: $851f0e008a3a2296$export$7ac8bd70029a2fa(),
        [(0, $8pcS0.EXTENSION_TYPE).MIGRATION]: (0, $5ho0B.getTemplateMigrationExtHandler)(),
        [(0, $8pcS0.EXTENSION_TYPE).TEMPLATE]: (0, $cbr0D.getTemplateExtensionHandler)
    });
const $851f0e008a3a2296$export$7ac8bd70029a2fa = ()=>(0, $eS4Za.createMacroExtensionHandler)((extension)=>{
        const { extensionKey: extensionKey } = extension;
        const attributes = (0, $5kjCz.getMacroAttributesFromADFNode)(extension);
        const templateId = '0';
        const macroDefaultProps = {
            node: extension,
            contentId: templateId,
            mode: 'editor',
            extensionKey: extensionKey,
            attributes: attributes
        };
        let implementation;
        switch(extensionKey){
            // whitelist (CFE-2326)
            case 'detailssummary':
            case 'recently-updated':
            case 'children':
            case 'attachments':
            case 'contentbylabel':
            case 'profile-picture':
            case 'pagetree':
            case 'include':
            case 'tasks-report-macro':
            case 'profile':
            case 'widget':
            case 'excerpt-include':
            case 'spaces':
                implementation = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fuLIO.LegacyMacroRendererQuery), macroDefaultProps);
                break;
            default:
                implementation = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c8uPc.DeadMacroRenderer), macroDefaultProps);
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4KFTW.MacroExperienceStart), {
            name: (0, $5kjCz.getExperienceName)((0, $5kjCz.EDITOR), extension),
            contentId: templateId,
            mode: (0, $5kjCz.EDITOR),
            extensionKey: extensionKey,
            attributes: attributes,
            timeout: (0, $aJPUt.ExperienceTimeout).MACRO_LOAD
        }), implementation);
    });

});

parcelRegister("j2dS3", function(module, exports) {
function $a9c66c4a525522c3$export$e2b5c5db9e2009fd(node) {
    return node.type.name || node.type;
}
function $a9c66c4a525522c3$export$8198c5b4e81b9082(node, newParams) {
    return {
        type: $a9c66c4a525522c3$export$e2b5c5db9e2009fd(node),
        attrs: {
            ...node.attrs,
            parameters: {
                ...node.attrs.parameters,
                ...newParams
            }
        }
    };
}
function $a9c66c4a525522c3$export$d1c50812de760a07(root, callbackFunc) {
    for (const nodeKey of Object.keys(root)){
        const nodeValue = root[nodeKey];
        callbackFunc(nodeKey, nodeValue);
        // go deeper
        if (nodeValue !== null && typeof nodeValue === 'object') $a9c66c4a525522c3$export$d1c50812de760a07(root[nodeKey], callbackFunc);
    }
}
function $a9c66c4a525522c3$export$676214b4858262c1(root, typeName) {
    const results = [];
    $a9c66c4a525522c3$export$d1c50812de760a07(root, (_nodeKey, nodeValue)=>{
        if (nodeValue && nodeValue.type === typeName) results.push(nodeValue);
    });
    return results;
}
module.exports["updateParams"] = $a9c66c4a525522c3$export$8198c5b4e81b9082;
module.exports["filterADNodesByType"] = $a9c66c4a525522c3$export$676214b4858262c1;

});

parcelRegister("7okiz", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $lspPP = parcelRequire("lspPP");


var $fUN4A = parcelRequire("fUN4A");


var $6O2BV = parcelRequire("6O2BV");


var $hFueH = parcelRequire("hFueH");





var $jmjWc = parcelRequire("jmjWc");

const $a3bfb2f361b9631e$export$e34f51b2cfaca368 = ()=>null;



const $93c4a623cfe89294$export$8b14718323f670aa = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "QOMzx",
    name: "RedactedPlaceholderExtensionHandler",
    loader: async ()=>{
        const { RedactedPlaceholder: RedactedPlaceholder } = await (parcelRequire("cjG4e"));
        return RedactedPlaceholder;
    },
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a3bfb2f361b9631e$export$e34f51b2cfaca368), null)
});



var $ge2sX = parcelRequire("ge2sX");


var $aJPUt = parcelRequire("aJPUt");


var $5kjCz = parcelRequire("5kjCz");


var $4KFTW = parcelRequire("4KFTW");


var $5a4cC = parcelRequire("5a4cC");


var $9m03g = parcelRequire("9m03g");


var $9JyIJ = parcelRequire("9JyIJ");


var $fuLIO = parcelRequire("fuLIO");


var $7NX4e = parcelRequire("7NX4e");


var $bQCqI = parcelRequire("bQCqI");


var $8pcS0 = parcelRequire("8pcS0");


var $eS4Za = parcelRequire("eS4Za");


var $hMRhJ = parcelRequire("hMRhJ");


var $l86Zj = parcelRequire("l86Zj");


var $6v9Za = parcelRequire("6v9Za");


var $2LCBF = parcelRequire("2LCBF");


var $hKeSi = parcelRequire("hKeSi");


var $Qcu7n = parcelRequire("Qcu7n");


var $e1Stz = parcelRequire("e1Stz");


var $e8Lxy = parcelRequire("e8Lxy");


var $fBjVq = parcelRequire("fBjVq");





var $1DWH0 = parcelRequire("1DWH0");


var $78QFu = parcelRequire("78QFu");


var $2E7zk = parcelRequire("2E7zk");

const $4f09d12458901289$export$9eec8c53e410de67 = (0, $1DWH0.default)()(class extends (0, $42omo.Component) {
    async componentDidMount() {
        const { createAnalyticsEvent: createAnalyticsEvent, extensionKey: extensionKey, attributes: attributes, node: node } = this.props;
        if (createAnalyticsEvent) {
            const jiraHostingOption = await (0, $2E7zk.getJiraHostingOption)(extensionKey, node?.parameters?.macroParams?.serverId?.value, true);
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'viewed',
                    actionSubject: 'macro',
                    actionSubjectId: extensionKey,
                    source: 'viewPageScreen',
                    attributes: {
                        ...attributes,
                        pageLoadInfo: (0, $78QFu.getUniquePageLoadId)(),
                        jiraHostingOption: jiraHostingOption
                    }
                }
            }).fire();
        }
    }
    render() {
        const { children: children } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, children);
    }
});


parcelRequire("2oer2");
var $cbr0D = parcelRequire("cbr0D");








var $cYJC5 = parcelRequire("cYJC5");

const $f19eca96759725e5$export$30c773822372f598 = ({ hasADF: hasADF, macroDefaultProps: macroDefaultProps, cloudId: cloudId, userId: userId, isPreviewMode: isPreviewMode, shouldLoadAfterPaint: shouldLoadAfterPaint })=>{
    if (!hasADF) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fuLIO.LegacyMacroRendererQuery), macroDefaultProps);
    return shouldLoadAfterPaint || isPreviewMode ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cYJC5.LazyCreateFromTemplateLoader), {
        userId: userId,
        cloudId: cloudId,
        macroDefaultProps: macroDefaultProps,
        isPreviewMode: isPreviewMode
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cYJC5.CreateFromTemplateLoader), {
        userId: userId,
        cloudId: cloudId,
        macroDefaultProps: macroDefaultProps,
        isPreviewMode: isPreviewMode
    });
};









var $6mEZ3 = parcelRequire("6mEZ3");


var $l7BGZ = parcelRequire("l7BGZ");

const $1fa3854e066af442$export$e8ac5007ab7a695a = ({ hasADF: hasADF, macroDefaultProps: macroDefaultProps, shouldLoadAfterPaint: shouldLoadAfterPaint })=>{
    // Fallback to LegacyMacroRenderer when adf string is not defined
    if (!hasADF) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fuLIO.LegacyMacroRendererQuery), macroDefaultProps);
    const { node: node } = macroDefaultProps;
    const macroNode = (0, $6mEZ3.extensionToADF)(node);
    return shouldLoadAfterPaint ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $l7BGZ.LazyLiveSearchLoader), {
        macroNode: macroNode
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $l7BGZ.LiveSearchLoader), {
        macroNode: macroNode
    });
};









var $dwS6P = parcelRequire("dwS6P");

const $ab0c2ef401baeb08$export$cf1c26fcb7e6ff9f = ({ adf: adf, macroDefaultProps: macroDefaultProps, cloudId: cloudId, userId: userId, shouldLoadAfterPaint: shouldLoadAfterPaint })=>{
    if (!adf) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fuLIO.LegacyMacroRendererQuery), macroDefaultProps);
    return shouldLoadAfterPaint ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dwS6P.LazyTableOfContentsLoader), {
        userId: userId,
        cloudId: cloudId,
        adf: adf,
        macroDefaultProps: macroDefaultProps
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dwS6P.TableOfContentsLoader), {
        userId: userId,
        cloudId: cloudId,
        adf: adf,
        macroDefaultProps: macroDefaultProps
    });
};



var $2XqLN = parcelRequire("2XqLN");


var $dx8CK = parcelRequire("dx8CK");

const $3bd71c84d7d120d2$var$memoAdfParsed = (0, $2XqLN.default)((adf)=>{
    let result = adf;
    if (typeof adf === 'string') try {
        result = JSON.parse(adf);
    } catch (e) {
        result = {
            version: 1,
            type: 'doc',
            content: []
        };
    }
    return result;
});
const $3bd71c84d7d120d2$export$c25b654b62d7c7b4 = ({ adf: adf, extensionParams: extensionParams, referentialityDataSourceProvider: referentialityDataSourceProvider, children: children })=>{
    const adfParsed = $3bd71c84d7d120d2$var$memoAdfParsed(adf);
    const { references: references } = (0, $dx8CK.useReference)({
        adf: adfParsed,
        extensionParams: extensionParams,
        dataSourceProvider: referentialityDataSourceProvider
    });
    return children({
        references: references
    });
};


var $27d039b331e27185$var$Styles = /*#__PURE__*/ function(Styles) {
    Styles["None"] = "none";
    Styles["Mixed"] = "mixed";
    Styles["Bullet"] = "bullet";
    Styles["Circle"] = "circle";
    Styles["Square"] = "square";
    Styles["Number"] = "number";
    return Styles;
}($27d039b331e27185$var$Styles || {});
var $27d039b331e27185$var$Separators = /*#__PURE__*/ function(Separators) {
    Separators["Brackets"] = "brackets";
    Separators["Braces"] = "braces";
    Separators["Pipe"] = "pipe";
    return Separators;
}($27d039b331e27185$var$Separators || {});
const $27d039b331e27185$export$b7595b0733376572 = (macroName, trackingData, createAnalyticsEvent, contentId)=>{
    const { minLevel: minLevel, maxLevel: maxLevel, outline: outline, type: type, printable: printable, style: style, separator: separator, include: include, exclude: exclude, indent: indent } = trackingData;
    const sensitiveData = {
        include: include?.value.length > 0 || false,
        exclude: exclude?.value.length > 0 || false,
        class: trackingData.class?.value.length > 0 || false,
        indent: indent?.value.length > 0 || false
    };
    // in the unlikely event these dropdown fields become custom input text, ensure no PII is logged
    const separatorValue = Object.values($27d039b331e27185$var$Separators).includes(separator?.value) ? separator?.value : 'invalid';
    const styleValue = Object.values($27d039b331e27185$var$Styles).includes(style?.value) ? style?.value : 'invalid';
    const potentiallySensitiveData = {};
    if (type) {
        if (type.value === 'flat') potentiallySensitiveData['separator'] = separatorValue;
        else if (type.value === 'list') potentiallySensitiveData['style'] = styleValue;
    } else potentiallySensitiveData['style'] = 'mixed';
    const nonSensitiveData = {
        minLevel: parseInt(minLevel?.value) || 1,
        maxLevel: parseInt(maxLevel?.value) || 6,
        outline: outline?.value === 'true' || false,
        printable: printable?.value === 'false' || true,
        type: type?.value === 'flat' ? 'flat' : 'list'
    };
    createAnalyticsEvent({
        type: 'sendTrackEvent',
        data: {
            action: 'viewed',
            actionSubject: 'macro',
            actionSubjectId: macroName,
            source: 'on page view',
            attributes: {
                pageID: contentId,
                ...sensitiveData,
                ...potentiallySensitiveData,
                ...nonSensitiveData
            },
            eventType: 'track'
        }
    }).fire();
};


const $53f1c3cb11bcb25b$export$fe33197d44e10fcf = ({ adf: adf, contentId: contentId, appearance: appearance, showTemplateVariablesInPreview: showTemplateVariablesInPreview, showTemplateInputInPreview: showTemplateInputInPreview, spaceKey: spaceKey, shouldIncludeMacroHandlers: shouldIncludeMacroHandlers = true, macroRenderedOutput: macroRenderedOutput, shouldIncludeMacroWithReferencesHandlers: shouldIncludeMacroWithReferencesHandlers = false, referentialityDataSourceProvider: referentialityDataSourceProvider, fromFabricEditor: fromFabricEditor = false, isPreviewMode: isPreviewMode = false, contentType: contentType, mediaToken: mediaToken, annotationProvider: annotationProvider, isInEditorRendererView: isInEditorRendererView }, createAnalyticsEvent)=>{
    const getMacroExtensionHandler = $53f1c3cb11bcb25b$export$d1ab742fa63c927c;
    const getTemplateHandler = showTemplateInputInPreview ? (0, $cbr0D.getTemplateVariableInputExtensionHandler) : (0, $cbr0D.getTemplateExtensionHandler);
    const templateHandler = showTemplateVariablesInPreview ? {
        [(0, $8pcS0.EXTENSION_TYPE).TEMPLATE]: getTemplateHandler
    } : {};
    const macroWithReferences = shouldIncludeMacroWithReferencesHandlers ? {
        [(0, $8pcS0.EXTENSION_TYPE).MACRO_WITH_REFERENCES]: $53f1c3cb11bcb25b$export$97164d5210648f5e({
            adf: adf,
            referentialityDataSourceProvider: referentialityDataSourceProvider
        })
    } : {};
    return shouldIncludeMacroHandlers ? {
        [(0, $8pcS0.EXTENSION_TYPE).MACRO_CORE]: getMacroExtensionHandler({
            adf: adf,
            appearance: appearance,
            contentId: contentId,
            showTemplateVariablesInPreview: showTemplateVariablesInPreview,
            showTemplateInputInPreview: showTemplateInputInPreview,
            spaceKey: spaceKey,
            macroRenderedOutput: macroRenderedOutput,
            referentialityDataSourceProvider: referentialityDataSourceProvider,
            fromFabricEditor: fromFabricEditor,
            isPreviewMode: isPreviewMode,
            contentType: contentType,
            mediaToken: mediaToken,
            annotationProvider: annotationProvider,
            isInEditorRendererView: isInEditorRendererView
        }, createAnalyticsEvent),
        [(0, $8pcS0.EXTENSION_TYPE).MIGRATION]: (0, $bQCqI.getMigrationExtHandlerForRenderer)({
            contentId: contentId,
            contextProviders: {
                ClassicEditorContextProvider: (0, $fUN4A.ClassicEditorContextProviderLazyLoader)
            }
        }),
        ...macroWithReferences,
        ...templateHandler
    } : {};
};
const $53f1c3cb11bcb25b$var$providers = {
    getExtensionHandlers: $53f1c3cb11bcb25b$export$fe33197d44e10fcf,
    EditorLoaderLoader: // CONFCLOUD-72035 - Make sure we are ALWAYS including the EditorLoaderLoader when loading
    //                   legacy macros or else the attachments macro WILL NOT WORK
    $hFueH.default
};
const $53f1c3cb11bcb25b$export$164cd9171430f0a5 = (isMacroSSRD, macroDefaultProps)=>{
    // if SSR Macros FF is disabled, page is not SSRd, or there are no macros on the page, do nothing
    if (!window.__SSR_RENDERED__ || !window?.__SSR_MACROS_INFO__) return;
    const { extensionKey: extensionKey } = macroDefaultProps;
    if (isMacroSSRD) {
        window.__SSR_MACROS_INFO__.successes[extensionKey] = (window.__SSR_MACROS_INFO__.successes[extensionKey] ?? 0) + 1;
        window.__SSR_MACROS_INFO__.successCount += 1;
    } else {
        window.__SSR_MACROS_INFO__.failures[extensionKey] = (window.__SSR_MACROS_INFO__.failures[extensionKey] ?? 0) + 1;
        window.__SSR_MACROS_INFO__.failureCount += 1;
    }
};
const $53f1c3cb11bcb25b$export$adb86c58ecb79d9c = (macroDefaultProps)=>{
    const { attributes: { macroId: macroId } } = macroDefaultProps;
    return Boolean(window?.__LEGACY_MACRO_RENDERED_OUTPUT__?.find((el)=>el.key === macroId));
};
const $53f1c3cb11bcb25b$export$97164d5210648f5e = ({ adf: adf, referentialityDataSourceProvider: referentialityDataSourceProvider })=>{
    const extensionHandlerWithReferences = (extension, extensionHandler)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3bd71c84d7d120d2$export$c25b654b62d7c7b4), {
            adf: adf,
            extensionParams: extension,
            referentialityDataSourceProvider: referentialityDataSourceProvider
        }, extensionHandler);
    };
    return extensionHandlerWithReferences;
};
const $53f1c3cb11bcb25b$export$d1ab742fa63c927c = ({ adf: adf, contentId: contentId, appearance: appearance, showTemplateVariablesInPreview: showTemplateVariablesInPreview, showTemplateInputInPreview: showTemplateInputInPreview, spaceKey: spaceKey, macroRenderedOutput: macroRenderedOutput, referentialityDataSourceProvider: referentialityDataSourceProvider, fromFabricEditor: fromFabricEditor, isPreviewMode: isPreviewMode, contentType: contentType, mediaToken: mediaToken, annotationProvider: annotationProvider, isInEditorRendererView: isInEditorRendererView }, createAnalyticsEvent)=>(0, $eS4Za.createMacroExtensionHandler)((extension, doc)=>{
        let { extensionKey: extensionKey } = extension;
        const resolvedExtensionKey = (0, $Qcu7n.resolveQuestionsMacroExtensionKey)(extensionKey);
        if (resolvedExtensionKey !== extensionKey) {
            extensionKey = resolvedExtensionKey;
            extension = {
                ...extension,
                extensionKey: resolvedExtensionKey
            };
        }
        const attributes = (0, $5kjCz.getMacroAttributesFromADFNode)(extension);
        const macroParams = extension?.parameters?.macroParams;
        const multiBodiedExtensionActions = doc?.[0]?.actions;
        const isBodiedMacro = extension?.type === 'bodiedExtension';
        const shouldUseDebouncedLegacyMacroRenderer = isBodiedMacro && isInEditorRendererView;
        // When isInEditorRendererView is true, we are rendering the macro in the editor renderer view.
        // In this scenario adf isn't passed to the macro extension handler as prop because we do not have access to
        // the adf from where we are using the macro extension handler. We can instead get the adf from the doc object provided to the handler.
        adf = isInEditorRendererView && !adf && !!doc ? doc?.[0] : adf;
        const attributesForAnalytics = {
            extensionType: extension?.type,
            ...extensionKey === 'excerpt-include' ? {
                isExcerptNamePresent: !!macroParams?.name
            } : undefined,
            ...extensionKey === 'gadget' && macroParams?.url?.value && {
                gadgetUrl: new URL(macroParams.url.value, location.origin).pathname
            }
        };
        const redactedAttributes = extensionKey === 'redactedMacroPlaceholder' ? {
            extensionKey: macroParams?.redactedMacroPluginKey?.value || macroParams?.redactedMacroExtensionKey?.value
        } : undefined;
        const isMissingMacroParameters = macroParams?.isMissingRequiredParameters?.value;
        const contentHandler = (macroDefaultProps, cloudId, userId)=>{
            const excerptMacroProps = {
                ...macroDefaultProps,
                appearance: appearance
            };
            const macroOutput = extension?.parameters?.macroOutput;
            if (extensionKey === 'toc' && macroParams && createAnalyticsEvent) (0, $27d039b331e27185$export$b7595b0733376572)(extensionKey, macroParams, createAnalyticsEvent, contentId);
            const legacyMacroRenderer = ()=>{
                const isMacroSSRD = window.__SSR_RENDERED__ && $53f1c3cb11bcb25b$export$adb86c58ecb79d9c(macroDefaultProps) && !isMissingMacroParameters;
                $53f1c3cb11bcb25b$export$164cd9171430f0a5(isMacroSSRD, macroDefaultProps);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hMRhJ.RendererExtensionContext).Provider, {
                    value: $53f1c3cb11bcb25b$var$providers
                }, shouldUseDebouncedLegacyMacroRenderer ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fuLIO.DebouncedLegacyMacroRendererQuery), {
                    ...macroDefaultProps,
                    isTemplateEditorRenderer: showTemplateVariablesInPreview,
                    macroRenderedOutputFromSSR: isMacroSSRD && macroRenderedOutput,
                    macroOutput: macroOutput,
                    isPreviewMode: isPreviewMode,
                    isInEditorRendererView: isInEditorRendererView
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fuLIO.LegacyMacroRendererQuery), {
                    ...macroDefaultProps,
                    isTemplateEditorRenderer: showTemplateVariablesInPreview,
                    macroRenderedOutputFromSSR: isMacroSSRD && macroRenderedOutput,
                    macroOutput: macroOutput,
                    isPreviewMode: isPreviewMode
                }));
            };
            switch(extensionKey){
                case 'redactedMacroPlaceholder':
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $93c4a623cfe89294$export$8b14718323f670aa), {
                        ...macroDefaultProps,
                        redactedAttributes: redactedAttributes
                    });
                case 'details':
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hKeSi.DetailsExtensionHandler), {
                        ...macroDefaultProps,
                        spaceKey: spaceKey,
                        Renderer: (0, $fBjVq.default),
                        isLegacyRenderer: true,
                        annotationProvider: annotationProvider
                    });
                case 'excerpt':
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2LCBF.ExcerptExtensionHandler), {
                        ...excerptMacroProps,
                        spaceKey: spaceKey,
                        Renderer: (0, $fBjVq.default),
                        isLegacyRenderer: true,
                        mediaToken: mediaToken,
                        annotationProvider: annotationProvider
                    });
                case 'expand':
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6v9Za.ExpandExtensionHandler), {
                        ...macroDefaultProps,
                        Renderer: (0, $fBjVq.default),
                        annotationProvider: annotationProvider,
                        isLegacyRenderer: true
                    });
                case 'create-from-template':
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f19eca96759725e5$export$30c773822372f598), {
                        hasADF: !!adf,
                        macroDefaultProps: macroDefaultProps,
                        cloudId: cloudId,
                        userId: userId,
                        isPreviewMode: isPreviewMode,
                        shouldLoadAfterPaint: fromFabricEditor
                    });
                case 'toc':
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ab0c2ef401baeb08$export$cf1c26fcb7e6ff9f), {
                        adf: adf,
                        macroDefaultProps: macroDefaultProps,
                        cloudId: cloudId,
                        userId: userId,
                        shouldLoadAfterPaint: fromFabricEditor
                    });
                case 'livesearch':
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1fa3854e066af442$export$e8ac5007ab7a695a), {
                        hasADF: !!adf,
                        macroDefaultProps: macroDefaultProps,
                        shouldLoadAfterPaint: fromFabricEditor
                    });
                case 'anchor':
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $l86Zj.AnchorExtensionHandler), {
                        ...macroDefaultProps,
                        isSSR: false
                    });
                case 'excerpt-include':
                    if (contentId) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6O2BV.ClassicEditorContextProviderLoader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7NX4e.ExcerptIncludeExtensionHandler), {
                        ...macroDefaultProps,
                        Renderer: (0, $e8Lxy.PageContentRenderer)
                    }));
                case 'detailssummary':
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6O2BV.ClassicEditorContextProviderLoader), {
                        isWithinEditor: false
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e1Stz.PagePropertiesReportRenderer), {
                        macroDefaultProps: macroDefaultProps,
                        macroParams: macroParams
                    }));
                case 'profile-picture':
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9m03g.ProfilePictureMacroHandler), {
                        macroDefaultProps: macroDefaultProps,
                        macroParams: extension?.parameters?.macroParams
                    });
                case 'profile':
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5a4cC.UserProfileMacroHandler), {
                        macroDefaultProps: macroDefaultProps,
                        macroParams: extension?.parameters?.macroParams
                    });
                case 'questionslist-macro':
                    return legacyMacroRenderer();
                case 'questionslist-macro-native':
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9JyIJ.GlobalQuestionsListMacroHandler), {
                        macroDefaultProps: macroDefaultProps,
                        macroParams: extension?.parameters?.macroParams
                    });
                // generic macro renderer
                default:
                    return legacyMacroRenderer();
            }
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lspPP.RendererActionsContext), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3bd71c84d7d120d2$export$c25b654b62d7c7b4), {
            adf: adf,
            extensionParams: extension,
            referentialityDataSourceProvider: referentialityDataSourceProvider
        }, ({ references: references })=>{
            const macroDefaultProps = {
                node: extension,
                references: references,
                contentId: contentId,
                contentType: contentType,
                showTemplateVariablesInPreview: showTemplateVariablesInPreview || false,
                showTemplateInputInPreview: showTemplateInputInPreview || false,
                spaceKey: spaceKey || '',
                mode: (0, $5kjCz.RENDERER),
                extensionKey: extensionKey,
                attributes: attributes,
                multiBodiedExtensionActions: multiBodiedExtensionActions
            };
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4KFTW.MacroExperienceStart), {
                contentId: contentId,
                name: (0, $5kjCz.getExperienceName)((0, $5kjCz.RENDERER), extension),
                mode: (0, $5kjCz.RENDERER),
                extensionKey: extensionKey,
                attributes: attributes,
                timeout: (0, $aJPUt.ExperienceTimeout).MACRO_LOAD
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4f09d12458901289$export$9eec8c53e410de67), {
                extensionKey: extensionKey,
                attributes: {
                    ...attributesForAnalytics,
                    ...redactedAttributes
                },
                node: extension
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ge2sX.SessionData), null, ({ cloudId: cloudId, userId: userId })=>contentHandler(macroDefaultProps, cloudId, userId))));
        }));
    });
module.exports["getExtensionHandlers"] = $53f1c3cb11bcb25b$export$fe33197d44e10fcf;

});

parcelRegister("5bak6", function(module, exports) {

var $1c598 = parcelRequire("1c598");

const $3d0eafc518daabc9$export$f774d7302af8e99b = ({ contentId: contentId, contentType: contentType, contentVersion: contentVersion, contentStatus: contentStatus, spaceKey: spaceKey, spaceId: spaceId, isLivePage: isLivePage, templateId: templateId })=>({
        type: 'macro',
        content: {
            id: contentId,
            type: contentType,
            subtype: isLivePage ? 'live' : null,
            version: contentVersion,
            status: contentStatus
        },
        space: {
            key: spaceKey,
            id: spaceId
        },
        ...templateId && {
            template: {
                id: templateId
            }
        }
    });
function $3d0eafc518daabc9$export$fd8e92520f3c0007({ objectId: objectId, objectType: objectType, containerId: containerId, containerType: containerType }) {
    return {
        objectId: objectId,
        objectType: objectType || undefined,
        containerId: containerId || undefined,
        containerType: containerType
    };
}
function $3d0eafc518daabc9$export$7cb0da5f4e919dd7(environment) {
    return(// In dev, proxying to a site will give that site's environment,
    // which is not what we want
    window.location.hostname === 'localhost' ? (0, $1c598.ProductEnvironment).DEVELOPMENT : environment === 'STAGING' ? (0, $1c598.ProductEnvironment).STAGING : environment === 'PRODUCTION' ? (0, $1c598.ProductEnvironment).PRODUCTION : (0, $1c598.ProductEnvironment).DEVELOPMENT);
}
module.exports["createForgeMacroExtensionData"] = $3d0eafc518daabc9$export$f774d7302af8e99b;
module.exports["createForgeUIAnalyticsContext"] = $3d0eafc518daabc9$export$fd8e92520f3c0007;
module.exports["environmentToForgeProductEnvironment"] = $3d0eafc518daabc9$export$7cb0da5f4e919dd7;

});

parcelRegister("cbr0D", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $8pcS0 = parcelRequire("8pcS0");


var $3JqyB = parcelRequire("3JqyB");


var $2igSQ = parcelRequire("2igSQ");

const $aaaff26cb260a96a$export$fb67b4c81279b22e = (extension)=>{
    if (!extension) return null;
    const { extensionKey: extensionKey, parameters: parameters } = extension;
    if (extensionKey === (0, $8pcS0.EXTENSION_KEY).TEMPLATE) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3JqyB.TemplateVariableComponent), {
        parameters: parameters
    });
    return null;
};
const $aaaff26cb260a96a$export$14d3630cd94f43d4 = (extension)=>{
    if (!extension) return null;
    const { extensionKey: extensionKey, parameters: parameters } = extension;
    if (extensionKey === (0, $8pcS0.EXTENSION_KEY).TEMPLATE) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2igSQ.TemplateVariableInput), {
        parameters: parameters
    });
    return null;
};
module.exports["getTemplateExtensionHandler"] = $aaaff26cb260a96a$export$fb67b4c81279b22e;
module.exports["getTemplateVariableInputExtensionHandler"] = $aaaff26cb260a96a$export$14d3630cd94f43d4;

});

parcelRegister("7y0YZ", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $683eb32df0243bcb$export$698db23c85ab60f9 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "skFyW",
    name: "InvalidExtensionLoader",
    loader: async ()=>(await (parcelRequire("8TisB"))).InvalidExtension
});
module.exports["InvalidExtensionLoader"] = $683eb32df0243bcb$export$698db23c85ab60f9;

});

parcelRegister("6842f", function(module, exports) {
/**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");


var $42omo = parcelRequire("42omo");


var $j1Ss3 = parcelRequire("j1Ss3");


var $xQxzY = parcelRequire("xQxzY");


var $hp2SH = parcelRequire("hp2SH");


var $5kjCz = parcelRequire("5kjCz");


var $JbVPK = parcelRequire("JbVPK");


var $bX5uj = parcelRequire("bX5uj");


var $1kHsc = parcelRequire("1kHsc");


var $fGzMp = parcelRequire("fGzMp");


var $fHdcj = parcelRequire("fHdcj");

const $3fe9035161e924ff$var$InlineImageWithApolloProvider = ({ link: link, id: id, collection: collection, contentId: contentId, mode: mode, extensionKey: extensionKey, node: node, ...props })=>{
    const { data: data, loading: loading, error: error } = (0, $xQxzY.useQuery)((0, $eSUdr.default)`query InlineImageQuery($contentId:ID){content(id:$contentId){nodes{id body{atlas_doc_format{mediaToken{token}}}}}mediaConfiguration{clientId fileStoreUrl}}`, {
        variables: {
            contentId: contentId
        }
    });
    if (loading) return null;
    const token = data?.content?.nodes?.[0]?.body?.atlas_doc_format?.mediaToken?.token;
    const clientId = data?.mediaConfiguration?.clientId;
    const fileStoreUrl = data?.mediaConfiguration?.fileStoreUrl;
    const attributes = (0, $5kjCz.getMacroAttributesFromADFNode)(node);
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": "inline-image",
        style: {
            display: 'inline-block'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fHdcj.InlineImageComponent), {
        ...props,
        id: id,
        collection: collection,
        link: link,
        token: token,
        clientId: clientId,
        baseUrl: fileStoreUrl
    }), error ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $JbVPK.MacroExperienceFailure), {
        name: (0, $5kjCz.getExperienceName)(mode, node),
        contentId: contentId,
        extensionKey: extensionKey,
        mode: mode,
        error: error || new Error(`${extensionKey} failed to render. InlineImage query data is empty`),
        attributes: attributes,
        source: "InlineImage"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bX5uj.MacroExperienceSuccess), {
        name: (0, $5kjCz.getExperienceName)(mode, node),
        contentId: contentId,
        extensionKey: extensionKey,
        mode: mode,
        attributes: attributes
    })));
};
const $3fe9035161e924ff$export$bd0ca5575b89f75a = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $j1Ss3.ApolloProvider), {
        client: (0, $hp2SH.getApolloClient)()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1kHsc.ExperienceTrackerContext).Provider, {
        value: (0, $fGzMp.getExperienceTracker)()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3fe9035161e924ff$var$InlineImageWithApolloProvider, props)));
module.exports["InlineImage"] = $3fe9035161e924ff$export$bd0ca5575b89f75a;

});

parcelRegister("3X9I5", function(module, exports) {
"use strict";
var $2e0e69fbafc87dd7$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
/**
 * An error thrown when an Observable or a sequence was queried but has no
 * elements.
 *
 * @see {@link first}
 * @see {@link last}
 * @see {@link single}
 *
 * @class EmptyError
 */ var $2e0e69fbafc87dd7$var$EmptyError = function(_super) {
    $2e0e69fbafc87dd7$var$__extends(EmptyError, _super);
    function EmptyError() {
        var err = _super.call(this, 'no elements in sequence');
        this.name = err.name = 'EmptyError';
        this.stack = err.stack;
        this.message = err.message;
    }
    return EmptyError;
}(Error);
module.exports.EmptyError = $2e0e69fbafc87dd7$var$EmptyError;

});

parcelRegister("8biLX", function(module, exports) {
$parcel$export(module.exports, "isNumeric", () => $5f4de9a497084830$export$e90fb89750dba83f, (v) => $5f4de9a497084830$export$e90fb89750dba83f = v);
var $5f4de9a497084830$export$e90fb89750dba83f;
"use strict";

var $fvPwd = parcelRequire("fvPwd");

function $5f4de9a497084830$var$isNumeric(val) {
    // parseFloat NaNs numeric-cast false positives (null|true|false|"")
    // ...but misinterprets leading-number strings, particularly hex literals ("0x...")
    // subtraction forces infinities to NaN
    // adding 1 corrects loss of precision from parseFloat (#15100)
    return !$fvPwd.isArray(val) && val - parseFloat(val) + 1 >= 0;
}
$5f4de9a497084830$export$e90fb89750dba83f = $5f4de9a497084830$var$isNumeric;

});

parcelRegister("2oer2", function(module, exports) {
$parcel$export(module.exports, "getTemplateExtensionHandler", () => (parcelRequire("cbr0D")).getTemplateExtensionHandler);
$parcel$export(module.exports, "getTemplateVariableInputExtensionHandler", () => (parcelRequire("cbr0D")).getTemplateVariableInputExtensionHandler);

var $iol5P = parcelRequire("iol5P");

parcelRequire("ajgiQ");
var $j2dS3 = parcelRequire("j2dS3");


var $8pcS0 = parcelRequire("8pcS0");


var $cbr0D = parcelRequire("cbr0D");

const $653189039caa12b3$export$ae3b897442224943 = 'text';
const $653189039caa12b3$export$a43e313f04be91d7 = 'textarea';
const $653189039caa12b3$export$22c50a44ec8aa5dd = 'select';
const $653189039caa12b3$export$178c63c1bbc65458 = 'variable_name';
function $653189039caa12b3$export$166100f9abd52166(name = $653189039caa12b3$export$178c63c1bbc65458) {
    return {
        type: (0, $8pcS0.INLINE_EXTENSION_TYPE),
        attrs: {
            extensionType: (0, $8pcS0.EXTENSION_TYPE).TEMPLATE,
            extensionKey: (0, $8pcS0.EXTENSION_KEY).TEMPLATE,
            parameters: {
                type: $653189039caa12b3$export$ae3b897442224943,
                name: name
            }
        }
    };
}
function $653189039caa12b3$export$fd5152d3cbf54f5f(node) {
    return node.attrs && node.attrs.extensionType === (0, $8pcS0.EXTENSION_TYPE).TEMPLATE;
}
function $653189039caa12b3$export$9d5f42c8c61fd9fc(selectedNode, config) {
    return new Promise((resolve, reject)=>{
        if (!selectedNode.attrs || !config.setActiveModal) {
            reject(new Error('Cannot open editing template variable dialog'));
            return;
        }
        const params = selectedNode.attrs.parameters;
        config.setActiveModal((0, $iol5P.TemplateVariableDialogLoader), {
            defaultVariableType: params.type,
            defaultVariableName: params.name,
            defaultRows: params.params && params.params.rows,
            defaultColumns: params.params && params.params.columns,
            defaultListOptions: params.params && params.params.options,
            onSave: (updatedParams)=>{
                const adf = (0, $j2dS3.updateParams)(selectedNode, updatedParams);
                // MacroAttributes and ADNode are pretty much the same type, but
                // MacroAttributes requires either "extension", "bodiedExtension", or
                // "inlineExtension". This check is so we can pass the ADNode as a
                // MacroAttributes, but will default to "extension" if given an
                // unexpected value.
                let extensionType = (0, $8pcS0.REGULAR_EXTENSION_TYPE);
                if (adf.type === (0, $8pcS0.BODIED_EXTENSION_TYPE)) extensionType = (0, $8pcS0.BODIED_EXTENSION_TYPE);
                else if (adf.type === (0, $8pcS0.INLINE_EXTENSION_TYPE)) extensionType = (0, $8pcS0.INLINE_EXTENSION_TYPE);
                resolve({
                    ...adf,
                    type: extensionType,
                    attrs: adf.attrs || {}
                });
            },
            onClose: ()=>{
                if (config.closeActiveModal) config.closeActiveModal();
            }
        });
    });
}
module.exports["TEXT_TYPE"] = $653189039caa12b3$export$ae3b897442224943;
module.exports["defaultVariableName"] = $653189039caa12b3$export$178c63c1bbc65458;
module.exports["openTemplateVariableDialog"] = $653189039caa12b3$export$9d5f42c8c61fd9fc;

});

parcelRegister("fUN4A", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $3c6a1291ddf1a836$export$5fc4d24c17f7a720 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "3123e",
    name: 'ClassicEditorContextProviderLazyLoader',
    loader: ()=>(parcelRequire("4YwC8"))
});
module.exports["ClassicEditorContextProviderLazyLoader"] = $3c6a1291ddf1a836$export$5fc4d24c17f7a720;

});

parcelRegister("bQCqI", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $lspPP = parcelRequire("lspPP");


var $eS4Za = parcelRequire("eS4Za");


var $8pcS0 = parcelRequire("8pcS0");


var $5kjCz = parcelRequire("5kjCz");


var $4KFTW = parcelRequire("4KFTW");


var $aJPUt = parcelRequire("aJPUt");


var $fPNzj = parcelRequire("fPNzj");


var $7y0YZ = parcelRequire("7y0YZ");


var $6842f = parcelRequire("6842f");


var $gmxua = parcelRequire("gmxua");

const $1e9e777543fb9510$export$112339158948d5ae = ({ contentId: contentId, contextProviders: contextProviders })=>(0, $eS4Za.createMacroExtensionHandler)((extension)=>{
        if (!extension) return null;
        const { extensionKey: extensionKey, parameters: parameters } = extension;
        const { ClassicEditorContextProvider: ClassicEditorContextProvider = ({ children: children })=>children } = contextProviders;
        const attributes = (0, $5kjCz.getMacroAttributesFromADFNode)(extension);
        const defaultProps = {
            contentId: contentId,
            mode: (0, $5kjCz.RENDERER),
            extensionKey: extensionKey,
            attributes: attributes,
            node: extension
        };
        let implementation;
        switch(extensionKey){
            case (0, $8pcS0.EXTENSION_KEY).INVALID:
                // extension is rendered outside of React DOM tree and require access to the ClassicEditorContext
                implementation = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ClassicEditorContextProvider, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7y0YZ.InvalidExtensionLoader), {
                    parameters: parameters,
                    ...defaultProps
                }));
                break;
            case (0, $8pcS0.EXTENSION_KEY).INLINE_EXTERNAL_IMAGE:
                const inlineExternalImageProps = parameters;
                implementation = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fPNzj.InlineExternalImage), {
                    ...inlineExternalImageProps,
                    ...defaultProps
                });
                break;
            case (0, $8pcS0.EXTENSION_KEY).INLINE_MEDIA_IMAGE:
                const inlineMediaImageProps = parameters;
                const { link: link } = parameters;
                implementation = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6842f.InlineImage), {
                    ...inlineMediaImageProps,
                    ...defaultProps,
                    link: link
                });
                break;
            case (0, $8pcS0.EXTENSION_KEY).LEGACY_CONTENT:
                implementation = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gmxua.LegacyContentExtensionHandler), defaultProps);
                break;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4KFTW.MacroExperienceStart), {
            name: (0, $5kjCz.getExperienceName)((0, $5kjCz.RENDERER), extension),
            mode: (0, $5kjCz.RENDERER),
            extensionKey: extensionKey,
            attributes: attributes,
            timeout: (0, $aJPUt.ExperienceTimeout).MACRO_LOAD,
            contentId: contentId
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lspPP.RendererActionsContext), null, implementation));
    });
module.exports["getMigrationExtHandlerForRenderer"] = $1e9e777543fb9510$export$112339158948d5ae;

});

parcelRegister("fHdcj", function(module, exports) {
/* InlineImageComponent.tsx generated by @compiled/babel-plugin v0.36.1 */ // Need to disable aobve as there's a prop named token that's being used already

var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $2XqLN = parcelRequire("2XqLN");


var $2Nwuj = parcelRequire("2Nwuj");


var $btHGY = parcelRequire("btHGY");


var $fZtQj = parcelRequire("fZtQj");


var $3gadb = parcelRequire("3gadb");


var $6mKj3 = parcelRequire("6mKj3");


var $jB07v = parcelRequire("jB07v");

const $a7a0adbf49836e6d$var$imageWrapper = null;
const $a7a0adbf49836e6d$var$ImageWrapperWithRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).forwardRef((props, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        ...props,
        ref: ref,
        className: (0, $gMc0m.default)([
            "_1e0c1nu9"
        ])
    });
});
const $a7a0adbf49836e6d$var$getMediaClientConfig = (0, $2XqLN.default)((clientId, token, baseUrl)=>({
        authProvider: ()=>Promise.resolve({
                clientId: clientId,
                token: token,
                baseUrl: baseUrl
            })
    }));
const $a7a0adbf49836e6d$var$getApiConfig = (0, $2XqLN.default)((collectionName, width, height)=>({
        collectionName: collectionName,
        width: Number(width) || undefined,
        height: Number(height) || undefined
    }));
const $a7a0adbf49836e6d$var$getIdentifier = (0, $2XqLN.default)((collectionName, identifier)=>({
        collectionName: collectionName,
        id: identifier,
        mediaItemType: 'file'
    }));
const $a7a0adbf49836e6d$export$84dace027f4282bc = ({ width: width = 'auto', height: height = 'auto', id: id, collection: collection, clientId: clientId, token: token, link: link, baseUrl: baseUrl })=>{
    const intl = (0, $8C5kA.default)();
    const apiConfig = $a7a0adbf49836e6d$var$getApiConfig(collection, width, height);
    const imageStyle = (0, $6mKj3.expValEquals)('enable_edit_of_inline_image_extensions', 'cohort', 'test') ? {
        width: apiConfig.width,
        height: apiConfig.height
    } : undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $btHGY.MediaImageWithErrorBoundary), {
        identifier: $a7a0adbf49836e6d$var$getIdentifier(collection, id),
        mediaClientConfig: $a7a0adbf49836e6d$var$getMediaClientConfig(clientId, token, baseUrl),
        apiConfig: apiConfig
    }, ({ loading: loading, error: error, data: data })=>{
        if (loading) return null;
        if (error || !data) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            tag: "span",
            content: intl.formatMessage((0, $jB07v.i18n).imageFailedToLoad)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fZtQj))), {
            color: "var(--ds-text, #292A2E)",
            label: intl.formatMessage((0, $jB07v.i18n).imageFailedToLoad)
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            content: intl.formatMessage((0, $jB07v.i18n).openLink),
            tag: $a7a0adbf49836e6d$var$ImageWrapperWithRef,
            delay: 0
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
            href: link
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("img" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        , {
            style: imageStyle,
            src: data.src,
            alt: ""
        })));
    });
};
module.exports["InlineImageComponent"] = $a7a0adbf49836e6d$export$84dace027f4282bc;

});

parcelRegister("jB07v", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $c57dfe92a0cf565f$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    openLink: {
        id: "fabric-extension-handlers.inline-image.openLink",
        defaultMessage: "Open link in a new tab"
    },
    imageFailedToLoad: {
        id: "fabric-extension-handlers.inline-image.imageFailed",
        defaultMessage: "Image has failed to load"
    }
});
module.exports["i18n"] = $c57dfe92a0cf565f$export$a7357cdd1f0b0168;

});


$parcel$global.rlb("3amkb")
//# sourceMappingURL=FullPageEditorComponent.52661d5a.js.map
